import React, { useState, useEffect, createContext, useContext, useMemo, useRef, Fragment, isValidElement, Children, memo } from 'react';
import PropTypes$1 from 'prop-types';
import styled, { withTheme, css, createGlobalStyle } from 'styled-components';
export { ThemeProvider } from 'styled-components';
import { rem, lighten, darken } from 'polished';
import Pagination from 'rc-pagination';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { injectIntl, FormattedMessage } from 'react-intl';
import window from 'global/window';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { usePalette } from 'react-palette';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';
import Select$1, { components } from 'react-select';
import Calendar from 'react-calendar/dist/entry.nostyle';
import { Accordion as Accordion$3, AccordionItem, AccordionItemTitle, AccordionItemBody } from 'react-accessible-accordion';
export { AccordionItem, AccordionItemBody, AccordionItemTitle, AccordionItem as GeneralAccordionItem, AccordionItemBody as GeneralAccordionItemBody, AccordionItemTitle as GeneralAccordionItemTitle } from 'react-accessible-accordion';
import { withSize, SizeMe } from 'react-sizeme';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /*\n  -- Variant\n  */\n  ", "\n  /*\n  -- Shared default Styles\n  */\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  padding: ", ";\n  line-height: ", ";\n  /*\n  -- General props\n  */\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  &:focus {\n    color: ", ";\n    background-color:  ", ";\n  }\n  border: ", ";\n  color: ", ";\n  background-color: ", ";\n  position: relative;\n  border-radius: 0;\n  cursor: pointer;\n  /*\n  -- Before & After for cutting effect\n  */\n  &:before,\n  &:after {\n    height: 36px;\n    width: 36px;\n    position: absolute;\n    top: -20px;\n    right: -19px;\n  }\n\n  &:before {\n    content: \"\";\n    transform: rotate(45deg);\n    background-color: ", ";\n  }\n\n  &:after {\n    content: '", "';\n    color: ", ";\n    font-size: 22px;\n    font-weight: 100;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n  }\n  /*\n  -- If needed for tag a\n  */\n  display: ", "; //inline-flex\n  width: ", ";\n  text-decoration: ", "; //none\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function variantModifier(theme) {
  return {
    primary: "\n    color: ".concat(theme.components.button.primaryColor, ";\n    background-color: ").concat(theme.components.button.primaryBackgroundColor, ";\n    border: 1px solid ").concat(theme.components.button.primaryBorderColor, ";\n    &:hover {\n      color:").concat(theme.components.button.primaryHoverColor, ";\n      background-color: ").concat(theme.components.button.primaryHoverBackgroundColor, ";\n    }\n    &:focus {\n      outline: 2px solid ").concat(theme.components.button.primaryFocus, ";\n    }\n    &:before {\n      background-color: ").concat(theme.components.button.primaryIconBackgroundColor, ";\n    }\n    &:after {\n      color: ").concat(theme.components.button.primaryIconColor, ";\n    }\n  "),
    dark: "\n    color: ".concat(theme.components.button.darkColor, ";\n    background-color: ").concat(theme.components.button.darkBackgroundColor, ";\n    border: 1px solid ").concat(theme.components.button.darkBorderColor, ";\n    &:hover {\n      color: ").concat(theme.components.button.darkHoverColor, ";\n      background-color:").concat(theme.components.button.darkHoverBackgroundColor, ";\n    }\n    &:focus {\n      outline: 2px solid ").concat(theme.components.button.darkFocus, ";\n    }\n    &:before {\n      background-color: ").concat(theme.components.button.darkIconBackgroundColor, ";\n    }\n    &:after {\n      color: ").concat(theme.components.button.darkIconColor, ";\n    }\n  "),
    light: "\n    color: ".concat(theme.components.button.lightColor, ";\n    background-color: ").concat(theme.components.button.lightBackgroundColor, ";\n    border: 1px solid ").concat(theme.components.button.lightBorderColor, ";\n    &:hover {\n      color: ").concat(theme.components.button.lightHoverColor, ";\n      background-color: ").concat(theme.components.button.lightHoverBackgroundColor, ";\n    }\n    &:focus {\n      outline: 2px solid ").concat(theme.components.button.lightFocus, ";\n    }\n    &:before {\n      background-color: ").concat(theme.components.button.lightIconBackgroundColor, ";\n    }\n    &:after {\n      color: ").concat(theme.components.button.lightIconColor, ";\n    }\n  "),
    "default": "\n    color: ".concat(theme.components.button.color, ";\n    background-color: ").concat(theme.components.button.backgroundColor, ";\n    border: 1px solid ").concat(theme.components.button.borderColor, ";\n    &:hover {\n      color: ").concat(theme.components.button.hoverColor, ";\n      background-color: ").concat(theme.components.button.hoverBackgroundColor, ";\n    }\n    &:focus {\n      background-color:  ").concat(theme.components.button.focus, ";\n    }\n    &:before {\n      background-color: ").concat(theme.components.button.iconBackgroundColor, ";\n    }\n    &:after {\n      color: ").concat(theme.components.button.iconColor, ";\n    }\n  ")
  };
}

var Button = styled.button(_templateObject(), function (props) {
  return variantModifier(props.theme)[props.variant];
}, function (props) {
  return props.theme.type.base;
}, function (props) {
  return props.fontSize || props.theme.components.button.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.components.button.fontWeight;
}, function (props) {
  return props.padding || props.theme.components.button.padding;
}, function (props) {
  return props.lineHeight || props.theme.components.button.lineHeight;
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.hoverBackgroundColor;
}, function (props) {
  return props.focusColor;
}, function (props) {
  return props.focusBackgroundColor;
}, function (props) {
  return props.border;
}, function (props) {
  return props.color;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.theme.icons.plus;
}, function (props) {
  return props.contentColor || props.color;
}, function (props) {
  return props.display;
}, function (props) {
  return props.width;
}, function (props) {
  return props.textDecoration;
});
var types = {
  children: PropTypes$1.node,
  variant: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  fontWeight: PropTypes$1.string,
  padding: PropTypes$1.string,
  lineHeight: PropTypes$1.string,
  hoverColor: PropTypes$1.string,
  hoverBackgroundColor: PropTypes$1.string,
  focusColor: PropTypes$1.string,
  focusBackgroundColor: PropTypes$1.string,
  border: PropTypes$1.string,
  color: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  contentColor: PropTypes$1.string,
  display: PropTypes$1.string,
  width: PropTypes$1.string,
  textDecoration: PropTypes$1.string
};
var defaults = {
  variant: "default"
};
Button.propTypes = types;
Button.defaultProps = defaults;

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  @keyframes placeHolderShimmer {\n    0% {\n      background-position: -468px 0;\n    }\n    100% {\n      background-position: 468px 0;\n    }\n  }\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeHolderShimmer;\n  animation-timing-function: linear;\n  background: ", ";\n  background: linear-gradient(\n    to right,\n    ", " 8%,\n    ", " 18%,\n    ", " 33%\n  );\n  background-size: 936px 104px;\n  height: ", ";\n  width: ", ";\n  position: relative;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedBackground = styled.div(_templateObject$1(), function (props) {
  return props.theme.components.animatedBackground.backgroundColor;
}, function (props) {
  return props.theme.components.animatedBackground.gradientColor[0];
}, function (props) {
  return props.theme.components.animatedBackground.gradientColor[1];
}, function (props) {
  return props.theme.components.animatedBackground.gradientColor[2];
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var types$1 = {
  height: PropTypes$1.string,
  width: PropTypes$1.string,
  children: PropTypes$1.node
};
AnimatedBackground.propTypes = types$1;

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: ", ";\n  height: 0;\n\n  //Default Aspect Ratio 1:1\n  ", ";\n\n  .aspRTO {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var variantModifier$1 = {
  /* 16:9 Aspect Ratio */
  sixteenByNine: "\n    padding-top: 56.25%;\n  ",

  /* 4:3 Aspect Ratio */
  fourByTree: "\n    padding-top: 75%;\n  ",

  /* 3:2 Aspect Ratio */
  treeByTwo: "\n    padding-top: 66.66%;\n  ",

  /* 8:5 Aspect Ratio */
  eightByFive: "\n    padding-top: 62.5%;\n  ",

  /* 1:1 Aspect Ratio  */
  oneByOne: "\n    padding-top: 100%;\n  "
};

var AspectRatio = function AspectRatio(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "aspRTO"
  }, children));
};

AspectRatio.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string
};
var AspectRatioWithStyles = styled(AspectRatio)(_templateObject$2(), function (props) {
  return props.backgroundColor || props.theme.components.aspectRatio.backgroundColor;
}, function (props) {
  return variantModifier$1[props.ratio];
});
var types$2 = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  ratio: PropTypes$1.string.isRequired
};
var defaults$1 = {
  ratio: "oneByOne"
};
AspectRatioWithStyles.propTypes = types$2;
AspectRatioWithStyles.defaultProps = defaults$1;

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  ", ";\n\n  @-webkit-keyframes FadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @-moz-keyframes FadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @-o-keyframes FadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes FadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var FadeIn = styled.div(_templateObject$3(), function (props) {
  return props.height;
}, function (props) {
  return props.fadeIn && "\n    -webkit-animation: FadeIn ".concat(props.animationTime, "s\n      cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    -moz-animation: FadeIn ").concat(props.animationTime, "s\n      cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    -o-animation: FadeIn ").concat(props.animationTime, "s\n      cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    animation: FadeIn ").concat(props.animationTime, "s\n      cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n  ");
});
var types$3 = {
  fadeIn: PropTypes$1.bool,
  animationTime: PropTypes$1.number,
  height: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaults$2 = {
  fadeIn: true,
  animationTime: 1
};
FadeIn.propTypes = types$3;
FadeIn.defaultProps = defaults$2;

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  max-height: ", ";\n  min-height: ", ";\n  object-fit: ", ";\n  border-radius: ", ";\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Image = styled.img.attrs(function (_ref) {
  var className = _ref.className,
      src = _ref.src,
      alt = _ref.alt;
  return {
    src: src,
    className: className,
    alt: alt
  };
})(_templateObject$4(), function (props) {
  return props.width || "auto";
}, function (props) {
  return props.height || "auto";
}, function (props) {
  return props.maxHeight;
}, function (props) {
  return props.minHeight;
}, function (props) {
  return props.objectFit;
}, function (props) {
  return props.borderRadius;
});
var types$4 = {
  src: PropTypes$1.string.isRequired,
  alt: PropTypes$1.string,
  width: PropTypes$1.string,
  height: PropTypes$1.string,
  borderRadius: PropTypes$1.string,
  objectFit: PropTypes$1.string,
  minHeight: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaults$3 = {
  src: "",
  alt: "image",
  objectFit: "cover"
};
Image.propTypes = types$4;
Image.defaultProps = defaults$3;

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  border: ", ";\n  font-size: ", ";\n  padding: 0 8px 0 8px;\n  background-color: transparent;\n  color: ", ";\n\n  &:focus {\n    outline: 2px solid ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Input = styled.input(_templateObject$5(), function (props) {
  return props.height || props.theme.components.input.height;
}, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.border || "none";
}, function (props) {
  return props.fontSize || props.theme.components.input.fontSize;
}, function (props) {
  return props.theme.components.input.color;
}, function (props) {
  return props.theme.components.input.focus;
}, function (props) {
  return props.color || props.theme.components.input.color;
});
var types$5 = {
  height: PropTypes$1.string,
  width: PropTypes$1.string,
  border: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  color: PropTypes$1.string,
  children: PropTypes$1.node
};
Input.propTypes = types$5;

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  position: ", ";\n  transform: ", ";\n  z-index: ", ";\n  right: ", ";\n  top: ", ";\n  left: ", ";\n  bottom: ", ";\n  width: 0;\n  height: 0;\n  border-left: ", " solid transparent;\n  border-right: ", " solid transparent;\n  border-bottom: ", " solid\n    ", ";\n\n  ", ";\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    border-left: ", " solid transparent;\n    border-right: ", " solid transparent;\n    border-bottom: ", " solid ", ";\n    top: ", ";\n\n    ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var Triangle = styled.div.attrs(function () {
  return {
    "aria-hidden": "true"
  };
})(_templateObject$6(), function (props) {
  return props.position;
}, function (props) {
  return props.transform;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.right;
}, function (props) {
  return props.top;
}, function (props) {
  return props.left;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.color || props.theme.components.triangle.color;
}, function (props) {
  return props.withContent && "\n    &:before {\n      content: \"".concat(props.content || props.theme.icons.plus, "\";\n      font-size: ").concat(props.contentSize, ";\n      font-weight: ").concat(props.contentFontWeight, ";\n      color: ").concat(props.contentColor || props.theme.components.triangle.contentColor, ";\n      height: ").concat(props.size, ";\n      width: calc(").concat(props.size, " * 2);\n      top: calc(").concat(props.size, " / 2);\n      right: ").concat(props.size, ";\n      background-color: transparent;\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      align-self: center;\n    }\n  ");
}, function (props) {
  return props.XsSize || props.size;
}, function (props) {
  return props.XsSize || props.size;
}, function (props) {
  return props.XsSize || props.size;
}, function (props) {
  return props.color;
}, function (props) {
  return props.XsTop;
}, function (props) {
  return props.withContent && "\n      &:before {\n        font-size: ".concat(props.XsContentSize || props.contentSize, ";\n        height: ").concat(props.XsSize || props.size, ";\n        width: calc(").concat(props.XsSize || props.size, " * 2);\n        top: calc(").concat(props.XsSize || props.size, " / 2);\n        right: ").concat(props.XsSize || props.size, ";\n      }\n  ");
});
var types$6 = {
  children: PropTypes$1.node,
  position: PropTypes$1.string,
  transform: PropTypes$1.string,
  zIndex: PropTypes$1.string,
  right: PropTypes$1.string,
  top: PropTypes$1.string,
  left: PropTypes$1.string,
  bottom: PropTypes$1.string,
  size: PropTypes$1.string,
  color: PropTypes$1.string,
  withContent: PropTypes$1.bool,
  content: PropTypes$1.string,
  contentSize: PropTypes$1.string,
  contentFontWeight: PropTypes$1.string,
  contentColor: PropTypes$1.string,
  XsSize: PropTypes$1.string,
  XsTop: PropTypes$1.string,
  XsContentSize: PropTypes$1.string
};
var defaults$4 = {
  withContent: false,
  position: "absolute",
  contentFontWeight: "100",
  contentSize: "14px"
};
Triangle.propTypes = types$6;
Triangle.defaultProps = defaults$4;

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  display: table;\n  table-layout: fixed;\n  width: ", ";\n  white-space: nowrap;\n  text-align: ", ";\n\n  > * {\n    display: table-cell;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var LineTruncate = styled.div(_templateObject$7(), function (props) {
  return props.width || "100%";
}, function (props) {
  return props.textAlign || "left";
});
var types$7 = {
  width: PropTypes$1.string,
  textAlign: PropTypes$1.string,
  children: PropTypes$1.node
};
LineTruncate.propTypes = types$7;

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap; /* added line */\n  border: 0;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var ScreenReaderText = styled.span(_templateObject$8());

var colors = {
  white: "#fff",
  whiteDark: "#F3F3F4",
  black: "#000",
  blackLight: "#333333",
  grey: "#666666",
  greyAnchor: "#6f6f6f",
  greyLight: "#E5E5E5",
  greyBorder: "#e6e6e6",
  greyDark: "#40494e",
  greyBg: "#E6E7E8",
  green: "#95CA3D",
  blue: "#00b2bd",
  blueLight: "#00d1ca",
  focus: "#91d300",
  yellow: "#f7b609",
  orange: "#f05a24",
  red: "#FF6666",
  arrow: "rgb(204, 204, 203)",
  borderColor: "#939597",
  subWeb: "#0EB4BD"
};
var type = {
  base: "'Roboto', sans-serif",
  serif: "'Playfair Display', 'Roboto', sans-serif",
  icons: "'FontAwesome'"
};
var weight = {
  xxlight: 100,
  xlight: 200,
  light: 300,
  xbase: 400,
  base: 500,
  bold: 600
};
var sizes = {
  xs3: rem("3px"),
  xs2: rem("8px"),
  xs: rem("12px"),
  s: rem("14px"),
  sm: rem("15px"),
  m: rem("16px"),
  l: rem("18px"),
  xl: rem("20px"),
  xl2: rem("22px"),
  xl3: rem("26px"),
  xl3m: rem("28px"),
  xl4: rem("32px"),
  xl5: rem("36px"),
  xl6: rem("48px"),
  xl7: rem("56px"),
  xll: rem("168px")
};
var typos = {
  input: sizes.xs,
  button: sizes.xs,
  link: sizes.xs,
  text: sizes.l,
  title: sizes.xl6
};
var spacing = {
  xs3: rem("5px"),
  xs2: rem("10px"),
  xs: rem("12px"),
  s: rem("15px"),
  m: rem("20px"),
  l: rem("24px"),
  xl: rem("30px"),
  xl1: rem("32px"),
  xl2: rem("40px"),
  xl3: rem("50px"),
  xl4: rem("70px"),
  xl5: rem("100px"),
  xl6: rem("120px")
};
var values = {
  borderSize: "1px",
  headerLine: {
    width: "34px",
    height: "5px"
  },
  letterSpacing: "normal"
};
var shadows = {
  base: "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
  card: "0 .125rem .25rem rgba(0,0,0,.075)"
};
var mixins = {
  focus: function focus() {
    return "\n    outline: 2px solid ".concat(theme.colors.focus, ";\n  ");
  }
};
var icons = {
  //Brand
  facebook: "fab fa-facebook-f",
  instagram: "fab fa-instagram",
  twitter: "fab fa-twitter",
  linkedIn: "fab fa-linkedin-in",
  youtube: "fab fa-youtube",
  spotify: "fab fa-spotify",
  //Computers
  link: "fal fa-link",
  fa_print: "fal fa-print",
  //Files
  file: "fal fa-file",
  //Navigation
  arrow_up: "fal fa-arrow-up",
  chevron_up: "fal fa-chevron-up",
  chevron_down: "fal fa-chevron-down",
  chevron_left: "fal fa-chevron-left",
  chevron_right: "fal fa-chevron-right",
  //Mathematics
  plus: "+",
  times_icon: "×",
  fas_times: "fas fa-times",
  //Status
  calendar: "fal fa-calendar-alt",
  //Social
  share_alt: "fal fa-share-alt",
  image: "fas fa-image",
  user: "fas fa-user",
  //Interfaces
  search: "fas fa-search",
  //Audio & Video
  audio_description: "fal fa-audio-description",
  audio_description_active: "fas fa-audio-description",
  youtube_play: "fab fa-youtube"
};
var theme = {
  colors: colors,
  type: type,
  sizes: sizes,
  typos: typos,
  weight: weight,
  values: values,
  spacing: spacing,
  shadows: shadows,
  mixins: mixins,
  icons: icons
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  /*\n  -- Size\n  */\n  ", ";\n  /*\n  -- Other props\n  */\n  color: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  margin-right: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  margin-left: ", ";\n  word-break: ", ";\n  display: ", ";\n  transform: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  font-family: ", ";\n  visibility: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  white-space: ", ";\n\n  &:first-letter {\n    text-transform: ", ";\n  }\n\n  &:focus {\n    outline: 2px solid inherit;\n  }\n\n  ", ";\n\n  /*\n  -- Responsive\n  */\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    color: ", ";\n  }\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    /*\n    -- Size\n    */\n    ", "\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    /*\n    -- Size\n    */\n    ", "\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var sizing = {
  xSmall: "\n    font-size: ".concat(theme.sizes.xs, "; //12px\n  "),
  small: "\n    font-size: ".concat(theme.sizes.s, "; //14px\n  "),
  article: "\n    font-size: ".concat(theme.sizes.sm, "; //15px\n  "),
  mediumSmall: "\n    font-size: ".concat(theme.sizes.m, "; //16px\n  "),
  medium: "\n    font-size: ".concat(theme.sizes.l, "; //18px\n    "),
  mediumLarge: "\n    font-size: ".concat(theme.sizes.xl, "; //20px\n    "),
  large: "\n    font-size: ".concat(theme.sizes.xl2, "; //22px\n  "),
  xLarge: "\n    font-size: ".concat(theme.sizes.xl3m, "; //28px\n  "),
  xxLarge: "\n    font-size: ".concat(theme.sizes.xl4, "; //32px\n  "),
  xxxLarge: "\n    font-size: ".concat(theme.sizes.xl6, "; //48px\n  ")
};
var Text = styled.p.attrs(function (_ref) {
  var text = _ref.text,
      children = _ref.children,
      isThemeReverse = _ref.isThemeReverse,
      isSerif = _ref.isSerif;
  return {
    children: text || children,
    isThemeReverse: isThemeReverse,
    isSerif: isSerif
  };
})(_templateObject$9(), function (props) {
  return props.fontSize ? "font-size: ".concat(rem(props.fontSize)) : sizing[props.size];
}, function (props) {
  return props.color || (props.isThemeReverse ? props.theme.components.text.colorReverse : props.theme.components.text.color);
}, function (props) {
  return props.lineHeight || "1.5";
}, function (props) {
  return props.fontWeight || props.theme.weight.light;
}, function (props) {
  return props.marginRight;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.textAlign;
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.marginLeft;
}, function (props) {
  return props.wordBreak || "break-word";
}, function (props) {
  return props.display;
}, function (props) {
  return props.transform;
}, function (props) {
  return props.paddingTop;
}, function (props) {
  return props.paddingBottom;
}, function (props) {
  return props.fontFamily || (props.isSerif ? props.theme.type.serif : props.theme.type.base);
}, function (props) {
  return props.visibility;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.opacity;
}, function (props) {
  return props.whiteSpace;
}, function (props) {
  return props.firstLetter;
}, function (props) {
  return props.hasHover && "&:hover{\n    color: ".concat(props.hoverColor, ";\n  }");
}, function (props) {
  return props.mobileMdColor;
}, function (props) {
  return props.fontSize ? "font-size: ".concat(props.mobileSmFontSize) : sizing[props.sizeSmSize];
}, function (props) {
  return props.fontSize ? "font-size: ".concat(props.mobileXsFontSize) : sizing[props.sizeXsSize];
}, function (props) {
  return props.mobileXsMarginTop;
}, function (props) {
  return props.mobileXsMarginBottom;
});
var types$8 = {
  as: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  color: PropTypes$1.string,
  lineHeight: PropTypes$1.string,
  fontWeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  marginBottom: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  display: PropTypes$1.string,
  marginRight: PropTypes$1.string,
  marginLeft: PropTypes$1.string,
  textTransform: PropTypes$1.string,
  mobileSmFontSize: PropTypes$1.string,
  mobileXsFontSize: PropTypes$1.string,
  sizeSmSize: PropTypes$1.string,
  sizeXsSize: PropTypes$1.string,
  visibility: PropTypes$1.string,
  isThemeReverse: PropTypes$1.bool,
  isSerif: PropTypes$1.bool,
  firstLetter: PropTypes$1.string,
  paddingBottom: PropTypes$1.string,
  children: PropTypes$1.node,
  opacity: PropTypes$1.string,
  textAlign: PropTypes$1.string
};
var defaults$5 = {
  isThemeReverse: false,
  isSerif: false,
  size: "small"
};
Text.propTypes = types$8;
Text.defaultProps = defaults$5;

// used when we want to extend a styled components className with the attrs method
// example:
// styled.div.attrs(({ className }) => withExtendedClass({ className, extended: 'costumClass' }))`
// result 'costumClass sc-ckVGcZ cUEZSI'
var withExtendedClass = function withExtendedClass(_ref) {
  var className = _ref.className,
      extend = _ref.extend;
  return {
    className: "".concat(extend || "", " ").concat(className && className || "").trim()
  };
};

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  /*\n  -- Size\n  */\n  ", ";\n  /*\n  -- Other props\n  */\n  cursor: ", ";\n  color: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n  min-width: ", ";\n  opacity: ", ";\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    /*\n  -- Size XS\n  */\n    ", ";\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var sizing$1 = {
  xxSmall: "\n    font-size: 12px;\n  ",
  xSmall: "\n    font-size: 14px;\n  ",
  small: "\n    font-size: 18px;\n  ",
  medium: "\n    font-size: 24px;\n  ",
  large: "\n    font-size: 32px;\n  ",
  xLarge: "\n    font-size: 36px;\n  ",
  xxLarge: "\n    font-size: 42px;\n  ",
  xxxLarge: "\n    font-size: 48px;\n  "
};
var Icon = styled.i.attrs(function (_ref) {
  var className = _ref.className,
      name = _ref.name;
  return withExtendedClass({
    className: className,
    extend: "".concat(name)
  });
})(_templateObject$a(), function (props) {
  return props.fontSize ? "font-size: ".concat(props.fontSize || "inherit") : sizing$1[props.size];
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.color || props.theme.components.icon.color;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginRight;
}, function (props) {
  return props.marginLeft;
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.opacity;
}, function (props) {
  return props.fontSize ? "font-size: ".concat(props.xsFontSize) : sizing$1[props.xsSize];
});
var types$9 = {
  className: PropTypes$1.string,
  name: PropTypes$1.string.isRequired,
  cursor: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  color: PropTypes$1.string,
  marginRight: PropTypes$1.string,
  children: PropTypes$1.node,
  xsSize: PropTypes$1.string,
  xsFontSize: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  opacity: PropTypes$1.string
};
var defaults$6 = {
  name: "fa-info"
};
Icon.propTypes = types$9;
Icon.defaultProps = defaults$6;

var activeColors = {
  "default": "#95CA3D",
  about: "#95CA3D",
  study: "#0EB4BD",
  live: "#F3B21B",
  investigation: "#42D3B8",
  cooperate: "#9878D3",
  international: "#F0592A"
};
var viewsColors = {
  root: activeColors["default"],
  cooperate: activeColors.cooperate,
  education: activeColors.study,
  "public": activeColors["default"],
  index: activeColors["default"],
  internal: activeColors["default"],
  international: activeColors.international,
  live: activeColors.live,
  investigation: activeColors.investigation
};
/*
-- HighContrast
-- Values are null in main theme so it passes forward to other conditions
*/

var highContrast = {
  backgroundColor: null,
  lightBackgroundColor: null,
  opacityBgColor: null,
  lightOpacityBgColor: null,
  text: null,
  link: null,
  linkHover: null,
  action: null,
  borderColor: null,
  border: null
};
var globalStyle = {
  body: {
    backgroundColor: theme.colors.white
  }
};
/*
-- Containers
*/

var accessibilitySelector = {
  whiteLogo: "/imgs/logo.svg",
  mobileWhiteLogo: "/imgs/logo_mobile.svg",
  blackLogo: "/imgs/logo_b.svg",
  mobileBlackLogo: "/imgs/logo_mobile_b.svg",
  borderColor: "#4d4d4d",
  backgroundColor: theme.colors.black,
  color: theme.colors.black,
  isSearchOpenBackgroundColor: theme.colors.white,
  activeLineColor: theme.colors.white,
  dropDownHoverBackgroundColor: "#eeeeee",
  dropDownIconColor: theme.colors.black,
  linksColor: theme.colors.black,
  iconColor: theme.colors.black,
  accessibilityActiveBgColor: theme.colors.black,
  accessibilityIconActiveColor: theme.colors.white,
  accessibilityMenuIconColor: theme.colors.black,
  accessibilityIconHoverColor: null,
  searchFilterColor: theme.colors.black,
  accessibilityOnColor: theme.colors.white
};
/*
-- Atoms
*/
//AnimatedBackground

var animatedBackground = {
  backgroundColor: "#f6f7f8",
  gradientColor: ["#eeeeee", "#dddddd", "#eeeeee"]
}; //AspectRatio

var aspectRatio = {
  backgroundColor: "#e0e0e0"
}; //Button

var button = {
  //Global
  fontSize: theme.sizes.s,
  fontWeight: String(theme.weight.light),
  padding: "10px 20px",
  lineHeight: "1",
  //Primary
  primaryColor: theme.colors.black,
  primaryBackgroundColor: theme.colors.white,
  primaryBorderColor: theme.colors.blue,
  primaryHoverColor: theme.colors.white,
  primaryHoverBackgroundColor: theme.colors.blue,
  primaryFocus: "rgba(0,178,189,0.4)",
  primaryIconBackgroundColor: theme.colors.white,
  primaryIconColor: theme.colors.blue,
  //Dark
  darkColor: theme.colors.white,
  darkBackgroundColor: theme.colors.black,
  darkBorderColor: theme.colors.white,
  darkHoverColor: theme.colors.black,
  darkHoverBackgroundColor: theme.colors.white,
  darkFocus: "rgba(255,255,255,0.4)",
  darkIconBackgroundColor: theme.colors.black,
  darkIconColor: theme.colors.white,
  //Light
  lightColor: theme.colors.white,
  lightBackgroundColor: theme.colors.blue,
  lightBorderColor: theme.colors.white,
  lightHoverColor: theme.colors.blue,
  lightHoverBackgroundColor: theme.colors.white,
  lightFocus: "rgba(255,255,255,0.4)",
  lightIconBackgroundColor: theme.colors.blue,
  lightIconColor: theme.colors.white,
  //Default
  color: theme.colors.black,
  backgroundColor: theme.colors.white,
  borderColor: theme.colors.black,
  hoverColor: theme.colors.white,
  hoverBackgroundColor: theme.colors.black,
  focus: "rgba(0,0,0,0.4)",
  iconBackgroundColor: theme.colors.white,
  iconColor: theme.colors.black
}; //Icon

var icon = {
  color: theme.colors.black
}; //Input

var input = {
  fontSize: theme.sizes.s,
  color: theme.colors.black,
  height: theme.sizes.xl5,
  focus: "rgba(0, 0, 0, 0.4)"
}; //Line

var line = {
  width: 34,
  height: 5,
  color: theme.colors.white,
  marginTop: 0,
  marginTopMarkdown: 10,
  widthDifference: 8
}; //Link

var link = {
  color: theme.colors.black,
  fontSize: theme.typos.link,
  fontWeight: String(theme.weight.xbase)
}; //Picture

var picture = {
  backgroundColor: "#e0e0e0",
  color: theme.colors.black
}; //Pagination

var pagination = {
  backgroundColor: theme.colors.white,
  linkColor: "#666",
  linkHoverColor: "#94d500",
  disabledHover: "#d9d9d9",
  linkActive: "#94d500",
  jumpNextColor: "#ccc",
  jumpNextHoverColor: "#94d500",
  jumpPrevColor: "#666",
  disabledLinkColor: "#ccc",
  quickJumperInputBgColor: theme.colors.white,
  quickJumperInputHoverColor: "#94d500",
  quickJumperButtonBgColor: theme.colors.white,
  quickJumperButtonColor: "rgba(0, 0, 0, 0.65)",
  quickJumperButtonHAFColor: "#94d500",
  quickJumperButtonHAFBgColor: theme.colors.white,
  simplePagerInputBgColor: theme.colors.white,
  simplePagerInputHoverColor: "#94d500",
  simplePagerButtonColor: "rgba(0, 0, 0, 0.65)",
  simplePagerButtonBgColor: theme.colors.white,
  simplePagerButtonHAFColor: "#94d500",
  simplePagerButtonHAFBgColor: theme.colors.white
}; //ScrollMore

var scrollMore = {
  iconColor: theme.colors.black
}; //Text

var text = {
  fontSize: theme.typos.text,
  color: theme.colors.black,
  colorReverse: theme.colors.white,
  fontWeight: String(theme.weight.xbase)
}; //Title

var title = {
  fontSize: theme.typos.title,
  color: theme.colors.white,
  fontWeight: String(theme.weight.xbase),
  fontFamily: theme.type.base,
  lineHeight: 1.4
}; //Triangle

var triangle = {
  color: theme.colors.white,
  contentColor: theme.colors.black
};
/*
-- Molecules
*/
//AccessibleAccordion

var accessibleAccordion = {
  color: theme.colors.white,
  arrowColor: theme.colors.grey
}; //Accordion

var accordion = {
  color: theme.colors.white
}; //Breadcrumbs

var breadcrumbs = {
  height: "32px",
  link: {
    color: theme.colors.grey,
    fontSize: "15px",
    fontWeight: 300
  },
  button: {
    iconColor: theme.colors.black,
    bgColor: "transparent",
    hoverBgColor: "#E7E8E9"
  },
  anchors: {
    buttonBgColor: "#E7E8E9",
    textColor: theme.colors.black
  }
}; // -- CARDS --
//AgendaCard

var agendaCard = {
  categoryColor: theme.colors.white,
  titleColor: theme.colors.white,
  textColor: theme.colors.white,
  dateColor: theme.colors.black,
  iconColor: theme.colors.white,
  borderColor: theme.colors.white,
  textColorHover: theme.colors.white,
  squareColorHover: theme.colors.white,
  iconColorHover: theme.colors.black
}; //AgendaFeatured

var agendaFeatured = {
  dateContainerTextColor: "rgb(77, 147, 255)",
  buttonBgColor: "rgb(77, 147, 255)",
  buttonTextColor: theme.colors.white,
  textColor: theme.colors.white,
  titleColor: theme.colors.white,
  dateColor: theme.colors.black,
  dateContainerBgColor: theme.colors.white,
  borderColor: theme.colors.white,
  textColorHover: theme.colors.white,
  animationBgColor: "rgb(77, 147, 255)",
  plusButtonHoverBgColor: "rgb(77, 147, 255)"
}; //BackgroundImageNewsCard

var backgroundImageNewsCard = {
  cardBackgroundColor: theme.colors.white,
  textColor: theme.colors.black,
  contentContainerBackgroundColor: "rgba(255, 255, 255, 0.8)"
}; //BorderedCArd

var borderedCard = {
  borderColor: theme.colors.black
}; //CandidatureCard

var candidatureCard = {
  titleColor: theme.colors.black,
  cardBackgroundColor: theme.colors.white
}; //ColorExtractCard

var colorExtractCard = {
  backgroundColor: theme.colors.greyLight,
  iconColor: theme.colors.black,
  linkColor: theme.colors.black
}; //Columns Card

var columnsCard = {
  textColor: theme.colors.black,
  linkColor: theme.colors.black,
  backgroundColor: theme.colors.white
}; //EventCard

var eventCard = {
  backgroundColor: theme.colors.white,
  color: theme.colors.black
}; //HorizontalNewsCard

var horizontalNewsCard = {
  backgroundColor: theme.colors.white,
  height: "294px",
  mobileXsHeight: "250px",
  textColor: theme.colors.black,
  contentContainerBgColor: theme.colors.white,
  triangleContentColor: theme.colors.black,
  categoryColor: theme.colors.black
}; //IconCard

var iconCard = {
  iconContainer: {
    backgroundColor: "#E7E8E9",
    iconColor: theme.colors.black
  },
  link: {
    color: "#231F20"
  }
}; //ImageCard

var imageCard = {
  link: {
    color: theme.colors.black,
    hoverColor: "#00b2bd"
  }
}; //Layered Card

var layeredCard = {
  textColor: theme.colors.black,
  linkColor: theme.colors.black,
  backgroundColor: theme.colors.white
}; //MiniHorizontalNewsCArd

var miniHorizontalNewsCard = {
  backgroundColor: theme.colors.white,
  height: "75px",
  dateColor: "#5B5C5E",
  borderColor: theme.colors.black,
  triangleBgColor: theme.colors.white,
  triangleContentColor: theme.colors.black
}; //NewsCard

var newsCard = {
  plusButtonTextColor: theme.colors.black,
  plusButtonBgColor: theme.colors.white,
  shareIconColor: theme.colors.black,
  dateColor: theme.colors.black,
  cardBackgroundColor: theme.colors.white,
  categoryColor: theme.colors.black
}; //PersonCard

var personCard = {
  backgroundColor: "#5B5C5E",
  textColor: theme.colors.white,
  imageSize: "115px",
  imageBackgroundColor: theme.colors.greyBg
}; //ShareSocialMedia

var shareSocialMedia = {
  backgroundColor: theme.colors.white,
  copyToClipboardTextColor: theme.colors.white,
  copyToClipboardBgColor: theme.colors.black,
  iconColor: theme.colors.black,
  boxShadow: "0 3px 6px #00000029"
}; //ShowMoreCard

var showMoreCard = {
  hoverBgColor: theme.colors.white,
  hoverTitleColor: theme.colors.subWeb,
  borderColor: theme.colors.white,
  titleColor: theme.colors.white,
  linkColor: "#818386"
}; //StudentCard

var studentCard = {
  borderColor: "#cccccb"
}; //StudentCardLink

var studentCardLink = {
  borderColor: "#B3B3B3",
  borderColorHover: theme.colors.black,
  outlineColorPressed: theme.colors.black,
  textDecoration: "none"
}; //Carousel

var carousel = {
  legendColor: theme.colors.black,
  dotsColor: theme.colors.grey
}; //CustomArrow

var customArrow = {
  customArrowColor: theme.colors.arrow
}; //DatePicker

var datePicker = {
  backgroundColor: "transparent",
  borderColor: theme.colors.black,
  separatorColor: theme.colors.black,
  textColor: theme.colors.black,
  shadowColor: theme.colors.black,
  hoverBorderColor: "rgba(0, 0, 0, 0.3)",
  iconColor: theme.colors.black,
  clearIconHoverColor: "rgba(0, 0, 0, 0.3)"
}; //DropDown

var dropDown = {
  backgroundColor: theme.colors.white,
  minWidth: "210px",
  underlineAnimationColor: theme.colors.white
}; //DropDownList

var dropdownList = {
  color: theme.colors.greyAnchor,
  hoverBackgroundColor: theme.colors.greyAnchor
}; //InjectHtml

var injectHtml = {
  "default": {
    color: theme.colors.black
  },
  presentationStyles: {
    color: theme.colors.black,
    before: "rgb(51, 51, 51)"
  },
  lightStyles: {
    color: theme.colors.white
  },
  span: theme.colors.black,
  link: {
    color: theme.colors.black,
    hoverColor: "#00b2bd"
  }
}; //IstituteSearch

var instituteSearch = {
  leftIconColor: "#94D500",
  rightIconColor: "#848484",
  beforeBackgroundColor: "#94d500",
  color: "#848484",
  borderColor: "#cecbcb"
};
var listItem = {
  lineColor: theme.colors.greyBorder,
  spacingBottom: theme.spacing.s,
  spacingLeft: theme.spacing.s
}; //PlusButton

var plusButton = {
  backgroundColor: theme.colors.white
}; //ReactCalendar

var reactCalendar = {
  titleActiveBgColor: "#4d93ff",
  titleActiveColor: theme.colors.white,
  backgroundColor: theme.colors.black,
  buttonFocus: "#4d93ff",
  buttonColor: theme.colors.white,
  buttonHoverBgColor: "#4d93ff",
  buttonHoverTextColor: theme.colors.white,
  monthViewWeekDaysColor: theme.colors.white,
  monthViewWeekDaysNeighboringColor: "rgba(255, 255, 255, 0.5)"
}; //ScrollableTabs

var scrollableTabs = {
  border: "1px solid #eeee",
  button: {
    iconColor: theme.colors.black,
    bgColor: theme.colors.white
  },
  tab: {
    linkColor: theme.colors.black,
    underlineColor: theme.colors.subWeb
  }
}; //Section

var section = {
  paddingTop: theme.spacing.xl4,
  paddingBottom: theme.spacing.xl4,
  backgroundColor: theme.colors.white
}; //SectionHeader

var sectionHeader = {
  backgroundColor: theme.colors.black,
  textColor: theme.colors.white
}; //Select

var select = {
  textColor: theme.colors.white,
  borderColor: theme.colors.white,
  outlineColor: theme.colors.focus,
  primary25: "#efefef",
  primary: "#000",
  primary50: "#EDEDED",
  grey5: "#F2F2F2",
  grey10: "#E6E6E6",
  grey60: "#666666",
  indicator: theme.colors.black,
  menuListBgColor: theme.colors.white,
  menuListColor: theme.colors.black,
  optionHover: theme.colors.black,
  menuListBorder: "none",
  optionIsSelected: theme.colors.black,
  optionBgColorHover: "#EDEDED",
  optionIsSelectedColor: theme.colors.white,
  clearIndicator: theme.colors.black,
  variantBlack: {
    color: theme.colors.black,
    bgColor: theme.colors.white
  },
  optionIsFocusColor: theme.colors.black,
  optionIsFocusBgColor: "#EDEDED"
};
var tab = {
  color: theme.colors.black,
  backgroundColor: "transparent"
};
var tabContent = {
  marginTop: theme.spacing.xs2,
  backgroundColor: "transparent"
}; //Table

var table = {
  borderColor: "rgb(147, 149, 151)",
  borderLightColor: "rgba(147, 149, 151, 0.5)",
  optionColor: theme.colors.focus,
  minorColor: theme.colors.focus,
  linksTextDecorationColor: theme.colors.focus,
  indentColor: theme.colors.black,
  textColor: theme.colors.black
};
/*
-- Organisms
*/
//About

var about = {
  backgroundColor: "#F1F1F2",
  arrowColor: theme.colors.arrow
}; //Agenda

var agenda = {
  backgroundColor: theme.colors.blue,
  titleColor: theme.colors.white,
  squareColorHover: theme.colors.white,
  agendaCardTextColor: theme.colors.white,
  agendaFeaturedTextColor: theme.colors.white,
  agendaFeaturedDateContainerBgColor: theme.colors.white
}; //Article

var article = {
  backgroundColor: theme.colors.white
}; //Campos

var campos = {
  textColor: theme.colors.black,
  backgroundColor: theme.colors.white
}; //Candidature

var candidature = {
  arrowColor: theme.colors.white,
  backgroundColor: theme.colors.white,
  dotsColor: theme.colors.white,
  card: {
    linkColor: theme.colors.black,
    linkHoverColor: "#0EB4BD"
  }
}; //Cards

var cards = {
  backgroundColor: theme.colors.white,
  titleColor: theme.colors.black,
  dotsColor: theme.colors.white,
  slideBackgroundColor: theme.colors.white,
  arrowColor: theme.colors.white
}; //ContentList

var contentList = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black,
  borderColor: theme.colors.borderColor,
  listTitleColor: theme.colors.black,
  listLinkColor: theme.colors.black
}; //ContentList -- SimpleList

var simpleList = {
  backgroundColor: theme.colors.white,
  borderColor: theme.colors.borderColor,
  linkColor: theme.colors.black
}; //Contents

var contents = {
  nestedRow: {
    linkColor: theme.colors.black,
    linkHoverColor: theme.colors.blue
  },
  oneCol: {
    textColor: theme.colors.white,
    buttonBgColor: "#00AFBB"
  },
  twoCols: {
    textColor: theme.colors.blue,
    linkColor: theme.colors.black,
    linkHoverColor: theme.colors.blue
  }
}; //Courses

var courses = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black,
  borderColor: theme.colors.borderColor,
  textColor: "#adacac",
  listLinkColor: theme.colors.black,
  noteColor: "#adacac"
}; //Curricular

var curricular = {
  backgroundColor: theme.colors.white
}; //CurricularPlan

var curricularPlan = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black,
  linkColor: theme.colors.black
}; //CurricularUnit

var curricularUnit = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black,
  titleColor: theme.colors.blue,
  containerBorderColor: theme.colors.black,
  infoContainerBorderColor: "#E5E3E3",
  linkColor: theme.colors.black,
  linkHoverColor: theme.colors.blue
}; //Departments

var departments = {
  backgroundColor: theme.colors.white,
  titleColor: "#00AFBB",
  borderColor: "#939597",
  linkColor: theme.colors.black
}; //Directory

var directory = {
  linkColor: theme.colors.black,
  linkHoverColor: theme.colors.green,
  alphabetColor: "#656565",
  textColor: "#656565",
  alphabetActiveLetter: theme.colors.green,
  alphabetBoxSelectedShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)"
}; //Edicts

var edicts = {
  backgroundColor: theme.colors.white,
  iconColor: theme.colors.black,
  emptyIconColor: "#97999C",
  linkColor: theme.colors.black
}; //Events

var events = {
  backgroundColor: theme.colors.white,
  agendaCard: {
    borderColor: theme.colors.black,
    outlineColor: "#616161",
    buttonOutlineColorHover: theme.colors.white,
    iconColorHover: theme.colors.white,
    iconColor: theme.colors.black,
    categoryColor: "#616161",
    titleColor: theme.colors.black,
    textColor: theme.colors.black,
    dateColor: "#616161",
    squareColorHover: theme.colors.black,
    textColorHover: theme.colors.white,
    isLimitHour: theme.colors.black,
    isNotLimitHour: "#616161"
  },
  agendaFeatured: {
    dateContainerBgColor: "#4d93ff",
    borderColor: "#4d93ff",
    dateContainerTextColor: theme.colors.white,
    buttonBgColor: "#4d93ff",
    buttonTextColor: theme.colors.white,
    titleColor: theme.colors.black,
    textColor: "#616161",
    dateColor: theme.colors.black,
    textColorHover: "#4d93ff",
    animationBgColor: theme.colors.white,
    plusButtonHoverBgColor: theme.colors.white
  },
  calendarCardToday: {
    backgroundColor: "#1755ff",
    titleColor: theme.colors.white,
    textColor: theme.colors.white,
    afterBgColor: "#1755ff",
    bottomBgColor: "#4d93ff",
    plusButtonBgColor: "#4d93ff",
    plusButtonTextColor: theme.colors.white
  },
  calendarCard: {
    backgroundColor: theme.colors.white,
    border: "1px solid #4d93ff",
    hoverBgColor: "#4d93ff",
    textColor: "#4d93ff",
    textColorHover: theme.colors.white,
    activeBgColor: "rgba(77, 147, 255, 0.7)"
  },
  calendarButton: {
    backgroundColor: theme.colors.black,
    color: theme.colors.white,
    iconColor: theme.colors.white,
    hoverBgColor: "rgba(0, 0, 0, 0.7)"
  }
}; //Facts

var oneFact = {
  backgroundColor: theme.colors.white
}; //Files

var files = {
  textColor: theme.colors.black,
  buttonColor: theme.colors.black,
  lightText: "#818386"
}; //Gallery

var gallery = {
  titleColor: theme.colors.black,
  theater: {
    backgroundColor: "#333333",
    textColor: theme.colors.white
  }
}; //Footer

var footer = {
  backgroundColor: theme.colors.black,
  color: theme.colors.white,
  linkColor: theme.colors.white,
  copyColor: "#757575",
  borderColor: "rgba(255,255,255,0.2)",
  socialMediaIconsColor: theme.colors.white,
  logos: {
    compete: "/imgs/logos/logo_compete.jpg",
    eciu: "/imgs/logos/logo_eciu.jpg",
    eche: "/imgs/logos/eche.jpg",
    eps: "/imgs/logos/eps.jpg",
    accessibility: "/imgs/logos/logo_acessibilidade.jpg"
  }
}; //Header

var header = {
  height: "calc(100vh - (40px + 105px + 50px))",
  mobileHeight: "calc(100vh - (40px + 85px + 50px))",
  maxHeight: "992px",
  arrowColor: theme.colors.white,
  arrowBackgroundColor: "rgba(0, 0, 0, 0.3)",
  subWeb: {
    height: "calc(100vh - (40px + 105px + 72px + 50px))",
    mobileHeight: "calc(100vh - (40px + 85px + 72px + 50px))",
    titleColor: theme.colors.white,
    bgColor: "rgba(50, 49, 51, 0.8)",
    iconColor: theme.colors.white,
    warning: {
      bgColor: "#e7e8e9",
      textColor: theme.colors.black
    }
  },
  video: {
    bgColor: theme.colors.black,
    imagePlaceholder: {
      iconColor: theme.colors.white
    },
    adButton: {
      iconColor: theme.colors.white,
      toolTipBgColor: "rgba(33, 33, 33, 0.8)",
      toolTipColor: theme.colors.white
    }
  }
}; //Information

var information = {
  lineColor: theme.colors.black,
  titleColor: theme.colors.blue
}; // -- Journal --
//JournalCards

var journalCards = {
  backgroundColor: theme.colors.white,
  titleColor: theme.colors.black
}; //JournalColumns

var journalColumns = {
  backgroundColor: theme.colors.white,
  titleColor: theme.colors.black
}; //JournalDetails

var journalDetails = {
  backgroundColor: theme.colors.white,
  color: theme.colors.black,
  linkColor: theme.colors.black,
  borderedCardLineColor: theme.colors.black,
  socialMediaIconsColor: theme.colors.black,
  printIconColor: theme.colors.black
}; //JournalDossiers

var journalDossiers = {
  backgroundColor: theme.colors.white,
  titleColor: theme.colors.black
}; //JournalFooter

var journalFooter = {
  backgroundColor: "#1A1A1A",
  color: theme.colors.white
}; //JournalHighlights

var journalHighlights = {
  backgroundColor: theme.colors.white,
  highlightCardBgColor: "#e7e8e9"
}; //JournalListing

var journalListing = {
  backgroundColor: theme.colors.greyBg,
  mobileBackgroundColor: theme.colors.white,
  mobileNewsCardBgColor: theme.colors.greyBg,
  titleColor: theme.colors.black
}; //JournalMoreNews

var journalMoreNews = {
  backgroundColor: "#E7E8E9",
  containerRightBgColor: theme.colors.white,
  titleColor: theme.colors.black,
  borderedCardLinkColor: theme.colors.black,
  newsCardBgColor: theme.colors.white
}; //JournalNavigation

var journalNavigation = {
  backgroundColor: theme.colors.white,
  mobileBorderBottomColor: theme.colors.greyBg,
  boxShadow: "0 0 10px  rgba(0, 0, 0, 0.2)",
  menuIconColor: theme.colors.black,
  linksColor: theme.colors.black,
  titleColor: theme.colors.black
}; //JournalNews

var journalNews = {
  backgroundColor: "#E7E8E9",
  mobileBackgroundColor: theme.colors.white,
  mobileNewsCardBgColor: theme.colors.greyBg,
  titleColor: theme.colors.black
}; //JournalRelated

var journalRelated = {
  backgroundColor: "#4d93ff"
}; //JournalSlides

var journalSlides = {
  backgroundColor: theme.colors.white,
  textColor: theme.colors.white,
  cardBackgroundColor: theme.colors.white,
  desktopContentContainerBgColor: "#c7c9cb",
  desktopContentContainerContentColor: "#6d6f72",
  activeCardBgColor: theme.colors.white,
  activeCardContentColor: theme.colors.black,
  mobileCardBackgroundColor: "#E7E8E9",
  cardTextColor: theme.colors.black,
  mobileMdTextColor: theme.colors.black,
  gradientColor: "rgba(8, 8, 8, 0.3)"
}; //LastUpdate

var lastUpdate = {
  bgColor: "#1A1A1A",
  textColor: theme.colors.white
}; //Loading

var loading = {
  backgroundColor: theme.colors.white
}; //MobileNavBar

var mobileNavBar = {
  mobileWhiteLogo: "/imgs/logo_mobile.svg",
  mobileBlackLogo: "/imgs/logo_mobile_b.svg",
  backgroundColor: theme.colors.black,
  isSearchOpenBackgroundColor: theme.colors.white,
  iconColor: theme.colors.white,
  textColor: theme.colors.white,
  dropDownBackgroundColor: theme.colors.black,
  linksColor: theme.colors.white
}; //MobilePublicNavBar

var mobilePublicNavBar = {
  backgroundColor: theme.colors.white,
  linksColor: theme.colors.black,
  textColor: theme.colors.black,
  iconColor: theme.colors.black,
  boxShadow: "0 15px 10px -15px rgba(0, 0, 0, 0.2)"
}; //News

var news = {
  personCard: {
    style2BgColor: "#E7E8E9",
    style2Color: "#000"
  }
}; //ErrorHandler

var errorHandler = {
  backgroundColor: theme.colors.white,
  color: theme.colors.black,
  linkColor: theme.colors.black,
  borderColor: theme.colors.black,
  hoverColor: "#E7E8E9",
  activeColor: "rgba(231, 232, 233, 0.5)",
  gameFontSize: theme.sizes.xl4,
  gameFontWeight: theme.weight.base,
  gameSquareSize: "110px",
  gameSquareMobileSize: "80px",
  gameSquareXXXSmallMobileSize: "60px",
  gameBorderSize: "1px",
  playButtonContainerBgColor: "rgba(255, 255, 255, 0.85)"
}; //Numbers

var numbers = {
  sectionTitleColor: "#939598"
}; //PeopleArticle

var peopleArticle = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black
}; //Presentation

var presentation = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black,
  linkColor: theme.colors.black,
  linkHoverColor: theme.colors.blue,
  card: {
    border: "3px solid #000",
    thinBorderColor: "#717070"
  }
}; //Profile

var profile = {
  backgroundColor: theme.colors.white,
  linkColor: theme.colors.black,
  iconColor: theme.colors.black
}; //Services

var services = {
  groupTitleColor: "#92D400"
}; //Streaming

var streaming = {
  textColor: theme.colors.white,
  backgroundColor: "#191919"
}; //Projects

var projects = {
  projectList: {
    titleColor: theme.colors.black,
    table: {
      linkColor: theme.colors.black
    },
    card: {
      borderColor: "#6D6E70",
      linkColor: theme.colors.black,
      textColor: "#97999C"
    }
  },
  projectDetails: {
    titleColor: theme.colors.black,
    textColor: "#97999C",
    logos: {
      borderColor: "#AFB1B3"
    }
  }
}; //PublicNavBar

var publicNavbar = {
  borderColor: "#e6e6e6",
  linksColor: theme.colors.black,
  backgroundColor: theme.colors.white,
  iconColor: theme.colors.black,
  myUAColor: theme.colors.green,
  avatar: {
    linksColor: "#231f20"
  },
  bentoMenu: {
    icon: "/icons/sushi_icon.svg",
    moreLinkBgColor: "#e7e8e9",
    moreLinkColor: "#231f20"
  }
}; //SideNav

var sideNav = {
  iconColor: theme.colors.white,
  backgroundColor: theme.colors.white,
  desktopBoxShadow: theme.shadows.base,
  mobileBoxShadow: "0 4px 10px -3px rgba(0, 0, 0, 0.1)"
}; //SiteMap

var siteMap = {
  backgroundColor: theme.colors.white,
  lineColor: theme.colors.black,
  linkColor: theme.colors.black
};
/*
-- SubWebs
*/
//SubWebContacts

var subWebContacts = {
  height: "485px",
  card: {
    bgColor: theme.colors.white,
    iconColor: theme.colors.black
  }
}; //SubWebCourses

var subWebCourses = {
  titleColor: theme.colors.white,
  backgroundColor: theme.colors.subWeb
}; //SubWebContacts

var subWebDepartment = {
  titleColor: theme.colors.black,
  backgroundColor: "#E7E8E9",
  height: "485px"
}; //SubWebDepartmentCourses

var subWebDepartmentCourses = {
  subTitleColor: theme.colors.subWeb,
  card: {
    borderColor: "#AFB1B3",
    titleColor: theme.colors.black,
    subTitle: "#97999C"
  }
}; //SubWebEvents

var subWebEvents = {
  color: theme.colors.black,
  linkColor: theme.colors.black,
  card: {
    bgColor: {
      darkGray: "#4D4D4D",
      lightGray: "#808080"
    },
    text: {
      dark: theme.colors.black,
      light: theme.colors.white
    }
  }
}; //SubWebNavigation

var subWebNavigation = {
  backgroundColor: theme.colors.subWeb,
  menuIconColor: theme.colors.white,
  linksColor: theme.colors.white,
  boxShadow: "0 0 10px  rgba(0, 0, 0, 0.2)",
  whiteLogo: "/imgs/logo.svg",
  activeLineColor: theme.colors.white
}; //SubWebPeople

var subWebPeople = {
  titleColor: theme.colors.subWeb,
  personCard: {
    textColor: "#818386",
    linkColor: "#818386",
    imagePlaceholderColor: theme.colors.white
  }
}; //SubWebWarnings

var subWebWarnings = {
  titleColor: theme.colors.black,
  card: {
    titleColor: theme.colors.subWeb,
    linkColor: theme.colors.black
  }
}; //SubWebSchedule

var subWebSchedule = {
  backgroundColor: {
    isOpen: "#E7E8E9",
    isClosed: "#5A5B5E"
  },
  textColor: {
    isOpen: theme.colors.black,
    isClosed: theme.colors.white
  },
  linkColor: {
    isOpen: theme.colors.black,
    isClosed: theme.colors.white,
    hover: theme.colors.subWeb
  }
}; //WebNavBar

var webNavBar = {
  whiteLogo: "/imgs/logo.svg",
  mobileWhiteLogo: "/imgs/logo_mobile.svg",
  blackLogo: "/imgs/logo_b.svg",
  mobileBlackLogo: "/imgs/logo_mobile_b.svg",
  borderColor: "#4d4d4d",
  backgroundColor: theme.colors.black,
  color: theme.colors.black,
  isSearchOpenBackgroundColor: theme.colors.white,
  activeLineColor: theme.colors.white,
  dropDownHoverBackgroundColor: "#eeeeee",
  dropDownIconColor: theme.colors.black,
  linksColor: theme.colors.white,
  iconColor: theme.colors.white,
  accessibilityActiveBgColor: theme.colors.black,
  accessibilityIconActiveColor: theme.colors.white,
  accessibilityMenuIconColor: theme.colors.black,
  accessibilityIconHoverColor: null,
  searchFilterColor: theme.colors.black,
  accessibilityOnColor: theme.colors.white
}; //Tables

var tables = {
  titleColor: theme.colors.black,
  linkColor: theme.colors.black
}; //Xperimenta

var xperimenta = {
  sessionColor: "#A145C4",
  sessionDateAndTimeColor: "#A145C4",
  card: {
    borderColor: theme.colors.white,
    subTitle: theme.colors.grey
  }
}; //generalAccordion

var generalAccordion = {
  title: theme.colors.black,
  header: theme.colors.black,
  borderColor: "1px solid ".concat(theme.colors.black)
};
/*
-- Templates
*/
//GlobalSearch

var globalSearch = {
  backgroundColor: theme.colors.white,
  tabLinkColor: theme.colors.black,
  tabsBorder: "1px solid #eeee",
  places: {
    linkColor: theme.colors.black,
    linkHoverColor: "#94D500",
    textColor: "#656565",
    mapLinkColor: "#656565"
  },
  news: {
    linkColor: theme.colors.black,
    linkHoverColor: "#94D500",
    dateColor: theme.colors.black,
    textColor: "#656565"
  }
}; //GoogleSearch

var googleSearch = {
  backgroundColor: theme.colors.white,
  brandingTextNameColor: theme.colors.black,
  brandingTextColor: "#999999",
  searchButtonBgColor: theme.colors.white,
  searchButtonSvgFill: "#94d60a",
  selectOptionBorder: "1px solid black",
  selectOptionColor: theme.colors.black,
  selectOptionBgColor: "transparent",
  selectLabelColor: theme.colors.black,
  linkColor: theme.colors.black,
  linkHoverColor: "#94d60a",
  pageNumberColor: "#999999",
  currentPageColor: theme.colors.black,
  gscResultInfo: "#676767",
  gscResultVisibleUrl: "#999999",
  gsSnippet: "#444444",
  gcscBrandingClickable: "transparent",
  findMoreMagnifier: theme.colors.black,
  optionMenuBgColor: theme.colors.white,
  optionMenuBorder: "none",
  gscOptionMenuBgColor: theme.colors.black,
  gscOptionMenuColor: theme.colors.white,
  gscMenuItemColor: theme.colors.black,
  gscActiveMenuItemHoverBgColor: theme.colors.black,
  gscActiveMenuItemHoverColor: theme.colors.white,
  gscMenuItemHoverBgColor: "#f1f1f1",
  gscMenuItemHoverColor: theme.colors.black
};
/*
-- Others
*/
//GoUpButton

var goToTopButton = {
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  boxShadow: "0 3px 6px #00000029",
  iconColor: theme.colors.white
}; //Loadings

var loadings = {
  mainBgColor: "#dddddd",
  bgColor: theme.colors.white,
  cardBgColor: theme.colors.white,
  cardBorderColor: theme.colors.black,
  lightBorderColor: "#dddddd",
  maskBgColor: theme.colors.white,
  iconColor: "#bdbdbd",
  iconContainerBgColor: "#e0e0e0",

  /*
  -- Molecules
  */
  //Cards
  bgImageNewsCard: {
    maskBgColor: theme.colors.white,
    contentContainerBgColor: theme.colors.white
  },
  agendaCard: {
    miniSliderColor: "#f6f7f8"
  },
  agendaFeaturedCard: {
    dateContainerBgColor: "#f6f7f8",
    borderColor: "#f6f7f8"
  },

  /*
  -- Journal
  */
  //JournalCards
  journalCards: {
    personCard: {
      bgColor: "#f5f5f5"
    }
  },
  //JournalDetails
  journalDetails: {
    maskBgColor: theme.colors.white,
    socialMediaIconsColor: "#eee"
  },
  //JournalHighLights
  journalHighlights: {
    backgroundColor: theme.colors.white,
    horizontalNewsCard: {
      bgColor: "#f9f9f9",
      maskColor: "#f9f9f9"
    }
  },
  //JournalListing
  journalListing: {
    mediumDevices: {
      loadingMaskBgColor: "#fafafa"
    }
  },
  //JournalNavigation
  journalNavigation: {
    iconColor: "#9e9e9e"
  }
}; //React Slick Slider

var reactSlickSlider = {
  buttonBgColor: theme.colors.grey
};
var theme$1 = _objectSpread2({}, theme, {
  viewsColors: viewsColors,
  highContrast: highContrast,
  globalStyle: globalStyle,
  loadings: loadings,
  containers: {
    accessibilitySelector: accessibilitySelector
  },
  components: {
    //Atoms
    animatedBackground: animatedBackground,
    aspectRatio: aspectRatio,
    button: button,
    icon: icon,
    input: input,
    line: line,
    link: link,
    picture: picture,
    pagination: pagination,
    scrollMore: scrollMore,
    text: text,
    title: title,
    triangle: triangle,
    //Molecules
    accessibleAccordion: accessibleAccordion,
    accordion: accordion,
    breadcrumbs: breadcrumbs,
    agendaCard: agendaCard,
    agendaFeatured: agendaFeatured,
    backgroundImageNewsCard: backgroundImageNewsCard,
    borderedCard: borderedCard,
    candidatureCard: candidatureCard,
    colorExtractCard: colorExtractCard,
    columnsCard: columnsCard,
    eventCard: eventCard,
    horizontalNewsCard: horizontalNewsCard,
    imageCard: imageCard,
    layeredCard: layeredCard,
    miniHorizontalNewsCard: miniHorizontalNewsCard,
    newsCard: newsCard,
    personCard: personCard,
    shareSocialMedia: shareSocialMedia,
    showMoreCard: showMoreCard,
    studentCard: studentCard,
    studentCardLink: studentCardLink,
    iconCard: iconCard,
    carousel: carousel,
    customArrow: customArrow,
    datePicker: datePicker,
    dropDown: dropDown,
    dropdownList: dropdownList,
    injectHtml: injectHtml,
    instituteSearch: instituteSearch,
    listItem: listItem,
    plusButton: plusButton,
    reactCalendar: reactCalendar,
    scrollableTabs: scrollableTabs,
    section: section,
    sectionHeader: sectionHeader,
    select: select,
    tab: tab,
    tabContent: tabContent,
    table: table,
    generalAccordion: generalAccordion,
    //Organisms
    about: about,
    agenda: agenda,
    article: article,
    campos: campos,
    candidature: candidature,
    cards: cards,
    contentList: contentList,
    simpleList: simpleList,
    contents: contents,
    courses: courses,
    curricular: curricular,
    curricularPlan: curricularPlan,
    curricularUnit: curricularUnit,
    departments: departments,
    directory: directory,
    edicts: edicts,
    events: events,
    oneFact: oneFact,
    files: files,
    gallery: gallery,
    footer: footer,
    header: header,
    information: information,
    xperimenta: xperimenta,
    // - Journal
    journalCards: journalCards,
    journalColumns: journalColumns,
    journalDetails: journalDetails,
    journalDossiers: journalDossiers,
    journalFooter: journalFooter,
    journalHighlights: journalHighlights,
    journalListing: journalListing,
    journalMoreNews: journalMoreNews,
    journalNavigation: journalNavigation,
    journalNews: journalNews,
    journalRelated: journalRelated,
    journalSlides: journalSlides,
    lastUpdate: lastUpdate,
    loading: loading,
    mobileNavBar: mobileNavBar,
    mobilePublicNavBar: mobilePublicNavBar,
    news: news,
    errorHandler: errorHandler,
    numbers: numbers,
    peopleArticle: peopleArticle,
    presentation: presentation,
    profile: profile,
    services: services,
    streaming: streaming,
    projects: projects,
    publicNavbar: publicNavbar,
    sideNav: sideNav,
    siteMap: siteMap,
    // - SubWebs
    subWebContacts: subWebContacts,
    subWebDepartment: subWebDepartment,
    subWebDepartmentCourses: subWebDepartmentCourses,
    subWebEvents: subWebEvents,
    subWebCourses: subWebCourses,
    subWebNavigation: subWebNavigation,
    subWebPeople: subWebPeople,
    subWebWarnings: subWebWarnings,
    subWebSchedule: subWebSchedule,
    webNavBar: webNavBar,
    tables: tables,
    //Templates
    globalSearch: globalSearch,
    googleSearch: googleSearch,
    //Others
    goToTopButton: goToTopButton,
    reactSlickSlider: reactSlickSlider
  }
});

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  transition: width 0.2s;\n  height: ", ";\n  background-color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  width: ", "px;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var Line = styled.div(_templateObject$b(), function (props) {
  return props.height;
}, function (props) {
  return props.color;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.isHover ? props.theme.components.line.width + props.theme.components.line.widthDifference : props.theme.components.line.width - props.theme.components.line.widthDifference;
});
var defaults$7 = {
  width: theme$1.components.line.width + "px",
  height: theme$1.components.line.height + "px",
  color: theme$1.components.line.color,
  marginTop: theme$1.components.line.marginTop + "px",
  marginBottom: "0",
  isHover: false
};
var props = {
  width: PropTypes$1.string,
  height: PropTypes$1.string,
  color: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  marginBottom: PropTypes$1.string,
  children: PropTypes$1.node,
  isHover: PropTypes$1.bool
};
Line.defaultProps = defaults$7;
Line.propTypes = props;

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  .rc-pagination {\n    font-size: 12px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    padding: 0;\n  }\n  .rc-pagination > li {\n    list-style: none;\n  }\n  .rc-pagination-total-text {\n    float: left;\n    height: 30px;\n    line-height: 30px;\n    list-style: none;\n    padding: 0;\n    margin: 0 8px 0 0;\n  }\n  .rc-pagination:after {\n    content: \" \";\n    display: block;\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n  .rc-pagination-item {\n    cursor: pointer;\n    min-width: 16px;\n    height: 28px;\n    line-height: 28px;\n    text-align: center;\n    list-style: none;\n    float: left;\n    background-color: ", ";\n    margin-right: 8px;\n  }\n  .rc-pagination-item a {\n    text-decoration: none;\n    color: ", ";\n    font-size: 0.75rem;\n  }\n  .rc-pagination-item:hover {\n    color: ", ";\n  }\n  .rc-pagination-item:hover a {\n    color: ", ";\n  }\n  .rc-pagination-item-disabled {\n    cursor: not-allowed;\n  }\n  .rc-pagination-item-disabled:hover {\n    color: ", ";\n  }\n  .rc-pagination-item-disabled:hover a {\n    color: ", ";\n  }\n  .rc-pagination-item-active {\n    color: ", ";\n  }\n  .rc-pagination-item-active a {\n    color: ", ";\n  }\n  .rc-pagination-item-active:hover a {\n    color: ", ";\n  }\n  .rc-pagination-jump-prev:after,\n  .rc-pagination-jump-next:after {\n    content: \"\u2022\u2022\u2022\";\n    display: block;\n    letter-spacing: 2px;\n    color: ", ";\n    font-size: 12px;\n    margin-top: 1px;\n  }\n  .rc-pagination-jump-prev:hover:after,\n  .rc-pagination-jump-next:hover:after {\n    color: ", ";\n  }\n  .rc-pagination-jump-prev:hover:after {\n    content: \"\xAB\";\n  }\n  .rc-pagination-jump-next:hover:after {\n    content: \"\xBB\";\n  }\n  .rc-pagination-jump-prev-custom-icon,\n  .rc-pagination-jump-next-custom-icon {\n    position: relative;\n  }\n  .rc-pagination-jump-prev-custom-icon:after,\n  .rc-pagination-jump-next-custom-icon:after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    transition: all 0.2s;\n    content: \"\u2022\u2022\u2022\";\n    opacity: 1;\n    display: block;\n    letter-spacing: 2px;\n    color: ", ";\n    font-size: 12px;\n    margin-top: 1px;\n  }\n  .rc-pagination-jump-prev-custom-icon .custom-icon-jump-prev,\n  .rc-pagination-jump-next-custom-icon .custom-icon-jump-prev,\n  .rc-pagination-jump-prev-custom-icon .custom-icon-jump-next,\n  .rc-pagination-jump-next-custom-icon .custom-icon-jump-next {\n    opacity: 0;\n    transition: all 0.2s;\n  }\n  .rc-pagination-jump-prev-custom-icon:hover:after,\n  .rc-pagination-jump-next-custom-icon:hover:after {\n    opacity: 0;\n    color: ", ";\n  }\n  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-prev,\n  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-prev,\n  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-next,\n  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-next {\n    opacity: 1;\n    color: ", ";\n  }\n  .rc-pagination-prev,\n  .rc-pagination-jump-prev,\n  .rc-pagination-jump-next {\n    margin-right: 8px;\n  }\n  .rc-pagination-prev,\n  .rc-pagination-next,\n  .rc-pagination-jump-prev,\n  .rc-pagination-jump-next {\n    cursor: pointer;\n    color: ", ";\n    font-size: 10px;\n    list-style: none;\n    min-width: 28px;\n    height: 28px;\n    line-height: 28px;\n    float: left;\n    text-align: center;\n  }\n  .rc-pagination-prev a:after {\n    content: \"\u2039\";\n    display: block;\n  }\n  .rc-pagination-next a:after {\n    content: \"\u203A\";\n    display: block;\n  }\n  .rc-pagination-prev,\n  .rc-pagination-next {\n    font-size: 18px;\n  }\n  .rc-pagination-prev a,\n  .rc-pagination-next a {\n    color: ", ";\n  }\n  .rc-pagination-prev a:after,\n  .rc-pagination-next a:after {\n    margin-top: -1px;\n  }\n  .rc-pagination-disabled {\n    cursor: not-allowed;\n  }\n  .rc-pagination-disabled a {\n    color: ", ";\n  }\n  .rc-pagination-options {\n    float: left;\n    margin-left: 15px;\n  }\n  .rc-pagination-options-size-changer {\n    float: left;\n    width: 80px;\n  }\n  .rc-pagination-options-quick-jumper {\n    float: left;\n    margin-left: 16px;\n    height: 28px;\n    line-height: 28px;\n  }\n  .rc-pagination-options-quick-jumper input {\n    margin: 0 8px;\n    box-sizing: border-box;\n    background-color: ", ";\n    outline: none;\n    padding: 3px 12px;\n    width: 50px;\n    height: 28px;\n  }\n  .rc-pagination-options-quick-jumper input:hover {\n    color: ", ";\n  }\n  .rc-pagination-options-quick-jumper button {\n    display: inline-block;\n    margin: 0 8px;\n    font-weight: 500;\n    text-align: center;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    white-space: nowrap;\n    padding: 0 15px;\n    font-size: 12px;\n    height: 28px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    position: relative;\n    color: ", ";\n    background-color: ", ";\n  }\n  .rc-pagination-options-quick-jumper button:hover,\n  .rc-pagination-options-quick-jumper button:active,\n  .rc-pagination-options-quick-jumper button:focus {\n    color: ", ";\n    background-color: ", ";\n  }\n  .rc-pagination-simple .rc-pagination-prev,\n  .rc-pagination-simple .rc-pagination-next {\n    border: none;\n    height: 24px;\n    line-height: 24px;\n    margin: 0;\n    font-size: 18px;\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager {\n    float: left;\n    margin-right: 8px;\n    list-style: none;\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager .rc-pagination-slash {\n    margin: 0 10px;\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager input {\n    margin: 0 8px;\n    box-sizing: border-box;\n    background-color: ", ";\n    outline: none;\n    padding: 5px 8px;\n    min-height: 20px;\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager input:hover {\n    color: ", ";\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager button {\n    display: inline-block;\n    margin: 0 8px;\n    font-weight: 500;\n    text-align: center;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    white-space: nowrap;\n    padding: 0 8px;\n    font-size: 12px;\n    height: 26px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    position: relative;\n    color: ", ";\n    background-color: ", ";\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager button:hover,\n  .rc-pagination-simple .rc-pagination-simple-pager button:active,\n  .rc-pagination-simple .rc-pagination-simple-pager button:focus {\n    color: ", ";\n    background-color: ", ";\n  }\n  @media only screen and (max-width: 1024px) {\n    .rc-pagination-item-after-jump-prev,\n    .rc-pagination-item-before-jump-next {\n      display: none;\n    }\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    .rc-pagination-item a {\n      font-size: 15px;\n    }\n\n    .rc-pagination-jump-prev:after,\n    .rc-pagination-jump-next:after {\n      font-size: 14px;\n    }\n\n    .rc-pagination-prev,\n    .rc-pagination-next {\n      font-size: 22px;\n    }\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var PaginationWithStyles = styled(Pagination)(_templateObject$c(), function (props) {
  return props.theme.components.pagination.backgroundColor;
}, function (props) {
  return props.theme.components.pagination.linkColor;
}, function (props) {
  return props.theme.highContrast.linkHover || props.mainColor || props.theme.components.pagination.linkHoverColor;
}, function (props) {
  return props.theme.highContrast.linkHover || props.mainColor || props.theme.components.pagination.linkHoverColor;
}, function (props) {
  return props.theme.components.pagination.disabledHover;
}, function (props) {
  return props.theme.components.pagination.disabledHover;
}, function (props) {
  return props.theme.highContrast.text || props.mainColor || props.theme.components.pagination.linkActive;
}, function (props) {
  return props.theme.highContrast.text || props.mainColor || props.theme.components.pagination.linkActive;
}, function (props) {
  return props.theme.highContrast.text || props.mainColor || props.theme.components.pagination.linkActive;
}, function (props) {
  return props.theme.components.pagination.jumpNextColor;
}, function (props) {
  return props.theme.highContrast.action || props.mainColor || props.theme.components.pagination.jumpNextHoverColor;
}, function (props) {
  return props.theme.components.pagination.jumpNextColor;
}, function (props) {
  return props.theme.components.pagination.jumpNextColor;
}, function (props) {
  return props.theme.highContrast.action || props.mainColor || props.theme.components.pagination.jumpNextHoverColor;
}, function (props) {
  return props.theme.components.pagination.jumpPrevColor;
}, function (props) {
  return props.theme.components.pagination.jumpPrevColor;
}, function (props) {
  return props.theme.components.pagination.disabledLinkColor;
}, function (props) {
  return props.theme.components.pagination.quickJumperInputBgColor;
}, function (props) {
  return props.theme.highContrast.action || props.mainColor || props.theme.components.pagination.quickJumperInputHoverColor;
}, function (props) {
  return props.theme.components.pagination.quickJumperButtonColor;
}, function (props) {
  return props.theme.components.pagination.quickJumperButtonBgColor;
}, function (props) {
  return props.theme.highContrast.action || props.mainColor || props.theme.components.pagination.quickJumperButtonHAFColor;
}, function (props) {
  return props.theme.components.pagination.quickJumperButtonHAFBgColor;
}, function (props) {
  return props.theme.components.pagination.simplePagerInputBgColor;
}, function (props) {
  return props.theme.highContrast.action || props.mainColor || props.theme.components.pagination.simplePagerInputHoverColor;
}, function (props) {
  return props.theme.components.pagination.simplePagerButtonColor;
}, function (props) {
  return props.theme.components.pagination.simplePagerButtonBgColor;
}, function (props) {
  return props.theme.highContrast.action || props.mainColor || props.theme.components.pagination.simplePagerButtonHAFColor;
}, function (props) {
  return props.theme.components.pagination.simplePagerButtonHAFBgColor;
});
var types$a = {
  mainColor: PropTypes$1.string
};
PaginationWithStyles.propTypes = types$a;

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  cursor: ", ";\n  line-height: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n  display: ", ";\n  font-family: ", ";\n  word-break: ", ";\n  text-transform: ", ";\n  position: ", ";\n  :first-letter {\n    text-transform: ", ";\n  }\n\n  :focus {\n    outline: 2px solid inherit;\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    color: ", ";\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    font-size: ", ";\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    font-size: ", ";\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

function Title(_ref) {
  var className = _ref.className,
      text = _ref.text,
      children = _ref.children,
      tag = _ref.tag,
      tabIndex = _ref.tabIndex;

  switch (tag) {
    case "h1":
      return /*#__PURE__*/React.createElement("h1", {
        tabIndex: tabIndex,
        className: className
      }, children || text);

    case "h3":
      return /*#__PURE__*/React.createElement("h3", {
        tabIndex: tabIndex,
        className: className
      }, children || text);

    default:
      return /*#__PURE__*/React.createElement("h2", {
        tabIndex: tabIndex,
        className: className
      }, children || text);
  }
}

Title.defaultProps = {
  tag: "h2"
};
Title.propTypes = {
  tag: PropTypes$1.string,
  text: PropTypes$1.string,
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  tabIndex: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
};
var TitleWithStyles = styled(Title)(_templateObject$d(), function (props) {
  return props.fontSize || "28px";
}, function (props) {
  return props.color || "#000";
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.lineHeight || "1.4";
}, function (props) {
  return props.fontStyle || "normal";
}, function (props) {
  return props.fontWeight || "500";
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.display;
}, function (props) {
  return props.alternativeStyle ? props.theme.type.serif : props.fontFamily;
}, function (props) {
  return props["break"];
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.position;
}, function (props) {
  return props.firstLetter;
}, function (props) {
  return props.mobileMdColor;
}, function (props) {
  return props.mobileSmFontSize;
}, function (props) {
  return props.mobileXsFontSize;
});
var types$b = {
  fontSize: PropTypes$1.string,
  color: PropTypes$1.string,
  lineHeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  fontWeight: PropTypes$1.string,
  marginBottom: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  marginTop: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  fontStyle: PropTypes$1.string,
  text: PropTypes$1.string,
  fontFamily: PropTypes$1.string,
  mobileSmFontSize: PropTypes$1.string,
  mobileXsFontSize: PropTypes$1.string,
  alternativeStyle: PropTypes$1.bool,
  mobileMdColor: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaults$8 = {
  fontFamily: theme$1.components.title.fontFamily,
  alternativeStyle: false
};
TitleWithStyles.propTypes = types$b;
TitleWithStyles.defaultProps = defaults$8;

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  position: ", ";\n  bottom: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n  button {\n    background-color: transparent;\n    height: 100%;\n    width: 100%;\n    border: none;\n    cursor: pointer;\n    i {\n      -webkit-animation: bouncey 1.6s linear infinite;\n      animation: bouncey 1.6s linear infinite;\n    }\n  }\n\n  @keyframes bouncey {\n    0% {\n      transform: translateY(0);\n      -webkit-transform: translateY(0);\n      -moz-transform: translateY(0);\n    }\n    50% {\n      transform: translateY(4px);\n      -webkit-transform: translateY(4px);\n      -moz-transform: translateY(4px);\n    }\n    100% {\n      transform: translateY(0);\n      -webkit-transform: translateY(0);\n      -moz-transform: translateY(0);\n    }\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var ScrollMore = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: className
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    "aria-label": "Sroll para baixo"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.chevron_down,
    size: "medium",
    color: theme.components.scrollMore.iconColor
  })));
});
ScrollMore.displayName = "ScrollMore";
var ScrollMoreWithStyles = styled(ScrollMore)(_templateObject$e(), function (props) {
  return props.height;
}, function (props) {
  return props.position;
}, function (props) {
  return props.bottom;
});
var types$c = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  onClick: PropTypes$1.func,
  height: PropTypes$1.string,
  position: PropTypes$1.string,
  bottom: PropTypes$1.string
};
var defaults$9 = {
  height: "50px",
  position: "relative",
  bottom: "initial"
};
ScrollMoreWithStyles.propTypes = types$c;
ScrollMoreWithStyles.defaultProps = defaults$9;
var ScrollMore$1 = withTheme(ScrollMoreWithStyles); //Only used for the Storybook Props Table

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: ", ";\n  color: ", ";\n  ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  text-decoration: ", ";\n  background: ", ";\n  transform: ", ";\n  text-transform: ", ";\n  margin: ", ";\n  padding: ", ";\n  padding-bottom: ", ";\n  cursor: ", ";\n  position: ", ";\n  right: ", ";\n  padding-right: ", ";\n  border: ", ";\n  border-right: ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n  display: ", ";\n  height: ", ";\n  width: ", ";\n  text-decoration-color: ", ";\n  -webkit-text-decoration-color: ", ";\n  ", ";\n  ", ";\n\n  &:focus {\n    ", ";\n    outline-offset: ", ";\n  }\n\n  //Alt styles\n  img {\n    color: #000;\n    font-weight: 300;\n  }\n\n  ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  /*\n  -- Responsive\n  */\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 992px) {\n    margin-bottom: ", ";\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    font-size: ", ";\n    padding: ", ";\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var sizing$2 = {
  xSmall: "\n    font-size: ".concat(theme.sizes.xs, "; //12px\n  "),
  small: "\n    font-size: ".concat(theme.sizes.s, "; //14px\n  "),
  article: "\n    font-size: ".concat(theme.sizes.sm, ";; //15px\n  "),
  mediumSmall: "\n    font-size: ".concat(theme.sizes.m, "; //16px\n  "),
  medium: "\n    font-size: ".concat(theme.sizes.l, "; //18px\n  "),
  large: "\n    font-size: ".concat(theme.sizes.xl2, "; //22px\n  "),
  xLarge: "\n    font-size: ".concat(theme.sizes.xl3m, "; //28px\n  "),
  xxLarge: "\n    font-size: ".concat(theme.sizes.xl4, "; //32px\n  "),
  xxxLarge: "\n    font-size: ".concat(theme.sizes.xl6, "; //48px\n  ")
};
var sharedStyle = css(_templateObject$f(), function (props) {
  return props.disabled ? "none" : "auto";
}, function (props) {
  return props.color || props.theme.components.link.color;
}, function (props) {
  return props.fontSize ? "font-size: ".concat(props.fontSize) : sizing$2[props.size || "small"];
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight || "400";
}, function (props) {
  return props.textDecoration || "none";
}, function (props) {
  return props.background;
}, function (props) {
  return props.transform;
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.paddingBottom;
}, function (props) {
  return props.cursor || "pointer";
}, function (props) {
  return props.position;
}, function (props) {
  return props.right;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.border;
}, function (props) {
  return props.borderRight;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.display;
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return props.textDecorationColor;
}, function (props) {
  return props.textDecorationColor;
}, function (props) {
  return props.uppercase && "text-transform: uppercase";
}, function (props) {
  return props.opacity && "opacity: 0.8";
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.outlineOffset;
}, function (props) {
  return props.hasHover ? "&:hover {\n    text-decoration: ".concat(props.fontDecoration, ";\n    color: ").concat(props["default"] ? props.textDecorationColor : lighten(0.1, props.color || props.theme.components.link.color), ";\n    ").concat(props.lighten && "opacity: 0.5;", ";\n    text-decoration-color: ").concat(props.textDecorationColor, ";\n    -webkit-text-decoration-color: ").concat(props.textDecorationColor, ";\n    /*\n    -- Icon Styles when hover a link\n    */\n    ").concat(props.hasIconHover && "\n      i,\n      p {\n        ".concat(props.darken ? "color: ".concat(darken(0.5, props.color || props.theme.components.link.color)) : "color: ".concat(lighten(0.5, props.color || props.theme.components.link.color)), ";\n      }\n    "), ";\n  }") : "";
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.mdMarginBottom;
}, function (props) {
  return props.mobileSmFontSize;
}, function (props) {
  return props.mobileSmPadding;
}, function (props) {
  return props.mobileXsFontSize;
}, function (props) {
  return props.mobileXsLineHeight;
});
var NativeLink = styled.a.attrs(function (_ref) {
  var text = _ref.text,
      children = _ref.children;
  return {
    children: text || children
  };
})(_templateObject2(), sharedStyle);

var Link = function Link(_ref2) {
  var opacity = _ref2.opacity,
      _native = _ref2["native"],
      href = _ref2.href,
      rest = _objectWithoutProperties(_ref2, ["opacity", "native", "href"]);

  return /*#__PURE__*/React.createElement(NativeLink, _extends({
    href: href
  }, rest));
};

Link.defaultProps = {
  fontDecoration: "underline",
  size: "small",
  uppercase: false,
  lighten: false,
  opacity: false,
  disabled: false,
  "native": false,
  hasHover: true,
  hasIconHover: true
};
Link.propTypes = {
  href: PropTypes$1.string,
  "native": PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  color: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  size: PropTypes$1.string,
  lineHeight: PropTypes$1.string,
  fontWeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  textDecoration: PropTypes$1.string,
  background: PropTypes$1.string,
  transform: PropTypes$1.string,
  textTransform: PropTypes$1.string,
  margin: PropTypes$1.string,
  padding: PropTypes$1.string,
  //paddingBottom: PropTypes.string,
  cursor: PropTypes$1.string,
  position: PropTypes$1.string,
  right: PropTypes$1.string,
  //paddingRight: PropTypes.string,
  //borderRight: PropTypes.string,
  marginBottom: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  display: PropTypes$1.string,
  height: PropTypes$1.string,
  width: PropTypes$1.string,
  textDecorationColor: PropTypes$1.string,
  uppercase: PropTypes$1.bool,
  opacity: PropTypes$1.bool,
  outlineOffset: PropTypes$1.string,
  //hasHover: PropTypes.bool,
  //fontDecoration: PropTypes.string,
  "default": PropTypes$1.bool,
  hasIconHover: PropTypes$1.bool,
  //darken: PropTypes.bool,
  lighten: PropTypes$1.bool,
  hoverColor: PropTypes$1.string,
  mdMarginBottom: PropTypes$1.string,
  mobileSmFontSize: PropTypes$1.string,
  mobileSmPadding: PropTypes$1.string,
  mobileXsFontSize: PropTypes$1.string,
  mobileXsLineHeight: PropTypes$1.string
};

var useMousePosition = function useMousePosition() {
  var _useState = useState({
    x: 0,
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      mouse = _useState2[0],
      setMouse = _useState2[1];

  var onMouse = function onMouse(_ref) {
    var pageX = _ref.pageX,
        pageY = _ref.pageY;
    setMouse({
      x: pageX,
      y: pageY
    });
  };

  useEffect(function () {
    window.addEventListener("mousemove", onMouse);
    return function () {
      window.removeEventListener("mousemove", onMouse);
    };
  });
  return mouse;
};

var IntlContext = createContext({}); // turn the old context into the new context

var InjectIntlContext = injectIntl(function (_ref) {
  var intl = _ref.intl,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(IntlContext.Provider, {
    value: intl
  }, children);
});

var useFormatMessage = function useFormatMessage() {
  var intl = useContext(IntlContext);
  return intl.formatMessage;
};

var ConfigContext = React.createContext({});
var useConfig = function useConfig() {
  return useContext(ConfigContext);
};
var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children,
      config = _ref.config,
      components = _ref.components,
      hooks = _ref.hooks;

  var initialState = _objectSpread2({}, config, {}, components, {}, hooks);

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 1),
      state = _useState2[0];

  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: _objectSpread2({}, state)
  }, children);
};
ConfigProvider.defaultProps = {
  config: {
    imageAPI: "https://api-assets.dev.ua.pt/v1",
    portalWWW: "https://www.dev.ua.pt",
    portalAPI: "https://api-portal.dev.ua.pt/api/v1"
  },
  components: {
    link: Link,
    formattedMessage: FormattedMessage,
    isIE: function isIE() {
      return false;
    }
  },
  hooks: {
    useIntl: useFormatMessage
  }
};
ConfigProvider.propTypes = {
  children: PropTypes$1.node.isRequired,
  components: PropTypes$1.shape({
    link: PropTypes$1.any,
    formattedMessage: PropTypes$1.any,
    isIE: PropTypes$1.func
  }),
  hooks: PropTypes$1.shape({
    useIntl: PropTypes$1.any
  }),
  config: PropTypes$1.shape({
    imageAPI: PropTypes$1.string,
    portalWWW: PropTypes$1.string,
    portalAPI: PropTypes$1.string
  }).isRequired
};

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  height: ", ";\n  color: ", ";\n  picture {\n    display: flex;\n    align-items: flex-start;\n    height: 100%;\n    width: ", ";\n    max-width: ", ";\n  }\n  img {\n    object-fit: ", ";\n    object-position: ", ";\n    width: ", ";\n    max-width: ", ";\n    max-height: ", ";\n    height: ", ";\n  }\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    img {\n      height: ", ";\n    }\n  }\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    img {\n      height: ", ";\n    }\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var breakpoints = {
  names: ["xs", "sm", "md", "lg"],
  mediaQueries: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200
  },
  sizes: {
    lg: {
      xs: 768,
      sm: 992,
      md: 1200,
      lg: 1920
    },
    md: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    },
    sm: {
      xs: 432,
      sm: 576,
      md: 768,
      lg: 992
    },
    xs: {
      xs: 324,
      sm: 432,
      md: 576,
      lg: 768
    }
  }
};

function isEmpty(str) {
  return !str || 0 === str.length;
}

function Picture(_ref) {
  var src = _ref.src,
      className = _ref.className,
      alt = _ref.alt,
      size = _ref.size,
      useHeight = _ref.useHeight,
      absoluteSize = _ref.absoluteSize,
      onCatchError = _ref.onCatchError,
      hasResize = _ref.hasResize,
      props = _objectWithoutProperties(_ref, ["src", "className", "alt", "size", "useHeight", "absoluteSize", "onCatchError", "hasResize"]);

  var _useConfig = useConfig(),
      imageAPI = _useConfig.imageAPI,
      portalWWW = _useConfig.portalWWW;

  var sizes = breakpoints.sizes;

  var onHandleSrc = function onHandleSrc(size) {
    var param = useHeight ? "height" : "width";

    if (!isEmpty(src)) {
      if (!hasResize) return src;

      if (src.includes("http")) {
        return "".concat(imageAPI, "/image/resizer?imageUrl=").concat(encodeURIComponent(src), "&").concat(param, "=").concat(size);
      } else {
        return "".concat(imageAPI, "/image/resizer?imageUrl=").concat(portalWWW, "/").concat(encodeURIComponent(src), "&").concat(param, "=").concat(size);
      }
    }
  }; // When the absoluteSize prop is defined it uses that size for the image query


  var isAbsolute = useMemo(function () {
    return !!absoluteSize;
  }, [absoluteSize]);
  var defaultSrc = useMemo(function () {
    if (!isAbsolute) return onHandleSrc(sizes[size].lg);
    return onHandleSrc(absoluteSize);
  }, [isAbsolute, src]);
  var pictureProps = {
    height: props.height,
    onClick: props.onClick
  };

  var onError = function onError(e) {
    e.target.style.display = "none";
    onCatchError(e);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("picture", null, !isAbsolute && breakpoints.names.map(function (breakpoint) {
    return /*#__PURE__*/React.createElement("source", _extends({
      key: breakpoint,
      media: "(max-width: ".concat(breakpoints.mediaQueries[breakpoint], "px)"),
      srcSet: onHandleSrc(sizes[size][breakpoint])
    }, pictureProps));
  }), /*#__PURE__*/React.createElement(LazyLoadImage, _extends({
    src: defaultSrc,
    alt: alt,
    onError: onError,
    width: "100%"
  }, pictureProps))));
}

Picture.defaultProps = {
  backgroundColor: "transparent",
  backgroundSize: "fill",
  imagePosition: "center",
  size: "md",
  useHeight: false,
  absoluteSize: null,
  onCatchError: function onCatchError() {
    return null;
  },
  hasResize: true
};
Picture.propTypes = {
  src: PropTypes$1.string.isRequired,
  alt: PropTypes$1.string,
  imagePosition: PropTypes$1.string,
  size: PropTypes$1.oneOf(["xs", "sm", "md", "lg"]),
  useHeight: PropTypes$1.bool,
  absoluteSize: PropTypes$1.string,
  height: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  onClick: PropTypes$1.func,
  className: PropTypes$1.string,
  onCatchError: PropTypes$1.func,
  hasResize: PropTypes$1.bool
};
var PictureWithStyles = styled(Picture)(_templateObject$g(), function (props) {
  return props.hasImageBgColor && "\n  background: ".concat(props.theme.highContrast.lightBackgroundColor || props.backgroundColor || props.theme.components.picture.backgroundColor, ";\n\n  ");
}, function (props) {
  return props.height;
}, function (props) {
  return props.theme.components.picture.color;
}, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.backgroundSize || "cover";
}, function (props) {
  return props.imagePosition;
}, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.maxHeight;
}, function (props) {
  return props.height;
}, function (props) {
  return props.smHeight;
}, function (props) {
  return props.xsHeight;
});
PictureWithStyles.defaultProps = {
  hasImageBgColor: true
};

var PictureContainer = function PictureContainer(props) {
  var _useConfig2 = useConfig(),
      isIE = _useConfig2.isIE;

  return /*#__PURE__*/React.createElement(PictureWithStyles, _extends({
    isIE: isIE
  }, props));
};

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ";\n\n  border: ", ";\n  border-radius: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-right: ", ";\n\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  padding: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-right: ", ";\n  padding-left: ", ";\n\n  color: ", ";\n  text-align: ", ";\n  transform: ", ";\n\n  display: ", ";\n  justify-content: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  flex-grow: ", ";\n\n  width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  z-index: ", ";\n  cursor: ", ";\n\n  position: ", ";\n  top: ", ";\n  right: ", ";\n  bottom: ", ";\n  left: ", ";\n\n  overflow: ", ";\n  overflow-x: ", ";\n\n  float: ", ";\n  clear: ", ";\n\n  ", ";\n\n  ", "\n\n  ", "\n\n  :last-child {\n    border-bottom: ", ";\n  }\n\n  ", ";\n\n  // Large devices (desktops, less than 1200px)\n  @media (max-width: 1199px) {\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n    margin-left: ", ";\n\n    padding-top: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n\n    border-top: ", ";\n    border-bottom: ", ";\n\n    display: ", ";\n    width: ", ";\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    height: ", ";\n    background-color: ", ";\n    display: ", ";\n    top: ", ";\n    width: ", ";\n\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n    margin-left: ", ";\n\n    padding: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n\n    border-bottom: ", ";\n    border-top: ", ";\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    height: ", ";\n    width: ", ";\n    top: ", ";\n\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n    margin-left: ", ";\n\n    padding: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: ", ";\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    display: ", ";\n\n    margin: ", ";\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-left: ", ";\n    margin-bottom: ", ";\n\n    padding: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n\n    border-bottom: ", ";\n    border-top: ", ";\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var ContentContainer = styled.div(_templateObject$h(), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.boxShadow;
}, function (props) {
  return props.border;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.borderTop;
}, function (props) {
  return props.borderBottom;
}, function (props) {
  return props.borderLeft;
}, function (props) {
  return props.borderRight;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginRight;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.marginLeft;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.paddingTop;
}, function (props) {
  return props.paddingBottom;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.color;
}, function (props) {
  return props.textAlign;
}, function (props) {
  return props.transform;
}, function (props) {
  return props.display;
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.flexDirection;
}, function (props) {
  return props.alignItems;
}, function (props) {
  return props.flexGrow;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.minHeight;
}, function (props) {
  return props.maxHeight;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.position;
}, function (props) {
  return props.top;
}, function (props) {
  return props.right;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.left;
}, function (props) {
  return props.overflow;
}, function (props) {
  return props.overflowX;
}, function (props) {
  return props["float"];
}, function (props) {
  return props.clear;
}, function (props) {
  return props.verticalAlign ? "display: flex; align-items: center;" : null;
}, function (props) {
  return props.hasLink && "&:hover {\n    ".concat(props.lighten && "opacity: 0.5;", ";\n    ").concat(props.pointer && "cursor: pointer;", ";\n  }");
}, function (props) {
  return props.behavior === "button" && "&:hover {\n    cursor: pointer;\n    background-color: ".concat(darken(0.1, props.backgroundColor), ";\n  }");
}, function (props) {
  return props.lastChildBorderBottom;
}, function (props) {
  return props.underlineWithAnimation && "&:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: ".concat(props.active ? "100%" : "0", ";\n      height: 3px;\n      background-color: ").concat(props.active ? props.underlineAnimationColor || "#000" : "transparent", ";\n      transition: width 0.4s ease;\n      -webkit-transition: width 0.4s ease;\n      bottom: 0px;\n    }\n    &:hover {\n      &:after {\n        background-color: ").concat(props.underlineAnimationColor || "#000", ";\n        width: 100%;\n      }\n    }");
}, function (props) {
  return props.lgMargintop;
}, function (props) {
  return props.mobileLgMarginRight;
}, function (props) {
  return props.lgMarginBottom;
}, function (props) {
  return props.mobileLgMarginLeft;
}, function (props) {
  return props.mobileLgPaddingTop;
}, function (props) {
  return props.mobileLgPaddingRight;
}, function (props) {
  return props.mobileLgPaddingBottom;
}, function (props) {
  return props.mobileLgPaddingLeft;
}, function (props) {
  return props.mobileLgBorderTop;
}, function (props) {
  return props.mobileLgBorderBottom;
}, function (props) {
  return props.mobileXlDisplay;
}, function (props) {
  return props.mobileXlWidth;
}, function (props) {
  return props.mdHeight;
}, function (props) {
  return props.mobileMdBgColor;
}, function (props) {
  return props.mobileMdDisplay;
}, function (props) {
  return props.mobileMdTop;
}, function (props) {
  return props.mobileMdWidth;
}, function (props) {
  return props.mdMargintop;
}, function (props) {
  return props.mobileMdMarginRight;
}, function (props) {
  return props.mdMarginBottom;
}, function (props) {
  return props.mobileMdMarginLeft;
}, function (props) {
  return props.mdPadding;
}, function (props) {
  return props.mobileMdPaddingTop;
}, function (props) {
  return props.mobileMdPaddingBottom;
}, function (props) {
  return props.mobileMdPaddingLeft;
}, function (props) {
  return props.mobileMdPaddingRight;
}, function (props) {
  return props.mobileMdBorderBottom;
}, function (props) {
  return props.mobileMdBorderTop;
}, function (props) {
  return props.smHeight;
}, function (props) {
  return props.mobileSmWidth;
}, function (props) {
  return props.smTop;
}, function (props) {
  return props.smMargintop;
}, function (props) {
  return props.mobileSmMarginRight;
}, function (props) {
  return props.smMarginbottom;
}, function (props) {
  return props.mobileSmMarginLeft;
}, function (props) {
  return props.mobileSmPadding;
}, function (props) {
  return props.mobileSmPaddingLeft;
}, function (props) {
  return props.mobileSmPaddingRight;
}, function (props) {
  return props.mobileSmPaddingTop;
}, function (props) {
  return props.mobileXsWidth;
}, function (props) {
  return props.mobileXsHeight;
}, function (props) {
  return props.xsTop;
}, function (props) {
  return props.mobileXsDisplay;
}, function (props) {
  return props.mobileXsMargin;
}, function (props) {
  return props.mobileXsMarginTop;
}, function (props) {
  return props.mobileXsMarginRight;
}, function (props) {
  return props.mobileXsMarginLeft;
}, function (props) {
  return props.mobileXsMarginBottom;
}, function (props) {
  return props.mobileXsPadding;
}, function (props) {
  return props.mobileXsPaddingTop;
}, function (props) {
  return props.mobileXsPaddingBottom;
}, function (props) {
  return props.mobileXsPaddingLeft;
}, function (props) {
  return props.mobileXsPaddingRight;
}, function (props) {
  return props.mobileXsBorderBottom;
}, function (props) {
  return props.mobileXsBorderTop;
});
var types$d = {
  children: PropTypes$1.node,
  backgroundColor: PropTypes$1.string,
  boxShadow: PropTypes$1.string,
  border: PropTypes$1.string,
  borderRadius: PropTypes$1.string,
  borderTop: PropTypes$1.string,
  borderBottom: PropTypes$1.string,
  borderLeft: PropTypes$1.string,
  borderRight: PropTypes$1.string,
  margin: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  marginRight: PropTypes$1.string,
  marginBottom: PropTypes$1.string,
  marginLeft: PropTypes$1.string,
  padding: PropTypes$1.string,
  paddingTop: PropTypes$1.string,
  paddingBottom: PropTypes$1.string,
  paddingRight: PropTypes$1.string,
  paddingLeft: PropTypes$1.string,
  color: PropTypes$1.string,
  textAlign: PropTypes$1.string,
  transform: PropTypes$1.string,
  display: PropTypes$1.string,
  justifyContent: PropTypes$1.string,
  flexDirection: PropTypes$1.string,
  alignItems: PropTypes$1.string,
  flexGrow: PropTypes$1.string,
  width: PropTypes$1.string,
  height: PropTypes$1.string,
  minHeight: PropTypes$1.string,
  maxHeight: PropTypes$1.string,
  zIndex: PropTypes$1.string,
  cursor: PropTypes$1.string,
  position: PropTypes$1.string,
  top: PropTypes$1.string,
  right: PropTypes$1.string,
  bottom: PropTypes$1.string,
  left: PropTypes$1.string,
  overflow: PropTypes$1.string,
  overflowX: PropTypes$1.string,
  "float": PropTypes$1.string,
  clear: PropTypes$1.string,
  underlineWithAnimation: PropTypes$1.bool,
  lgMargintop: PropTypes$1.string,
  mobileLgMarginRight: PropTypes$1.string,
  lgMarginBottom: PropTypes$1.string,
  mobileLgMarginLeft: PropTypes$1.string,
  mobileLgPaddingTop: PropTypes$1.string,
  mobileLgPaddingRight: PropTypes$1.string,
  mobileLgPaddingBottom: PropTypes$1.string,
  mobileLgPaddingLeft: PropTypes$1.string,
  mobileLgBorderTop: PropTypes$1.string,
  mobileLgBorderBottom: PropTypes$1.string,
  mobileXlDisplay: PropTypes$1.string,
  mobileXlWidth: PropTypes$1.string,
  mdHeight: PropTypes$1.string,
  mobileMdBgColor: PropTypes$1.string,
  mobileMdDisplay: PropTypes$1.string,
  mobileMdTop: PropTypes$1.string,
  mobileMdWidth: PropTypes$1.string,
  mdMargintop: PropTypes$1.string,
  mobileMdMarginRight: PropTypes$1.string,
  mdMarginBottom: PropTypes$1.string,
  mobileMdMarginLeft: PropTypes$1.string,
  mdPadding: PropTypes$1.string,
  mobileMdPaddingTop: PropTypes$1.string,
  mobileMdPaddingBottom: PropTypes$1.string,
  mobileMdPaddingLeft: PropTypes$1.string,
  mobileMdPaddingRight: PropTypes$1.string,
  mobileMdBorderBottom: PropTypes$1.string,
  mobileMdBorderTop: PropTypes$1.string,
  smHeight: PropTypes$1.string,
  mobileSmWidth: PropTypes$1.string,
  smTop: PropTypes$1.string,
  smMargintop: PropTypes$1.string,
  mobileSmMarginRight: PropTypes$1.string,
  smMarginbottom: PropTypes$1.string,
  mobileSmMarginLeft: PropTypes$1.string,
  mobileSmPaddingLeft: PropTypes$1.string,
  mobileSmPaddingRight: PropTypes$1.string,
  mobileSmPaddingTop: PropTypes$1.string,
  mobileXsWidth: PropTypes$1.string,
  mobileXsHeight: PropTypes$1.string,
  xsTop: PropTypes$1.string,
  mobileXsDisplay: PropTypes$1.string,
  mobileXsMargin: PropTypes$1.string,
  mobileXsMarginTop: PropTypes$1.string,
  mobileXsMarginRight: PropTypes$1.string,
  mobileXsMarginLeft: PropTypes$1.string,
  mobileXsMarginBottom: PropTypes$1.string,
  mobileXsPadding: PropTypes$1.string,
  mobileXsPaddingTop: PropTypes$1.string,
  mobileXsPaddingBottom: PropTypes$1.string,
  mobileXsBorderBottom: PropTypes$1.string,
  mobileXsBorderTop: PropTypes$1.string
};
var defaults$a = {
  hasLink: false
};
ContentContainer.propTypes = types$d;
ContentContainer.defaultProps = defaults$a;

function ClickAwayListener(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      as = _ref.as,
      props = _objectWithoutProperties(_ref, ["children", "onChange", "as"]);

  var wrapperRef = useRef(null);
  var Element = as || "div";

  var handleClickOutside = function handleClickOutside(e) {
    if (wrapperRef && !wrapperRef.current.contains(e.target)) {
      onChange();
    }
  };

  useEffect(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
  return /*#__PURE__*/React.createElement(Element, _extends({
    ref: wrapperRef
  }, props), children);
}

ClickAwayListener.propTypes = {
  children: PropTypes$1.node.isRequired,
  onChange: PropTypes$1.func.isRequired,
  as: PropTypes$1.string
};

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: ", ";\n  left: ", ";\n\n  li {\n    display: ", ";\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    text-align: ", ";\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var HorizontalList = styled.ul(_templateObject$i(), function (props) {
  return props.position;
}, function (props) {
  return props.left;
}, function (props) {
  return props.display;
}, function (props) {
  return props.xsTextAlign;
});
var types$e = {
  display: PropTypes$1.string,
  xsTextAlign: PropTypes$1.string,
  position: PropTypes$1.string,
  left: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaults$b = {
  display: "inline"
};
HorizontalList.propTypes = types$e;
HorizontalList.defaultProps = defaults$b;

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  li {\n    line-height: ", ";\n    list-style-type: ", ";\n\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    &:last-child {\n      margin-bottom: ", ";\n    }\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var VerticalList = styled.ul(_templateObject$j(), function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.listStyleType;
}, function (props) {
  return props.listPaddingTop;
}, function (props) {
  return props.listPaddingBottom;
}, function (props) {
  return props.marginBottom;
});
var defaults$c = {
  marginTop: "0",
  marginBottom: "0",
  lineHeight: "normal",
  listStyleType: "none"
};
var types$f = {
  marginTop: PropTypes$1.string,
  marginBottom: PropTypes$1.string,
  lineHeight: PropTypes$1.string,
  listPaddingTop: PropTypes$1.string,
  listPaddingBottom: PropTypes$1.string,
  children: PropTypes$1.node
};
VerticalList.defaultProps = defaults$c;
VerticalList.propTypes = types$f;

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  line-height: ", ";\n  height: ", ";\n  vertical-align: ", ";\n\n  ", ";\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var ListItem = styled.li(_templateObject$k(), function (props) {
  return props.width;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.marginRight;
}, function (props) {
  return props.marginLeft;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingTop;
}, function (props) {
  return props.paddingBottom;
}, function (props) {
  return props.borderTop;
}, function (props) {
  return props.borderBottom;
}, function (props) {
  return props.borderRight;
}, function (props) {
  return props.borderLeft;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.height;
}, function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.separationLine ? "\n    border-right: 1px solid ".concat(props.lineColor || props.theme.components.listItem.lineColor, ";\n    padding: ").concat(props.padding || "0 12px 0 12px", ";\n    &:last-child{\n      padding-right: 0;\n      border-right: none;\n    }\n    &:first-child{\n      padding-left: 0;\n    }\n    ") : null;
});
var types$g = {
  width: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  marginBottom: PropTypes$1.string,
  marginRight: PropTypes$1.string,
  marginLeft: PropTypes$1.string,
  paddingRight: PropTypes$1.string,
  paddingLeft: PropTypes$1.string,
  paddingTop: PropTypes$1.string,
  paddingBottom: PropTypes$1.string,
  borderTop: PropTypes$1.string,
  borderBottom: PropTypes$1.string,
  borderRight: PropTypes$1.string,
  borderLeft: PropTypes$1.string,
  lineHeight: PropTypes$1.string,
  height: PropTypes$1.string,
  verticalAlign: PropTypes$1.string,
  separationLine: PropTypes$1.bool,
  lineColor: PropTypes$1.string,
  padding: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaults$d = {
  separationLine: false,
  lineColor: theme$1.components.listItem.lineColor,
  padding: "0 12px 0 12px"
};
ListItem.propTypes = types$g;
ListItem.defaultProps = defaults$d;

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  //highContrast only border\n  border-top: ", ";\n\n  min-height: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  background-color: ", ";\n  position: ", ";\n  width: ", ";\n  bottom: ", ";\n  border-top: ", ";\n\n  ", ";\n\n  // Large devices (desktops, less than 1200px)\n  @media (max-width: 1199px) {\n    border-top: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    border-top: ", ";\n    padding-bottom: ", ";\n    padding-top: ", ";\n    margin-top: ", ";\n\n    min-height: ", ";\n  }\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var Section = styled.section(_templateObject$l(), function (props) {
  return props.hasHighContrastBorderTop && props.theme.highContrast.border;
}, function (props) {
  return props.height;
}, function (props) {
  return props.paddingTop || props.theme.components.section.paddingTop;
}, function (props) {
  return props.hasBottomSpacing ? props.paddingBottom || props.theme.components.section.paddingBottom : 0;
}, function (props) {
  return props.backgroundColor || props.theme.components.section.backgroundColor;
}, function (props) {
  return props.position;
}, function (props) {
  return props.width;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.borderTop;
}, function (props) {
  return props.verticalAlign ? "display: flex; align-items: center;" : null;
}, function (props) {
  return props.lgBorderTop;
}, function (props) {
  return props.lgPaddingTop;
}, function (props) {
  return props.lgPaddingBottom;
}, function (props) {
  return props.mdBorderTop;
}, function (props) {
  return props.mdPaddingBottom;
}, function (props) {
  return props.mdPaddingTop;
}, function (props) {
  return props.mdMarginTop;
}, function (props) {
  return props.mdHeight;
}, function (props) {
  return props.smPaddingTop;
}, function (props) {
  return props.smPaddingBottom;
});
var types$h = {
  children: PropTypes$1.node,
  hasHighContrastBorderTop: PropTypes$1.bool,
  height: PropTypes$1.string,
  paddingTop: PropTypes$1.string,
  hasBottomSpacing: PropTypes$1.bool,
  paddingBottom: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  position: PropTypes$1.string,
  width: PropTypes$1.string,
  bottom: PropTypes$1.string,
  borderTop: PropTypes$1.string,
  verticalAlign: PropTypes$1.bool,
  lgBorderTop: PropTypes$1.string,
  lgPaddingTop: PropTypes$1.string,
  lgPaddingBottom: PropTypes$1.string,
  mdBorderTop: PropTypes$1.string,
  mdPaddingBottom: PropTypes$1.string,
  mdPaddingTop: PropTypes$1.string,
  mdMarginTop: PropTypes$1.string,
  mdHeight: PropTypes$1.string,
  smPaddingTop: PropTypes$1.string,
  smPaddingBottom: PropTypes$1.string
};
var defaults$e = {
  hasHighContrastBorderTop: true,
  hasBottomSpacing: true,
  verticalAlign: false
};
Section.propTypes = types$h;
Section.defaultProps = defaults$e;

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  min-width: ", ";\n  height: ", ";\n  width: ", ";\n  background-image: url(", ");\n  background-color: ", ";\n  background-size: ", ";\n  -webkit-background-size: ", ";\n  -moz-background-size: ", ";\n  -o-background-size: ", ";\n  background-position: ", ";\n  background-repeat: ", ";\n  background-attachment: ", ";\n  overflow: ", ";\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    height: ", ";\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var ImageContainer = styled.div(_templateObject$m(), function (props) {
  return props.minWidth || "";
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return props.url === "" ? "" : props.url;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.backgroundSize;
}, function (props) {
  return props.backgroundSize;
}, function (props) {
  return props.backgroundSize;
}, function (props) {
  return props.backgroundSize;
}, function (props) {
  return props.backgroundPosition;
}, function (props) {
  return props.backgroundRepeat;
}, function (props) {
  return props.backgroundAttachment;
}, function (props) {
  return props.overflow;
}, function (props) {
  return props.mdHeight;
});
var types$i = {
  width: PropTypes$1.string,
  height: PropTypes$1.string,
  url: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  backgroundSize: PropTypes$1.string,
  backgroundPosition: PropTypes$1.string,
  backgroundRepeat: PropTypes$1.string,
  backgroundAttachment: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaults$f = {
  height: "auto",
  width: "auto",
  url: "",
  backgroundColor: theme$1.components.picture.backgroundColor,
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "initial"
};
ImageContainer.propTypes = types$i;
ImageContainer.defaultProps = defaults$f;

var Portal = function Portal(_ref) {
  var children = _ref.children;
  var el = document.createElement("div");
  var portalRoot = document.getElementById("portal");
  useEffect(function () {
    portalRoot.appendChild(el);
    return function () {
      return portalRoot.removeChild(el);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);
  return ReactDOM.createPortal(children, el);
};

Portal.propTypes = {
  children: PropTypes$1.node.isRequired
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  position: absolute;\n  z-index: 9999;\n  font-size: ", ";\n  top: ", "px;\n  left: ", "px;\n  transform: translateY(-110%);\n  padding: ", ";\n  font-weight: ", ";\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  color: #000;\n  font-size: ", ";\n  text-decoration: ", ";\n  };\n  &:hover {\n    text-decoration-color: inherit;\n  }\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var Link$1 = styled.a(_templateObject$n(), function (props) {
  return props.theme.sizes.s;
}, function (props) {
  return props.textDecoration || "none";
});
var HelperStyled = styled.div(_templateObject2$1(), function (props) {
  return lighten(0.34, props.activeColor);
}, function (props) {
  return props.theme.sizes.xs;
}, function (props) {
  return props.mouseY;
}, function (props) {
  return props.mouseX;
}, function (props) {
  return props.theme.spacing.xs3;
}, function (props) {
  return props.theme.weight.light;
});

var Helper = function Helper(_ref) {
  var children = _ref.children,
      activeColor = _ref.activeColor;

  var _useMousePosition = useMousePosition(),
      mouseX = _useMousePosition.x,
      mouseY = _useMousePosition.y;

  return /*#__PURE__*/React.createElement(HelperStyled, {
    style: {
      top: mouseY,
      left: mouseX
    },
    activeColor: activeColor
  }, children);
};

Helper.propTypes = {
  children: PropTypes$1.node.isRequired,
  activeColor: PropTypes$1.string
};

var LinkExternal = function LinkExternal(_ref2) {
  var href = _ref2.href,
      children = _ref2.children,
      activeColor = _ref2.activeColor,
      hasPop = _ref2.hasPop;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHover = _useState2[0],
      setHover = _useState2[1];

  var cleanUrl = useMemo(function () {
    return href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  }, [href]);
  return /*#__PURE__*/React.createElement(Link$1, {
    href: href,
    target: "_blank",
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    className: "link-external",
    rel: "noopener",
    "native": true
  }, children, hasPop && isHover && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Helper, {
    activeColor: activeColor
  }, cleanUrl)));
};

LinkExternal.defaultProps = {
  href: "#",
  hasPop: true
};
LinkExternal.propTypes = {
  href: PropTypes$1.string.isRequired,
  children: PropTypes$1.node.isRequired,
  activeColor: PropTypes$1.string,
  hasPop: PropTypes$1.bool
};

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  cursor: pointer;\n  border-bottom: 1px solid\n    ", ";\n  &:focus {\n    ", ";\n  }\n  &:first-child {\n    border-top: 1px solid\n      ", ";\n  }\n\n  .agenda-card-right {\n    padding-right: 15px;\n    .bottom-content {\n      margin-top: 15px;\n    }\n  }\n\n  //Agenda Card Animation\n  .agenda-card-left {\n    position: relative;\n    z-index: 0;\n    text-align: center;\n    margin-right: 30px;\n    min-width: 93px;\n\n    .arrow-container {\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding: 4px;\n    }\n\n    button {\n      background-color: transparent;\n      border: none;\n      &:focus {\n        ", ";\n      }\n      &:hover {\n        cursor: pointer;\n      }\n      i {\n        height: 24px;\n        width: 16px;\n        line-height: 24px;\n      }\n    }\n\n    .no-slider {\n      padding: 10px 0;\n    }\n\n    //Text date, overflow, slide\n    .text {\n      max-width: 45px;\n      overflow: hidden;\n\n      .text-slider {\n        display: flex;\n        padding: 10px 0;\n        //Start center container\n        transform: translateX(-45px);\n        transition: all 0.4s;\n      }\n\n      .initial-date,\n      .today,\n      .end-date {\n        display: inline-block;\n        min-width: 45px;\n      }\n    }\n\n    &:after {\n      content: \"\";\n      -webkit-transition: all 0.2s;\n      -moz-transition: all 0.2s;\n      -o-transition: all 0.2s;\n      transition: all 0.2s;\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 0;\n      height: 100%;\n      background-color: ", ";\n      z-index: -1;\n    }\n\n    &:hover {\n      .arrow-button {\n        background-color: ", ";\n      }\n    }\n  }\n\n  /*\n  -- Arrows states for opacity feedback\n  */\n\n  .slide-is-right {\n    .fa-chevron-right {\n      opacity: 0.5;\n    }\n    .fa-chevron-left {\n      opacity: 1;\n    }\n  }\n\n  .slide-is-left {\n    .fa-chevron-left {\n      opacity: 0.5;\n    }\n    .fa-chevron-right {\n      opacity: 1;\n    }\n  }\n\n  /*\n  -- Agenda white block animation when hover all card for content\n  */\n  &:hover {\n    .agenda-card-left {\n      &:after {\n        width: 100%;\n      }\n      p {\n        color: ", ";\n      }\n    }\n    i {\n      color: ", ";\n    }\n    button {\n      &:focus {\n        ", ";\n      }\n    }\n  }\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var AgendaCard = function AgendaCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      category = _ref.category,
      title = _ref.title,
      text = _ref.text,
      date = _ref.date,
      href = _ref.href,
      target = _ref.target,
      categoryColor = _ref.categoryColor,
      titleColor = _ref.titleColor,
      textColor = _ref.textColor,
      dateColor = _ref.dateColor,
      iconColor = _ref.iconColor,
      hasDateSlider = _ref.hasDateSlider,
      hasText = _ref.hasText,
      theme = _ref.theme,
      agendaCardRef = _ref.agendaCardRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSlideRight = _useState2[0],
      setSlideRight = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSlideLeft = _useState4[0],
      setSlideLeft = _useState4[1];

  var agendaCardLeft = useRef(null);
  var sliderContainer = useRef(null);

  var slideRight = function slideRight(e) {
    e.preventDefault();

    if (isSlideLeft) {
      sliderContainer.current.style.transform = "translateX(-45px)";
      setSlideRight(true);
      setSlideLeft(false);
      agendaCardLeft.current.classList.remove("slide-is-right");
      agendaCardLeft.current.classList.remove("slide-is-left");
    } else {
      sliderContainer.current.style.transform = "translateX(-90px)";
      setSlideRight(true);
      setSlideLeft(false);
      agendaCardLeft.current.classList.add("slide-is-right");
      agendaCardLeft.current.classList.remove("slide-is-left");
    }
  };

  var slideLeft = function slideLeft(e) {
    e.preventDefault();

    if (isSlideRight) {
      sliderContainer.current.style.transform = "translateX(-45px)";
      setSlideLeft(true);
      setSlideRight(false);
      agendaCardLeft.current.classList.remove("slide-is-right");
      agendaCardLeft.current.classList.remove("slide-is-left");
    } else {
      sliderContainer.current.style.transform = "translateX(0)";
      setSlideLeft(true);
      setSlideRight(false);
      agendaCardLeft.current.classList.add("slide-is-left");
      agendaCardLeft.current.classList.remove("slide-is-right");
    }
  };

  return /*#__PURE__*/React.createElement("a", {
    className: className,
    href: href,
    target: target,
    ref: agendaCardRef,
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    ref: agendaCardLeft,
    className: "agenda-card-left"
  }, hasDateSlider ? /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "arrow-container"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: slideLeft,
    "aria-label": "Ir para a data inicial"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "fa-chevron-left",
    name: theme.icons.chevron_left,
    color: iconColor || theme.components.agendaCard.iconColor
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderContainer,
    className: "text-slider"
  }, children))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "arrow-container"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: slideRight,
    "aria-label": "Ir para a data final"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "fa-chevron-right",
    name: theme.icons.chevron_right,
    color: iconColor || theme.components.agendaCard.iconColor
  }))))) : /*#__PURE__*/React.createElement(Fragment, null, children))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "agenda-card-right"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "article",
    text: category,
    color: categoryColor || theme.components.agendaCard.categoryColor,
    fontWeight: "300"
  }), /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    text: title || theme.components.agendaCard.titleColor,
    size: "article",
    fontWeight: "400",
    color: titleColor,
    marginBottom: "0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bottom-content"
  }, hasText && /*#__PURE__*/React.createElement(Text, {
    text: text,
    color: textColor || theme.components.agendaCard.textColor,
    size: "article",
    fontWeight: "300"
  }), /*#__PURE__*/React.createElement(Text, {
    textTransform: "lowercase",
    text: date,
    color: dateColor || theme.components.agendaCard.dateColor,
    size: "xSmall",
    fontWeight: "300"
  }))))));
};

AgendaCard.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  text: PropTypes$1.string,
  date: PropTypes$1.string,
  href: PropTypes$1.string,
  target: PropTypes$1.string,
  categoryColor: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  textColor: PropTypes$1.string,
  dateColor: PropTypes$1.string,
  iconColor: PropTypes$1.string,
  hasDateSlider: PropTypes$1.bool,
  hasText: PropTypes$1.bool,
  theme: PropTypes$1.object
};
AgendaCard.defaultProps = {
  category: "Categoria",
  title: "Título",
  text: "Texto",
  date: "Data",
  target: "_blank",
  hasText: true
};
var AgendaCardWithStyles = styled(AgendaCard)(_templateObject$o(), function (props) {
  return props.borderColor || props.theme.components.agendaCard.borderColor;
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.borderColor || props.theme.components.agendaCard.borderColor;
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.squareColorHover || props.theme.components.agendaCard.squareColorHover;
}, function (props) {
  return props.squareColorHover || props.theme.components.agendaCard.squareColorHover;
}, function (props) {
  return props.textColorHover || props.theme.components.agendaCard.textColorHover;
}, function (props) {
  return props.iconColorHover || props.theme.components.agendaCard.iconColorHover;
}, function (props) {
  return props.theme.mixins.focus;
});
var AgendaCard$1 = withTheme(AgendaCardWithStyles); //Only used for the Storybook Props Table

var WithProps = function WithProps(props) {
  return /*#__PURE__*/React.createElement(AgendaCardWithStyles, props);
};
WithProps.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  text: PropTypes$1.string,
  date: PropTypes$1.string,
  href: PropTypes$1.string,
  target: PropTypes$1.string,
  categoryColor: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  textColor: PropTypes$1.string,
  dateColor: PropTypes$1.string,
  iconColor: PropTypes$1.string,
  hasDateSlider: PropTypes$1.bool,
  hasText: PropTypes$1.bool,
  theme: PropTypes$1.object,
  borderColor: PropTypes$1.string,
  squareColorHover: PropTypes$1.string,
  textColorHover: PropTypes$1.string,
  iconColorHover: PropTypes$1.string
};
WithProps.defaultProps = {
  category: "Categoria",
  title: "Título",
  text: "Texto",
  date: "Data",
  target: "_blank",
  hasText: true
};

var Mask = function Mask(_ref) {
  var backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, ["backgroundColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: backgroundColor || props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

Mask.propTypes = {
  backgroundColor: PropTypes$1.string
};

var Loading = function Loading(_ref2) {
  var borderBottom = _ref2.borderBottom,
      props = _objectWithoutProperties(_ref2, ["borderBottom"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "139px",
    borderTop: "1px solid ".concat(props.theme.loadings.cardBorderColor),
    padding: "20px 0",
    borderBottom: borderBottom
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    padding: "10px 0",
    width: "93px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "24px",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "16px",
    width: "8px",
    backgroundColor: props.theme.loadings.agendaCard.miniSliderColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "15px",
    width: "30px",
    backgroundColor: props.theme.loadings.agendaCard.miniSliderColor
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    height: "15px",
    width: "30px",
    backgroundColor: props.theme.loadings.agendaCard.miniSliderColor,
    marginTop: "5px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "24px",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "16px",
    width: "8px",
    backgroundColor: props.theme.loadings.agendaCard.miniSliderColor
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "97px"
  }, /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "15px",
    right: "0",
    width: "50%"
  })), /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "6px",
    top: "15px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "15px",
    top: "21px",
    right: "0",
    width: "40%"
  })), /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "25px",
    top: "36px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "15px",
    top: "61px",
    right: "0",
    width: "50%"
  })), /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "6px",
    top: "76px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask, _extends({}, props, {
    height: "15px",
    top: "82px",
    right: "0",
    width: "60%"
  }))))));
};

Loading.propTypes = {
  borderBottom: PropTypes$1.string
};
var AgendaCardLoading = withTheme(Loading);

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  transform: rotate(45deg);\n  display: flex;\n  align-items: center;\n  border-right: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  cursor: ", ";\n  i,\n  p {\n    margin: auto;\n    font-size: ", ";\n    transform: rotate(-45deg);\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  width: ", ";\n  height: ", ";\n  display: flex;\n  align-items: ", ";\n  justify-content: ", ";\n  z-index: ", ";\n  position: ", ";\n  top: ", ";\n  right: ", ";\n  bottom: ", ";\n  left: ", ";\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    width: ", ";\n  }\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var PlusButton = function PlusButton(_ref) {
  var onClick = _ref.onClick,
      href = _ref.href,
      size = _ref.size,
      backgroundColor = _ref.backgroundColor,
      borderRight = _ref.borderRight,
      borderTop = _ref.borderTop,
      borderBottom = _ref.borderBottom,
      cursor = _ref.cursor,
      target = _ref.target,
      alt = _ref.alt,
      as = _ref.as,
      props = _objectWithoutProperties(_ref, ["onClick", "href", "size", "backgroundColor", "borderRight", "borderTop", "borderBottom", "cursor", "target", "alt", "as"]);

  var hrefLink = useMemo(function () {
    return href ? {
      href: href
    } : {};
  }, [href]);
  var rel = useMemo(function () {
    return target === "_blank" ? {
      rel: "noopener"
    } : {};
  }, [target]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    tabIndex: -1
  }, props, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Triangle$1, _extends({
    className: "plus-button-triangle",
    as: as,
    alt: alt,
    target: target,
    tabIndex: 0,
    size: size,
    backgroundColor: backgroundColor,
    borderRight: borderRight,
    borderTop: borderTop,
    borderBottom: borderBottom,
    cursor: cursor
  }, hrefLink, rel, props), props.children));
};

var Wrapper = styled.div(_templateObject$p(), function (props) {
  return props.marginLeft;
}, function (props) {
  return props.size;
}, function (props) {
  return props.height;
}, function (props) {
  return props.alignItems;
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.position;
}, function (props) {
  return props.top;
}, function (props) {
  return props.right;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.left;
}, function (props) {
  return props.XsSize;
});
var Triangle$1 = styled.span(_templateObject2$2(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderRight;
}, function (props) {
  return props.borderTop;
}, function (props) {
  return props.borderBottom;
}, function (props) {
  return props.borderLeft;
}, function (props) {
  return props.cursor || "pointer";
}, function (props) {
  return props.fontSize;
});
PlusButton.propTypes = {
  marginLeft: PropTypes$1.string,
  size: PropTypes$1.string,
  height: PropTypes$1.string,
  alignItems: PropTypes$1.string,
  zIndex: PropTypes$1.string,
  position: PropTypes$1.string,
  top: PropTypes$1.string,
  right: PropTypes$1.string,
  bottom: PropTypes$1.string,
  left: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  borderBottom: PropTypes$1.string,
  borderRight: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  children: PropTypes$1.node,
  href: PropTypes$1.string,
  as: PropTypes$1.string,
  borderTop: PropTypes$1.string,
  target: PropTypes$1.string,
  alt: PropTypes$1.string,
  cursor: PropTypes$1.string,
  onClick: PropTypes$1.bool
};
PlusButton.defaultProps = {
  alignItems: "center",
  position: "absolute",
  backgroundColor: theme$1.components.plusButton.backgroundColor,
  borderBottom: "none",
  borderRight: "none",
  children: null,
  href: null
};

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  margin-top: ", ";\n  &:focus {\n    ", ";\n  }\n  .date-container {\n    height: 120px;\n    width: 120px;\n    text-align: center;\n    background-color: ", ";\n    position: relative;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    border: 1px solid\n      ", ";\n    border-right: none;\n\n    .date-content-container {\n      z-index: 1;\n    }\n\n    &:before {\n      content: \"\";\n      -webkit-transition: all 0.2s;\n      -moz-transition: all 0.2s;\n      -o-transition: all 0.2s;\n      transition: all 0.2s;\n      position: absolute;\n      left: 0;\n      width: 0;\n      height: 100%;\n      background-color: ", ";\n      z-index: 0;\n    }\n  }\n\n  &:hover {\n    .date-container {\n      p {\n        color: ", ";\n      }\n      :before {\n        width: 100%;\n      }\n      a {\n        background-color: ", ";\n      }\n      .plus-button-triangle {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .content-container {\n    border: 1px solid\n      ", ";\n    padding: 30px;\n    .title {\n      margin: 10px 0;\n    }\n  }\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

var AgendaFeatured = function AgendaFeatured(_ref) {
  var className = _ref.className,
      dateContainerTextColor = _ref.dateContainerTextColor,
      dateContainerDay = _ref.dateContainerDay,
      dateContainerMonth = _ref.dateContainerMonth,
      buttonBgColor = _ref.buttonBgColor,
      buttonTextColor = _ref.buttonTextColor,
      text = _ref.text,
      textColor = _ref.textColor,
      title = _ref.title,
      titleColor = _ref.titleColor,
      date = _ref.date,
      dateColor = _ref.dateColor,
      href = _ref.href,
      target = _ref.target,
      theme = _ref.theme,
      dateContainerMonthAriaLabel = _ref.dateContainerMonthAriaLabel;
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    tabIndex: 0,
    href: href,
    target: target
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-content-container"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "56px",
    text: dateContainerDay,
    color: dateContainerTextColor || theme.components.agendaFeatured.dateContainerTextColor,
    fontWeight: "900",
    lineHeight: "1"
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: "30px",
    text: dateContainerMonth,
    "aria-label": dateContainerMonthAriaLabel,
    color: dateContainerTextColor || theme.components.agendaFeatured.dateContainerTextColor,
    fontWeight: "300",
    textTransform: "uppercase",
    lineHeight: "1"
  }), /*#__PURE__*/React.createElement(PlusButton, {
    backgroundColor: buttonBgColor || theme.components.agendaFeatured.buttonBgColor,
    size: "30px",
    right: "-16px",
    top: "calc(50% - 15px)",
    zIndex: "2",
    "aria-hidden": "true",
    tabIndex: -1,
    as: "div"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "24px",
    fontWeight: "100",
    color: buttonTextColor || theme.components.agendaFeatured.buttonTextColor,
    lineHeight: "1",
    text: theme.icons.plus
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(Text, {
    color: textColor || theme.components.agendaFeatured.textColor,
    fontWeight: "300",
    text: text,
    size: "article"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "large",
    text: title,
    color: titleColor || theme.components.agendaFeatured.titleColor,
    fontWeight: "500",
    lineHeight: "1.3"
  })), /*#__PURE__*/React.createElement(Text, {
    textTransform: "lowercase",
    color: dateColor || theme.components.agendaFeatured.dateColor,
    text: date,
    fontSize: "13px"
  })))));
};

AgendaFeatured.propTypes = {
  className: PropTypes$1.string,
  dateContainerTextColor: PropTypes$1.string,
  dateContainerDay: PropTypes$1.string,
  dateContainerMonth: PropTypes$1.string,
  buttonBgColor: PropTypes$1.string,
  buttonTextColor: PropTypes$1.string,
  text: PropTypes$1.string,
  textColor: PropTypes$1.string,
  title: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  date: PropTypes$1.string,
  dateColor: PropTypes$1.string,
  href: PropTypes$1.string,
  target: PropTypes$1.string,
  theme: PropTypes$1.object,
  dateContainerMonthAriaLabel: PropTypes$1.string
};
AgendaFeatured.defaultProps = {
  dateContainerDay: "00",
  dateContainerMonth: "MMM",
  text: "Texto",
  title: "Título",
  date: "data",
  target: "_blank"
};
var AgendaFeaturedWithStyles = styled(AgendaFeatured)(_templateObject$q(), function (props) {
  return props.marginTop;
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.dateContainerBgColor || props.theme.components.agendaFeatured.dateContainerBgColor;
}, function (props) {
  return props.dateContainerBgColor || props.theme.components.agendaFeatured.dateContainerBgColor;
}, function (props) {
  return props.animationBgColor || props.theme.components.agendaFeatured.animationBgColor;
}, function (props) {
  return props.textColorHover || props.theme.components.agendaFeatured.textColorHover;
}, function (props) {
  return props.animationBgColor || props.theme.components.agendaFeatured.animationBgColor;
}, function (props) {
  return props.plusButtonHoverBgColor || props.theme.components.agendaFeatured.plusButtonHoverBgColor;
}, function (props) {
  return props.borderColor || props.theme.components.agendaFeatured.borderColor;
});
var AgendaFeatured$1 = withTheme(AgendaFeaturedWithStyles); //Only used for the Storybook Props Table

var WithProps$1 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(AgendaFeaturedWithStyles, props);
};
WithProps$1.propTypes = {
  className: PropTypes$1.string,
  dateContainerTextColor: PropTypes$1.string,
  dateContainerDay: PropTypes$1.string,
  dateContainerMonth: PropTypes$1.string,
  buttonBgColor: PropTypes$1.string,
  buttonTextColor: PropTypes$1.string,
  text: PropTypes$1.string,
  textColor: PropTypes$1.string,
  title: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  date: PropTypes$1.string,
  dateColor: PropTypes$1.string,
  href: PropTypes$1.string,
  target: PropTypes$1.string,
  theme: PropTypes$1.object,
  dateContainerMonthAriaLabel: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  dateContainerBgColor: PropTypes$1.string,
  animationBgColor: PropTypes$1.string,
  textColorHover: PropTypes$1.string,
  plusButtonHoverBgColor: PropTypes$1.string,
  borderColor: PropTypes$1.string
};
WithProps$1.defaultProps = {
  dateContainerDay: "00",
  dateContainerMonth: "MMM",
  text: "Texto",
  title: "Título",
  date: "data",
  target: "_blank"
};

var Mask$1 = function Mask(_ref) {
  var backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, ["backgroundColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: backgroundColor || props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

Mask$1.propTypes = {
  backgroundColor: PropTypes$1.string
};

var Loading$1 = function Loading(_ref2) {
  var mdMarginBottom = _ref2.mdMarginBottom,
      props = _objectWithoutProperties(_ref2, ["mdMarginBottom"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    mdMarginBottom: mdMarginBottom
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "120px",
    height: "120px",
    backgroundColor: props.theme.loadings.agendaFeaturedCard.dateContainerBgColor,
    position: "relative",
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "30px",
    width: "30px",
    transform: "rotate(45deg)",
    backgroundColor: props.backgroundColor,
    position: "absolute",
    right: "-16px",
    zIndex: "2"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    border: "1px solid ".concat(props.theme.loadings.agendaFeaturedCard.borderColor),
    padding: "30px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "100px"
  }, /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "15px",
    right: "0",
    width: "40%"
  })), /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "10px",
    top: "15px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "22px",
    top: "25px",
    right: "0",
    width: "20%"
  })), /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "6px",
    top: "47px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "22px",
    top: "53px",
    right: "0",
    width: "30%"
  })), /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "10px",
    top: "75px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$1, _extends({}, props, {
    height: "15px",
    top: "85px",
    right: "0",
    width: "60%"
  })))))));
};

Loading$1.propTypes = {
  backgroundColor: PropTypes$1.string,
  mdMarginBottom: PropTypes$1.string
};
var AgendaFeaturedLoading = withTheme(Loading$1);

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n  height: 360px;\n  text-decoration: none;\n  display: block;\n  position: relative;\n  overflow: hidden;\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    border: none;\n    &:hover {\n      i {\n        color: ", ";\n      }\n    }\n  }\n  &:focus {\n    ", ";\n  }\n  .content-container {\n    position: absolute;\n    bottom: 20px;\n    left: 20px;\n    right: 20px;\n    height: auto;\n    background-color: ", ";\n    padding: 20px;\n  }\n\n  //Image Animation\n  img {\n    -webkit-transition: all 0.4s;\n    -moz-transition: all 0.4s;\n    -o-transition: all 0.4s;\n    transition: all 0.4s;\n  }\n\n  &:hover {\n    img {\n      -ms-transform: scale(1.1);\n      -moz-transform: scale(1.1);\n      -webkit-transform: scale(1.1);\n      -o-transform: scale(1.1);\n      transform: scale(1.1);\n    }\n  }\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

var BackgroundImageNewsCard = function BackgroundImageNewsCard(_ref) {
  var className = _ref.className,
      src = _ref.src,
      href = _ref.href,
      title = _ref.title,
      theme = _ref.theme,
      alt = _ref.alt;
  return /*#__PURE__*/React.createElement(Link, {
    className: className,
    href: href,
    hasHover: false
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: "100%"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(Triangle, {
    className: "triangle",
    withContent: true,
    contentColor: theme.components.backgroundImageNewsCard.textColor,
    color: theme.components.backgroundImageNewsCard.contentContainerBackgroundColor,
    size: "22px",
    top: "-22px",
    left: "20px",
    contentSize: "24px"
  }), /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "medium",
    fontDecoration: "none",
    fontWeight: "400",
    lineHeight: "1.5",
    text: title
  })));
};

var types$j = {
  className: PropTypes$1.string,
  src: PropTypes$1.string,
  href: PropTypes$1.string,
  title: PropTypes$1.string,
  theme: PropTypes$1.object,
  alt: PropTypes$1.string
};
var defaults$g = {
  href: "/",
  title: "Título",
  alt: "Imagem sem alt"
};
BackgroundImageNewsCard.propTypes = types$j;
BackgroundImageNewsCard.defaultProps = defaults$g;
var BackgroundImageNewsCardWithStyles = styled(BackgroundImageNewsCard)(_templateObject$r(), function (props) {
  return lighten(0.5, props.theme.components.backgroundImageNewsCard.textColor);
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.theme.components.backgroundImageNewsCard.contentContainerBackgroundColor;
});
var BackgroundImageNewsCard$1 = withTheme(BackgroundImageNewsCardWithStyles); //Only used for the Storybook Props Table

var Mask$2 = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgImageNewsCard.maskBgColor,
    position: "absolute"
  }, props));
};

var Loading$2 = function Loading(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "360px",
    backgroundColor: props.theme.loadings.iconContainerBgColor,
    className: "background-image-card"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    position: "relative",
    backgroundColor: props.theme.loadings.iconContainerBgColor,
    height: "inherit",
    display: "flex"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    position: "absolute",
    bottom: "20px",
    left: "20px",
    right: "20px",
    padding: "23px 20px",
    backgroundColor: props.theme.loadings.bgImageNewsCard.contentContainerBgColor
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "21px"
  }, /*#__PURE__*/React.createElement(Mask$2, _extends({
    height: "21px",
    right: "0",
    width: "30%"
  }, props))))));
};

var BackgroundImageNewsCardLoading = withTheme(Loading$2);

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  &:focus {\n    ", ";\n  }\n  button {\n    background-color: transparent;\n  }\n  .content-container {\n    padding: ", ";\n    margin-top: ", ";\n    border-top: 1px solid\n      ", ";\n  }\n  &:last-child {\n    .content-container {\n      border-bottom: 1px solid\n        ", ";\n    }\n  }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

var BorderedCard = function BorderedCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      onKeyPress = _ref.onKeyPress,
      cardIsLink = _ref.cardIsLink,
      target = _ref.target,
      hasHover = _ref.hasHover,
      props = _objectWithoutProperties(_ref, ["children", "className", "href", "onKeyPress", "cardIsLink", "target", "hasHover"]);

  return /*#__PURE__*/React.createElement(Fragment, null, cardIsLink ? /*#__PURE__*/React.createElement(Link, _extends({
    className: className,
    tabIndex: 0,
    href: href,
    onKeyPress: onKeyPress,
    target: target,
    hasHover: hasHover
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, children)) : /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, children)));
};

BorderedCard.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  href: PropTypes$1.string,
  onKeyPress: PropTypes$1.func,
  history: PropTypes$1.object,
  cardIsLink: PropTypes$1.bool,
  target: PropTypes$1.string,
  hasHover: PropTypes$1.bool
};
BorderedCard.defaultProps = {
  href: "/",
  cardIsLink: true,
  hasHover: false
};
var BorderedCardWithStyles = styled(BorderedCard)(_templateObject$s(), function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.contentContainerPadding || "10px 0";
}, function (props) {
  return props.contentContainerMarginTop || "0";
}, function (props) {
  return props.borderColor || props.theme.components.borderedCard.borderColor;
}, function (props) {
  return props.borderColor || props.theme.components.borderedCard.borderColor;
});

var WithProps$2 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(BorderedCardWithStyles, props);
};
WithProps$2.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  href: PropTypes$1.string,
  onKeyPress: PropTypes$1.func,
  history: PropTypes$1.object,
  cardIsLink: PropTypes$1.bool,
  target: PropTypes$1.string,
  hasHover: PropTypes$1.bool,
  contentContainerPadding: PropTypes$1.string,
  borderColor: PropTypes$1.string
};
WithProps$2.defaultProps = {
  href: "/",
  cardIsLink: true,
  hasHover: false
};

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  :last-child {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$3 = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var Loading$3 = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "109px",
    backgroundColor: props.theme.loadings.bgColor,
    padding: "11px 0",
    borderTop: "1px solid ".concat(props.theme.loadings.cardBorderColor),
    className: className
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "87px"
  }, /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "16px",
    right: "0",
    width: "80%"
  }, props)), /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "3px",
    top: "16px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "18px",
    top: "19px",
    right: "0",
    width: "20%"
  }, props)), /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "3px",
    top: "37px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "18px",
    top: "40px",
    right: "0",
    width: "50%"
  }, props)), /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "11px",
    top: "58px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$3, _extends({
    height: "18px",
    top: "69px",
    right: "0",
    width: "70%"
  }, props))));
};

var LoadingWithStyles = styled(Loading$3)(_templateObject$t(), function (props) {
  return props.theme.loadings.cardBorderColor;
});
var BorderedCardLoading = withTheme(LoadingWithStyles);

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  height: inherit;\n  position: relative;\n  background-color: ", ";\n  word-break: break-word;\n\n  .content-container {\n    padding: 20px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var CandidatureCard = function CandidatureCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      titleColor = _ref.titleColor,
      title = _ref.title,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: title,
    size: "large",
    color: theme.highContrast.text || titleColor || theme.components.candidatureCard.titleColor
  }), children));
};

var types$k = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  buttonBgColor: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  title: PropTypes$1.string,
  theme: PropTypes$1.object
};
var defaults$h = {
  titleColor: "#000",
  title: "Título"
};
CandidatureCard.propTypes = types$k;
CandidatureCard.defaultProps = defaults$h;
var CandidatureCardWithStyles = styled(CandidatureCard)(_templateObject$u(), function (props) {
  return props.theme.components.candidatureCard.cardBackgroundColor;
});
var CandidatureCard$1 = withTheme(CandidatureCardWithStyles); //Only used for the Storybook Props Table

var Mask$4 = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

var Loading$4 = function Loading(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "300px",
    backgroundColor: props.theme.loadings.cardBgColor,
    padding: "20px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "125px"
  }, /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "15px",
    right: "0",
    width: "70%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "10px",
    top: "15px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "5px",
    top: "25px",
    right: "0",
    width: "90%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "20px",
    top: "30px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "15px",
    top: "50px",
    right: "0",
    width: "50%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "5px",
    top: "65px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "15px",
    top: "70px",
    right: "0",
    width: "30%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "5px",
    top: "85px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "15px",
    top: "90px",
    right: "0",
    width: "75%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "5px",
    top: "105px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$4, _extends({
    height: "15px",
    top: "110px",
    right: "0",
    width: "40%"
  }, props))));
};

Loading$4.propTypes = {
  className: PropTypes$1.string
};
var CandidatureCardLoading = withTheme(Loading$4);

var compose = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  }, function (arg) {
    return arg;
  });
};
function fallbackCopyTextToClipboard(text) {
  if (typeof window !== "undefined") {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }
}
function copyTextToClipboard(_x) {
  return _copyTextToClipboard.apply(this, arguments);
}

function _copyTextToClipboard() {
  _copyTextToClipboard = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(text) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window !== "undefined")) {
              _context.next = 6;
              break;
            }

            if (navigator.clipboard) {
              _context.next = 4;
              break;
            }

            fallbackCopyTextToClipboard(text);
            return _context.abrupt("return");

          case 4:
            _context.next = 6;
            return navigator.clipboard.writeText(text);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _copyTextToClipboard.apply(this, arguments);
}

function truncateOnWord(str) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var collapse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var ellipsis = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "...";

  if (!collapse || str === null) {
    return str;
  }

  var trimmable = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF";
  var reg = new RegExp("(?=[" + trimmable + "])");
  var words = str.split(reg);
  var count = 0;
  var content = words.filter(function (word) {
    count += word.length;
    return count <= limit;
  }).join("") + ellipsis;
  return content;
} // eslint-disable-next-line

Array.prototype.chunk = function (chunk_size) {
  if (!this.length) {
    return [];
  }

  return [this.slice(0, chunk_size)].concat(this.slice(chunk_size).chunk(chunk_size));
};

function isEmpty$1(str) {
  return !str || 0 === str.length;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  /*\n  -- Copy to Clipboard Feedback -- Globals\n  */\n  .copy-clipboard-feedback {\n    position: absolute;\n    z-index: 1;\n    padding: 5px 15px;\n    left: 0;\n    top: 0;\n    background-color: ", ";\n    box-shadow: ", ";\n    -webkit-animation: animateClipboard 2s ease-in-out forwards;\n    animation: animateClipboard 2s ease-in-out forwards;\n  }\n  //Copy to Clipboard Feedback Animation\n  @-webkit-keyframes animateClipboard {\n    0% {\n      top: 0;\n      opacity: 0;\n    }\n    15% {\n      top: -30px;\n      opacity: 1;\n    }\n    80% {\n      top: -30px;\n      opacity: 1;\n    }\n    100% {\n      top: 0;\n      opacity: 0;\n    }\n  }\n\n  @keyframes animateClipboard {\n    0% {\n      top: 0;\n      opacity: 0;\n    }\n    15% {\n      top: -30px;\n      opacity: 1;\n    }\n    80% {\n      top: -30px;\n      opacity: 1;\n    }\n    100% {\n      top: 0;\n      opacity: 0;\n    }\n  }\n\n  // Extra small devices (portrait phones, more than 575px)\n  @media (min-width: 576px) {\n    position: absolute;\n    width: auto;\n    top: ", ";\n    right: ", ";\n    height: ", ";\n\n    .share-social-media {\n      width: 181px;\n      height: 64px;\n      position: relative;\n\n      /*\n      -- Copy to Clipboard Feedback\n      */\n      .copy-clipboard-feedback {\n        width: 181px;\n      }\n\n      ul {\n        z-index: 3;\n        position: relative;\n        height: 100%;\n        li {\n          height: 100%;\n          width: 25%;\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n\n      a,\n      button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n        height: 100%;\n        width: 100%;\n        text-decoration: none;\n        &:hover {\n          i {\n            color: ", ";\n          }\n        }\n        &:focus {\n          ", ";\n        }\n      }\n\n      //Paper\n      &:before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: inherit;\n        left: 0;\n        top: 0;\n        z-index: 2;\n      }\n\n      &:before,\n      &:after {\n        background-color: ", ";\n      }\n\n      ,\n      &:after {\n        box-shadow: ", ";\n      }\n\n      //Triangle\n      &:after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        bottom: -5px;\n        right: 31px;\n        z-index: 0;\n        transform: rotate(45deg);\n      }\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    height: 100px;\n    width: 100%;\n    padding: 0 15px;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 2147483641;\n    box-shadow: ", ";\n    background-color: ", ";\n\n    .share-social-media {\n      width: 100%;\n      height: inherit;\n      display: flex;\n      align-items: center;\n\n      // -- Copy to Clipboard Feedback\n      .copy-clipboard-feedback {\n        width: 100%;\n      }\n\n      //Paper\n      &:before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: inherit;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        background-color: ", ";\n      }\n\n      ul {\n        display: flex;\n        justify-content: space-between;\n        z-index: 3;\n      }\n\n      a,\n      button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n        height: 50px;\n        width: 50px;\n        text-decoration: none;\n        i {\n          font-size: 24px;\n        }\n        &:hover {\n          i {\n            color: ", ";\n          }\n        }\n        &:focus {\n          ", ";\n        }\n      }\n    }\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

var ShareSocialMedia = function ShareSocialMedia(_ref) {
  var className = _ref.className,
      share = _ref.share,
      theme = _ref.theme;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useConfig = useConfig(),
      useIntl = _useConfig.useIntl,
      FormattedMessage = _useConfig.formattedMessage;

  var intl = useIntl();

  var onHandleAnimation = function onHandleAnimation(e) {
    e.preventDefault();
    setOpen(true);
  };

  var onHandleCopyToClipboard = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              _context.next = 3;
              return copyTextToClipboard(share.url);

            case 3:
              if (!_context.sent) {
                _context.next = 5;
                break;
              }

              onHandleAnimation(e);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onHandleCopyToClipboard(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var openLink = function openLink(e, url) {
    e.preventDefault();
    window.open(url, "_blank");
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "share-social-media"
  }, isOpen && /*#__PURE__*/React.createElement("div", {
    className: "copy-clipboard-feedback"
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.components.shareSocialMedia.copyToClipboardTextColor,
    size: "xSmall"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.journal.news.share.feedback",
    defaultMessage: "Url copiado para clipboard"
  }))), /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    as: "button",
    tabIndex: "0",
    onClick: onHandleCopyToClipboard,
    title: intl({
      id: "app.journal.news.share.button.title",
      defaultMessage: "Copy to Clipboard"
    }),
    "aria-label": intl({
      id: "app.journal.news.share.button.title",
      defaultMessage: "Copy to Clipboard"
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.link,
    size: "small",
    color: theme.components.shareSocialMedia.iconColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    as: "button",
    onClick: function onClick(e) {
      return openLink(e, share.facebook);
    },
    title: "Facebook",
    "aria-label": "Facebook"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.facebook,
    size: "small",
    color: theme.components.shareSocialMedia.iconColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    as: "button",
    onClick: function onClick(e) {
      return openLink(e, share.twitter);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.twitter,
    size: "small",
    title: "Twitter",
    "aria-label": "Twitter",
    color: theme.components.shareSocialMedia.iconColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    as: "button",
    onClick: function onClick(e) {
      return openLink(e, share.linkedin);
    },
    title: "LinkedIn",
    "aria-label": "LinkedIn"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.linkedIn,
    size: "small",
    color: theme.components.shareSocialMedia.iconColor
  }))))));
};

ShareSocialMedia.defaultProps = {
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  }
};
ShareSocialMedia.propTypes = {
  className: PropTypes$1.string,
  share: PropTypes$1.object,
  intl: PropTypes$1.string,
  theme: PropTypes$1.object
};
var ShareSocialMediaWithStyles = styled(ShareSocialMedia)(_templateObject$v(), function (props) {
  return props.theme.components.shareSocialMedia.copyToClipboardBgColor;
}, function (props) {
  return props.theme.components.shareSocialMedia.boxShadow;
}, function (props) {
  return props.top || "-85px";
}, function (props) {
  return props.right || "-25px";
}, function (props) {
  return props.height || "90px";
}, function (props) {
  return lighten(0.5, props.theme.components.shareSocialMedia.iconColor);
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.backgroundColor || props.theme.components.shareSocialMedia.backgroundColor;
}, function (props) {
  return props.theme.components.shareSocialMedia.boxShadow;
}, function (props) {
  return props.theme.components.shareSocialMedia.boxShadow;
}, function (props) {
  return props.backgroundColor || props.theme.components.shareSocialMedia.backgroundColor;
}, function (props) {
  return props.backgroundColor || props.theme.components.shareSocialMedia.backgroundColor;
}, function (props) {
  return lighten(0.5, props.theme.components.shareSocialMedia.iconColor);
}, function (props) {
  return props.theme.mixins.focus;
}); //export default withTheme(injectIntl(ShareSocialMediaWithStyles));

var ShareSocialMedia$1 = withTheme(ShareSocialMediaWithStyles); //Only used for the Storybook Props Table

var WithProps$3 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(ShareSocialMediaWithStyles, props);
};
WithProps$3.propTypes = {
  className: PropTypes$1.string,
  share: PropTypes$1.object,
  intl: PropTypes$1.string,
  theme: PropTypes$1.object,
  top: PropTypes$1.string,
  right: PropTypes$1.string,
  height: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
WithProps$3.defaultProps = {
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  },
  top: "-85px",
  right: "-25px",
  height: "90px"
};

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n  button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    height: 24px;\n    width: 24px;\n    &:hover {\n      i {\n        color: ", ";\n      }\n    }\n    &:focus {\n      ", ";\n    }\n  }\n  .social-media-container {\n    position: relative;\n  }\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}

var SocialMediaActions = function SocialMediaActions(_ref) {
  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      iconColor = _ref.iconColor,
      share = _ref.share,
      theme = _ref.theme;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useConfig = useConfig(),
      useIntl = _useConfig.useIntl;

  var intl = useIntl();

  var showShareIcons = function showShareIcons(e) {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };

  var hideShareIcons = function hideShareIcons(e) {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
  };

  var socialProps = size.width > 575 ? {
    onMouseEnter: showShareIcons,
    onMouseLeave: hideShareIcons
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: "social-media-container"
  }, socialProps), /*#__PURE__*/React.createElement("button", {
    onClick: showShareIcons,
    tabIndex: "0",
    "aria-label": intl({
      id: "app.socialMediaActions.button.description",
      defaultMessage: "Share Button"
    })
  }, children, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.share_alt,
    color: iconColor,
    size: "xSmall"
  })), isOpen && /*#__PURE__*/React.createElement(Fragment, null, size.width <= 575 ? /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onChange: function onChange() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement(ShareSocialMedia$1, {
    share: share
  }))) : /*#__PURE__*/React.createElement(ShareSocialMedia$1, {
    share: share
  }))));
};

var defaults$i = {
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  }
};
var types$l = {
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  iconColor: PropTypes$1.string,
  size: PropTypes$1.object,
  share: PropTypes$1.object,
  intl: PropTypes$1.string,
  theme: PropTypes$1.object,
  ariaLabel: PropTypes$1.string
};
SocialMediaActions.propTypes = types$l;
SocialMediaActions.defaultProps = defaults$i;
var SocialMediaActionsWithStyles = styled(SocialMediaActions)(_templateObject$w(), function (props) {
  return lighten(0.5, props.iconColor || "#000");
}, function (props) {
  return props.theme.mixins.focus;
}); //export default withTheme(injectIntl(SocialMediaActionsWithStyles));

var SocialMediaActions$1 = withTheme(SocialMediaActionsWithStyles); //Only used for the Storybook Props Table

function _templateObject$x() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  &:focus {\n    ", ";\n  }\n  button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    &:hover {\n      i {\n        color: ", ";\n      }\n    }\n  }\n\n  .horizontal-news-card {\n    //Image Animation\n    img {\n      -webkit-transition: all 0.4s;\n      -moz-transition: all 0.4s;\n      -o-transition: all 0.4s;\n      transition: all 0.4s;\n    }\n\n    cursor: pointer;\n    &:hover {\n      img {\n        -ms-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -webkit-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n      }\n    }\n\n    background-color: ", ";\n    .image-container {\n      height: ", ";\n      overflow: hidden;\n    }\n    .content-container {\n      position: relative;\n      height: 100%;\n      padding: 20px;\n      background-color: ", ";\n      .title-container {\n        max-height: 210px;\n        overflow: hidden;\n        margin-top: 10px;\n      }\n    }\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 992px) {\n    .triangle {\n      ", "\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .horizontal-news-card {\n      height: ", ";\n      .image-container {\n        height: ", ";\n      }\n      .content-container {\n        .title-container {\n          max-height: 135px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}

var HorizontalNewsCard = function HorizontalNewsCard(_ref) {
  var className = _ref.className,
      category = _ref.category,
      title = _ref.title,
      date = _ref.date,
      src = _ref.src,
      alt = _ref.alt,
      removeImage = _ref.removeImage,
      triangleBgColor = _ref.triangleBgColor,
      changeMdOrder = _ref.changeMdOrder,
      href = _ref.href,
      theme = _ref.theme,
      size = _ref.size,
      categoryUrl = _ref.categoryUrl,
      share = _ref.share,
      history = _ref.history;
  return /*#__PURE__*/React.createElement(Link, {
    className: className,
    tabIndex: 0,
    href: href,
    hasHover: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "horizontal-news-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col order-lg-0 ".concat(changeMdOrder ? "order-1" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container d-flex flex-column justify-content-between"
  }, /*#__PURE__*/React.createElement(Triangle, {
    className: "triangle",
    transform: removeImage ? "rotate(-90deg)" : "rotate(90deg)",
    withContent: true,
    contentColor: theme.components.horizontalNewsCard.triangleContentColor,
    color: triangleBgColor || theme.components.horizontalNewsCard.backgroundColor,
    size: "22px",
    top: "calc(50% - 11px)",
    right: "-33px",
    contentSize: "24px",
    zIndex: "1"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    as: "button",
    text: category,
    fontWeight: "300",
    onClick: function onClick(e) {
      e.preventDefault();
      history.push(categoryUrl);
    },
    color: theme.components.horizontalNewsCard.categoryColor,
    lineHeight: "1.4" //Accessibility problems with id="tag" remove later on if all ok
    //id="tag"
    ,
    mobileXsFontSize: "12px"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/React.createElement(Text, {
    isSerif: true,
    as: "h3",
    display: "block",
    size: "large",
    sizeXsSize: "small",
    fontDecoration: "none",
    fontWeight: "400",
    lineHeight: "1.5",
    text: title,
    color: theme.components.horizontalNewsCard.textColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(LineTruncate, null, /*#__PURE__*/React.createElement(Text, {
    text: date,
    size: "xSmall",
    color: theme.components.horizontalNewsCard.textColor,
    textTransform: "lowercase"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(SocialMediaActions$1, {
    size: size,
    iconColor: theme.components.horizontalNewsCard.textColor,
    share: share
  }))))), removeImage ? "" : /*#__PURE__*/React.createElement("div", {
    className: "col order-lg-1 ".concat(changeMdOrder ? "order-0" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: theme.components.horizontalNewsCard.height,
    xsHeight: theme.components.horizontalNewsCard.mobileXsHeight
  }))))));
};

HorizontalNewsCard.propTypes = {
  className: PropTypes$1.string,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  date: PropTypes$1.string,
  src: PropTypes$1.string,
  triangleBgColor: PropTypes$1.string,
  removeImage: PropTypes$1.bool,
  changeMdOrder: PropTypes$1.bool,
  href: PropTypes$1.string,
  theme: PropTypes$1.object,
  size: PropTypes$1.object,
  categoryUrl: PropTypes$1.string,
  share: PropTypes$1.object,
  history: PropTypes$1.object,
  alt: PropTypes$1.string
};
HorizontalNewsCard.defaultProps = {
  category: "Categoria",
  title: "Título",
  date: "data",
  src: "",
  changeMdOrder: false,
  href: "/",
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  }
};
var HorizontalNewsCardWithStyles = styled(HorizontalNewsCard)(_templateObject$x(), function (props) {
  return props.theme.mixins.focus;
}, lighten(0.5, "#000"), function (props) {
  return props.backgroundColor || props.theme.components.horizontalNewsCard.backgroundColor;
}, function (props) {
  return props.theme.components.horizontalNewsCard.height;
}, function (props) {
  return props.contentContainerBgColor || props.theme.components.horizontalNewsCard.contentContainerBgColor;
}, function (props) {
  return props.changeMdOrder && "\n        right: -33px;\n        left: unset;\n        transform: rotate(90deg);\n      ";
}, function (props) {
  return props.theme.components.horizontalNewsCard.mobileXsHeight;
}, function (props) {
  return props.theme.components.horizontalNewsCard.mobileXsHeight;
});
var HorizontalNewsCard$1 = compose(withTheme)(HorizontalNewsCardWithStyles); //Only used for the Storybook Props Table

var WithProps$4 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(HorizontalNewsCardWithStyles, props);
};
WithProps$4.propTypes = {
  className: PropTypes$1.string,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  date: PropTypes$1.string,
  src: PropTypes$1.string,
  triangleBgColor: PropTypes$1.string,
  removeImage: PropTypes$1.bool,
  changeMdOrder: PropTypes$1.bool,
  href: PropTypes$1.string,
  theme: PropTypes$1.object,
  size: PropTypes$1.object,
  categoryUrl: PropTypes$1.string,
  share: PropTypes$1.object,
  history: PropTypes$1.object,
  alt: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  contentContainerBgColor: PropTypes$1.string
};
WithProps$4.defaultProps = {
  category: "Categoria",
  title: "Título",
  date: "data",
  src: "",
  changeMdOrder: false,
  href: "/",
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  }
};

var Mask$5 = function Mask(_ref) {
  var maskBgColor = _ref.maskBgColor,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["maskBgColor", "theme"]);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: maskBgColor || theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

Mask$5.propTypes = {
  maskBgColor: PropTypes$1.string
};

var CardTextAnimation = function CardTextAnimation(_ref2) {
  var props = _extends({}, _ref2);

  return /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "146px",
    className: "loading-card-animated-background"
  }, /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "18px",
    right: "0",
    width: "80%"
  }, props)), /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "18px",
    top: "18px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "30px",
    smHeight: "22px",
    mobileXsHeight: "18px",
    top: "36px",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "10px",
    mobileXsHeight: "5px",
    top: "66px",
    smTop: "58px",
    xsTop: "54px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "30px",
    smHeight: "22px",
    mobileXsHeight: "18px",
    top: "76px",
    smTop: "68px",
    xsTop: "59px",
    right: "0",
    width: "20%"
  }, props)), /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "10px",
    mobileXsHeight: "5px",
    top: "106px",
    smTop: "90px",
    xsTop: "77px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "30px",
    smHeight: "22px",
    mobileXsHeight: "18px",
    top: "116px",
    smTop: "100px",
    xsTop: "82px",
    right: "0",
    width: "30%"
  }, props)));
};

var Loading$5 = function Loading(_ref3) {
  var changeMdOrder = _ref3.changeMdOrder,
      contentContainerBgColor = _ref3.contentContainerBgColor,
      columnFullSize = _ref3.columnFullSize,
      props = _objectWithoutProperties(_ref3, ["changeMdOrder", "contentContainerBgColor", "columnFullSize"]);

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(columnFullSize ? "col-sm col-12" : "col", " order-lg-0 ").concat(changeMdOrder ? "order-1" : "")
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex flex-column justify-content-between",
    padding: "20px",
    height: "294px",
    mobileXsHeight: columnFullSize ? "213px" : "250px",
    backgroundColor: contentContainerBgColor || props.theme.loadings.cardBgColor
  }, /*#__PURE__*/React.createElement(CardTextAnimation, props), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "18px"
  }, /*#__PURE__*/React.createElement(Mask$5, _extends({
    height: "18px",
    right: "0",
    width: "75%"
  }, props)))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(columnFullSize ? "col-sm col-12" : "col", " order-lg-1 ").concat(changeMdOrder ? "order-0" : "")
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "294px",
    mobileXsHeight: columnFullSize ? "185px" : "250px",
    backgroundColor: props.theme.loadings.iconContainerBgColor
  }))));
};

Loading$5.propTypes = {
  changeMdOrder: PropTypes$1.bool,
  contentContainerBgColor: PropTypes$1.string,
  columnFullSize: PropTypes$1.bool
};
Loading$5.defaultProps = {
  columnFullSize: false
};
var HorizontalNewsCardLoading = withTheme(Loading$5);

function _templateObject$y() {
  var data = _taggedTemplateLiteral(["\n  min-height: 400px;\n  background-color: ", ";\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$6 = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  });
};

Loading$6.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$1 = styled(Loading$6)(_templateObject$y(), function (props) {
  return props.theme.loadings.iconContainerBgColor;
});
var Loading$7 = withTheme(LoadingWithStyles$1);

var ImageWrapper = function ImageWrapper(_ref) {
  var heightProp = _ref.height,
      alt = _ref.alt,
      backgroundSize = _ref.backgroundSize,
      backgroundColor = _ref.backgroundColor,
      imagePosition = _ref.imagePosition,
      className = _ref.className,
      smHeight = _ref.smHeight,
      size = _ref.size,
      useHeight = _ref.useHeight,
      absoluteSize = _ref.absoluteSize,
      data = _ref.data,
      url = _ref.url,
      endpoint = _ref.endpoint,
      hasEndpoint = _ref.hasEndpoint;

  var _useState = useState({
    loading: false,
    error: false,
    content: data
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var getData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res, content;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("".concat(url).concat(endpoint));

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              content = _context.sent;
              setState(function (prevState) {
                return _objectSpread2({}, prevState, {
                  content: content,
                  loading: false
                });
              });
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              setState(function (prevState) {
                return _objectSpread2({}, prevState, {
                  loading: false,
                  error: true
                });
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setState(function (prevState) {
      return _objectSpread2({}, prevState, {
        content: data
      });
    });
  }, [data]); //If the user changes the url update the content

  useEffect(function () {
    if (hasEndpoint) {
      setState(function (prevState) {
        return _objectSpread2({}, prevState, {
          loading: true
        });
      });
      getData();
    }
  }, [url, endpoint, hasEndpoint]);
  return state.loading ? /*#__PURE__*/React.createElement(Loading$7, null) : state.error ? /*#__PURE__*/React.createElement("div", null, "No content to display") : /*#__PURE__*/React.createElement(PictureContainer, {
    className: className,
    src: state.content.url,
    alt: alt || state.content.url,
    height: heightProp,
    backgroundSize: backgroundSize,
    backgroundColor: backgroundColor,
    imagePosition: imagePosition,
    smHeight: smHeight,
    size: size,
    useHeight: useHeight,
    absoluteSize: absoluteSize
  });
};

ImageWrapper.defaultProps = {
  alt: null,
  backgroundSize: "cover",
  backgroundColor: "#fff",
  imagePosition: "center",
  size: "lg",
  useHeight: false,
  absoluteSize: null,
  hasEndpoint: false,
  endpoint: function endpoint() {
    return null;
  }
};
ImageWrapper.propTypes = {
  data: PropTypes$1.object,
  height: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  className: PropTypes$1.string,
  smHeight: PropTypes$1.string,
  endpoint: PropTypes$1.func,
  hasEndpoint: PropTypes$1.bool,
  url: PropTypes$1.string,
  match: PropTypes$1.object,
  backgroundSize: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  imagePosition: PropTypes$1.string,
  alt: PropTypes$1.string,
  size: PropTypes$1.oneOf(["xs", "sm", "md", "lg"]),
  useHeight: PropTypes$1.bool,
  absoluteSize: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
};

function _templateObject$z() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  > div {\n    height: inherit;\n  }\n  .news-card {\n    display: block;\n    text-decoration: none;\n    flex-grow: 1;\n    button {\n      background-color: transparent;\n      cursor: pointer;\n      border: none;\n      &:hover {\n        i {\n          color: ", ";\n        }\n      }\n    }\n    &:focus {\n      ", ";\n    }\n    background-color: ", ";\n    min-height: 398px;\n    height: 100%;\n\n    //Image Animation\n    img {\n      -webkit-transition: all 0.4s;\n      -moz-transition: all 0.4s;\n      -o-transition: all 0.4s;\n      transition: all 0.4s;\n    }\n\n    cursor: pointer;\n    &:hover {\n      img {\n        -ms-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -webkit-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n      }\n    }\n\n    .image-container {\n      height: ", ";\n      overflow: hidden;\n    }\n\n    .content-container {\n      position: relative;\n      padding: 20px;\n      min-height: ", ";\n\n      .title-container {\n        max-height: 80px;\n        overflow: hidden;\n        z-index: 1;\n        position: relative;\n      }\n\n      .cover-is-null {\n        margin-top: 10px;\n        height: 190px;\n        overflow: hidden;\n      }\n\n      .content-container-footer {\n        margin-top: 20px;\n      }\n    }\n  }\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .news-card {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

var NewsCard = function NewsCard(_ref) {
  var className = _ref.className,
      data = _ref.data,
      _onKeyPress = _ref.onKeyPress,
      imageBgColor = _ref.imageBgColor,
      linkColor = _ref.linkColor,
      onKeyDown = _ref.onKeyDown,
      hasColAuto = _ref.hasColAuto,
      hasShareIcon = _ref.hasShareIcon,
      centerPlusButton = _ref.centerPlusButton,
      onMouseOver = _ref.onMouseOver,
      theme = _ref.theme,
      hasCategoryTitle = _ref.hasCategoryTitle,
      size = _ref.size,
      history = _ref.history,
      imageSize = _ref.imageSize,
      plusButtonSize = _ref.plusButtonSize,
      plusButtonFontSize = _ref.plusButtonFontSize,
      titleIsSerif = _ref.titleIsSerif,
      plusButtonBgColor = _ref.plusButtonBgColor,
      changeImageVerticalOrder = _ref.changeImageVerticalOrder,
      linkProps = _ref.linkProps;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onKeyDown: onKeyDown,
    onMouseOver: onMouseOver
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-grow-1 ".concat(hasColAuto && "col-auto")
  }, /*#__PURE__*/React.createElement(Link, {
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      return _onKeyPress(e, data.url);
    },
    href: data.url,
    className: "news-card d-flex flex-column",
    hasHover: false,
    "native": true // {...linkProps}

  }, data.imageCover !== null && data.imageCover !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "image-container ".concat(changeImageVerticalOrder ? "order-last" : "")
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    size: "xs",
    className: "news-image",
    height: imageSize + "px" || "185px",
    width: "100%",
    backgroundColor: imageBgColor,
    data: {
      url: data.imageCover !== null && data.imageCover.url !== null ? data.imageCover.url : "https://via.placeholder.com/350"
    },
    alt: data.imageCover !== null && data.imageCover.alt !== null ? data.imageCover.alt : "Imagem da Not\xEDcia ".concat(data.title),
    hasEndpoint: false,
    endpoint: function endpoint() {
      return null;
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "content-container d-flex flex-column justify-content-between flex-grow-1 ".concat(changeImageVerticalOrder ? "order-first" : "")
  }, data.imageCover !== null && /*#__PURE__*/React.createElement(PlusButton, {
    left: centerPlusButton ? "0" : "25px",
    right: centerPlusButton ? "0" : null,
    justifyContent: centerPlusButton && "center",
    size: plusButtonSize + "px",
    top: changeImageVerticalOrder ? null : -plusButtonSize / 2 + "px",
    bottom: changeImageVerticalOrder ? -plusButtonSize / 2 + "px" : null,
    "aria-hidden": "true",
    tabIndex: -1,
    target: "_blank",
    alt: data.title,
    href: data.url,
    className: "news-plus-button",
    backgroundColor: plusButtonBgColor || theme.components.newsCard.plusButtonBgColor,
    "native": true
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: plusButtonFontSize || "24px",
    fontWeight: "100",
    margin: "auto",
    fontDecoration: "none",
    color: theme.highContrast.text || linkColor || theme.components.newsCard.plusButtonTextColor,
    text: theme.icons.plus,
    lineHeight: "0"
  })), /*#__PURE__*/React.createElement("div", null, hasCategoryTitle && /*#__PURE__*/React.createElement(Link, {
    as: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      history.push(data.categoryUrl);
    },
    text: data.category,
    color: theme.components.newsCard.categoryColor,
    fontWeight: "300",
    lineHeight: "1.4" //Accessibility problems with id="tag" remove later on if all ok
    //id="tag"
    ,
    marginBottom: "10px" //this className in other components to access this element
    ,
    className: "news-card-category"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "medium",
    fontDecoration: "none",
    fontWeight: "400",
    lineHeight: "1.5",
    text: data.title,
    marginBottom: data.imageCover === null ? "20px" : "",
    isSerif: titleIsSerif //this className in other components to access this element
    ,
    className: "news-card-title"
  })), data.imageCover === null && /*#__PURE__*/React.createElement("div", {
    className: "cover-is-null"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "article",
    lineHeight: "1.6",
    text: data.summary //this className in other components to access this element
    ,
    className: "news-card-text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content-container-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(Text, {
    text: moment(data.startDate).format("DD MMMM YYYY"),
    lineHeight: "1.6",
    size: "xSmall",
    fontWeight: "300",
    textTransform: "lowercase",
    color: theme.components.newsCard.dateColor //this className in other components to access this element
    ,
    className: "news-card-date"
  })), hasShareIcon && /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(SocialMediaActions$1, {
    size: size,
    iconColor: theme.components.newsCard.shareIconColor,
    share: data.share
  }))))))));
};

var types$m = {
  className: PropTypes$1.string,
  data: PropTypes$1.object,
  onClick: PropTypes$1.func,
  onKeyDown: PropTypes$1.func,
  cardBgColor: PropTypes$1.string,
  onKeyPress: PropTypes$1.func,
  onMouseOver: PropTypes$1.func,
  imageBgColor: PropTypes$1.string,
  linkColor: PropTypes$1.string,
  href: PropTypes$1.string,
  hasColAuto: PropTypes$1.bool,
  hasShareIcon: PropTypes$1.bool,
  centerPlusButton: PropTypes$1.bool,
  theme: PropTypes$1.object,
  hasCategoryTitle: PropTypes$1.bool,
  size: PropTypes$1.object,
  history: PropTypes$1.object,
  imageSize: PropTypes$1.number,
  plusButtonSize: PropTypes$1.number,
  plusButtonFontSize: PropTypes$1.string,
  plusButtonBgColor: PropTypes$1.string,
  titleIsSerif: PropTypes$1.bool,
  changeImageVerticalOrder: PropTypes$1.bool,
  linkProps: PropTypes$1.object,
  mobileCardBgColor: PropTypes$1.string
};
var defaults$j = {
  hasColAuto: true,
  hasShareIcon: true,
  centerPlusButton: false,
  href: "/",
  hasCategoryTitle: true,
  imageSize: 185,
  plusButtonSize: 30,
  titleIsSerif: false,
  changeImageVerticalOrder: false
};
NewsCard.propTypes = types$m;
NewsCard.defaultProps = defaults$j;
var NewsCardWithStyles = styled(NewsCard)(_templateObject$z(), function (props) {
  return lighten(0.5, props.theme.components.newsCard.shareIconColor);
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.cardBgColor || props.theme.components.newsCard.cardBackgroundColor;
}, function (props) {
  return props.imageSize + "px" || "200px";
}, function (props) {
  return props.data.imageCover === null ? "100%" : props.contentContainerHeight || "198px";
}, function (props) {
  return props.mobileCardBgColor;
});
NewsCardWithStyles.propTypes = {
  contentContainerHeight: PropTypes$1.string,
  mobileCardBgColor: PropTypes$1.string
};
NewsCardWithStyles.defaultProps = {
  imageSize: 185
};
var NewsCard$1 = compose(withTheme)(NewsCardWithStyles); //Only used for the Storybook Props Table

var Mask$6 = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    className: "loading-mask",
    backgroundColor: props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

var Loading$8 = function Loading(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    className: "loading-card",
    height: "398px",
    backgroundColor: props.theme.loadings.cardBgColor
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex",
    backgroundColor: props.theme.loadings.iconContainerBgColor,
    height: "200px"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    height: "198px",
    padding: "20px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "150px"
  }, /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "15px",
    right: "0",
    width: "75%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "20px",
    top: "15px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "18px",
    top: "35px",
    right: "0",
    mobileSmWidth: "20%",
    mobileXsWidth: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "8px",
    top: "53px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "18px",
    top: "61px",
    right: "0",
    mobileSmWidth: "20%",
    mobileXsWidth: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "8px",
    top: "79px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "18px",
    top: "87px",
    right: "0",
    width: "60%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "30px",
    top: "105px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$6, _extends({
    height: "15px",
    top: "135px",
    right: "0",
    width: "70%"
  }, props)))));
};

var NewsCardLoading = withTheme(Loading$8);

var PeopleCard = function PeopleCard(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      name = _ref.name,
      email = _ref.email,
      extension = _ref.extension,
      theme = _ref.theme,
      href = _ref.href,
      hasPhoto = _ref.hasPhoto,
      marginBottom = _ref.marginBottom,
      linkHoverColor = _ref.linkHoverColor,
      lang = _ref.lang;
  var phoneNumber = useMemo(function () {
    if (extension) {
      var extensionArray = extension.split("|");
      return extensionArray.reduce(function (a, b) {
        return a.length > b.length ? a : b;
      });
    }
  }, [extension]);
  return /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: marginBottom
  }, /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
    ratio: "oneByOne"
  }, hasPhoto ? /*#__PURE__*/React.createElement(Link, {
    textDecoration: "none",
    cursor: "pointer",
    href: href
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: "100%",
    hasResize: false
  })) : /*#__PURE__*/React.createElement(ContentContainer, {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.user,
    fontSize: "80px",
    xsFontSize: "40px",
    color: theme.components.subWebPeople.personCard.imagePlaceholderColor
  }))), /*#__PURE__*/React.createElement(Link, {
    fontSize: "16px",
    marginTop: "8px",
    marginBottom: "8px",
    fontWeight: "300",
    display: "block",
    lineHeight: "1.5",
    href: href,
    hoverColor: theme.highContrast.link || linkHoverColor
  }, name), /*#__PURE__*/React.createElement(Link, {
    fontSize: "12px",
    fontWeight: "300",
    textDecoration: "underline",
    color: theme.components.subWebPeople.personCard.linkColor,
    href: "mailto:".concat(email),
    hoverColor: theme.highContrast.link || linkHoverColor
  }, email), extension && /*#__PURE__*/React.createElement(Text, {
    size: "xSmall",
    marginTop: "4px",
    color: theme.components.subWebPeople.personCard.textColor
  }, lang === "pt" ? "extensão:" : "extension:", " ", /*#__PURE__*/React.createElement(Link, {
    fontSize: "12px",
    fontWeight: "300",
    textDecoration: "underline",
    href: "tel:".concat(phoneNumber.trim()),
    color: theme.components.subWebPeople.personCard.linkColor,
    hoverColor: theme.highContrast.link || linkHoverColor
  }, extension)));
};

PeopleCard.propTypes = {
  className: PropTypes$1.string,
  src: PropTypes$1.string,
  alt: PropTypes$1.string,
  name: PropTypes$1.string,
  email: PropTypes$1.string,
  extension: PropTypes$1.string,
  marginBottom: PropTypes$1.string,
  theme: PropTypes$1.object,
  href: PropTypes$1.string.isRequired,
  hasPhoto: PropTypes$1.bool,
  linkHoverColor: PropTypes$1.string,
  lang: PropTypes$1.string
};
PeopleCard.defaultProps = {
  src: "",
  name: "Nome",
  email: "Email",
  extension: "000000",
  hasPhoto: true,
  marginBottom: "70px",
  lang: "pt"
};
var PeopleCard$1 = withTheme(PeopleCard);

var Mask$7 = function Mask(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var Loading$9 = function Loading(_ref2) {
  var props = _extends({}, _ref2);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    backgroundColor: props.theme.loadings.bgColor
  }, /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
    ratio: "oneByOne"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "100%",
    height: "100%",
    backgroundColor: props.theme.loadings.iconContainerBgColor,
    marginRight: "20px"
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "10px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "94px"
  }, /*#__PURE__*/React.createElement(Mask$7, _extends({
    height: "42px",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$7, _extends({
    height: "16px",
    top: "42px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$7, _extends({
    height: "36px",
    top: "58px",
    right: "0",
    width: "50%"
  }, props)))));
};

Loading$9.propTypes = {
  className: PropTypes$1.string,
  CardBgColor: PropTypes$1.string
};
var PeopleCardLoading = withTheme(Loading$9);

function _templateObject$A() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  .person-card {\n    height: inherit;\n    min-height: ", ";\n    text-decoration: none;\n    button {\n      background-color: transparent;\n      border: none;\n      cursor: pointer;\n      &:hover {\n        i {\n          color: ", ";\n        }\n      }\n    }\n    background-color: ", ";\n    .image-container {\n      background-color: ", ";\n      width: ", ";\n      overflow: hidden;\n    }\n\n    img {\n      -webkit-transition: all 0.4s;\n      -moz-transition: all 0.4s;\n      -o-transition: all 0.4s;\n      transition: all 0.4s;\n    }\n\n    &:hover {\n      img {\n        -ms-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -webkit-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n      }\n    }\n    &:focus {\n      ", ";\n    }\n  }\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}

var ImageBottom = function ImageBottom(_ref) {
  var title = _ref.title,
      src = _ref.src,
      alt = _ref.alt,
      name = _ref.name,
      textColor = _ref.textColor,
      theme = _ref.theme,
      hasSubTitle = _ref.hasSubTitle,
      subTitle = _ref.subTitle,
      titleIsSerif = _ref.titleIsSerif,
      url = _ref.url,
      size = _ref.size,
      share = _ref.share,
      linkProps = _ref.linkProps;
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: "person-card d-flex flex-column justify-content-between",
    tabIndex: 0,
    href: url,
    hasHover: false
  }, linkProps), /*#__PURE__*/React.createElement(ContentContainer, {
    minHeight: hasSubTitle ? "auto" : "200px" //maxHeight="230px"
    //overflow="hidden"
    ,
    padding: "20px"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "xLarge",
    color: textColor || theme.components.personCard.textColor,
    isSerif: titleIsSerif
  }, title), hasSubTitle && /*#__PURE__*/React.createElement(Text, {
    marginTop: "20px",
    marginBottom: "20px",
    color: textColor || theme.components.personCard.textColor
  }, subTitle)), /*#__PURE__*/React.createElement(ContentContainer, {
    paddingBottom: "20px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: theme.components.personCard.imageSize
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "100%",
    margin: "0 20px",
    className: "d-flex flex-column justify-content-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    size: "xSmall",
    fontWeight: "300",
    color: textColor || theme.components.personCard.textColor
  }, name)), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(SocialMediaActions$1, {
    size: size,
    iconColor: textColor || theme.components.personCard.textColor,
    share: share
  })))))));
};

ImageBottom.defaultProps = {
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  },
  url: "/"
};
ImageBottom.propTypes = {
  title: PropTypes$1.string,
  name: PropTypes$1.string,
  src: PropTypes$1.string,
  textColor: PropTypes$1.string,
  subTitle: PropTypes$1.string,
  titleIsSerif: PropTypes$1.bool,
  theme: PropTypes$1.object,
  hasSubTitle: PropTypes$1.bool,
  url: PropTypes$1.string,
  size: PropTypes$1.object,
  share: PropTypes$1.object,
  alt: PropTypes$1.string,
  linkProps: PropTypes$1.object
}; //ImageTop

var ImageTop = function ImageTop(_ref2) {
  var title = _ref2.title,
      src = _ref2.src,
      name = _ref2.name,
      textColor = _ref2.textColor,
      theme = _ref2.theme,
      titleIsSerif = _ref2.titleIsSerif,
      url = _ref2.url,
      history = _ref2.history;
  return /*#__PURE__*/React.createElement("div", {
    className: "person-card",
    tabIndex: 0,
    onClick: function onClick() {
      return history.push(url);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    height: theme.components.personCard.imageSize
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    padding: "20px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "15px"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    fontSize: "16px",
    color: textColor || theme.components.personCard.textColor,
    isSerif: titleIsSerif
  }, title)), /*#__PURE__*/React.createElement(Text, {
    size: "xSmall",
    fontWeight: "300",
    color: textColor || theme.components.personCard.textColor
  }, name)))));
};

ImageTop.propTypes = {
  title: PropTypes$1.string,
  name: PropTypes$1.string,
  src: PropTypes$1.string,
  textColor: PropTypes$1.string,
  theme: PropTypes$1.object,
  titleIsSerif: PropTypes$1.bool,
  url: PropTypes$1.string,
  history: PropTypes$1.object,
  linkProps: PropTypes$1.object
};

var PersonCard = function PersonCard(_ref3) {
  var className = _ref3.className,
      imageTop = _ref3.imageTop,
      size = _ref3.size,
      props = _objectWithoutProperties(_ref3, ["className", "imageTop", "size"]);

  var personProps = _objectSpread2({
    size: size
  }, props);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, imageTop ? /*#__PURE__*/React.createElement(ImageTop, props) : /*#__PURE__*/React.createElement(ImageBottom, personProps));
};

PersonCard.propTypes = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  name: PropTypes$1.string,
  text: PropTypes$1.string,
  src: PropTypes$1.string,
  imageTop: PropTypes$1.bool,
  size: PropTypes$1.object
};
PersonCard.defaultProps = {
  title: "Título",
  name: "Nome",
  text: "Texto",
  subTitle: "texto",
  src: "",
  imageTop: false
};
var PersonCardWithStyles = styled(PersonCard)(_templateObject$A(), function (props) {
  return props.minHeight;
}, darken(0.2, "#fff"), function (props) {
  return props.backgroundColor || props.theme.components.personCard.backgroundColor;
}, function (props) {
  return props.theme.components.personCard.imageBackgroundColor;
}, function (props) {
  return props.theme.components.personCard.imageSize;
}, function (props) {
  return props.theme.mixins.focus;
});
var PersonCard$1 = compose(withTheme)(PersonCardWithStyles); //Only used for the Storybook Props Table

var WithProps$5 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(PersonCardWithStyles, props);
};
WithProps$5.propTypes = {
  title: PropTypes$1.string,
  name: PropTypes$1.string,
  src: PropTypes$1.string,
  textColor: PropTypes$1.string,
  subTitle: PropTypes$1.string,
  titleIsSerif: PropTypes$1.bool,
  theme: PropTypes$1.object,
  hasSubTitle: PropTypes$1.bool,
  url: PropTypes$1.string,
  size: PropTypes$1.object,
  share: PropTypes$1.object,
  alt: PropTypes$1.string,
  history: PropTypes$1.object,
  linkProps: PropTypes$1.object,
  className: PropTypes$1.string,
  text: PropTypes$1.string,
  imageTop: PropTypes$1.bool,
  minHeight: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
WithProps$5.defaultProps = {
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  },
  url: "/",
  title: "Título",
  name: "Nome",
  text: "Texto",
  subTitle: "texto",
  src: "",
  imageTop: false
};

var Mask$8 = function Mask(_ref) {
  var MaskBgColor = _ref.MaskBgColor,
      props = _objectWithoutProperties(_ref, ["MaskBgColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: MaskBgColor || props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props, {
    className: "loading-mask"
  }));
};

var Loading$a = function Loading(_ref2) {
  var CardBgColor = _ref2.CardBgColor,
      props = _objectWithoutProperties(_ref2, ["CardBgColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "398px",
    backgroundColor: CardBgColor || props.theme.loadings.cardBgColor,
    className: "loading-card d-flex flex-column justify-content-between",
    padding: "30px 20px 20px 0"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginLeft: "20px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "108px"
  }, /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "26px",
    right: "0",
    width: "15%",
    MaskBgColor: CardBgColor
  }, props)), /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "15px",
    top: "26px",
    width: "100%",
    MaskBgColor: CardBgColor
  }, props)), /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "26px",
    top: "41px",
    right: "0",
    width: "10%",
    MaskBgColor: CardBgColor
  }, props)), /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "15px",
    top: "67px",
    width: "100%",
    MaskBgColor: CardBgColor
  }, props)), /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "26px",
    top: "82px",
    right: "0",
    width: "80%",
    MaskBgColor: CardBgColor
  }, props)))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "115px",
    height: "115px",
    backgroundColor: props.theme.loadings.iconContainerBgColor,
    marginRight: "20px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "15px",
    right: "0",
    width: "15%",
    MaskBgColor: CardBgColor
  }, props)), /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "5px",
    top: "15px",
    width: "100%",
    MaskBgColor: CardBgColor
  }, props)), /*#__PURE__*/React.createElement(Mask$8, _extends({
    height: "15px",
    top: "20px",
    right: "0",
    width: "25%",
    MaskBgColor: CardBgColor
  }, props))))));
};

Loading$a.propTypes = {
  className: PropTypes$1.string,
  CardBgColor: PropTypes$1.string
};
var PersonCardLoading = withTheme(Loading$a);

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  position: relative;\n  height: 100%;\n  padding: 10px;\n  min-height: 80px;\n  border-top: 1px solid\n    ", ";\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 0;\n    top: -1px;\n    left: 0;\n    right: 0;\n    background-color: ", ";\n    z-index: 0;\n    transition: height 0.3s ease-in-out;\n  }\n\n  @media (min-width: 768px) {\n    &:hover {\n      ", ";\n      &:after {\n        height: 100%;\n      }\n    }\n  }\n\n  @media (max-width: 767.98px) {\n    ", ";\n    &:after {\n      height: 100%;\n    }\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteral(["\n  .card-title {\n    color: ", ";\n  }\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var titleStyles = css(_templateObject$B(), function (props) {
  return props.theme.highContrast.text || props.titleHoverColor || props.theme.components.showMoreCard.hoverTitleColor;
});
var ShowMoreCardContainer = styled.a(_templateObject2$3(), function (props) {
  return props.theme.components.showMoreCard.borderColor;
}, function (props) {
  return props.theme.components.showMoreCard.hoverBgColor;
}, titleStyles, titleStyles);

var ShowMoreCard = function ShowMoreCard(_ref) {
  var className = _ref.className,
      title = _ref.title,
      theme = _ref.theme,
      href = _ref.href,
      props = _objectWithoutProperties(_ref, ["className", "title", "theme", "href"]);

  return /*#__PURE__*/React.createElement(ShowMoreCardContainer, _extends({
    className: "".concat(className, " d-flex"),
    href: href
  }, props), /*#__PURE__*/React.createElement(ContentContainer, {
    zIndex: "1"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    sizeSmSize: "medium",
    color: theme.components.showMoreCard.titleColor,
    className: "card-title",
    fontWeight: "400"
  }, title)));
};

var types$n = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  title: PropTypes$1.string,
  href: PropTypes$1.string,
  titleHoverColor: PropTypes$1.string
};
var defaults$k = {
  title: "Título"
};
ShowMoreCard.propTypes = types$n;
ShowMoreCard.defaultProps = defaults$k;
var ShowMoreCard$1 = withTheme(ShowMoreCard); //Only used for the Storybook Props Table

var Mask$9 = function Mask(_ref) {
  var MaskBgColor = _ref.MaskBgColor,
      props = _objectWithoutProperties(_ref, ["MaskBgColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: MaskBgColor || props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

var Loading$b = function Loading(_ref2) {
  var CardBgColor = _ref2.CardBgColor,
      props = _objectWithoutProperties(_ref2, ["CardBgColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "100px",
    padding: "12px 0",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "26px"
  }, /*#__PURE__*/React.createElement(Mask$9, _extends({
    height: "26px",
    right: "0",
    width: "15%",
    MaskBgColor: CardBgColor
  }, props))));
};

Loading$b.propTypes = {
  className: PropTypes$1.string,
  CardBgColor: PropTypes$1.string
};
var ShowMoreCardLoading = withTheme(Loading$b);

function _templateObject$C() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n  background-color: ", ";\n\n  //Image Animation\n  img {\n    -webkit-transition: all 0.4s;\n    -moz-transition: all 0.4s;\n    -o-transition: all 0.4s;\n    transition: all 0.4s;\n  }\n\n  &:hover {\n    img {\n      -ms-transform: scale(1.1);\n      -moz-transform: scale(1.1);\n      -webkit-transform: scale(1.1);\n      -o-transform: scale(1.1);\n      transform: scale(1.1);\n    }\n  }\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var CardContainer = styled.a(_templateObject$C(), function (props) {
  return props.backgroundColor;
});

var EventCard = function EventCard(_ref) {
  var backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      image = _ref.image,
      alt = _ref.alt,
      theme = _ref.theme,
      textColor = _ref.textColor,
      orderClasses = _ref.orderClasses,
      padding = _ref.padding,
      mdPadding = _ref.mdPadding,
      xsPadding = _ref.xsPadding,
      hasEndDate = _ref.hasEndDate,
      title = _ref.title,
      description = _ref.description,
      columnClasses = _ref.columnClasses,
      href = _ref.href,
      target = _ref.target,
      cardHeight = _ref.cardHeight,
      changeXlTriangleOrder = _ref.changeXlTriangleOrder,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
  var color = theme.highContrast.text || textColor || theme.components.eventCard.color;
  var bgColor = backgroundColor || theme.components.eventCard.backgroundColor;
  return /*#__PURE__*/React.createElement(CardContainer, {
    target: target,
    href: href,
    tabIndex: "0",
    backgroundColor: bgColor,
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(columnClasses[0], " ").concat(orderClasses[0])
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex flex-column",
    height: "100%",
    padding: padding,
    mdPadding: mdPadding,
    mobileXsPadding: xsPadding,
    position: "relative"
  }, /*#__PURE__*/React.createElement(Triangle, {
    className: "triangle",
    transform: changeXlTriangleOrder ? "rotate(-90deg)" : "rotate(90deg)",
    right: changeXlTriangleOrder ? null : "-48px",
    left: changeXlTriangleOrder ? "-48px" : null,
    withContent: true,
    contentColor: color,
    color: bgColor,
    size: "32px",
    top: "calc(50% - 16px)",
    contentSize: "36px",
    zIndex: "1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "flex-shrink-0",
    marginRight: "10px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xLarge",
    fontWeight: "900",
    lineHeight: "1",
    color: color
  }, moment(startDate).format("DD")), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: color,
    textTransform: "uppercase"
  }, moment(startDate).format("MMM"))), hasEndDate && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    marginTop: "8px",
    name: "fal fa-chevron-right",
    size: "small",
    color: color,
    opacity: "0.6"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    className: "flex-shrink-0",
    marginLeft: "10px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xLarge",
    fontWeight: "900",
    lineHeight: "1",
    color: color,
    opacity: "0.6"
  }, moment(endDate).format("DD")), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: color,
    opacity: "0.6",
    textTransform: "uppercase"
  }, moment(endDate).format("MMM"))))), /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex flex-column justify-content-end",
    marginTop: "auto",
    minHeight: "140px",
    maxHeight: "140px",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    fontWeight: "500",
    color: color
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: color
  }, description)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(columnClasses[1], " ").concat(orderClasses[1])
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: cardHeight,
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: image,
    alt: alt,
    height: "100%"
  })))));
};

var types$o = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  theme: PropTypes$1.object,
  image: PropTypes$1.string,
  alt: PropTypes$1.string,
  textColor: PropTypes$1.string,
  orderClasses: PropTypes$1.array,
  columnClasses: PropTypes$1.array,
  padding: PropTypes$1.string,
  mdPadding: PropTypes$1.string,
  xsPadding: PropTypes$1.string,
  title: PropTypes$1.string,
  description: PropTypes$1.string,
  href: PropTypes$1.string,
  target: PropTypes$1.string,
  cardHeight: PropTypes$1.string,
  hasEndDate: PropTypes$1.bool,
  changeXlTriangleOrder: PropTypes$1.bool,
  startDate: PropTypes$1.string.isRequired,
  endDate: PropTypes$1.string.isRequired
};
var defaults$l = {
  href: "#",
  image: "https://static.ua.pt/images/ua/placeholder-bw.png",
  alt: "Imagem sem alt",
  orderClasses: ["", ""],
  columnClasses: ["col", "col"],
  padding: "30px",
  mdPadding: "30px",
  xsPadding: "10px",
  title: "Título",
  description: "Descrição",
  cardHeight: "300px",
  hasEndDate: true,
  changeXlTriangleOrder: false,
  startDate: "2020-01-15T00:00:00",
  endDate: "2020-01-15T00:00:00"
};
EventCard.propTypes = types$o;
EventCard.defaultProps = defaults$l;
var EventCard$1 = withTheme(EventCard); //Only used for the Storybook Props Table

var Loading$c = function Loading(_ref) {
  var cardHeight = _ref.cardHeight,
      cardBgColor = _ref.cardBgColor,
      columnClasses = _ref.columnClasses,
      orderClasses = _ref.orderClasses,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    className: "row no-gutters d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "45.2px",
    width: "45.2px",
    position: "absolute",
    zIndex: "1",
    transform: "rotate(45deg)",
    backgroundColor: cardBgColor || theme.loadings.cardBgColor
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(columnClasses[0], " ").concat(orderClasses[0])
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex flex-column justify-content-between",
    height: cardHeight,
    padding: "30px",
    mobileXsPadding: "10px",
    backgroundColor: cardBgColor || theme.loadings.cardBgColor
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "54px",
    width: "96px"
  }), /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "60px",
    width: "60%"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "10px",
    width: "100%",
    position: "absolute",
    top: "calc(50% - 5px)",
    backgroundColor: cardBgColor || theme.loadings.cardBgColor
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(columnClasses[1], " ").concat(orderClasses[1])
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: cardHeight,
    backgroundColor: theme.loadings.mainBgColor
  })));
};

Loading$c.propTypes = {
  className: PropTypes$1.string,
  cardBgColor: PropTypes$1.string,
  cardHeight: PropTypes$1.string,
  theme: PropTypes$1.object,
  columnClasses: PropTypes$1.array,
  orderClasses: PropTypes$1.array
};
Loading$c.defaultProps = {
  cardHeight: "300px",
  orderClasses: ["", ""],
  columnClasses: ["col", "col"]
};
var EventCardLoading = withTheme(Loading$c);

function _templateObject$D() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid\n    ", ";\n  padding-bottom: 10px;\n  padding-top: 10px;\n\n  &:first-child {\n    border-top: 1px solid\n      ", ";\n  }\n\n  .horizontal-news-card {\n    display: block;\n    background-color: ", ";\n    height: ", ";\n    .image-container {\n      height: ", ";\n      width: 115px;\n      overflow: hidden;\n    }\n    .content-container {\n      position: relative;\n      height: ", ";\n      padding-right: 20px;\n      .title-container {\n        margin-bottom: 10px;\n        max-height: 42px;\n        overflow: hidden;\n      }\n    }\n    //Image Animation\n    img {\n      -webkit-transition: all 0.4s;\n      -moz-transition: all 0.4s;\n      -o-transition: all 0.4s;\n      transition: all 0.4s;\n    }\n\n    cursor: pointer;\n    &:hover {\n      text-decoration: none;\n      img {\n        -ms-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -webkit-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n      }\n    }\n    &:focus {\n      ", ";\n    }\n  }\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}

var MiniHorizontalNewsCard = function MiniHorizontalNewsCard(_ref) {
  var className = _ref.className,
      title = _ref.title,
      date = _ref.date,
      src = _ref.src,
      alt = _ref.alt,
      backgroundColor = _ref.backgroundColor,
      theme = _ref.theme,
      href = _ref.href,
      linkProps = _ref.linkProps;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Link, _extends({
    tabIndex: 0,
    href: href,
    className: "horizontal-news-card"
  }, linkProps), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container d-flex flex-column justify-content-between"
  }, src !== null && /*#__PURE__*/React.createElement(Triangle, {
    zIndex: "2",
    transform: "rotate(90deg)",
    withContent: true,
    contentColor: theme.components.miniHorizontalNewsCard.triangleContentColor,
    color: backgroundColor || theme.components.miniHorizontalNewsCard.triangleBgColor,
    size: "16px",
    top: "calc(50% - 8px)",
    right: "-24px",
    contentSize: "18px"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    display: "block",
    size: "small",
    fontDecoration: "none",
    fontWeight: "400",
    text: title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(LineTruncate, null, /*#__PURE__*/React.createElement(Text, {
    text: date,
    size: "xSmall",
    color: theme.components.miniHorizontalNewsCard.dateColor
  })))))), src !== null && /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: theme.components.miniHorizontalNewsCard.height
  }))))));
};

var types$p = {
  className: PropTypes$1.string,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  date: PropTypes$1.string,
  src: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  theme: PropTypes$1.func,
  onClick: PropTypes$1.func,
  onKeyPress: PropTypes$1.func,
  href: PropTypes$1.string,
  alt: PropTypes$1.string,
  history: PropTypes$1.object.isRequired,
  linkProps: PropTypes$1.object
};
var defaults$m = {
  category: "Categoria",
  title: "Título",
  date: "data",
  src: "",
  href: "/"
};
MiniHorizontalNewsCard.propTypes = types$p;
MiniHorizontalNewsCard.defaultProps = defaults$m;
var MiniHorizontalNewsCardWithStyles = styled(MiniHorizontalNewsCard)(_templateObject$D(), function (props) {
  return props.theme.components.miniHorizontalNewsCard.borderColor;
}, function (props) {
  return props.theme.components.miniHorizontalNewsCard.borderColor;
}, function (props) {
  return props.backgroundColor || props.theme.components.miniHorizontalNewsCard.backgroundColor;
}, function (props) {
  return props.theme.components.miniHorizontalNewsCard.height;
}, function (props) {
  return props.theme.components.miniHorizontalNewsCard.height;
}, function (props) {
  return props.theme.components.miniHorizontalNewsCard.height;
}, function (props) {
  return props.theme.mixins.focus;
});
var MiniHorizontalNewsCard$1 = compose(withTheme)(MiniHorizontalNewsCardWithStyles); //Only used for the Storybook Props Table

function _templateObject$E() {
  var data = _taggedTemplateLiteral(["\n  .student-card {\n    background-color: ", ";\n    user-select: text;\n    &__image {\n      div:first-child {\n        height: inherit;\n      }\n    }\n\n    &:focus {\n      ", ";\n    }\n\n    .text-container {\n      padding: 20px;\n      border: 1px solid\n        ", ";\n      height: 192px;\n      .content-container {\n        max-height: 150px;\n        overflow: hidden;\n      }\n    }\n\n    .name-container {\n      padding: 20px;\n    }\n  }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}

var StudentCard = function StudentCard(_ref) {
  var className = _ref.className,
      text = _ref.text,
      src = _ref.src,
      alt = _ref.alt,
      imageBgColor = _ref.imageBgColor,
      name = _ref.name,
      about = _ref.about,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      theme = _ref.theme,
      hasColAuto = _ref.hasColAuto;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onFocus: onFocus,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hasColAuto ? "col-auto" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "student-card",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(Text, {
    text: text,
    size: "article",
    lineHeight: "1.6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    height: "120px",
    width: "120px",
    backgroundColor: imageBgColor || theme.components.picture.backgroundColor,
    className: "student-card__image"
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    absoluteSize: "120",
    backgroundColor: imageBgColor || theme.components.picture.backgroundColor,
    data: {
      url: src
    },
    alt: alt,
    height: "100%",
    width: "100%",
    endpoint: function endpoint() {
      return null;
    },
    hasEndpoint: false
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name-container"
  }, /*#__PURE__*/React.createElement(Text, {
    text: name,
    size: "mediumSmall",
    fontWeight: "500"
  }), /*#__PURE__*/React.createElement(Text, {
    text: about,
    size: "small"
  })))))));
};

var types$q = {
  className: PropTypes$1.string,
  text: PropTypes$1.string,
  name: PropTypes$1.string,
  about: PropTypes$1.string,
  src: PropTypes$1.string,
  alt: PropTypes$1.string,
  imageBgColor: PropTypes$1.string,
  onFocus: PropTypes$1.func,
  onKeyDown: PropTypes$1.func,
  theme: PropTypes$1.object,
  hasColAuto: PropTypes$1.bool
};
var defaults$n = {
  text: "Texto",
  name: "Nome",
  about: "Aluno",
  onFocus: function onFocus() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  hasColAuto: true
};
StudentCard.propTypes = types$q;
StudentCard.defaultProps = defaults$n;
var StudentCardWithStyles = styled(StudentCard)(_templateObject$E(), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.theme.components.studentCard.borderColor;
});
var StudentCard$1 = withTheme(StudentCardWithStyles); //Only used for the Storybook Props Table

function _templateObject$F() {
  var data = _taggedTemplateLiteral(["\n  .student-card-link {\n    background-color: ", ";\n    user-select: text;\n    padding: 18px;\n    margin: 2px 0;\n    border: 1px solid\n      ", ";\n    .text-container {\n      height: 176px;\n      overflow: hidden;\n      margin-bottom: 40px;\n    }\n\n    img {\n      -webkit-transition: all 0.4s;\n      -moz-transition: all 0.4s;\n      -o-transition: all 0.4s;\n      transition: all 0.4s;\n    }\n    &:hover {\n      border: 1px solid\n        ", ";\n\n      img {\n        -ms-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -webkit-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n      }\n    }\n    &:active {\n      outline: 2px solid\n        ", ";\n    }\n    .name-container {\n      padding: 0 0 0 18px;\n      max-height: 87px;\n      overflow: hidden;\n    }\n  }\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}

var StudentCardLink = function StudentCardLink(_ref) {
  var className = _ref.className,
      text = _ref.text,
      src = _ref.src,
      alt = _ref.alt,
      imageBgColor = _ref.imageBgColor,
      name = _ref.name,
      about = _ref.about,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      theme = _ref.theme,
      href = _ref.href,
      isEditor = _ref.isEditor;
  var isInternal = href ? href.includes("ua.pt") : false;

  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "student-card-link"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/React.createElement(Text, {
      text: text,
      lineHeight: "30px",
      size: "mediumLarge"
    })), /*#__PURE__*/React.createElement("div", {
      className: "image-name-container d-flex "
    }, /*#__PURE__*/React.createElement(ImageContainer, {
      height: "96px",
      width: "96px",
      minWidth: "96px",
      maxWidth: "96px",
      overflow: "hidden",
      backgroundColor: imageBgColor || theme.components.picture.backgroundColor,
      className: "student-card-link__image"
    }, /*#__PURE__*/React.createElement(ImageWrapper, {
      absoluteSize: "120",
      backgroundColor: imageBgColor || theme.components.picture.backgroundColor,
      data: {
        url: src
      },
      alt: alt,
      height: "100%",
      width: "100%",
      endpoint: function endpoint() {
        return null;
      },
      hasEndpoint: false
    })), /*#__PURE__*/React.createElement("div", {
      className: "col pl-0 pr-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "name-container"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      wordBreak: "break-word"
    }, name), /*#__PURE__*/React.createElement(Text, {
      size: "small",
      wordBreak: "break-word"
    }, about)))))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onFocus: onFocus,
    onKeyDown: onKeyDown
  }, isEditor ? /*#__PURE__*/React.createElement("div", {
    className: "editor-links"
  }, renderContent()) : isInternal ? /*#__PURE__*/React.createElement(Link, {
    fontDecoration: "none",
    href: href,
    hasHover: false
  }, renderContent()) : /*#__PURE__*/React.createElement(LinkExternal, {
    textDecoration: "none",
    href: href,
    isHover: false,
    hasPop: false
  }, renderContent()));
};

var types$r = {
  className: PropTypes$1.string,
  text: PropTypes$1.string,
  name: PropTypes$1.string,
  about: PropTypes$1.string,
  src: PropTypes$1.string,
  alt: PropTypes$1.string,
  imageBgColor: PropTypes$1.string,
  onFocus: PropTypes$1.func,
  onKeyDown: PropTypes$1.func,
  theme: PropTypes$1.object,
  href: PropTypes$1.string,
  isEditor: PropTypes$1.bool
};
var defaults$o = {
  text: "Texto",
  name: "Nome",
  about: "Aluno",
  onFocus: function onFocus() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  hasColAuto: true
};
StudentCardLink.propTypes = types$r;
StudentCardLink.defaultProps = defaults$o;
var StudentCardLinkWithStyles = styled(StudentCardLink)(_templateObject$F(), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.theme.components.studentCardLink.borderColor;
}, function (props) {
  return props.theme.components.studentCardLink.borderColorHover;
}, function (props) {
  return props.theme.components.studentCardLink.borderColorPressed;
});
var StudentCardLink$1 = withTheme(StudentCardLinkWithStyles); //Only used for the Storybook Props Table

function _templateObject$G() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: ", ";\n  .content-container {\n    padding: 20px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 50%;\n    z-index: 1;\n    .h-100 {\n      height: 100%;\n    }\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 992px) {\n    .content-container {\n      ", "\n      .triangle {\n        ", "\n      }\n    }\n  }\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}

var ColorExtractCard = function ColorExtractCard(_ref) {
  var className = _ref.className,
      alt = _ref.alt,
      src = _ref.src,
      share = _ref.share,
      size = _ref.size,
      category = _ref.category,
      title = _ref.title,
      date = _ref.date,
      isOpen = _ref.isOpen,
      theme = _ref.theme;

  //data: {darkMuted, darkVibrant, lightMuted, lightVibrant, muted, vibrant}
  var _usePalette = usePalette(src),
      data = _usePalette.data,
      loading = _usePalette.loading,
      error = _usePalette.error; //Convert hex Color to rgba


  var hex2rgba = function hex2rgba(hex) {
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var _hex$match$map = hex.match(/\w\w/g).map(function (x) {
      return parseInt(x, 16);
    }),
        _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
        r = _hex$match$map2[0],
        g = _hex$match$map2[1],
        b = _hex$match$map2[2];

    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
  };

  var dominantColor = hex2rgba("".concat(data.lightMuted), 0.6);
  var defaultColor = hex2rgba("".concat(theme.components.colorExtractCard.backgroundColor), 0.5);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "content-container",
    backgroundColor: !loading && !error ? theme.highContrast.lightOpacityBgColor || dominantColor : defaultColor
  }, /*#__PURE__*/React.createElement(Triangle, {
    className: "triangle",
    transform: "rotate(90deg)",
    withContent: true,
    color: !loading && !error ? theme.highContrast.lightOpacityBgColor || dominantColor : defaultColor,
    size: "22px",
    top: "calc(50% - 11px)",
    right: "-33px",
    contentSize: "24px",
    zIndex: "1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column justify-content-between h-100"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    text: category,
    fontWeight: "300",
    lineHeight: "1.4",
    mobileXsFontSize: "12px",
    color: theme.components.colorExtractCard.linkColor
  }), /*#__PURE__*/React.createElement(Text, {
    isSerif: true,
    as: "h3",
    size: "large",
    sizeXsSize: "small",
    fontWeight: "400",
    lineHeight: "1.5",
    text: title,
    marginTop: "10px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(LineTruncate, null, /*#__PURE__*/React.createElement(Text, {
    text: date,
    size: "xSmall",
    textTransform: "lowercase"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(SocialMediaActions$1, {
    size: size,
    iconColor: theme.components.colorExtractCard.iconColor,
    share: share,
    isOpen: isOpen
  }))))), /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
    ratio: "sixteenByNine",
    backgroundColor: theme.components.colorExtractCard.backgroundColor
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: "100%"
  })));
};

ColorExtractCard.propTypes = {
  size: PropTypes$1.object,
  share: PropTypes$1.object,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  date: PropTypes$1.string,
  src: PropTypes$1.string,
  className: PropTypes$1.string,
  alt: PropTypes$1.string,
  theme: PropTypes$1.object,
  isOpen: PropTypes$1.bool
};
ColorExtractCard.defaultProps = {
  href: "/",
  category: "Categoria",
  title: "Título",
  date: "Data",
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  },
  alt: "Imagem sem alt",
  src: "https://static.ua.pt/images/ua/placeholder-bw.png"
};
var ColorExtractCardWithStyles = styled(ColorExtractCard)(_templateObject$G(), function (props) {
  return props.theme.components.colorExtractCard.backgroundColor;
}, function (props) {
  return props.changeMdOrder && "\n        right: 0;\n        left: unset;\n      ";
}, function (props) {
  return props.changeMdOrder && "\n        left: -33px;\n        right: unset;\n        transform: rotate(-90deg);\n      ";
});
ColorExtractCardWithStyles.propTypes = {
  changeMdOrder: PropTypes$1.bool
};
ColorExtractCardWithStyles.defaultProps = {
  changeMdOrder: false
};
var index = withTheme(ColorExtractCardWithStyles); //Only used for the Storybook Props Table

var WithProps$6 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(ColorExtractCardWithStyles, props);
};
WithProps$6.propTypes = {
  size: PropTypes$1.object,
  share: PropTypes$1.object,
  category: PropTypes$1.string,
  title: PropTypes$1.string,
  date: PropTypes$1.string,
  src: PropTypes$1.string,
  className: PropTypes$1.string,
  alt: PropTypes$1.string,
  theme: PropTypes$1.object,
  isOpen: PropTypes$1.bool,
  changeMdOrder: PropTypes$1.bool
};
WithProps$6.defaultProps = {
  href: "/",
  category: "Categoria",
  title: "Título",
  date: "Data",
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  },
  alt: "Imagem sem alt",
  src: "https://images.pexels.com/photos/3097297/pexels-photo-3097297.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  changeMdOrder: false
};

var ImageCard = function ImageCard(_ref) {
  var title = _ref.title,
      name = _ref.name,
      email = _ref.email,
      src = _ref.src,
      url = _ref.url,
      hasPhoto = _ref.hasPhoto,
      theme = _ref.theme,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "10px"
  }, hasPhoto && /*#__PURE__*/React.createElement(ContentContainer, {
    overflow: "hidden",
    maxHeight: "150px",
    minHeight: "50px",
    marginBottom: "10px",
    backgroundColor: theme.components.picture.backgroundColor
  }, /*#__PURE__*/React.createElement(Image, {
    width: "100%",
    height: "100%",
    src: src,
    onClick: onClick
  })), /*#__PURE__*/React.createElement(Text, {
    text: title,
    fontWeight: "500",
    marginBottom: "10px",
    size: "small",
    lineHeight: "1"
  })), url === null ? /*#__PURE__*/React.createElement(Text, {
    text: name,
    fontWeight: "300",
    fontSize: "14px"
  }) : /*#__PURE__*/React.createElement(Link, {
    text: name,
    fontWeight: "300",
    fontSize: "14px",
    textDecoration: "underline",
    color: theme.components.imageCard.link.color,
    hoverColor: theme.components.imageCard.link.hoverColor,
    href: "".concat(url),
    title: "ver perfil",
    "default": true
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "5px",
    marginTop: "5px"
  }, /*#__PURE__*/React.createElement(Link, {
    text: email,
    title: email,
    fontWeight: "300",
    fontSize: "14px",
    textDecoration: "underline",
    color: theme.components.imageCard.link.color,
    hoverColor: theme.components.imageCard.link.hoverColor,
    href: "mailto:".concat(email),
    target: "_top",
    "default": true,
    "native": true
  })));
};

ImageCard.defaultProps = {
  hasPhoto: false,
  title: "Título",
  name: "Nome",
  email: "Email"
};
ImageCard.propTypes = {
  title: PropTypes$1.string,
  name: PropTypes$1.string,
  email: PropTypes$1.string,
  src: PropTypes$1.string,
  url: PropTypes$1.string.isRequired,
  hasPhoto: PropTypes$1.bool,
  theme: PropTypes$1.object,
  onClick: PropTypes$1.func
};
var ImageCard$1 = compose(withTheme)(ImageCard);

var IconCard = function IconCard(_ref) {
  var iconName = _ref.iconName,
      linkText = _ref.linkText,
      theme = _ref.theme,
      margin = _ref.margin,
      mobileXsMargin = _ref.mobileXsMargin,
      linkProps = _ref.linkProps,
      favorite = _ref.favorite;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    margin: margin,
    mobileXsMargin: mobileXsMargin,
    width: "64px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex align-items-center justify-content-center",
    height: "64px",
    width: "64px",
    backgroundColor: theme.components.iconCard.iconContainer.backgroundColor,
    marginBottom: "4px"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: "medium",
    color: theme.components.iconCard.iconContainer.iconColor
  })), /*#__PURE__*/React.createElement(Link, _extends({
    size: "xSmall",
    color: theme.components.iconCard.link.color
  }, linkProps), linkText), favorite.show && /*#__PURE__*/React.createElement(Icon, {
    name: "".concat(favorite.check ? "fas" : "fal", " fa-star"),
    onClick: favorite.check ? favorite.remove : favorite.set,
    size: "xSmall",
    color: "#000",
    marginLeft: "5px",
    cursor: "pointer"
  }));
};

var types$s = {
  iconName: PropTypes$1.string,
  linkText: PropTypes$1.string,
  margin: PropTypes$1.string,
  mobileXsMargin: PropTypes$1.string,
  theme: PropTypes$1.object,
  linkProps: PropTypes$1.object,
  favorite: PropTypes$1.object
};
var defaults$p = {
  iconName: "fal fa-paperclip",
  linkText: "texto",
  favorite: {
    show: false,
    check: false,
    set: function set() {
      return null;
    },
    remove: function remove() {
      return null;
    }
  }
};
IconCard.propTypes = types$s;
IconCard.defaultProps = defaults$p;
var IconCard$1 = withTheme(IconCard); //Only used for the Storybook Props Table

function _templateObject$H() {
  var data = _taggedTemplateLiteral(["\n  z-index: ", ";\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  &:focus {\n    ", ";\n  }\n  &.slick-disabled {\n    opacity: 0.4;\n    outline: none;\n    i {\n      cursor: default;\n      &:hover {\n        ", ";\n      }\n    }\n  }\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}

var CustomArrow = function CustomArrow(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      left = _ref.left,
      darken = _ref.darken,
      ariaLabel = _ref.ariaLabel,
      tabIndex = _ref.tabIndex,
      theme = _ref.theme,
      arrowSize = _ref.arrowSize,
      props = _objectWithoutProperties(_ref, ["className", "onClick", "left", "darken", "ariaLabel", "tabIndex", "theme", "arrowSize"]);

  return /*#__PURE__*/React.createElement("button", {
    className: className,
    onClick: onClick,
    "aria-label": ariaLabel,
    tabIndex: tabIndex
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    name: "".concat(left ? theme.icons.chevron_left : theme.icons.chevron_right),
    darken: darken,
    color: props.color || theme.components.customArrow.customArrowColor
  }, props, {
    size: arrowSize || "xLarge"
  })));
};

CustomArrow.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  name: PropTypes$1.string,
  onClick: PropTypes$1.func,
  style: PropTypes$1.shape({}),
  darken: PropTypes$1.bool,
  left: PropTypes$1.bool,
  tabIndex: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  ariaLabel: PropTypes$1.string,
  theme: PropTypes$1.object,
  color: PropTypes$1.string,
  arrowSize: PropTypes$1.string
};
CustomArrow.defaultProps = {
  left: false,
  darken: false,
  tabIndex: "-1"
};
var CustomArrowWithStyles = styled(CustomArrow)(_templateObject$H(), function (props) {
  return props.zIndex || "2";
}, function (props) {
  return props.theme.mixins.focus();
}, function (props) {
  return props.darken ? "color: ".concat(darken(0, props.color || props.theme.components.customArrow.customArrowColor)) : "color: ".concat(lighten(0, props.color || props.theme.components.customArrow.customArrowColor));
});
var CustomArrow$1 = withTheme(CustomArrowWithStyles); //Only used for the Storybook Props Table

var WithProps$7 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(CustomArrowWithStyles, props);
};
WithProps$7.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  name: PropTypes$1.string,
  onClick: PropTypes$1.func,
  style: PropTypes$1.shape({}),
  darken: PropTypes$1.bool,
  left: PropTypes$1.bool,
  tabIndex: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  ariaLabel: PropTypes$1.string,
  theme: PropTypes$1.object,
  color: PropTypes$1.string,
  arrowSize: PropTypes$1.string,
  zIndex: PropTypes$1.string
};
WithProps$7.defaultProps = {
  left: false,
  darken: false,
  tabIndex: "-1",
  zIndex: "2",
  arrowSize: "xLarge"
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: ", ";\n  padding-top: ", ";\n  padding-right: 0;\n  padding-left: 0;\n\n  .carousel-legend {\n    font-size: 12px;\n    color: ", ";\n  }\n\n  .slick-prev {\n    left: ", ";\n  }\n  .slick-next {\n    right: ", ";\n  }\n  .slick-next,\n  .slick-prev {\n    width: auto;\n    height: 35px;\n    top: calc(50% - (35px / 2));\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-active {\n    &:before {\n      content: \"\";\n      width: 0;\n      height: 0;\n    }\n  }\n\n  .slick-dots {\n    li {\n      &:before {\n        height: 0;\n      }\n    }\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  img {\n    margin-left: auto;\n    margin-right: auto;\n    width: 100% !important;\n    object-fit: cover;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    height: ", ";\n\n    margin-bottom: ", ";\n    @media (max-width: 767px) {\n      height: ", ";\n    }\n  }\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}

var Carousel = function Carousel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      shouldStretchVertical = _ref.shouldStretchVertical,
      isComponents = _ref.isComponents;
  var lineBreak = "\n"; // remove lineBreaks

  var filteredImages = useMemo(function () {
    return !isComponents && children.filter(function (element) {
      return element !== lineBreak;
    });
  }, [children, isComponents]);
  return /*#__PURE__*/React.createElement(Slider, {
    tabIndex: -1,
    useTransform: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    initialSlide: 0,
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "slide anterior",
      left: true,
      darken: true,
      tabIndex: 0
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "pr\xF3ximo slide",
      darken: true,
      tabIndex: 0
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 575,
      settings: {
        arrows: false,
        dots: true
      }
    }],
    className: className
  }, isComponents ? children : children && filteredImages.map(function (image, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(ImageWrapper$1, {
      shouldStretchVertical: shouldStretchVertical
    }, image), image.props.title && /*#__PURE__*/React.createElement(Text, {
      className: "carousel-legend",
      marginTop: "15px"
    }, image.props.title));
  }));
};

Carousel.propTypes = {
  className: PropTypes$1.string,
  children: PropTypes$1.node.isRequired,
  shouldStretchVertical: PropTypes$1.bool,
  hasVerticalSpacing: PropTypes$1.bool,
  isComponents: PropTypes$1.bool
};
Carousel.defaultProps = {
  className: "",
  shouldStretchVertical: false,
  hasVerticalSpacing: true,
  isComponents: false
};
var ImageWrapper$1 = styled.div(_templateObject$I(), function (props) {
  return props.theme.colors.greyBg;
}, function (props) {
  return props.shouldStretchVertical ? "600px" : "300px";
}, function (props) {
  return props.shouldStretchVertical ? "-3px" : "0px";
}, function (props) {
  return props.shouldStretchVertical ? "60vh" : "300px";
});
var CarouselWithStyles = styled(Carousel)(_templateObject2$4(), function (props) {
  return props.hasVerticalSpacing ? props.theme.spacing.l : 0;
}, function (props) {
  return props.theme.spacing.xl1;
}, function (props) {
  return lighten(0.6, props.theme.components.carousel.legendColor);
}, function (props) {
  return props.shouldStretchVertical ? "-35px" : "-25px";
}, function (props) {
  return props.shouldStretchVertical ? "-35px" : "-25px";
}, function (props) {
  return props.theme.components.carousel.dotsColor;
});

var WithProps$8 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(CarouselWithStyles, props);
};
WithProps$8.propTypes = {
  className: PropTypes$1.string,
  children: PropTypes$1.node.isRequired,
  shouldStretchVertical: PropTypes$1.bool,
  hasVerticalSpacing: PropTypes$1.bool,
  isComponents: PropTypes$1.bool
};
WithProps$8.defaultProps = {
  className: "",
  shouldStretchVertical: false,
  hasVerticalSpacing: true,
  isComponents: false
};

function _templateObject$J() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: ", ";\n  padding-top: ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}

var VideoPlayer = function VideoPlayer(_ref) {
  var className = _ref.className,
      url = _ref.url,
      props = _objectWithoutProperties(_ref, ["className", "url"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/React.createElement(ReactPlayer, _extends({
    className: "react-player",
    url: url,
    width: "100%",
    height: "100%",
    controls: true
  }, props)));
};

VideoPlayer.propTypes = {
  className: PropTypes$1.string,
  url: PropTypes$1.string.isRequired
};
VideoPlayer.defaultProps = {
  className: ""
};
var VideoPlayer$1 = styled(VideoPlayer)(_templateObject$J(), function (props) {
  return props.height;
}, function (props) {
  return props.paddingTop || "56.25%";
}, function (props) {
  return props.marginBottom || props.theme.spacing.xl3;
}, function (props) {
  return props.marginTop || props.theme.spacing.xl1;
});

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  table {\n    width: ", ";\n    margin-top: ", ";\n    border-collapse: collapse;\n    border-spacing: 0;\n    color: ", ";\n  }\n\n  tbody {\n    vertical-align: top;\n  }\n\n  caption {\n    font-size: 28px;\n    font-weight: 500;\n    line-height: 1.4;\n  }\n\n  tbody td {\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n\n  thead th {\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n\n  th,\n  td,\n  caption {\n    text-align: left;\n  }\n\n  tr th:first-child,\n  tr td:first-child {\n    //word-break: break-word;\n    word-break: initial;\n  }\n\n  tr th:nth-child(2),\n  tr td:nth-child(2) {\n    width: ", ";\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  tr th:nth-child(3),\n  tr td:nth-child(3) {\n    width: ", ";\n  }\n\n  tr th:nth-child(4),\n  tr td:nth-child(4) {\n    width: ", ";\n  }\n\n  // Small devices (landscape phones, 576px and up)\n  @media (max-width: 576px) {\n    tr th:nth-child(2),\n    tr td:nth-child(2) {\n      width: ", ";\n    }\n\n    tr th:nth-child(3),\n    tr td:nth-child(3) {\n      width: ", ";\n    }\n\n    tr th:nth-child(4),\n    tr td:nth-child(4) {\n      width: ", ";\n    }\n  }\n\n  tbody td {\n    border-top: ", ";\n    border-bottom: ", ";\n  }\n\n  /*An option has color*/\n  .option {\n    color: ", ";\n  }\n\n  /*An option inside minor has indent and color*/\n  .option-inside-minor {\n    margin-left: 10px;\n    display: block;\n  }\n\n  /*A minor has color and weight*/\n  .minor {\n    font-weight: 400;\n    color: ", ";\n  }\n\n  .last-child {\n    padding-top: 20px;\n    font-weight: 400;\n  }\n\n  .if-has-links {\n    a {\n      text-decoration: underline;\n    }\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$K() {
  var data = _taggedTemplateLiteral(["\n  /*indent for a div with \xB7*/\n  .indent {\n    margin: 0 5px 0 ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}

var Indent = function Indent(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "indent"
  }, "\xB7")), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, children));
};

Indent.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string
};
var IndentWithStyles = styled(Indent)(_templateObject$K(), function (props) {
  return props["double"] ? "20px" : "10px";
}, function (props) {
  return props.theme.components.table.indentColor;
});

var Table = function Table(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      width = _ref2.width;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("table", {
    width: width
  }, children));
};

Table.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  width: PropTypes$1.string
};
var TableWithStyles = styled(Table)(_templateObject2$5(), function (props) {
  return props.width;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.theme.components.table.textColor;
}, function (props) {
  return props.tableRowSpace;
}, function (props) {
  return props.tableRowSpace;
}, function (props) {
  return props.tableHeaderMarginTop;
}, function (props) {
  return props.tableRowSpace;
}, function (props) {
  return props.col2Size;
}, function (props) {
  return props.col3Size;
}, function (props) {
  return props.col4Size;
}, function (props) {
  return props.col2SizeMobile;
}, function (props) {
  return props.col3SizeMobile;
}, function (props) {
  return props.col4SizeMobile;
}, function (props) {
  return props.borders ? "1px solid ".concat(props.theme.components.table.borderColor) : props.lightBorders ? "1px solid ".concat(props.theme.components.table.borderLightColor) : null;
}, function (props) {
  return props.borders ? "1px solid ".concat(props.theme.components.table.borderColor) : props.lightBorders ? "1px solid ".concat(props.theme.components.table.borderLightColor) : null;
}, function (props) {
  return props.theme.highContrast.text || props.activeColor || props.theme.components.table.optionColor;
}, function (props) {
  return props.theme.highContrast.text || props.activeColor || props.theme.components.table.optionColor;
});
TableWithStyles.defaultProps = {
  width: "100%",
  tableRowSpace: "6px",
  marginTop: "40px",
  tableHeaderMarginTop: "20px"
};

var WithProps$9 = function WithProps(props) {
  return /*#__PURE__*/React.createElement(TableWithStyles, props);
};
WithProps$9.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  width: PropTypes$1.string,
  tableRowSpace: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  tableHeaderMarginTop: PropTypes$1.string,
  col2Size: PropTypes$1.string,
  col3Size: PropTypes$1.string,
  col4Size: PropTypes$1.string,
  col2SizeMobile: PropTypes$1.string,
  col3SizeMobile: PropTypes$1.string,
  col4SizeMobile: PropTypes$1.string,
  borders: PropTypes$1.bool,
  lightBorders: PropTypes$1.bool,
  activeColor: PropTypes$1.string
};
WithProps$9.defaultProps = {
  width: "100%",
  tableRowSpace: "6px",
  marginTop: "40px",
  tableHeaderMarginTop: "20px"
};

var global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title$1 = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};

function noop() {}

var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var browser$1 = {
  nextTick: nextTick,
  title: title$1,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

var reg = /[\'\"]/;

var unquote = function unquote(str) {
  if (!str) {
    return ''
  }
  if (reg.test(str.charAt(0))) {
    str = str.substr(1);
  }
  if (reg.test(str.charAt(str.length - 1))) {
    str = str.substr(0, str.length - 1);
  }
  return str
};

var _extends$1=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_typeof=typeof Symbol=='function'&&typeof Symbol.iterator=='symbol'?function(a){return typeof a}:function(a){return a&&typeof Symbol=='function'&&a.constructor===Symbol&&a!==Symbol.prototype?'symbol':typeof a};function _objectWithoutProperties$1(a,b){var c={};for(var d in a)b.indexOf(d)>=0||Object.prototype.hasOwnProperty.call(a,d)&&(c[d]=a[d]);return c}var ATTRIBUTE_TO_JSX_PROP_MAP={accesskey:'accessKey',allowfullscreen:'allowFullScreen',allowtransparency:'allowTransparency',autocomplete:'autoComplete',autofocus:'autoFocus',autoplay:'autoPlay',cellpadding:'cellPadding',cellspacing:'cellSpacing',charset:'charSet',class:'className',classid:'classId',colspan:'colSpan',contenteditable:'contentEditable',contextmenu:'contextMenu',crossorigin:'crossOrigin',enctype:'encType',for:'htmlFor',formaction:'formAction',formenctype:'formEncType',formmethod:'formMethod',formnovalidate:'formNoValidate',formtarget:'formTarget',frameborder:'frameBorder',hreflang:'hrefLang',inputmode:'inputMode',keyparams:'keyParams',keytype:'keyType',marginheight:'marginHeight',marginwidth:'marginWidth',maxlength:'maxLength',mediagroup:'mediaGroup',minlength:'minLength',novalidate:'noValidate',radiogroup:'radioGroup',readonly:'readOnly',rowspan:'rowSpan',spellcheck:'spellCheck',srcdoc:'srcDoc',srclang:'srcLang',srcset:'srcSet',tabindex:'tabIndex',usemap:'useMap'},namedCodesToUnicode={amp:'&',apos:'\'',gt:'>',lt:'<',nbsp:'\xA0',quot:'\u201C'},DO_NOT_PROCESS_HTML_ELEMENTS=['style','script'],ATTR_EXTRACTOR_R=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,AUTOLINK_MAILTO_CHECK_R=/mailto:/i,BLOCK_END_R=/\n{2,}$/,BLOCKQUOTE_R=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,BLOCKQUOTE_TRIM_LEFT_MULTILINE_R=/^ *> ?/gm,BREAK_LINE_R=/^ {2,}\n/,BREAK_THEMATIC_R=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,CODE_BLOCK_FENCED_R=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,CODE_BLOCK_R=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,CODE_INLINE_R=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,CONSECUTIVE_NEWLINE_R=/^(?:\n *)*\n/,CR_NEWLINE_R=/\r\n?/g,FOOTNOTE_R=/^\[\^(.*)\](:.*)\n/,FOOTNOTE_REFERENCE_R=/^\[\^(.*)\]/,FORMFEED_R=/\f/g,GFM_TASK_R=/^\s*?\[(x|\s)\]/,HEADING_R=/^ *(#{1,6}) *([^\n]+)\n{0,2}/,HEADING_SETEXT_R=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,HTML_BLOCK_ELEMENT_R=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,HTML_CHAR_CODE_R=/&([a-z]+);/g,HTML_COMMENT_R=/^<!--.*?-->/,HTML_CUSTOM_ATTR_R=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,HTML_SELF_CLOSING_ELEMENT_R=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,INTERPOLATION_R=/^\{.*\}$/,LINK_AUTOLINK_BARE_URL_R=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,LINK_AUTOLINK_MAILTO_R=/^<([^ >]+@[^ >]+)>/,LINK_AUTOLINK_R=/^<([^ >]+:\/[^ >]+)>/,LIST_ITEM_END_R=/ *\n+$/,LIST_LOOKBEHIND_R=/(?:^|\n)( *)$/,CAPTURE_LETTER_AFTER_HYPHEN=/-([a-z])?/gi,NP_TABLE_R=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,PARAGRAPH_R=/^((?:[^\n]|\n(?! *\n))+)(?:\n *)+\n/,REFERENCE_IMAGE_OR_LINK=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,REFERENCE_IMAGE_R=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,REFERENCE_LINK_R=/^\[([^\]]*)\] ?\[([^\]]*)\]/,SQUARE_BRACKETS_R=/(\[|\])/g,SHOULD_RENDER_AS_BLOCK_R=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,TAB_R=/\t/g,TABLE_SEPARATOR_R=/^ *\| */,TABLE_TRIM_PIPES=/(^ *\||\| *$)/g,TABLE_CELL_END_TRIM=/ *$/,TABLE_CENTER_ALIGN=/^ *:-+: *$/,TABLE_LEFT_ALIGN=/^ *:-+ *$/,TABLE_RIGHT_ALIGN=/^ *-+: *$/,TEXT_BOLD_R=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,TEXT_EMPHASIZED_R=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1)/,TEXT_STRIKETHROUGHED_R=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,TEXT_ESCAPED_R=/^\\([^0-9A-Za-z\s])/,TEXT_PLAIN_R=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,TRIM_NEWLINES_AND_TRAILING_WHITESPACE_R=/(^\n+|\n+$|\s+$)/g,HTML_LEFT_TRIM_AMOUNT_R=/^([ \t]*)/,UNESCAPE_URL_R=/\\([^0-9A-Z\s])/gi,LIST_ITEM_PREFIX_R=/^( *)((?:[*+-]|\d+\.)) +/,LIST_ITEM_R=/( *)((?:[*+-]|\d+\.)) +[^\n]*(?:\n(?!\1(?:[*+-]|\d+\.) )[^\n]*)*(\n|$)/gm,LIST_R=/^( *)((?:[*+-]|\d+\.)) [\s\S]+?(?:\n{2,}(?! )(?!\1(?:[*+-]|\d+\.) (?!(?:[*+-]|\d+\.) ))\n*|\s*\n*$)/,LINK_R=/^\[((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/,IMAGE_R=/^!\[((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/,BLOCK_SYNTAXES=[BLOCKQUOTE_R,CODE_BLOCK_R,CODE_BLOCK_FENCED_R,HEADING_R,HEADING_SETEXT_R,HTML_BLOCK_ELEMENT_R,HTML_COMMENT_R,HTML_SELF_CLOSING_ELEMENT_R,LIST_ITEM_R,LIST_R,NP_TABLE_R,PARAGRAPH_R];function containsBlockSyntax(a){return BLOCK_SYNTAXES.some(function(b){return b.test(a)})}function slugify(a){return a.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,'a').replace(/[çÇ]/g,'c').replace(/[ðÐ]/g,'d').replace(/[ÈÉÊËéèêë]/g,'e').replace(/[ÏïÎîÍíÌì]/g,'i').replace(/[Ññ]/g,'n').replace(/[øØœŒÕõÔôÓóÒò]/g,'o').replace(/[ÜüÛûÚúÙù]/g,'u').replace(/[ŸÿÝý]/g,'y').replace(/[^a-z0-9- ]/gi,'').replace(/ /gi,'-').toLowerCase()}function parseTableAlignCapture(a){if(TABLE_RIGHT_ALIGN.test(a))return 'right';return TABLE_CENTER_ALIGN.test(a)?'center':TABLE_LEFT_ALIGN.test(a)?'left':null}function parseTableRow(a,b,c){var d=c.inTable;c.inTable=!0;var e=b(a.trim(),c);c.inTable=d;var f=[[]];return e.forEach(function(a,b){a.type==='tableSeparator'?b!==0&&b!==e.length-1&&f.push([]):(a.type==='text'&&(e[b+1]==null||e[b+1].type==='tableSeparator')&&(a.content=a.content.replace(TABLE_CELL_END_TRIM,'')),f[f.length-1].push(a));}),f}function parseTableAlign(a){var b=a.replace(TABLE_TRIM_PIPES,'').split('|');return b.map(parseTableAlignCapture)}function parseTableCells(a,b,c){var d=a.trim().split('\n');return d.map(function(a){return parseTableRow(a,b,c)})}function parseTable(a,b,c){c.inline=!0;var d=parseTableRow(a[1],b,c),e=parseTableAlign(a[2]),f=parseTableCells(a[3],b,c);return c.inline=!1,{align:e,cells:f,header:d,type:'table'}}function getTableStyle(a,b){return a.align[b]==null?{}:{textAlign:a.align[b]}}function normalizeAttributeKey(a){var b=a.indexOf('-');return b!==-1&&a.match(HTML_CUSTOM_ATTR_R)===null&&(a=a.replace(CAPTURE_LETTER_AFTER_HYPHEN,function(a,b){return b.toUpperCase()})),a}function attributeValueToJSXPropValue(a,b){return a==='style'?b.split(/;\s?/).reduce(function(a,b){var c=b.slice(0,b.indexOf(':')),d=c.replace(/(-[a-z])/g,function(a){return a[1].toUpperCase()});return a[d]=b.slice(c.length+1).trim(),a},{}):a==='href'?sanitizeUrl(b):(b.match(INTERPOLATION_R)&&(b=b.slice(1,b.length-1)),b==='true'||b!=='false'&&b)}function normalizeWhitespace(a){return a.replace(CR_NEWLINE_R,'\n').replace(FORMFEED_R,'').replace(TAB_R,'    ')}function parserFor(a){function b(d,e){for(var f=[],g='';d;)for(var l=0;l<c.length;){var h=c[l],j=a[h],k=j.match(d,e,g);if(k){var i=k[0];d=d.substring(i.length);var m=j.parse(k,b,e);m.type==null&&(m.type=h),f.push(m),g=i;break}l++;}return f}var c=Object.keys(a);return c.forEach(function(b){var c=a[b].order;typeof c=='number'&&isFinite(c)||console.warn('markdown-to-jsx: Invalid order for rule `'+b+'`: '+c);}),c.sort(function(b,c){var d=a[b].order,e=a[c].order;return d===e?b<c?-1:1:d-e}),function(a,c){return b(normalizeWhitespace(a),c)}}function inlineRegex(a){return function(b,c){return c.inline?a.exec(b):null}}function simpleInlineRegex(a){return function(b,c){return c.inline||c.simple?a.exec(b):null}}function blockRegex(a){return function(b,c){return c.inline||c.simple?null:a.exec(b)}}function anyScopeRegex(a){return function(b){return a.exec(b)}}function reactFor(a){return function b(c,d){if(d=d||{},Array.isArray(c)){for(var e=d.key,f=[],g=!1,h=0;h<c.length;h++){d.key=h;var j=b(c[h],d),k=typeof j=='string';k&&g?f[f.length-1]+=j:f.push(j),g=k;}return d.key=e,f}return a(c,b,d)}}function sanitizeUrl(a){try{var b=decodeURIComponent(a);if(b.match(/^\s*javascript:/i))return browser$1.env.NODE_ENV!=='production'&&console.warn('Anchor URL contains an unsafe JavaScript expression, it will not be rendered.',b),null}catch(b){return console.warn('Anchor URL could not be decoded due to malformed syntax or characters, it will not be rendered.',a),null}return a}function unescapeUrl(a){return a.replace(UNESCAPE_URL_R,'$1')}function parseInline(a,b,c){var d=c.inline||!1,e=c.simple||!1;c.inline=!0,c.simple=!0;var f=a(b,c);return c.inline=d,c.simple=e,f}function parseSimpleInline(a,b,c){var d=c.inline||!1,e=c.simple||!1;c.inline=!1,c.simple=!0;var f=a(b,c);return c.inline=d,c.simple=e,f}function parseBlock(a,b,c){return c.inline=!1,a(b+'\n\n',c)}function parseCaptureInline(a,b,c){return {content:parseInline(b,a[1],c)}}function captureNothing(){return {}}function renderNothing(){return null}function ruleOutput(a){return function(b,c,d){return a[b.type].react(b,c,d)}}function cx(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];return b.filter(Boolean).join(' ')}function get(a,b,c){for(var d=a,e=b.split('.');e.length&&(d=d[e[0]],d!==void 0);)e.shift();return d||c}function getTag(a,b){var c=get(b,a);return c?typeof c=='function'||(typeof c=='undefined'?'undefined':_typeof(c))==='object'&&'render'in c?c:get(b,a+'.component',a):a}var PARSE_PRIORITY_MAX=1,PARSE_PRIORITY_HIGH=2,PARSE_PRIORITY_MED=3,PARSE_PRIORITY_LOW=4,PARSE_PRIORITY_MIN=5;function compiler(a,b){function d(a,c){for(var d=get(b.overrides,a+'.props',{}),e=arguments.length,g=Array(e>2?e-2:0),h=2;h<e;h++)g[h-2]=arguments[h];return f.apply(void 0,[getTag(a,b.overrides),_extends$1({},c,d,{className:cx(c&&c.className,d.className)||void 0})].concat(g))}function c(a){var c=!1;b.forceInline?c=!0:!b.forceBlock&&(c=SHOULD_RENDER_AS_BLOCK_R.test(a)===!1);var e=k(j(c?a:a.replace(TRIM_NEWLINES_AND_TRAILING_WHITESPACE_R,'')+'\n\n',{inline:c})),f=void 0;return e.length>1?f=c?d('span',{key:'outer'},e):d('div',{key:'outer'},e):e.length===1?(f=e[0],typeof f=='string'&&(f=d('span',{key:'outer'},f))):f=d('span',{key:'outer'}),f}function e(a){var b=a.match(ATTR_EXTRACTOR_R);return b?b.reduce(function(a,b,d){var e=b.indexOf('=');if(e!==-1){var f=normalizeAttributeKey(b.slice(0,e)).trim(),g=unquote(b.slice(e+1).trim()),h=ATTRIBUTE_TO_JSX_PROP_MAP[f]||f,i=a[h]=attributeValueToJSXPropValue(f,g);(HTML_BLOCK_ELEMENT_R.test(i)||HTML_SELF_CLOSING_ELEMENT_R.test(i))&&(a[h]=React.cloneElement(c(i.trim()),{key:d}));}else b!=='style'&&(a[ATTRIBUTE_TO_JSX_PROP_MAP[b]||b]=!0);return a},{}):void 0}b=b||{},b.overrides=b.overrides||{},b.slugify=b.slugify||slugify,b.namedCodesToUnicode=b.namedCodesToUnicode?_extends$1({},namedCodesToUnicode,b.namedCodesToUnicode):namedCodesToUnicode;var f=b.createElement||React.createElement;{if(typeof a!='string')throw new Error('markdown-to-jsx: the first argument must be\n                             a string');if(Object.prototype.toString.call(b.overrides)!=='[object Object]')throw new Error('markdown-to-jsx: options.overrides (second argument property) must be\n                             undefined or an object literal with shape:\n                             {\n                                htmltagname: {\n                                    component: string|ReactComponent(optional),\n                                    props: object(optional)\n                                }\n                             }')}var g=[],h={},i={blockQuote:{match:blockRegex(BLOCKQUOTE_R),order:PARSE_PRIORITY_HIGH,parse:function d(a,b,c){return {content:b(a[0].replace(BLOCKQUOTE_TRIM_LEFT_MULTILINE_R,''),c)}},react:function e(a,b,c){return d('blockquote',{key:c.key},b(a.content,c))}},breakLine:{match:anyScopeRegex(BREAK_LINE_R),order:PARSE_PRIORITY_HIGH,parse:captureNothing,react:function e(a,b,c){return d('br',{key:c.key})}},breakThematic:{match:blockRegex(BREAK_THEMATIC_R),order:PARSE_PRIORITY_HIGH,parse:captureNothing,react:function e(a,b,c){return d('hr',{key:c.key})}},codeBlock:{match:blockRegex(CODE_BLOCK_R),order:PARSE_PRIORITY_MAX,parse:function c(a){var b=a[0].replace(/^ {4}/gm,'').replace(/\n+$/,'');return {content:b,lang:void 0}},react:function e(a,b,c){return d('pre',{key:c.key},d('code',{className:a.lang?'lang-'+a.lang:''},a.content))}},codeFenced:{match:blockRegex(CODE_BLOCK_FENCED_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return {content:a[3],lang:a[2]||void 0,type:'codeBlock'}}},codeInline:{match:simpleInlineRegex(CODE_INLINE_R),order:PARSE_PRIORITY_LOW,parse:function b(a){return {content:a[2]}},react:function e(a,b,c){return d('code',{key:c.key},a.content)}},footnote:{match:blockRegex(FOOTNOTE_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return g.push({footnote:a[2],identifier:a[1]}),{}},react:renderNothing},footnoteReference:{match:inlineRegex(FOOTNOTE_REFERENCE_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return {content:a[1],target:'#'+a[1]}},react:function e(a,b,c){return d('a',{key:c.key,href:sanitizeUrl(a.target)},d('sup',{key:c.key},a.content))}},gfmTask:{match:inlineRegex(GFM_TASK_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return {completed:a[1].toLowerCase()==='x'}},react:function e(a,b,c){return d('input',{checked:a.completed,key:c.key,readOnly:!0,type:'checkbox'})}},heading:{match:blockRegex(HEADING_R),order:PARSE_PRIORITY_HIGH,parse:function e(a,c,d){return {content:parseInline(c,a[2],d),id:b.slugify(a[2]),level:a[1].length}},react:function f(a,b,c){var e='h'+a.level;return d(e,{id:a.id,key:c.key},b(a.content,c))}},headingSetext:{match:blockRegex(HEADING_SETEXT_R),order:PARSE_PRIORITY_MAX,parse:function d(a,b,c){return {content:parseInline(b,a[1],c),level:a[2]==='='?1:2,type:'heading'}}},htmlComment:{match:anyScopeRegex(HTML_COMMENT_R),order:PARSE_PRIORITY_HIGH,parse:function a(){return {}},react:renderNothing},image:{match:simpleInlineRegex(IMAGE_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return {alt:a[1],target:unescapeUrl(a[2]),title:a[3]}},react:function e(a,b,c){return d('img',{key:c.key,alt:a.alt||void 0,title:a.title||void 0,src:sanitizeUrl(a.target)})}},link:{match:inlineRegex(LINK_R),order:PARSE_PRIORITY_LOW,parse:function d(a,b,c){return {content:parseSimpleInline(b,a[1],c),target:unescapeUrl(a[2]),title:a[3]}},react:function e(a,b,c){return d('a',{key:c.key,href:sanitizeUrl(a.target),title:a.title},b(a.content,c))}},linkAngleBraceStyleDetector:{match:inlineRegex(LINK_AUTOLINK_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return {content:[{content:a[1],type:'text'}],target:a[1],type:'link'}}},linkBareUrlDetector:{match:inlineRegex(LINK_AUTOLINK_BARE_URL_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return {content:[{content:a[1],type:'text'}],target:a[1],title:void 0,type:'link'}}},linkMailtoDetector:{match:inlineRegex(LINK_AUTOLINK_MAILTO_R),order:PARSE_PRIORITY_MAX,parse:function d(a){var b=a[1],c=a[1];return AUTOLINK_MAILTO_CHECK_R.test(c)||(c='mailto:'+c),{content:[{content:b.replace('mailto:',''),type:'text'}],target:c,type:'link'}}},list:{match:function f(a,b,c){var d=LIST_LOOKBEHIND_R.exec(c),e=b._list||!b.inline;return d&&e?(a=d[1]+a,LIST_R.exec(a)):null},order:PARSE_PRIORITY_HIGH,parse:function j(a,b,c){var d=a[2],e=d.length>1,f=e?+d:void 0,g=a[0].replace(BLOCK_END_R,'\n').match(LIST_ITEM_R),h=!1,i=g.map(function(a,d){var e=LIST_ITEM_PREFIX_R.exec(a)[0].length,f=new RegExp('^ {1,'+e+'}','gm'),i=a.replace(f,'').replace(LIST_ITEM_PREFIX_R,''),j=d===g.length-1,k=i.indexOf('\n\n')!==-1,l=k||j&&h;h=l;var m=c.inline,n=c._list;c._list=!0;var o;l?(c.inline=!1,o=i.replace(LIST_ITEM_END_R,'\n\n')):(c.inline=!0,o=i.replace(LIST_ITEM_END_R,''));var p=b(o,c);return c.inline=m,c._list=n,p});return {items:i,ordered:e,start:f}},react:function f(a,b,c){var e=a.ordered?'ol':'ul';return d(e,{key:c.key,start:a.start},a.items.map(function(a,e){return d('li',{key:e},b(a,c))}))}},newlineCoalescer:{match:blockRegex(CONSECUTIVE_NEWLINE_R),order:PARSE_PRIORITY_LOW,parse:captureNothing,react:function a(){return '\n'}},paragraph:{match:blockRegex(PARAGRAPH_R),order:PARSE_PRIORITY_LOW,parse:parseCaptureInline,react:function e(a,b,c){return d('p',{key:c.key},b(a.content,c))}},ref:{match:inlineRegex(REFERENCE_IMAGE_OR_LINK),order:PARSE_PRIORITY_MAX,parse:function b(a){return h[a[1]]={target:a[2],title:a[4]},{}},react:renderNothing},refImage:{match:simpleInlineRegex(REFERENCE_IMAGE_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return {alt:a[1]||void 0,ref:a[2]}},react:function e(a,b,c){return d('img',{key:c.key,alt:a.alt,src:sanitizeUrl(h[a.ref].target),title:h[a.ref].title})}},refLink:{match:inlineRegex(REFERENCE_LINK_R),order:PARSE_PRIORITY_MAX,parse:function d(a,b,c){return {content:b(a[1],c),fallbackContent:b(a[0].replace(SQUARE_BRACKETS_R,'\\$1'),c),ref:a[2]}},react:function e(a,b,c){return h[a.ref]?d('a',{key:c.key,href:sanitizeUrl(h[a.ref].target),title:h[a.ref].title},b(a.content,c)):d('span',{key:c.key},b(a.fallbackContent,c))}},table:{match:blockRegex(NP_TABLE_R),order:PARSE_PRIORITY_HIGH,parse:parseTable,react:function f(a,b,e){return d('table',{key:e.key},d('thead',null,d('tr',null,a.header.map(function(c,f){return d('th',{key:f,style:getTableStyle(a,f)},b(c,e))}))),d('tbody',null,a.cells.map(function(c,f){return d('tr',{key:f},c.map(function(f,g){return d('td',{key:g,style:getTableStyle(a,g)},b(f,e))}))})))}},tableSeparator:{match:function c(a,b){return b.inTable?TABLE_SEPARATOR_R.exec(a):null},order:PARSE_PRIORITY_HIGH,parse:function a(){return {type:'tableSeparator'}},react:function a(){return ' | '}},text:{match:anyScopeRegex(TEXT_PLAIN_R),order:PARSE_PRIORITY_MIN,parse:function c(a){return {content:a[0].replace(HTML_CHAR_CODE_R,function(a,c){return b.namedCodesToUnicode[c]?b.namedCodesToUnicode[c]:a})}},react:function b(a){return a.content}},textBolded:{match:simpleInlineRegex(TEXT_BOLD_R),order:PARSE_PRIORITY_MED,parse:function d(a,b,c){return {content:b(a[2],c)}},react:function e(a,b,c){return d('strong',{key:c.key},b(a.content,c))}},textEmphasized:{match:simpleInlineRegex(TEXT_EMPHASIZED_R),order:PARSE_PRIORITY_LOW,parse:function d(a,b,c){return {content:b(a[2],c)}},react:function e(a,b,c){return d('em',{key:c.key},b(a.content,c))}},textEscaped:{match:simpleInlineRegex(TEXT_ESCAPED_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return {content:a[1],type:'text'}}},textStrikethroughed:{match:simpleInlineRegex(TEXT_STRIKETHROUGHED_R),order:PARSE_PRIORITY_LOW,parse:parseCaptureInline,react:function e(a,b,c){return d('del',{key:c.key},b(a.content,c))}}};b.disableParsingRawHTML!==!0&&(i.htmlBlock={match:anyScopeRegex(HTML_BLOCK_ELEMENT_R),order:PARSE_PRIORITY_HIGH,parse:function l(a,b,c){var d=a[3].match(HTML_LEFT_TRIM_AMOUNT_R),f=d[1],g=new RegExp('^'+f,'gm'),h=a[3].replace(g,''),i=containsBlockSyntax(h)?parseBlock:parseInline,j=a[1].toLowerCase(),k=DO_NOT_PROCESS_HTML_ELEMENTS.indexOf(j)!==-1;return {attrs:e(a[2]),content:k?a[3]:i(b,h,c),noInnerParse:k,tag:k?j:a[1]}},react:function e(a,b,c){return d(a.tag,_extends$1({key:c.key},a.attrs),a.noInnerParse?a.content:b(a.content,c))}},i.htmlSelfClosing={match:anyScopeRegex(HTML_SELF_CLOSING_ELEMENT_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return {attrs:e(a[2]||''),tag:a[1]}},react:function e(a,b,c){return d(a.tag,_extends$1({},a.attrs,{key:c.key}))}});var j=parserFor(i),k=reactFor(ruleOutput(i)),l=c(function(a){return a.replace(/<!--[\s\S]*?(?:-->)/g,'')}(a));return g.length&&l.props.children.push(d('footer',{key:'footer'},g.map(function(a){return d('div',{id:a.identifier,key:a.identifier},a.identifier,k(j(a.footnote,{inline:!0})))}))),l}function Markdown(a){var b=a.children,c=a.options,d=_objectWithoutProperties$1(a,['children','options']);return React.cloneElement(compiler(b,c),d)}{var PropTypes=require('prop-types');Markdown.propTypes={children:PropTypes.string.isRequired,options:PropTypes.object};}

var hasChildren = function hasChildren(element) {
  return isValidElement(element) && Boolean(element.props.children);
};
var childToString = function childToString(child) {
  if (typeof child === "undefined" || child === null || typeof child === "boolean") {
    return "";
  }

  if (JSON.stringify(child) === "{}") {
    return "";
  }

  return child.toString();
};
var onlyText = function onlyText(children) {
  if (!(children instanceof Array) && !isValidElement(children)) {
    return childToString(children);
  }

  return Children.toArray(children).reduce(function (text, child) {
    var newText = "";

    if (isValidElement(child) && hasChildren(child)) {
      newText = onlyText(child.props.children);
    } else if (isValidElement(child) && !hasChildren(child)) {
      newText = "";
    } else {
      newText = childToString(child);
    }

    return text.concat(newText);
  }, "");
};

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  padding: 0;\n  visibility: hidden;\n  speak: none;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$L() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  &.slick-slider:first-child {\n    padding-top: 0;\n  }\n\n  .markdown {\n    h2:first-child {\n      padding-top: 0;\n    }\n    h3:first-child {\n      padding-top: 0;\n    }\n    img:first-child {\n      padding-top: 0;\n    }\n    picture:first-child {\n      img {\n        padding-top: 0;\n      }\n    }\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: ", ";\n    font-weight: ", ";\n    padding-bottom: ", ";\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    line-height: ", ";\n\n    a {\n      &.link-external {\n        padding-bottom: 5px;\n      }\n\n      font-size: inherit;\n      font-weight: inherit;\n      text-decoration: none !important;\n      &:hover {\n        color: ", ";\n        &:after {\n          content: \"\";\n          width: ", "px;\n        }\n      }\n      &:after {\n        content: \"\";\n        transition: width 0.2s;\n        display: block;\n        margin-top: ", "px;\n        color: ", ";\n        margin-bottom: 0;\n        width: ", "px;\n        height: ", "px;\n        background-color: ", ";\n      }\n    }\n  }\n\n  h1 {\n    font-size: ", ";\n    font-weight: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    a {\n      font-size: inherit;\n      font-weight: inherit;\n      &:hover {\n        &:after {\n          width: ", "px;\n        }\n      }\n      &:after {\n        width: ", "px;\n        height: ", "px;\n      }\n    }\n  }\n\n  h2 {\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    a {\n      color: ", " !important;\n      &:after {\n        content: \"\";\n        width: ", "px;\n        background-color: ", ";\n        height: ", "px;\n        margin-top: ", "px;\n      }\n      &:hover {\n        text-decoration: none;\n        &:after {\n          content: \"\";\n          width: ", "px;\n        }\n      }\n    }\n  }\n\n  h3 {\n    padding-top: ", ";\n    font-size: ", ";\n    a {\n      &:after {\n        content: \"\";\n        height: ", "px;\n        width: ", "px;\n        margin-top: ", "px;\n      }\n      &:hover {\n        &:after {\n          content: \"\";\n          width: ", "px;\n        }\n      }\n    }\n  }\n\n  h4 {\n    padding-top: ", ";\n    font-size: ", ";\n    a {\n      &:after {\n        content: \"\";\n        height: ", "px;\n        width: ", "px;\n        margin-top: ", "px;\n      }\n      &:hover {\n        &:after {\n          content: \"\";\n          width: ", "px;\n        }\n      }\n    }\n  }\n\n  h5 {\n    padding-top: ", ";\n    font-size: ", ";\n    a {\n      &:after {\n        content: \"\";\n        height: ", "px;\n        width: ", "px;\n        margin-top: ", "px;\n      }\n      &:hover {\n        &:after {\n          content: \"\";\n          width: ", "px;\n        }\n      }\n    }\n  }\n\n  p {\n    line-height: 1.5;\n    padding: 0;\n    padding-bottom: ", ";\n    text-transform: none;\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n    color: ", ";\n  }\n\n  hr {\n    margin-bottom: ", ";\n    margin-top: ", ";\n    background-color: ", ";\n    height: 1px;\n    border: none;\n  }\n\n  ul,\n  ol {\n    font-size: ", ";\n    line-height: 1.6;\n    list-style-position: outside;\n    font-weight: ", ";\n    padding-bottom: ", ";\n    transform: translateX(10px);\n    letter-spacing: ", ";\n    color: ", ";\n  }\n  ol {\n    transform: translateX(15px);\n  }\n  ul > li {\n    list-style-type: none;\n    position: relative;\n    &::before {\n      display: inline-block;\n      vertical-align: middle;\n      width: 2px;\n      height: 2px;\n      background-color: ", ";\n      border-radius: 50%;\n      transform: translateX(-10px);\n      content: \"\";\n      position: absolute;\n      top: 11px;\n    }\n    p {\n      display: inline;\n    }\n  }\n\n  a {\n    font-size: ", ";\n    font-weight: ", ";\n    text-decoration: underline;\n    text-decoration-color: ", ";\n    color: ", ";\n    &.white {\n      text-decoration-color: ", ";\n      color: ", ";\n      &:hover {\n        color: ", ";\n        text-decoration-color: ", ";\n      }\n    }\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  strong {\n    font-weight: ", ";\n  }\n\n  img {\n    width: auto;\n    max-width: 100%;\n    padding-bottom: ", ";\n    padding-top: ", ";\n  }\n\n  pre {\n    background-color: #f6f8fa;\n    border-radius: 3px;\n    font-size: 85%;\n    line-height: 1.45;\n    overflow: auto;\n    padding: 16px;\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n\n  ", "\n\n  table {\n    line-height: 1.6;\n    padding: 0;\n    padding-bottom: ", ";\n    text-transform: none;\n    font-size: ", ";\n    font-weight: ", ";\n    th {\n      text-align: left !important;\n      font-weight: ", " !important;\n    }\n\n    td {\n      text-align: left !important;\n      color: ", ";\n    }\n  }\n\n  .food-table {\n    overflow-x: auto;\n    table {\n      margin: 2em 0;\n      tr {\n        th {\n          padding: 0 10px 0 0;\n          vertical-align: top;\n          text-align: center !important;\n          width: 90px;\n        }\n        th:nth-child(1) {\n          width: auto;\n          text-align: left !important;\n        }\n        td {\n          padding-left: 0;\n          padding-right: 10px;\n          vertical-align: middle;\n          text-align: center !important;\n          &:first-child {\n            text-align: left !important;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}

var LinkWrapper = function LinkWrapper(_ref) {
  var href = _ref.href,
      props = _objectWithoutProperties(_ref, ["href"]);

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  var isExternalLink = href !== null && href.includes("http") && !href.includes("www.ua");
  return /*#__PURE__*/React.createElement(Link, _extends({
    href: href,
    target: isExternalLink ? "_blank" : "_self"
  }, props));
};

LinkWrapper.propTypes = {
  href: PropTypes$1.string.isRequired
};

var MarkdownRenderer = function MarkdownRenderer(_ref2) {
  var content = _ref2.content,
      activeColor = _ref2.activeColor,
      isInline = _ref2.isInline,
      isThemeReverse = _ref2.isThemeReverse,
      className = _ref2.className,
      isMobile = _ref2.isMobile,
      props = _objectWithoutProperties(_ref2, ["content", "activeColor", "isInline", "isThemeReverse", "className", "isMobile"]);

  var _useConfig2 = useConfig(),
      isIE = _useConfig2.isIE;

  var imageOption = props["default"] ? {} : {
    img: {
      component: PictureContainer,
      props: {
        size: "md",
        hasImageBgColor: false,
        width: "auto",
        maxWidth: "100%"
      }
    }
  };
  var markdownOptions = {
    forceBlock: true,
    overrides: _objectSpread2({
      table: {
        component: TableWithStyles,
        props: {
          marginTop: "0",
          tableRowSpace: "10px",
          lightBorders: true
        }
      },
      carousel: {
        component: CarouselWithStyles,
        props: {
          hasVerticalSpacing: true
        }
      },
      icon: {
        component: Icon
      },
      carouselxl: {
        component: CarouselWithStyles,
        props: {
          hasVerticalSpacing: false
        }
      },
      picture: {
        component: PictureContainer,
        props: {
          size: "md",
          hasImageBgColor: false,
          width: "auto",
          maxWidth: "100%"
        }
      },
      video: {
        component: isIE() ? null : VideoPlayer$1 //component: VideoPlayer

      },
      link: {
        component: LinkExternal,
        props: {
          activeColor: activeColor
        }
      },
      h1: {
        component: Header,
        props: {
          as: "h1"
        }
      },
      h2: {
        component: Header,
        props: {
          as: "h2",
          isMobile: isMobile
        }
      },
      h3: {
        component: Header,
        props: {
          as: "h3"
        }
      },
      h4: {
        component: Header,
        props: {
          as: "h4"
        }
      },
      h5: {
        component: Header,
        props: {
          as: "h5"
        }
      },
      p: {
        component: Text,
        props: {
          color: "#000",
          fontWeight: "300"
        }
      },
      a: {
        component: LinkWrapper,
        props: {
          fontWeight: "400",
          fontSize: "15px",
          paddingBottom: "5px",
          "native": true
        }
      }
    }, imageOption)
  };
  return /*#__PURE__*/React.createElement(MarkdownStyles, _extends({
    activeColor: activeColor,
    isInline: isInline,
    isThemeReverse: isThemeReverse,
    className: className
  }, props), /*#__PURE__*/React.createElement(Markdown, {
    className: "markdown",
    options: markdownOptions
  }, content));
};

MarkdownRenderer.propTypes = {
  content: PropTypes$1.string.isRequired,
  activeColor: PropTypes$1.string,
  isInline: PropTypes$1.bool,
  isThemeReverse: PropTypes$1.bool,
  className: PropTypes$1.string,
  "default": PropTypes$1.bool,
  isMobile: PropTypes$1.bool,
  isStreaming: PropTypes$1.bool
};
MarkdownRenderer.defaultProps = {
  activeColor: "#00b2bd",
  isInline: false,
  isThemeReverse: false,
  className: "",
  "default": false,
  isMobile: false,
  isStreaming: false
}; // add markdown styles below

var MarkdownStyles = styled.div(_templateObject$L(), function (props) {
  return props.isInline && "display: inline-block;";
}, function (props) {
  return props.isThemeReverse ? props.theme.components.text.colorReverse : props.theme.components.text.color;
}, function (props) {
  return props.theme.weight.xbase;
}, function (props) {
  return props.theme.spacing.xs3;
}, function (props) {
  return props.theme.sizes.s;
}, function (props) {
  return props.theme.components.title.lineHeight;
}, function (props) {
  return props.isThemeReverse ? props.theme.components.text.colorReverse : props.theme.components.text.color;
}, function (props) {
  return props.theme.components.line.width + props.theme.components.line.widthDifference;
}, function (props) {
  return props.theme.components.line.marginTopMarkdown;
}, function (props) {
  return props.theme.components.line.color;
}, function (props) {
  return props.theme.components.line.width;
}, function (props) {
  return props.theme.components.line.height;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.sizes.xl3m;
}, function (props) {
  return props.theme.weight.base;
}, function (props) {
  return props.theme.spacing.xl2;
}, function (props) {
  return props.theme.spacing.xs2;
}, function (props) {
  return props.theme.components.line.width + props.theme.components.line.widthDifference;
}, function (props) {
  return props.theme.components.line.width;
}, function (props) {
  return props.theme.components.line.height;
}, function (props) {
  return props.theme.highContrast.text || props.activeColor;
}, function (props) {
  return props.theme.sizes.xl2;
}, function (props) {
  return props.theme.spacing.xl;
}, function (props) {
  return props.theme.spacing.xs2;
}, function (props) {
  return props.theme.highContrast.link || props.activeColor;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference;
}, function (props) {
  return props.theme.highContrast.link || props.activeColor;
}, function (props) {
  return props.theme.components.line.height - 1;
}, function (props) {
  return props.theme.components.line.marginTopMarkdown - 4;
}, function (props) {
  return props.theme.components.line.width;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.sizes.l;
}, function (props) {
  return props.theme.components.line.height - 2;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference * 1.2;
}, function (props) {
  return props.theme.components.line.marginTopMarkdown - 4;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference + 4;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.sizes.m;
}, function (props) {
  return props.theme.components.line.height - 2;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference * 1.5;
}, function (props) {
  return props.theme.components.line.marginTopMarkdown - 4;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference + 2;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.sizes.s;
}, function (props) {
  return props.theme.components.line.height - 2;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference * 2;
}, function (props) {
  return props.theme.components.line.marginTopMarkdown - 4;
}, function (props) {
  return props.theme.components.line.width - props.theme.components.line.widthDifference;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.weight.light;
}, function (props) {
  return props.theme.values.letterSpacing;
}, function (props) {
  return props.isThemeReverse ? props.theme.components.text.colorReverse : props.theme.components.text.color;
}, function (props) {
  return props.theme.spacing.m;
}, function (props) {
  return props.theme.spacing.m;
}, function (props) {
  return props.theme.highContrast.lightBorderColor || props.theme.colors.greyBorder;
}, function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.weight.light;
}, function (props) {
  return props.theme.components.listItem.spacingBottom;
}, function (props) {
  return props.theme.values.letterSpacing;
}, function (props) {
  return props.isThemeReverse ? props.theme.components.text.colorReverse : props.theme.components.text.color;
}, function (props) {
  return props.theme.highContrast.text || props.isThemeReverse ? props.theme.colors.white : props.theme.colors.blackLight;
}, function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.weight.light;
}, function (props) {
  return props.theme.highContrast.link || (props.linkColor ? props.linkColor : props.theme.colors.black);
}, function (props) {
  return props.theme.highContrast.link || (props.linkColor ? props.linkColor : props.theme.colors.black);
}, function (props) {
  return props.theme.highContrast.link || props.theme.colors.white;
}, function (props) {
  return props.theme.highContrast.link || props.theme.colors.white;
}, function (props) {
  return props.theme.highContrast.linkHover || props.theme.colors.black;
}, function (props) {
  return props.theme.highContrast.linkHover || props.theme.colors.black;
}, function (props) {
  return props.isThemeReverse ? props.theme.highContrast.linkHover || lighten(0.5, props.activeColor) : props.theme.highContrast.linkHover || props.activeColor;
}, function (props) {
  return props.theme.weight.xbase;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.spacing.m;
}, function (props) {
  return !props.isProfile && "blockquote {\n    padding-bottom: ".concat(props.theme.spacing.s, ";\n\n    p {\n      padding-top: ").concat(props.theme.spacing.s, ";\n      padding-bottom: ").concat(props.theme.spacing.s, ";\n      font-size: ").concat(props.theme.sizes.xl3m, ";\n      color: ").concat(props.theme.highContrast.text || "#bdbdbd", ";\n      line-height: 1.3;\n      font-family: ").concat(props.theme.type.serif, ";\n    }\n  }");
}, function (props) {
  return props.theme.spacing.s;
}, function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.weight.light;
}, function (props) {
  return props.theme.weight.xbase;
}, function (props) {
  return props.theme.highContrast.text;
});

var AnchorElement = function AnchorElement(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement("anchor", props, onlyText(children));
};

AnchorElement.propTypes = {
  children: PropTypes$1.node.isRequired
};
var AnchorPlaceholder = styled(AnchorElement)(_templateObject2$6(), function (props) {
  return props.isMobile ? "-150px" : "-125px";
});
var Header = function Header(_ref4) {
  var children = _ref4.children,
      as = _ref4.as,
      props = _objectWithoutProperties(_ref4, ["children", "as"]);

  return /*#__PURE__*/React.createElement(TitleWithStyles, _extends({
    as: as
  }, props, {
    position: "relative"
  }), /*#__PURE__*/React.createElement(AnchorPlaceholder, _extends({
    "aria-hidden": "true"
  }, props), children), children);
};
Header.defaultProps = {
  as: "h1"
};
Header.propTypes = {
  as: PropTypes$1.oneOf(["h1", "h2", "h3", "h4", "h5"]),
  children: PropTypes$1.node.isRequired
};

var SectionHeader = function SectionHeader(_ref) {
  var textColor = _ref.textColor,
      title = _ref.title,
      children = _ref.children,
      marginBottom = _ref.marginBottom,
      hasLine = _ref.hasLine,
      hasLink = _ref.hasLink,
      href = _ref.href,
      hasContainer = _ref.hasContainer,
      tag = _ref.tag,
      mobileSmFontSize = _ref.mobileSmFontSize,
      mobileXsFontSize = _ref.mobileXsFontSize,
      fontSize = _ref.fontSize,
      outlineOffset = _ref.outlineOffset,
      lineMarginTop = _ref.lineMarginTop,
      lineHeight = _ref.lineHeight,
      mobileMdColor = _ref.mobileMdColor,
      externalLink = _ref.externalLink,
      fontWeight = _ref.fontWeight;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHover = _useState2[0],
      setHover = _useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "Section-Header ".concat(hasContainer ? "container" : "")
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: marginBottom || "50px",
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    width: "fit-content",
    pointer: true
  }, hasLink ? /*#__PURE__*/React.createElement(Link, {
    fontDecoration: "none",
    href: href,
    "arial-label": title || children,
    display: "inline-block",
    outlineOffset: outlineOffset,
    "native": externalLink
  }, /*#__PURE__*/React.createElement(TitleWithStyles, {
    fontSize: fontSize,
    color: textColor,
    fontWeight: fontWeight || "500",
    tag: tag,
    mobileSmFontSize: mobileSmFontSize,
    mobileXsFontSize: mobileXsFontSize,
    mobileMdColor: mobileMdColor
  }, title || children)) : /*#__PURE__*/React.createElement(TitleWithStyles, {
    tabIndex: 0,
    fontSize: fontSize,
    color: textColor,
    fontWeight: fontWeight || "500",
    "arial-label": title || children,
    tag: tag,
    mobileSmFontSize: mobileSmFontSize,
    mobileXsFontSize: mobileXsFontSize,
    mobileMdColor: mobileMdColor,
    cursor: "default",
    display: "inline-block",
    lineHeight: lineHeight
  }, title || children), (hasLink || hasLine) && /*#__PURE__*/React.createElement(Line, {
    className: "Section-Header-Line",
    color: textColor,
    isHover: isHover,
    marginTop: lineMarginTop
  })));
};

SectionHeader.propTypes = {
  textColor: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
  children: PropTypes$1.node,
  marginBottom: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  hasLink: PropTypes$1.bool,
  href: PropTypes$1.string,
  hasContainer: PropTypes$1.bool,
  tag: PropTypes$1.string,
  mobileSmFontSize: PropTypes$1.string,
  mobileXsFontSize: PropTypes$1.string,
  outlineOffset: PropTypes$1.string,
  lineMarginTop: PropTypes$1.string,
  mobileMdColor: PropTypes$1.string,
  lineHeight: PropTypes$1.string,
  externalLink: PropTypes$1.bool,
  fontWeight: PropTypes$1.string
};
SectionHeader.defaultProps = _objectSpread2({}, theme$1.components.sectionHeader, {
  fontSize: "28px",
  children: null,
  hasLine: true,
  hasLink: true,
  hasContainer: true,
  tag: "h2",
  lineMarginTop: "3px",
  lineHeight: "1.4",
  externalLink: false
});

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  max-height: 200px;\n  overflow: hidden;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-right: ", ";\n  padding-left: ", ";\n  width: 50%;\n  float: ", ";\n\n  @media (max-width: 575px) {\n    padding-right: ", ";\n    padding-left: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  position: relative;\n  overflow: hidden;\n\n  @media (max-width: 575px) {\n    .campus-items {\n      display: none;\n    }\n  }\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}
var CardContainer$1 = styled.div(_templateObject$M(), function (props) {
  return props.backgroundColor;
});
var PositionContainer = styled.div(_templateObject2$7());
var TextContainer = styled.div(_templateObject3(), function (props) {
  return props.paddingRight;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props["float"];
}, function (props) {
  return props.xsPaddingRight;
}, function (props) {
  return props.xsPaddingLeft;
});
var OverflowContainer = styled.div(_templateObject4());

var LayeredCard = function LayeredCard(_ref) {
  var theme = _ref.theme,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      alt = _ref.alt,
      src = _ref.src,
      showPlusButton = _ref.showPlusButton,
      inverted = _ref.inverted,
      title = _ref.title,
      href = _ref.href,
      links = _ref.links,
      externalLink = _ref.externalLink,
      description = _ref.description,
      hasText = _ref.hasText,
      isMarkdown = _ref.isMarkdown,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var _theme$components$lay = theme.components.layeredCard,
      themeTextColor = _theme$components$lay.textColor,
      themeLinkColor = _theme$components$lay.linkColor,
      themeBgColor = _theme$components$lay.backgroundColor;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CardContainer$1, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || themeBgColor
  }, /*#__PURE__*/React.createElement(PositionContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(TextContainer, {
    paddingLeft: inverted ? "70px" : "0",
    paddingRight: inverted ? "0" : "70px",
    xsPaddingLeft: inverted ? "30px" : "0",
    xsPaddingRight: inverted ? "0" : "30px",
    "float": inverted ? "right" : "left"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    position: "relative",
    zIndex: "2"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: href,
    tag: "h3",
    fontSize: "28px",
    mobileSmFontSize: "26px",
    mobileXsFontSize: "20px",
    hasContainer: false,
    hasLine: true,
    hasLink: true,
    textColor: theme.highContrast.link || textColor || themeTextColor,
    marginBottom: "15px",
    externalLink: externalLink
  }, title), /*#__PURE__*/React.createElement(OverflowContainer, null, hasText ? isMarkdown ? /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: description,
    activeColor: activeColor
  }) : /*#__PURE__*/React.createElement(Text, {
    lineHeight: "1.6",
    size: "article",
    fontWeight: "300",
    text: description
  }) : /*#__PURE__*/React.createElement(VerticalList, {
    className: "campus-items"
  }, links.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      marginBottom: "5px"
    }, /*#__PURE__*/React.createElement(Link, {
      size: "medium",
      fontWeight: "400",
      color: theme.highContrast.link || textColor || themeLinkColor,
      href: item.href
    }, item.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: item.resource,
      defaultMessage: item.text
    }) : item.text));
  })))), showPlusButton && /*#__PURE__*/React.createElement(PlusButton, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || themeBgColor,
    size: "60px",
    position: "absolute",
    height: "100%",
    right: inverted ? "initial" : "-30px",
    left: inverted ? "-30px" : "initial",
    top: "0",
    zIndex: "1",
    as: "a",
    href: href
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "50px",
    fontWeight: "100",
    color: theme.highContrast.link || textColor || themeLinkColor,
    text: theme.icons.plus,
    lineHeight: "1"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-6 ".concat(inverted ? "" : "offset-6")
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: "350px"
  })))));
};

var types$t = {
  showPlusButton: PropTypes$1.bool,
  inverted: PropTypes$1.bool,
  alt: PropTypes$1.string,
  src: PropTypes$1.string,
  title: PropTypes$1.string,
  links: PropTypes$1.array,
  href: PropTypes$1.string,
  externalLink: PropTypes$1.bool,
  description: PropTypes$1.string,
  hasText: PropTypes$1.bool,
  isMarkdown: PropTypes$1.bool,
  activeColor: PropTypes$1.string
};
var defaults$q = {
  href: "#",
  showPlusButton: true,
  title: "Título",
  description: "Texto",
  alt: "imagem sem alt",
  src: "https://static.ua.pt/images/ua/placeholder-bw.png",
  inverted: false,
  links: [{
    text: "texto",
    href: "#"
  }],
  hasText: false,
  isMarkdown: false,
  activeColor: "#0EB4BD",
  externalLink: false
};
LayeredCard.propTypes = types$t;
LayeredCard.defaultProps = defaults$q;
var LayeredCard$1 = withTheme(LayeredCard); //Only used for the Storybook Props Table

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-height: 200px;\n  overflow: hidden;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-right: ", ";\n  padding-left: ", ";\n  @media (max-width: 575px) {\n    padding-right: ", ";\n    padding-left: ", ";\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  align-self: center;\n\n  @media (min-width: 576px) {\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n\n  @media (max-width: 575.98px) {\n    .campus-items {\n      display: none;\n    }\n  }\n\n  @media (max-width: 767.98px) {\n    grid-column: ", ";\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  grid-column: ", ";\n\n  @media (max-width: 767.98px) {\n    grid-column: ", ";\n  }\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  overflow: hidden;\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-rows: 350px;\n\n  @media (max-width: 575.98px) {\n    grid-template-columns: 15px repeat(10, 1fr) 15px;\n  }\n\n  @media (min-width: 576px) and (max-width: 767.98px) {\n    //540px / 10\n    grid-template-columns: 1fr repeat(10, 54px) 1fr;\n  }\n\n  @media (min-width: 768px) and (max-width: 991.98px) {\n    //720px / 10\n    grid-template-columns: 1fr repeat(10, 72px) 1fr;\n  }\n\n  @media (min-width: 992px) and (max-width: 1199.98px) {\n    //960px / 10\n    grid-template-columns: 1fr repeat(10, 96px) 1fr;\n  }\n\n  @media (min-width: 1200px) {\n    //1140px / 10\n    grid-template-columns: 1fr repeat(10, 114px) 1fr;\n  }\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}
var CardContainer$2 = styled.div(_templateObject$N(), function (props) {
  return props.backgroundColor;
});
var ImageContainer$1 = styled.div(_templateObject2$8(), function (props) {
  return props.gridColumn;
}, function (props) {
  return props.smGridColumn;
});
var TextContainer$1 = styled.div(_templateObject3$1(), function (props) {
  return props.gridColumn;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.smGridColumn;
});
var TextContentContainer = styled.div(_templateObject4$1(), function (props) {
  return props.paddingRight;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.xsPaddingRight;
}, function (props) {
  return props.xsPaddingLeft;
});
var OverflowContainer$1 = styled.div(_templateObject5());

var ColumnsCard = function ColumnsCard(_ref) {
  var textGridColumn = _ref.textGridColumn,
      imageGridColumn = _ref.imageGridColumn,
      theme = _ref.theme,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      alt = _ref.alt,
      src = _ref.src,
      showPlusButton = _ref.showPlusButton,
      inverted = _ref.inverted,
      title = _ref.title,
      href = _ref.href,
      links = _ref.links,
      externalLink = _ref.externalLink,
      description = _ref.description,
      hasText = _ref.hasText,
      isMarkdown = _ref.isMarkdown,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var _theme$components$col = theme.components.columnsCard,
      themeTextColor = _theme$components$col.textColor,
      themeLinkColor = _theme$components$col.linkColor,
      themeBgColor = _theme$components$col.backgroundColor;
  return /*#__PURE__*/React.createElement(CardContainer$2, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || themeBgColor
  }, /*#__PURE__*/React.createElement(TextContainer$1, {
    paddingLeft: inverted ? "0" : "15px",
    paddingRight: inverted ? "15px" : "0",
    gridColumn: textGridColumn,
    smGridColumn: inverted ? "7 / 12" : "2 / 7"
  }, /*#__PURE__*/React.createElement(TextContentContainer, {
    paddingLeft: inverted ? "55px" : "0",
    paddingRight: inverted ? "0" : "55px",
    xsPaddingLeft: inverted ? "30px" : "0",
    xsPaddingRight: inverted ? "0" : "30px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    zIndex: "2",
    position: "relative"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: href,
    tag: "h3",
    fontSize: "28px",
    mobileSmFontSize: "26px",
    mobileXsFontSize: "20px",
    hasContainer: false,
    hasLine: true,
    hasLink: true,
    textColor: theme.highContrast.link || textColor || themeTextColor,
    marginBottom: "15px",
    externalLink: externalLink
  }, title), /*#__PURE__*/React.createElement(OverflowContainer$1, null, hasText ? isMarkdown ? /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: description,
    activeColor: activeColor
  }) : /*#__PURE__*/React.createElement(Text, {
    lineHeight: "1.6",
    size: "article",
    fontWeight: "300",
    text: description
  }) : /*#__PURE__*/React.createElement(VerticalList, {
    className: "campus-items"
  }, links.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      marginBottom: "5px"
    }, /*#__PURE__*/React.createElement(Link, {
      size: "medium",
      fontWeight: "400",
      color: theme.highContrast.link || textColor || themeLinkColor,
      href: item.href
    }, item.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: item.resource,
      defaultMessage: item.text
    }) : item.text));
  })))), showPlusButton && /*#__PURE__*/React.createElement(PlusButton, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || themeBgColor,
    size: "60px",
    position: "absolute",
    height: "100%",
    right: inverted ? "initial" : "-30px",
    left: inverted ? "-30px" : "initial",
    top: "0",
    zIndex: "1",
    as: "a",
    href: href
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "50px",
    fontWeight: "100",
    color: theme.highContrast.link || textColor || themeLinkColor,
    text: theme.icons.plus,
    lineHeight: "1"
  })))), /*#__PURE__*/React.createElement(ImageContainer$1, {
    gridColumn: imageGridColumn,
    smGridColumn: inverted ? "1 / 7" : "7 / -1"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: src,
    alt: alt,
    height: "100%"
  })));
};

var types$u = {
  backgroundColor: PropTypes$1.string,
  textGridColumn: PropTypes$1.string,
  imageGridColumn: PropTypes$1.string,
  showPlusButton: PropTypes$1.bool,
  inverted: PropTypes$1.bool,
  alt: PropTypes$1.string,
  src: PropTypes$1.string,
  title: PropTypes$1.string,
  links: PropTypes$1.array,
  href: PropTypes$1.string,
  externalLink: PropTypes$1.bool,
  description: PropTypes$1.string,
  hasText: PropTypes$1.bool,
  isMarkdown: PropTypes$1.bool,
  activeColor: PropTypes$1.string
};
var defaults$r = {
  textGridColumn: "2 / 7",
  imageGridColumn: "7 / -1",
  href: "#",
  showPlusButton: true,
  title: "Título",
  description: "Texto",
  alt: "imagem sem alt",
  src: "https://static.ua.pt/images/ua/placeholder-bw.png",
  inverted: false,
  links: [{
    text: "texto",
    href: "#"
  }],
  hasText: false,
  isMarkdown: false,
  activeColor: "#0EB4BD",
  externalLink: false
};
ColumnsCard.propTypes = types$u;
ColumnsCard.defaultProps = defaults$r;
var ColumnsCard$1 = withTheme(ColumnsCard); //Only used for the Storybook Props Table

var DropdownIndicator = function DropdownIndicator(props) {
  var color = props.selectProps.variant === "black" ? "#000" : "#fff";
  return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(Icon, {
    size: "xSmall",
    color: color,
    name: "far fa-chevron-down"
  }));
};

DropdownIndicator.propTypes = {
  selectProps: PropTypes$1.object
};

var NoOptionsMessage = function NoOptionsMessage(props) {
  return /*#__PURE__*/React.createElement(components.NoOptionsMessage, props, "Sem op\xE7\xF5es");
};

function SelectWithStyles(props) {
  var color = "".concat(props.variant === "black" ? props.theme.components.select.variantBlack.color : "#fff");
  var background = "".concat(props.variant === "black" ? props.theme.components.select.variantBlack.bgColor : "transparent");
  return /*#__PURE__*/React.createElement(Select$1, _extends({}, props, {
    components: {
      DropdownIndicator: DropdownIndicator,
      NoOptionsMessage: NoOptionsMessage
    },
    styles: {
      singleValue: function singleValue(provided) {
        return _objectSpread2({}, provided, {
          color: "".concat(color)
        });
      },
      control: function control(provided) {
        return _objectSpread2({}, provided, {
          background: "".concat(background),
          border: "1px solid ".concat(color),
          cursor: "pointer",
          fontSize: "14px"
        });
      },
      option: function option(provided, state) {
        return _objectSpread2({}, provided, {
          cursor: "pointer",
          fontSize: "12px",
          color: state.isSelected ? props.theme.components.select.optionIsSelectedColor : state.isFocused && props.theme.components.select.optionIsFocusColor,
          backgroundColor: state.isSelected ? props.theme.components.select.optionIsSelected : state.isFocused && props.theme.components.select.optionIsFocusBgColor,
          "&:hover": {
            color: !state.isSelected && props.theme.components.select.optionHover,
            backgroundColor: !state.isSelected && props.theme.components.select.optionBgColorHover
          }
        });
      },
      indicatorSeparator: function indicatorSeparator(provided) {
        return _objectSpread2({}, provided, {
          backgroundColor: props.theme.components.select.indicator
        });
      },
      clearIndicator: function clearIndicator(provided) {
        return _objectSpread2({}, provided, {
          color: props.theme.components.select.clearIndicator
        });
      },
      menuList: function menuList(provided) {
        return _objectSpread2({}, provided, {
          backgroundColor: props.theme.components.select.menuListBgColor,
          color: props.theme.components.select.menuListColor,
          border: props.theme.components.select.menuListBorder
        });
      },
      placeholder: function placeholder(provided) {
        return _objectSpread2({}, provided, {
          color: "".concat(color),
          fontSize: props.theme.sizes.s
        });
      },
      noOptionsMessage: function noOptionsMessage(provided) {
        return _objectSpread2({}, provided, {
          fontSize: "12px"
        });
      },
      indicatorsContainer: function indicatorsContainer(provided) {
        return _objectSpread2({}, provided, {
          position: "relative"
        });
      },
      valueContainer: function valueContainer(provided) {
        return props.hasMultiCustomStyles ? _objectSpread2({}, provided, {
          overflow: "auto",
          padding: "0",
          margin: "0 0 0 ".concat(props.theme.sizes.xs3),
          "&::-webkit-scrollbar": {
            height: "0px"
          }
        }) : _objectSpread2({}, provided);
      },
      multiValue: function multiValue(provided) {
        return props.hasMultiCustomStyles ? _objectSpread2({}, provided, {
          minWidth: "none",
          backgroundColor: props.theme.components.select.grey5,
          padding: props.theme.sizes.xs3,
          "&:hover": {
            backgroundColor: props.theme.components.select.grey10,
            borderColor: props.theme.components.select.grey10,
            div: {
              backgroundColor: props.theme.components.select.grey10,
              borderColor: props.theme.components.select.grey10,
              svg: {
                fill: props.theme.components.select.indicator,
                "&:hover": {
                  fill: props.theme.components.select.grey60
                }
              }
            }
          }
        }) : _objectSpread2({}, provided);
      }
    },
    theme: function theme(_theme) {
      return _objectSpread2({}, _theme, {
        borderRadius: 0,
        colors: _objectSpread2({}, _theme.colors, {
          primary25: props.theme.components.select.primary25,
          primary: props.theme.components.select.primary,
          primary50: props.theme.components.select.primary50
        })
      });
    }
  }));
}

SelectWithStyles.propTypes = {
  theme: PropTypes$1.object,
  variant: PropTypes$1.string,
  hasMultiCustomStyles: PropTypes$1.bool
};
var Select = withTheme(SelectWithStyles);

var Loading$d = function Loading(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "38px",
    border: "1px solid ".concat(theme.loadings.lightBorderColor),
    padding: "0 0 0 10px",
    className: "d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginRight: "10px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "30px",
    height: "22px",
    borderLeft: "1px solid ".concat(theme.loadings.lightBorderColor),
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    backgroundColor: theme.loadings.mainBgColor
  })))));
};

Loading$d.propTypes = {
  theme: PropTypes$1.object
};
var SelectLoading = withTheme(Loading$d);

function _templateObject$O() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: ", ";\n  position: absolute;\n  border: none;\n  height: 100%;\n  width: 40px;\n  cursor: pointer;\n  top: 0;\n  z-index: 1;\n  &.right {\n    right: -15px;\n  }\n  &.left {\n    left: -15px;\n  }\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}

var ArrowButton = function ArrowButton(_ref) {
  var className = _ref.className,
      arrowRight = _ref.arrowRight,
      onClick = _ref.onClick,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: "".concat(className, " ").concat(arrowRight ? "arrow right" : "arrow left")
  }, /*#__PURE__*/React.createElement(Icon, {
    name: arrowRight ? theme.icons.chevron_right : theme.icons.chevron_left,
    size: "small",
    color: theme.components.scrollableTabs.button.iconColor
  }));
};

ArrowButton.defaultProps = {
  arrowRight: false
};
ArrowButton.propTypes = {
  className: PropTypes$1.string,
  arrowRight: PropTypes$1.bool
};
var ArrowButtonWithStyles = styled(ArrowButton)(_templateObject$O(), function (props) {
  return props.theme.components.scrollableTabs.button.bgColor;
}, function (props) {
  return props.display || "none";
});
var ArrowButton$1 = withTheme(ArrowButtonWithStyles);

function _templateObject$P() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  margin-bottom: ", ";\n\n  .tabs {\n    //For Buttons\n    position: relative;\n\n    .tabs-container {\n      overflow-x: scroll;\n      white-space: nowrap;\n      scroll-snap-type: x mandatory;\n      -webkit-overflow-scrolling: touch;\n      scroll-behavior: smooth;\n\n      //Hide ScrollBar\n      &::-webkit-scrollbar {\n        display: none;\n        height: 0;\n      }\n      -ms-overflow-style: none;\n      overflow: -moz-scrollbars-none;\n      scrollbar-width: none;\n\n      .tab {\n        scroll-snap-align: start;\n        display: inline-block;\n        button {\n          &:focus {\n            ", ";\n            outline-offset: -2px;\n          }\n        }\n      }\n      .tab:last-child {\n        margin-right: 40px;\n      }\n    }\n  }\n"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}

var Tab = function Tab(_ref) {
  var isActive = _ref.isActive,
      text = _ref.text,
      onClick = _ref.onClick,
      theme = _ref.theme,
      activeColor = _ref.activeColor;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    marginRight: "50px",
    mobileSmMarginRight: "40px",
    className: "tab",
    role: "tab"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    as: "button",
    position: "relative",
    cursor: "pointer" //For Underline
    ,
    active: isActive,
    underlineWithAnimation: true,
    underlineAnimationColor: theme.highContrast.link || activeColor || theme.components.scrollableTabs.tab.underlineColor,
    backgroundColor: "transparent",
    border: "none",
    onClick: onClick,
    onMouseLeave: function onMouseLeave(e) {
      return e.currentTarget.blur();
    }
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    display: "block",
    text: text,
    color: theme.components.scrollableTabs.tab.linkColor,
    size: "small",
    fontWeight: isActive ? theme.weight.xbase : theme.weight.light,
    paddingTop: "18px",
    paddingBottom: "18px"
  })));
};

Tab.defaultProps = {
  href: "/",
  text: "Texto",
  isActive: false
};
Tab.propTypes = {
  isActive: PropTypes$1.bool,
  text: PropTypes$1.string,
  onClick: PropTypes$1.func,
  theme: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
var ScrollableTab = withTheme(Tab);

var ScrollableTabs = function ScrollableTabs(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      offSetClasses = _ref2.offSetClasses;
  //Get Reference of TabsContainer
  var refTabsContainer = useRef(null); //Arrows States

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showLeftArrow = _useState2[0],
      setLeftArrow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showRightArrow = _useState4[0],
      setRightArrow = _useState4[1]; //What user can scroll


  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      scrollableWidth = _useState6[0],
      setScrollableWidth = _useState6[1];

  var checkHorizontalScroll = function checkHorizontalScroll() {
    var tabsScrollWidth = refTabsContainer.current.scrollWidth;
    var tabsClientWidth = refTabsContainer.current.clientWidth; //Update What user can scroll

    setScrollableWidth(tabsScrollWidth - tabsClientWidth);
    /*
    -- If tabsContainer has scroll
    -- Show rightArrow
    */

    if (tabsScrollWidth > tabsClientWidth) {
      setRightArrow(true);
    } else {
      setRightArrow(false);
    }
  };

  var checkScrollPosition = function checkScrollPosition() {
    //Update what user scrolled Left
    var scrolledLeftValue = refTabsContainer.current.scrollLeft; //Check if at end of container

    if (scrolledLeftValue === scrollableWidth) {
      setRightArrow(false);
      setLeftArrow(true);
    } else if (scrolledLeftValue === 0) {
      setRightArrow(true);
      setLeftArrow(false);
    }
  };

  var scrollRight = function scrollRight() {
    refTabsContainer.current.scrollLeft += scrollableWidth;
    setRightArrow(false);
    setLeftArrow(true);
  };

  var scrollLeft = function scrollLeft() {
    refTabsContainer.current.scrollLeft = 0;
    setRightArrow(true);
    setLeftArrow(false);
  };

  useEffect(function () {
    window.addEventListener("resize", checkHorizontalScroll);
    checkHorizontalScroll();
    return function () {
      window.removeEventListener("resize", checkHorizontalScroll);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: String(offSetClasses)
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs",
    role: "tablist"
  }, /*#__PURE__*/React.createElement(ArrowButton$1, {
    display: showLeftArrow ? "block" : "none",
    onClick: scrollLeft
  }), /*#__PURE__*/React.createElement(ArrowButton$1, {
    arrowRight: true,
    display: showRightArrow ? "block" : "none",
    onClick: scrollRight
  }), /*#__PURE__*/React.createElement("div", {
    className: "tabs-container",
    ref: refTabsContainer,
    onScroll: checkScrollPosition
  }, children)))));
};

ScrollableTabs.defaultProps = {
  offSetClasses: "no-offset"
};
ScrollableTabs.propTypes = {
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  offSetClasses: PropTypes$1.string
};
var ScrollableTabsWithStyles = styled(ScrollableTabs)(_templateObject$P(), function (props) {
  return props.theme.components.scrollableTabs.border;
}, function (props) {
  return props.marginBottom || "50px";
}, function (props) {
  return props.theme.mixins.focus;
});

var WithProps$a = function WithProps(props) {
  return /*#__PURE__*/React.createElement(ScrollableTabsWithStyles, props);
};
WithProps$a.propTypes = {
  isActive: PropTypes$1.bool,
  text: PropTypes$1.string,
  onClick: PropTypes$1.func,
  theme: PropTypes$1.object,
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  offSetClasses: PropTypes$1.string,
  marginBottom: PropTypes$1.string
};
WithProps$a.defaultProps = {
  href: "/",
  text: "Texto",
  isActive: false,
  offSetClasses: "no-offset",
  marginBottom: "50px"
};

var Mask$a = function Mask(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor
  }, props));
};

var Loading$e = function Loading(_ref2) {
  var CardBgColor = _ref2.CardBgColor,
      offsetClasses = _ref2.offsetClasses,
      props = _objectWithoutProperties(_ref2, ["CardBgColor", "offsetClasses"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    padding: "18px 0",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "300px",
    mobileXsWidth: "90%",
    className: "".concat(offsetClasses)
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(Mask$a, _extends({
    height: "15px",
    width: "50px"
  }, props))), /*#__PURE__*/React.createElement("div", {
    className: "col d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(Mask$a, _extends({
    height: "15px",
    width: "50px"
  }, props))), /*#__PURE__*/React.createElement("div", {
    className: "col d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(Mask$a, _extends({
    height: "15px",
    width: "50px"
  }, props))))))));
};

Loading$e.propTypes = {
  className: PropTypes$1.string,
  CardBgColor: PropTypes$1.string
};
Loading$e.defaultProps = {
  offsetClasses: ""
};
var ScrollableTabsLoading = withTheme(Loading$e);

var Mask$b = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard = function LoadingCard(props) {
  return /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "170px"
  }, /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    width: "85%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "15px"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "21px",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "27px",
    width: "40%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "42px"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "48px",
    width: "50%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "63px"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "69px",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "75px",
    width: "50%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "90px"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "96px",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "102px",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "117px"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "123px",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "137px"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "143px",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "149px",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$b, _extends({}, props, {
    height: "6px",
    width: "100%",
    top: "164px",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })));
};

var Loading$f = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px"
  }, /*#__PURE__*/React.createElement(LoadingCard, props)));
};

Loading$f.propTypes = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
var Loading$g = withTheme(Loading$f);

function _templateObject$Q() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  display: ", ";\n  position: relative;\n  padding-bottom: ", ";\n  .dropdown-content,\n  .dropdown-menu {\n    //HighContrast border only\n    border: ", ";\n\n    padding: ", ";\n    display: ", ";\n    position: absolute;\n    background-color: ", ";\n    box-shadow: ", ";\n    -moz-box-shadow: ", ";\n    -webkit-box-shadow: ", ";\n    -o-box-shadow: ", ";\n    min-width: ", ";\n    max-width: ", ";\n    z-index: ", ";\n    right: ", ";\n    left: ", ";\n    top: ", ";\n    margin-top: ", ";\n  }\n\n  ", "\n\n  &:focus-within {\n    .dropdown-content {\n      display: block;\n    }\n  }\n\n  //Underline animation on hover menu links\n  ", ";\n"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}
var Dropdown = styled.div.attrs(function (_ref) {
  var className = _ref.className;
  return withExtendedClass({
    className: className,
    extend: "dropdown"
  });
})(_templateObject$Q(), function (props) {
  return props.width;
}, function (props) {
  return props.display;
}, function (props) {
  return props.paddingBottom;
}, function (props) {
  return props.theme.highContrast.border;
}, function (props) {
  return props.padding || "".concat(props.theme.spacing.m, " 0");
}, function (props) {
  return props.openMenuOnHover ? "none" : "block";
}, function (props) {
  return props.backgroundColor || props.theme.components.dropDown.backgroundColor;
}, function (props) {
  return props.boxShadow || props.theme.shadows.base;
}, function (props) {
  return props.boxShadow;
}, function (props) {
  return props.boxShadow;
}, function (props) {
  return props.boxShadow;
}, function (props) {
  return props.minContentWidth || props.theme.components.dropDown.minWidth;
}, function (props) {
  return props.maxContentWidth;
}, function (props) {
  return props.zIndex || "99";
}, function (props) {
  return props.right;
}, function (props) {
  return props.left;
}, function (props) {
  return props.top;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.openMenuOnHover && "\n  &:hover {\n    .dropdown-content,\n    .dropdown-menu {\n      display: block;\n    }\n  }\n  ";
}, function (props) {
  return props.withUnderlineAnimation && "\n    &:hover {\n      &:after {\n        background-color: ".concat(props.underlineAnimationColor || props.theme.components.dropDown.underlineAnimationColor, ";\n        width: 30px;\n      }\n    }\n    &:focus-within {\n      &:after {\n        background-color: ").concat(props.underlineAnimationColor || props.theme.components.dropDown.underlineAnimationColor, ";\n        width: 30px;\n      }\n    }\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 3px;\n      background-color: transparent;\n      margin-top: 5px;\n      transition: width 0.4s ease;\n      -webkit-transition: width 0.4s ease;\n    }\n  ");
});
var defaults$s = {
  width: "100%",
  display: "inline",
  openMenuOnHover: true
};
var types$v = {
  className: PropTypes$1.string,
  width: PropTypes$1.string,
  display: PropTypes$1.string,
  paddingBottom: PropTypes$1.string,
  padding: PropTypes$1.string,
  openMenuOnHover: PropTypes$1.bool,
  backgroundColor: PropTypes$1.string,
  boxShadow: PropTypes$1.string,
  minContentWidth: PropTypes$1.string,
  top: PropTypes$1.string,
  right: PropTypes$1.string,
  left: PropTypes$1.string,
  marginTop: PropTypes$1.string,
  withUnderlineAnimation: PropTypes$1.bool,
  underlineAnimationColor: PropTypes$1.string,
  zIndex: PropTypes$1.string,
  maxContentWidth: PropTypes$1.string
};
Dropdown.propTypes = types$v;
Dropdown.defaultProps = defaults$s;
var Dropdown$1 = withTheme(Dropdown); //Only used for the Storybook Props Table

function _templateObject$R() {
  var data = _taggedTemplateLiteral(["\n  a,\n  button {\n    color: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    &:first-child {\n      margin-top: 0;\n    }\n    &:focus {\n      outline-offset: -2px;\n    }\n  }\n  a {\n    margin-right: 0 !important;\n    text-decoration: none;\n    display: block;\n  }\n  button {\n    border: none;\n    background-color: transparent;\n    width: 100%;\n    text-align: left;\n    font-size: 14px;\n    cursor: pointer;\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  ", ";\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}
var lightenHover = 0.5;
var DropdownList = styled.div.attrs(function (_ref) {
  var className = _ref.className;
  return withExtendedClass({
    className: className,
    extend: "dropdown-content"
  });
})(_templateObject$R(), function (props) {
  return props.color || props.theme.components.dropdownList.color;
}, function (props) {
  return props.fontWeight || props.theme.weight.base;
}, function (props) {
  return props.padding || "".concat(props.theme.sizes.xs2, " ").concat(props.theme.sizes.xl);
}, function (props) {
  return props.theme.highContrast.link || lighten(lightenHover, props.hoverBackgroundColor || props.theme.components.dropdownList.hoverBackgroundColor);
}, function (props) {
  return darken(0.5, props.color || props.theme.components.dropdownList.color);
}, function (props) {
  return props.hasMaxHeight && "\n    max-height: ".concat(props.maxHeight, "px;\n    overflow-y: scroll;\n  ");
});
var defaults$t = {
  hasMaxHeight: false,
  maxHeight: 300
};
var types$w = {
  className: PropTypes$1.string,
  color: PropTypes$1.string,
  fontWeight: PropTypes$1.string,
  padding: PropTypes$1.string,
  hoverBackgroundColor: PropTypes$1.string,
  maxHeight: PropTypes$1.number,
  hasMaxHeight: PropTypes$1.bool
};
DropdownList.propTypes = types$w;
DropdownList.defaultProps = defaults$t;
var DropdownList$1 = withTheme(DropdownList); //Only used for the Storybook Props Table

function _templateObject$S() {
  var data = _taggedTemplateLiteral(["\n  min-height: ", ";\n\n  //Open menu button\n  button.open-menu {\n    width: 32px;\n    height: 32px;\n    background-color: ", ";\n    border: none;\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  //Breadcrumbs list items\n  li:not(.dropdown-item) {\n    color: ", ";\n    &:after {\n      content: \"/\";\n      font-weight: ", ";\n      margin: 0 5px;\n      font-size: ", ";\n    }\n    &:last-child {\n      &:after {\n        content: initial;\n      }\n    }\n  }\n\n  //Anchors\n  button.open-anchor-menu {\n    background-color: ", ";\n    border: none;\n    padding: 0 10px;\n    height: ", ";\n    cursor: pointer;\n  }\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}

var Crumb = function Crumb(_ref) {
  var text = _ref.text,
      theme = _ref.theme,
      color = _ref.color,
      href = _ref.href,
      truncateLength = _ref.truncateLength,
      activeColor = _ref.activeColor,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "link" : _ref$type;
  return type === "text" ? /*#__PURE__*/React.createElement(Text, {
    size: "article",
    color: color,
    display: "inline-block",
    fontWeight: theme.components.breadcrumbs.link.fontWeight,
    text: truncateOnWord(text, truncateLength, true, text.length >= truncateLength ? "..." : "")
  }) : /*#__PURE__*/React.createElement(Link, {
    href: href,
    color: color,
    fontSize: rem(theme.components.breadcrumbs.link.fontSize),
    fontWeight: theme.components.breadcrumbs.link.fontWeight,
    textDecorationColor: theme.highContrast.link || activeColor,
    "default": true,
    display: "inline-block",
    margin: "6px 0"
  }, truncateOnWord(text, truncateLength, true, text.length >= truncateLength ? "..." : ""));
};

Crumb.defaultProps = {
  text: "link",
  activeColor: "#000"
};
Crumb.propTypes = {
  text: PropTypes$1.string,
  theme: PropTypes$1.object,
  color: PropTypes$1.string,
  href: PropTypes$1.string,
  truncateLength: PropTypes$1.number,
  activeColor: PropTypes$1.string,
  type: PropTypes$1.string
};

var More = function More(_ref2) {
  var theme = _ref2.theme,
      onClick = _ref2.onClick;

  var _useConfig = useConfig(),
      useIntl = _useConfig.useIntl;

  var intl = useIntl();
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: "open-menu",
    "aria-label": intl({
      id: "app.breadcrumbs.button.description",
      defaultMessage: "Breadcrumbs"
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fal fa-ellipsis-h",
    color: theme.components.breadcrumbs.button.iconColor,
    size: "xSmall"
  }));
};

More.propTypes = {
  onClick: PropTypes$1.func,
  theme: PropTypes$1.object,
  ariaLabel: PropTypes$1.string
};
More.defaultProps = {
  ariaLabel: "Breadcrumbs"
};

var Breadcrumbs = function Breadcrumbs(_ref3) {
  var className = _ref3.className,
      theme = _ref3.theme,
      breadcrumbs = _ref3.breadcrumbs,
      lang = _ref3.lang,
      anchors = _ref3.anchors,
      truncateLength = _ref3.truncateLength,
      anchorOnClick = _ref3.anchorOnClick;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      onOpenAnchorMenu = _useState2[0],
      setAnchorMenu = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showMore = _useState4[0],
      setShowMore = _useState4[1];

  var limit = 4;
  var breadcrumbsTotal = breadcrumbs.length;
  var beforeItems = breadcrumbsTotal === 3 ? 2 : breadcrumbsTotal === 2 ? 1 : 3;

  var openAnchorMenu = function openAnchorMenu() {
    if (onOpenAnchorMenu) {
      setAnchorMenu(false);
    } else {
      setAnchorMenu(true);
    }
  };

  var onShowMoreBreadCrumbs = function onShowMoreBreadCrumbs() {
    setShowMore(true);
  };
  /*
  const checkIfUserScrolledDown = () => {
    let windowY = window.scrollY;
    if (windowY >= 40) {
      setAnchorMenu(false);
    }
  };
    useEffect(() => {
    window.addEventListener("scroll", checkIfUserScrolledDown);
    return () => {
      window.removeEventListener("scroll", checkIfUserScrolledDown);
    };
  }, []);
   */


  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " d-flex align-items-center")
  }, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, breadcrumbs.filter(function (_, i) {
    return i + 1 <= beforeItems;
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index
    }, /*#__PURE__*/React.createElement(Crumb, _extends({
      theme: theme,
      color: theme.components.breadcrumbs.link.color,
      text: item.text,
      href: "/".concat(lang).concat(item.url),
      truncateLength: truncateLength
    }, item)));
  }), breadcrumbs.length > limit && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
    as: "li",
    onChange: function onChange() {
      return setShowMore(false);
    }
  }, !showMore && /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(More, {
    theme: theme,
    onClick: onShowMoreBreadCrumbs
  })), showMore && breadcrumbs.filter(function (_, i) {
    return i + 1 > beforeItems && breadcrumbs.length !== i + 1;
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index
    }, /*#__PURE__*/React.createElement(Crumb, _extends({
      theme: theme,
      color: theme.components.breadcrumbs.link.color,
      text: item.text,
      href: "/".concat(lang).concat(item.url),
      truncateLength: truncateLength
    }, item)));
  }))), breadcrumbs.filter(function (_, i) {
    return breadcrumbs.length === i + 1;
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index
    }, /*#__PURE__*/React.createElement(Fragment, null, anchors.length > 0 ? /*#__PURE__*/React.createElement(ClickAwayListener, {
      onChange: function onChange() {
        return setAnchorMenu(false);
      }
    }, /*#__PURE__*/React.createElement(Dropdown$1, {
      width: "100%",
      left: "0",
      display: "block",
      openMenuOnHover: false
    }, /*#__PURE__*/React.createElement("button", {
      onClick: openAnchorMenu,
      className: "open-anchor-menu d-flex align-items-center"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "article",
      color: theme.components.breadcrumbs.anchors.textColor,
      text: truncateOnWord(item.text, truncateLength, true, item.text.length >= truncateLength ? "..." : "")
    }), /*#__PURE__*/React.createElement(Icon, {
      size: "xSmall",
      color: theme.components.breadcrumbs.anchors.textColor,
      name: onOpenAnchorMenu ? theme.icons.chevron_up : theme.icons.chevron_down,
      marginLeft: "15px"
    })), onOpenAnchorMenu && /*#__PURE__*/React.createElement(DropdownList$1, {
      fontWeight: "400",
      hasMaxHeight: true
    }, /*#__PURE__*/React.createElement(VerticalList, null, anchors.map(function (item, i) {
      return /*#__PURE__*/React.createElement(ListItem, {
        key: i,
        className: "dropdown-item",
        width: "100%"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          setAnchorMenu(false);
          anchorOnClick(item);
        }
      }, item.text));
    }))))) : /*#__PURE__*/React.createElement(Text, {
      size: "article",
      color: theme.components.breadcrumbs.link.lastChild,
      text: truncateOnWord(item.text, truncateLength, true, item.text.length >= truncateLength ? "..." : "")
    })));
  })));
};

Breadcrumbs.defaultProps = {
  truncateLength: 30
};
Breadcrumbs.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  breadcrumbs: PropTypes$1.array,
  lang: PropTypes$1.string,
  anchors: PropTypes$1.array,
  truncateLength: PropTypes$1.number,
  anchorOnClick: PropTypes$1.func
};
var BreadcrumbsWithTheme = withTheme(Breadcrumbs);
var BreadcrumbsWithStyles = styled(BreadcrumbsWithTheme)(_templateObject$S(), function (props) {
  return props.theme.components.breadcrumbs.height;
}, function (props) {
  return props.theme.components.breadcrumbs.button.bgColor;
}, function (props) {
  return props.theme.components.breadcrumbs.button.hoverBgColor;
}, function (props) {
  return props.theme.components.breadcrumbs.link.color;
}, function (props) {
  return props.theme.components.breadcrumbs.link.fontWeight;
}, function (props) {
  return rem(props.theme.components.breadcrumbs.link.fontSize);
}, function (props) {
  return props.theme.components.breadcrumbs.anchors.buttonBgColor;
}, function (props) {
  return props.theme.components.breadcrumbs.height;
});

var WithProps$b = function WithProps(props) {
  return /*#__PURE__*/React.createElement("div", props);
};
WithProps$b.propTypes = {
  text: PropTypes$1.string,
  theme: PropTypes$1.object,
  color: PropTypes$1.string,
  href: PropTypes$1.string,
  truncateLength: PropTypes$1.number,
  activeColor: PropTypes$1.string,
  type: PropTypes$1.string,
  onClick: PropTypes$1.func,
  ariaLabel: PropTypes$1.string,
  className: PropTypes$1.string,
  breadcrumbs: PropTypes$1.array,
  lang: PropTypes$1.string,
  anchors: PropTypes$1.array,
  anchorOnClick: PropTypes$1.func
};
WithProps$b.defaultProps = {
  text: "Link",
  activeColor: "#000",
  ariaLabel: "Breadcrumbs",
  truncateLength: 30
};

var Loading$h = function Loading(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "18px",
    width: "20px"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "article",
    color: theme.loadings.mainBgColor,
    marginLeft: "5px",
    marginRight: "5px"
  }, "/"), /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "18px",
    width: "68px"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "article",
    color: theme.loadings.mainBgColor,
    marginLeft: "5px",
    marginRight: "5px"
  }, "/"), /*#__PURE__*/React.createElement(ContentContainer, {
    height: "32px",
    width: "128px",
    padding: "0 8px 0 10px",
    className: "d-flex align-items-center justify-content-between",
    border: "1px solid ".concat(theme.loadings.mainBgColor)
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "18px",
    width: "75px"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    backgroundColor: theme.loadings.mainBgColor
  })));
};

Loading$h.propTypes = {
  borderBottom: PropTypes$1.string,
  theme: PropTypes$1.object
};
var Loading$i = withTheme(Loading$h);

function _templateObject$T() {
  var data = _taggedTemplateLiteral(["\n  max-width: 800px;\n"]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$c = function Mask(_ref) {
  var maskBgColor = _ref.maskBgColor,
      props = _objectWithoutProperties(_ref, ["maskBgColor"]);

  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: maskBgColor || theme$1.loadings.bgColor,
    position: "absolute"
  }, props));
};

Mask$c.propTypes = {
  maskBgColor: PropTypes$1.string
};

var LoadingCard$1 = function LoadingCard(_ref2) {
  var fullSize = _ref2.fullSize,
      props = _objectWithoutProperties(_ref2, ["fullSize"]);

  return /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: fullSize ? "110px" : "80px"
  }, /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "20px",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "10px",
    top: "20px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "20px",
    top: "30px",
    right: "0",
    width: "20%"
  }, props)), /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "10px",
    top: "50px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "20px",
    top: "60px",
    right: "0",
    width: "30%"
  }, props)), fullSize && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "10px",
    top: "80px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$c, _extends({
    height: "20px",
    top: "90px",
    right: "0",
    width: "30%"
  }, props))));
};

LoadingCard$1.propTypes = {
  fullSize: PropTypes$1.bool
};
LoadingCard$1.defaultProps = {
  fullSize: true
};

var Loading$j = function Loading(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(LoadingCard$1, props));
};

Loading$j.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$2 = styled(Loading$j)(_templateObject$T());

var WithProps$c = function WithProps(props) {
  return /*#__PURE__*/React.createElement(LoadingWithStyles$2, props);
};
WithProps$c.propTypes = {
  className: PropTypes$1.string,
  maskBgColor: PropTypes$1.string,
  fullSize: PropTypes$1.bool
};
WithProps$c.defaultProps = {
  fullSize: true
};

function _templateObject$U() {
  var data = _taggedTemplateLiteral(["\n  h3,\n  p {\n    padding-bottom: 12px;\n  }\n  ul,\n  ol {\n    font-size: ", ";\n    line-height: 1.6;\n    list-style-position: outside;\n    font-weight: ", ";\n    padding-bottom: ", ";\n    transform: translateX(10px);\n    letter-spacing: ", ";\n    color: ", ";\n  }\n  ul > li {\n    list-style-type: none;\n    position: relative;\n    &::before {\n      display: inline-block;\n      vertical-align: middle;\n      width: 2px;\n      height: 2px;\n      background-color: ", ";\n      border-radius: 50%;\n      transform: translateX(-10px);\n      content: \"\";\n      position: absolute;\n      top: 11px;\n    }\n    p {\n      display: inline;\n    }\n  }\n  a {\n    font-size: ", ";\n    font-weight: ", ";\n    text-decoration: underline;\n    text-decoration-color: ", ";\n    color: ", ";\n    &.white {\n      text-decoration-color: ", ";\n      color: ", ";\n      &:hover {\n        color: ", ";\n        text-decoration-color: ", ";\n      }\n    }\n    &:hover {\n      color: ", ";\n    }\n  }\n  .title-link {\n    font-size: ", ";\n  }\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}

var Contest = function Contest(_ref) {
  var contest = _ref.contest,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(ContestStyles, {
    activeColor: activeColor
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "medium",
    fontWeight: "400"
  }, contest.title, " ", /*#__PURE__*/React.createElement(Link, {
    target: "_blank",
    href: contest.link,
    className: "title-link",
    display: "block"
  }, contest.reference)), /*#__PURE__*/React.createElement(Text, {
    size: "article",
    fontWeight: "400"
  }, contest.subTitle), /*#__PURE__*/React.createElement("ul", null, contest.files.map(function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file.fileId
    }, /*#__PURE__*/React.createElement(Link, {
      href: file.url
    }, file.description));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.contest.applicationDeadline",
    defaultMessage: "prazo de candidaturas: at\xE9 ao dia"
  }), " ", contest.submissionDeadlineFormattedDate, ",", " ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.contest.inclusive",
    defaultMessage: "inclusive"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.contest.stageOfProcedure",
    defaultMessage: "fase do procedimento"
  }), ": ", contest.contestState)));
};

var defaults$u = {
  contest: {
    title: "",
    subTitle: "",
    files: [],
    submissionDeadlineFormattedDate: "",
    contestState: ""
  }
};
var types$x = {
  contest: PropTypes$1.shape({
    title: PropTypes$1.string,
    subTitle: PropTypes$1.string,
    files: PropTypes$1.arrayOf(PropTypes$1.shape({
      fileId: PropTypes$1.number,
      url: PropTypes$1.string,
      description: PropTypes$1.string
    })),
    submissionDeadlineFormattedDate: PropTypes$1.string,
    contestState: PropTypes$1.string
  })
};
Contest.propTypes = types$x;
Contest.defaultProps = defaults$u;
var ContestStyles = styled.div(_templateObject$U(), function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.weight.light;
}, function (props) {
  return props.theme.components.listItem.spacingBottom;
}, function (props) {
  return props.theme.values.letterSpacing;
}, function (props) {
  return props.isThemeReverse ? props.theme.components.text.colorReverse : props.theme.components.text.color;
}, function (props) {
  return props.theme.highContrast.text || props.isThemeReverse ? props.theme.colors.white : props.theme.colors.blackLight;
}, function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.weight.light;
}, function (props) {
  return props.theme.highContrast.link || props.theme.colors.black;
}, function (props) {
  return props.theme.highContrast.link || props.theme.colors.black;
}, function (props) {
  return props.theme.highContrast.link || props.theme.colors.white;
}, function (props) {
  return props.theme.highContrast.link || props.theme.colors.white;
}, function (props) {
  return props.theme.highContrast.linkHover || props.theme.colors.black;
}, function (props) {
  return props.theme.highContrast.linkHover || props.theme.colors.black;
}, function (props) {
  return props.isThemeReverse ? props.theme.highContrast.linkHover || // eslint-disable-next-line no-undef
  lighten(0.5, props.activeColor) : props.theme.highContrast.linkHover || props.activeColor;
}, function (props) {
  return props.theme.sizes.l;
});

function _templateObject$V() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n"]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}

var Empty = function Empty(_ref) {
  var className = _ref.className,
      text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, text);
};

Empty.propTypes = {
  text: PropTypes$1.string,
  className: PropTypes$1.string
};
Empty.defaultProps = {
  text: "Sem conteudo"
};
var EmptyStyles = styled(Empty)(_templateObject$V(), function (props) {
  return props.padding;
});
var defaults$v = {
  padding: "0"
};
var types$y = {
  padding: PropTypes$1.string
};
EmptyStyles.propTypes = types$y;
EmptyStyles.defaultProps = defaults$v;

function _templateObject$W() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: ", ";\n  height: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  p {\n    margin-top: 10px;\n  }\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}

var Error$1 = function Error(_ref) {
  var className = _ref.className,
      children = _ref.children,
      text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fas fa-server",
    fontSize: "24px"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "mediumSmall",
    fontWeight: "400"
  }, children || text));
};

var defaults$w = {
  text: "Aconteceu um erro ao fazer o pedido"
};
var types$z = {
  text: PropTypes$1.string,
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  minHeight: PropTypes$1.string
};
Error$1.propTypes = types$z;
Error$1.defaultProps = defaults$w;
var ErrorWithStyles = styled(Error$1)(_templateObject$W(), function (props) {
  return props.minHeight || "200px";
});

function _templateObject$X() {
  var data = _taggedTemplateLiteral(["\n  text-align: ", ";\n  .spinner {\n    display: inline-block;\n    width: 64px;\n    height: 64px;\n  }\n  .spinner:after {\n    content: \" \";\n    display: block;\n    width: 46px;\n    height: 46px;\n    margin: 1px;\n    border-radius: 50%;\n    border: 5px solid ", ";\n    border-color: ", " transparent ", "\n      transparent;\n    animation: spinner 1.2s linear infinite;\n  }\n  @keyframes spinner {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$k = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner"
  }));
};

Loading$k.propTypes = {
  className: PropTypes$1.string
};
var LoadingStyles = styled(Loading$k)(_templateObject$X(), function (props) {
  return props.position;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
var defaults$x = {
  color: "#fff",
  position: "center"
};
var types$A = {
  color: PropTypes$1.string,
  position: PropTypes$1.oneOf(["center", "left", "right"])
};
LoadingStyles.propTypes = types$A;
LoadingStyles.defaultProps = defaults$x;

function _templateObject$Y() {
  var data = _taggedTemplateLiteral(["\n  &.custom-react-calendar {\n    position: absolute;\n    right: ", ";\n    left: ", ";\n    z-index: 3;\n    top: ", ";\n\n    .react-calendar__tile--active,\n    .react-calendar__tile--hasActive,\n    .react-calendar__navigation button[disabled] {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    .react-calendar {\n      background: ", ";\n      width: calc(40px * 7 + 40px);\n      padding: 20px;\n      border: none;\n      font-family: \"Roboto\", sans-serif;\n    }\n\n    .react-calendar__navigation {\n      height: auto;\n      margin-bottom: 5px;\n\n      button {\n        text-transform: uppercase;\n        font-size: 24px;\n        font-weight: 100;\n        font-family: \"Roboto\", sans-serif;\n        &:hover,\n        &:focus {\n          background-color: ", ";\n        }\n      }\n    }\n\n    .react-calendar__month-view__weekdays {\n      color: ", ";\n      text-transform: capitalize;\n      font-weight: 300;\n      font-size: 14px;\n    }\n\n    .react-calendar__month-view__days__day--neighboringMonth {\n      color: ", ";\n    }\n\n    .react-calendar__tile {\n      padding: 0;\n    }\n\n    abbr[title],\n    acronym[title] {\n      text-decoration: none;\n    }\n\n    button {\n      font-family: \"Roboto\", sans-serif;\n      flex-basis: unset !important;\n      color: ", ";\n      height: 40px;\n      width: 40px;\n      font-weight: 300;\n      font-size: 12px;\n\n      &:hover,\n      &:focus {\n        background-color: ", ";\n        color: ", ";\n      }\n    }\n\n    button.react-calendar__century-view__decades__decade {\n      flex-basis: 33.3333% !important;\n    }\n  }\n"]);

  _templateObject$Y = function _templateObject() {
    return data;
  };

  return data;
}

var ReactCalendar = function ReactCalendar(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " custom-react-calendar")
  }, /*#__PURE__*/React.createElement(Calendar, _extends({}, props, {
    next2Label: null,
    prev2Label: null,
    formatShortWeekday: function formatShortWeekday(locale, date) {
      return moment(date).format("ddd");
    },
    formatMonthYear: function formatMonthYear(locale, date) {
      return moment(date).format("MMMM YYYY");
    },
    formatMonth: function formatMonth(locale, date) {
      return moment(date).format("MMM");
    }
  })));
};

ReactCalendar.propTypes = {
  className: PropTypes$1.string
};
var ReactCalendarWithStyles = styled(ReactCalendar)(_templateObject$Y(), function (props) {
  return props.right || "0";
}, function (props) {
  return props.left;
}, function (props) {
  return props.top;
}, function (props) {
  return props.theme.highContrast.action || props.primaryColor || props.theme.components.reactCalendar.titleActiveBgColor;
}, function (props) {
  return props.theme.components.reactCalendar.titleActiveColor;
}, function (props) {
  return props.theme.components.reactCalendar.backgroundColor;
}, function (props) {
  return props.theme.highContrast.action || props.primaryColor || props.theme.components.reactCalendar.buttonFocus;
}, function (props) {
  return props.theme.components.reactCalendar.monthViewWeekDaysColor;
}, function (props) {
  return props.theme.components.reactCalendar.monthViewWeekDaysNeighboringColor;
}, function (props) {
  return props.theme.components.reactCalendar.buttonColor;
}, function (props) {
  return props.theme.highContrast.action || props.primaryColor || props.theme.components.reactCalendar.buttonHoverBgColor;
}, function (props) {
  return props.theme.components.reactCalendar.buttonHoverTextColor;
});

var WithProps$d = function WithProps(props) {
  return /*#__PURE__*/React.createElement(ReactCalendarWithStyles, props);
};
WithProps$d.propTypes = {
  right: PropTypes$1.string,
  left: PropTypes$1.string,
  top: PropTypes$1.string,
  primaryColor: PropTypes$1.string
};

function _templateObject$Z() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 38px;\n  box-sizing: border-box;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:hover {\n    input {\n      border: 1px solid\n        ", ";\n    }\n  }\n\n  input {\n    height: inherit;\n    width: 100%;\n    border: 1px solid ", ";\n    padding: ", ";\n\n    line-height: 1.4;\n    cursor: pointer;\n    transition: all 100ms;\n    background-color: transparent;\n    font-weight: ", ";\n    font-size: ", ";\n\n    &:hover {\n      border: 1px solid\n        ", ";\n    }\n\n    &:focus {\n      outline: none;\n      border: 1px solid\n        ", ";\n      box-shadow: 0 0 0 1px\n        ", ";\n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n\n  .icon-container {\n    position: absolute;\n    width: 30px;\n    top: 1px;\n    bottom: 1px;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      background-color: ", ";\n      width: 1px;\n      top: 8px;\n      bottom: 8px;\n      left: -1px;\n    }\n\n    &.clear {\n      pointer-events: all;\n      right: 30px;\n      width: 36px;\n\n      &:hover {\n        i {\n          color: ", ";\n        }\n      }\n\n      &:before {\n        content: initial;\n      }\n    }\n  }\n"]);

  _templateObject$Z = function _templateObject() {
    return data;
  };

  return data;
}

var DatePicker = function DatePicker(_ref) {
  var className = _ref.className,
      value = _ref.value,
      theme = _ref.theme,
      calendarPrimaryColor = _ref.calendarPrimaryColor,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  useEffect(function () {
    setInputValue(value);
  }, [value]);

  var onHandleChange = function onHandleChange(value) {
    var date = moment(value).format("DD-MM-YYYY");
    setInputValue(date);
    onChange(date);
    setOpen(false);
  };

  var onClear = function onClear() {
    setInputValue("");
    onChange(null);
  };

  return /*#__PURE__*/React.createElement(ClickAwayListener, {
    onChange: function onChange() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: inputValue,
    placeholder: placeholder || "dd/mm/aaaa",
    onFocus: function onFocus() {
      return setOpen(true);
    },
    readOnly: true
  }), inputValue && /*#__PURE__*/React.createElement("div", {
    className: "icon-container clear",
    onClick: onClear
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.fas_times,
    color: theme.components.datePicker.iconColor,
    size: "xSmall",
    "aria-label": "Abrir calend\xE1rio"
  })), /*#__PURE__*/React.createElement("div", {
    className: "icon-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.calendar,
    color: theme.components.datePicker.iconColor,
    size: "xSmall",
    "aria-label": "Abrir calend\xE1rio"
  })), isOpen && /*#__PURE__*/React.createElement(ReactCalendarWithStyles, {
    top: "45px",
    primaryColor: calendarPrimaryColor,
    onChange: onHandleChange
  })));
};

var types$B = {
  className: PropTypes$1.string,
  value: PropTypes$1.string,
  theme: PropTypes$1.object,
  calendarPrimaryColor: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  onChange: PropTypes$1.func,
  showClear: PropTypes$1.bool
};
var defaults$y = {
  isOpen: false
};
DatePicker.propTypes = types$B;
DatePicker.defaultProps = defaults$y;
var DatePickerWithStyles = styled(DatePicker)(_templateObject$Z(), function (props) {
  return props.theme.components.datePicker.backgroundColor;
}, function (props) {
  return props.theme.components.datePicker.hoverBorderColor;
}, function (props) {
  return props.theme.components.datePicker.borderColor;
}, function (props) {
  return props.showClear ? "2px 63px 2px 10px" : "2px 40px 2px 10px";
}, function (props) {
  return props.theme.weight.xbase;
}, function (props) {
  return props.theme.sizes.s;
}, function (props) {
  return props.theme.components.datePicker.hoverBorderColor;
}, function (props) {
  return props.theme.components.datePicker.borderColor;
}, function (props) {
  return props.theme.components.datePicker.shadowColor;
}, function (props) {
  return props.theme.components.datePicker.textColor;
}, function (props) {
  return props.theme.components.datePicker.separatorColor;
}, function (props) {
  return props.theme.components.datePicker.clearIconHoverColor;
});
var index$1 = withTheme(DatePickerWithStyles); //Only used for the Storybook Props Table

function _templateObject$_() {
  var data = _taggedTemplateLiteral(["\n  input {\n    position: absolute;\n    opacity: 0;\n    z-index: -1;\n  }\n  label {\n    opacity: 0.8;\n    cursor: pointer;\n    position: relative;\n    display: block;\n    color: ", ";\n    background-color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    padding-top: 5px;\n    padding-bottom: 5px;\n    :hover,\n    :active {\n      background-color: ", ";\n    }\n    ", ";\n  }\n  /* :checked */\n  input:checked ~ .tab-content {\n    max-height: 10em;\n    padding-bottom: 12px;\n  }\n  /* Icon */\n  label::after {\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: block;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    text-align: center;\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n    cursor: pointer;\n  }\n  input[type=\"checkbox\"] + label::after {\n    font-family: entypo;\n    content: \"\\e764\";\n  }\n  input[type=\"radio\"] + label::after {\n    font-family: entypo;\n    content: \"\\e764\";\n  }\n  input[type=\"checkbox\"]:checked + label::after {\n    transform: rotate(180deg);\n  }\n  input[type=\"radio\"]:checked + label::after {\n    transform: rotateX(180deg);\n  }\n"], ["\n  input {\n    position: absolute;\n    opacity: 0;\n    z-index: -1;\n  }\n  label {\n    opacity: 0.8;\n    cursor: pointer;\n    position: relative;\n    display: block;\n    color: ", ";\n    background-color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    padding-top: 5px;\n    padding-bottom: 5px;\n    :hover,\n    :active {\n      background-color: ", ";\n    }\n    ", ";\n  }\n  /* :checked */\n  input:checked ~ .tab-content {\n    max-height: 10em;\n    padding-bottom: 12px;\n  }\n  /* Icon */\n  label::after {\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: block;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    text-align: center;\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n    cursor: pointer;\n  }\n  input[type=\"checkbox\"] + label::after {\n    font-family: entypo;\n    content: \"\\\\e764\";\n  }\n  input[type=\"radio\"] + label::after {\n    font-family: entypo;\n    content: \"\\\\e764\";\n  }\n  input[type=\"checkbox\"]:checked + label::after {\n    transform: rotate(180deg);\n  }\n  input[type=\"radio\"]:checked + label::after {\n    transform: rotateX(180deg);\n  }\n"]);

  _templateObject$_ = function _templateObject() {
    return data;
  };

  return data;
}

function Tab$1(_ref) {
  var className = _ref.className,
      name = _ref.name,
      title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab ".concat(className)
  }, /*#__PURE__*/React.createElement("input", {
    id: name,
    alt: name,
    type: "checkbox",
    name: "tabs"
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: name
  }, title), children);
}

Tab$1.propTypes = {
  className: PropTypes$1.string,
  name: PropTypes$1.string,
  title: PropTypes$1.string,
  children: PropTypes$1.node
};
Tab$1.defaultProps = {
  name: "Nome",
  title: "Título"
};
var TabStyles = styled(Tab$1)(_templateObject$_(), function (props) {
  return props.color;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.uppercase && "text-transform: uppercase";
});
var defaults$z = {
  color: theme$1.components.tab.color,
  backgroundColor: theme$1.components.tab.backgroundColor,
  uppercase: false,
  fontSize: "inherit",
  fontWeight: 400
};
var types$C = {
  color: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  uppercase: PropTypes$1.bool,
  fontSize: PropTypes$1.string,
  fontWeight: PropTypes$1.number
};
TabStyles.propTypes = types$C;
TabStyles.defaultProps = defaults$z;

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  .u-position-absolute {\n    position: absolute;\n  }\n\n  .u-position-relative {\n    position: relative;\n  }\n\n  .accordion {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 2px;\n  }\n\n  .accordion__item + .accordion__item {\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  .accordion__item--has-icon {\n    position: relative;\n  }\n\n  .accordion__title {\n    cursor: pointer;\n    padding: 5px 0;\n    width: 100%;\n    text-align: left;\n    border: none;\n    outline: none;\n    margin-bottom: 5px;\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    .accordion__title {\n      padding: 10px 0;\n    }\n  }\n\n  .accordion__body {\n    margin: 0 0 12px 0;\n    display: block;\n    animation: fadein 0.35s ease-in;\n  }\n\n  /*\n  .accordion__body li {\n    margin-bottom: 5px;\n  }\n  */\n\n  .accordion__body--hidden {\n    display: none;\n    opacity: 0;\n    animation: fadein 0.35s ease-in;\n  }\n\n  .accordion__title > *:last-child,\n  .accordion__body > *:last-child {\n    margin-bottom: 0;\n  }\n\n  .accordion__arrow {\n    display: inline-block;\n    width: 24px;\n    height: 12px;\n    position: absolute;\n    top: 50%;\n    right: 0;\n    margin-top: -6px;\n  }\n\n  .accordion__arrow::after,\n  .accordion__arrow::before {\n    display: block;\n    position: absolute;\n    top: 50%;\n    width: 10px;\n    height: 2px;\n    background-color: ", ";\n    border-radius: 2px;\n    content: \"\";\n  }\n\n  .accordion__arrow::before {\n    left: 4px;\n    transform: rotate(45deg);\n  }\n\n  [aria-expanded=\"true\"] .accordion__arrow::before,\n  [aria-selected=\"true\"] .accordion__arrow::before {\n    transform: rotate(-45deg);\n  }\n\n  .accordion__arrow::after {\n    right: 4px;\n    transform: rotate(-45deg);\n  }\n\n  [aria-expanded=\"true\"] .accordion__arrow::after,\n  [aria-selected=\"true\"] .accordion__arrow::after {\n    transform: rotate(45deg);\n  }\n\n  .accordion__arrow::before,\n  .accordion__arrow::after {\n    transition: transform 0.25s ease, -webkit-transform 0.25s ease;\n  }\n\n  /* -------------------------------------------------- */\n  /* ---------------- Animation part ------------------ */\n  /* -------------------------------------------------- */\n\n  @keyframes fadein {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes move-down {\n    0% {\n      transform: translateY(0);\n    }\n    10% {\n      transform: translateY(0);\n    }\n    20% {\n      transform: translateY(5px);\n    }\n    30% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes move-up {\n    0% {\n      transform: translateY(0);\n    }\n    10% {\n      transform: translateY(0);\n    }\n    20% {\n      transform: translateY(-5px);\n    }\n    30% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n\n  .accordion__title--animated:hover .accordion__arrow {\n    animation-name: move-down;\n    animation-duration: 1.5s;\n  }\n\n  .accordion__title--animated[aria-expanded=\"true\"]:hover .accordion__arrow {\n    animation-name: move-up;\n    animation-duration: 1.5s;\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$$() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-decoration: none;\n"]);

  _templateObject$$ = function _templateObject() {
    return data;
  };

  return data;
}

var AccordionTitleStyles = function AccordionTitleStyles(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasLinks = _ref.hasLinks,
      baseLinkUrl = _ref.baseLinkUrl,
      accordionTitleHasLink = _ref.accordionTitleHasLink,
      color = _ref.color,
      _native = _ref["native"];

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " u-position-relative")
  }, accordionTitleHasLink ? /*#__PURE__*/React.createElement(Link, {
    href: baseLinkUrl,
    color: color,
    size: "mediumSmall",
    fontDecoration: "none",
    fontWeight: "400",
    lineHeight: "1.4",
    "native": _native
  }, children) : /*#__PURE__*/React.createElement(Text, {
    color: theme$1.highContrast.text || color,
    size: "mediumSmall",
    fontWeight: "400",
    lineHeight: "1.4"
  }, children), hasLinks && /*#__PURE__*/React.createElement("div", {
    className: "accordion__arrow",
    role: "presentation"
  }));
};

AccordionTitleStyles.defaultProps = {
  hasLinks: true,
  accordionTitleHasLink: true,
  "native": false
};
AccordionTitleStyles.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  accordionTitleHasLink: PropTypes$1.bool,
  baseLinkUrl: PropTypes$1.string,
  color: PropTypes$1.string,
  "native": PropTypes$1.bool,
  hasLinks: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.instanceOf("undefined")])
};
var AccordionTitle = styled(AccordionTitleStyles)(_templateObject$$(), function (props) {
  return props.color;
}, function (props) {
  return props.uppercase;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontWeight;
});
AccordionTitle.propTypes = {
  color: PropTypes$1.string,
  uppercase: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  fontWeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
};
AccordionTitle.defaultProps = {
  color: theme$1.components.accessibleAccordion.color,
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 300
};
var Accordion = styled(Accordion$3)(_templateObject2$9(), function (props) {
  return props.theme.components.accessibleAccordion.arrowColor;
});

var WithProps$e = function WithProps(props) {
  return /*#__PURE__*/React.createElement("div", props);
};
WithProps$e.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  baseLinkUrl: PropTypes$1.string,
  color: PropTypes$1.string,
  hasLinks: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.instanceOf("undefined")]),
  uppercase: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  fontWeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  accordionTitleHasLink: PropTypes$1.bool
};
WithProps$e.defaultProps = {
  hasLinks: true,
  color: theme$1.components.accessibleAccordion.color,
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 300,
  accordionTitleHasLink: true
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  .u-position-absolute {\n    position: absolute;\n  }\n\n  .u-position-relative {\n    position: relative;\n    i {\n      transition: transform 0.25s ease-in-out;\n    }\n  }\n\n  .accordion {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 2px;\n  }\n\n  .accordion__item + .accordion__item {\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  .accordion__item--has-icon {\n    position: relative;\n  }\n  .accordion__item {\n    border-top: ", ";\n  }\n\n  .accordion__title {\n    cursor: pointer;\n    padding-top: 18px;\n    width: 100%;\n    text-align: left;\n    border: none;\n    outline: none;\n    margin-bottom: 18px;\n  }\n\n  .accordion__body {\n    margin: 0 0 12px 0;\n    display: block;\n    animation: fadein 0.35s ease-in;\n  }\n\n  .accordion__body--hidden {\n    display: none;\n    opacity: 0;\n    animation: fadein 0.35s ease-in;\n  }\n\n  .accordion__title > *:last-child,\n  .accordion__body > *:last-child {\n    margin-bottom: 0;\n  }\n\n  .fal {\n    display: inline-block;\n    position: absolute;\n    top: 0%;\n    right: 0;\n    margin-right: 9px;\n    font-weight: 100;\n    color: ", ";\n\n    &.animate {\n      position: absolute;\n      transform: rotate(0deg);\n    }\n    &.normal {\n      position: absolute;\n      transform: rotate(90deg);\n    }\n  }\n\n  /* -------------------------------------------------- */\n  /* ---------------- Animation part ------------------ */\n  /* -------------------------------------------------- */\n\n  @keyframes fadein {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes move-down {\n    0% {\n      transform: translateY(0);\n    }\n    10% {\n      transform: translateY(0);\n    }\n    20% {\n      transform: translateY(5px);\n    }\n    30% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes move-up {\n    0% {\n      transform: translateY(0);\n    }\n    10% {\n      transform: translateY(0);\n    }\n    20% {\n      transform: translateY(-5px);\n    }\n    30% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n\n  .accordion__title--animated:hover .fal {\n    animation-name: move-down;\n    animation-duration: 1.5s;\n  }\n\n  .accordion__title--animated[aria-expanded=\"true\"]:hover .fal {\n    animation-name: move-up;\n    animation-duration: 1.5s;\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  .title {\n    color: ", ";\n    font-size: ", ";\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$10() {
  var data = _taggedTemplateLiteral(["\n  .header {\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n  }\n"]);

  _templateObject$10 = function _templateObject() {
    return data;
  };

  return data;
}

var AccordionHeader = function AccordionHeader(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " u-position-relative")
  }, /*#__PURE__*/React.createElement("p", {
    className: "header"
  }, children));
};

var AccordionHeaderWithStyles = styled(AccordionHeader)(_templateObject$10(), function (props) {
  return props.color || props.theme.components.generalAccordion.header;
}, function (props) {
  return props.fontSize || props.theme.sizes.m;
}, function (props) {
  return props.fontWeight || props.theme.weight.light;
});

var AccordionTitle$1 = function AccordionTitle(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      isOpen = _ref2.isOpen,
      theme = _ref2.theme,
      url = _ref2.url;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " u-position-relative col-auto pl-0 pr-5")
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: url,
    hasContainer: false,
    hasLine: isOpen,
    hasLink: isOpen,
    textColor: theme.components.generalAccordion.title,
    fontSize: "20px",
    fontWeight: "400",
    marginBottom: "0px"
  }, children), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-minus",
    role: "presentation"
  }), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-minus ".concat(isOpen ? "animate" : "normal"),
    role: "presentation"
  }));
};

var AccordionTitleWithStyles = styled(AccordionTitle$1)(_templateObject2$a(), function (props) {
  return props.color || props.theme.components.generalAccordion.title;
}, function (props) {
  return props.fontSize || props.theme.sizes.m;
});
AccordionHeader.propTypes = {
  color: PropTypes$1.string,
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  uppercase: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  fontWeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
};
AccordionTitle$1.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  isOpen: PropTypes$1.bool,
  theme: PropTypes$1.object,
  url: PropTypes$1.string
};
var Accordion$1 = styled(Accordion$3)(_templateObject3$2(), function (props) {
  return props.theme.components.generalAccordion.borderColor;
}, function (props) {
  return props.theme.components.generalAccordion.title;
});

var WithProps$f = function WithProps(props) {
  return /*#__PURE__*/React.createElement("div", props);
};
WithProps$f.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  isOpen: PropTypes$1.bool,
  color: PropTypes$1.string,
  fontSize: PropTypes$1.string,
  fontWeight: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  url: PropTypes$1.string
};
WithProps$f.defaultProps = {
  color: theme$1.components.generalAccordion.title,
  fontSize: "14px",
  fontWeight: 300,
  isOpen: false
};

function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var hasOwnProperty = Object.hasOwnProperty;
var setPrototypeOf = Object.setPrototypeOf;
var isFrozen = Object.isFrozen;
var objectKeys = Object.keys;
var freeze = Object.freeze;
var seal = Object.seal; // eslint-disable-line import/no-mutable-exports

var _ref = typeof Reflect !== 'undefined' && Reflect;
var apply = _ref.apply;
var construct = _ref.construct;

if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}

if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}

if (!seal) {
  seal = function seal(x) {
    return x;
  };
}

if (!construct) {
  construct = function construct(Func, args) {
    return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray$1(args))))();
  };
}

var arrayForEach = unapply(Array.prototype.forEach);
var arrayIndexOf = unapply(Array.prototype.indexOf);
var arrayJoin = unapply(Array.prototype.join);
var arrayPop = unapply(Array.prototype.pop);
var arrayPush = unapply(Array.prototype.push);
var arraySlice = unapply(Array.prototype.slice);

var stringToLowerCase = unapply(String.prototype.toLowerCase);
var stringMatch = unapply(String.prototype.match);
var stringReplace = unapply(String.prototype.replace);
var stringIndexOf = unapply(String.prototype.indexOf);
var stringTrim = unapply(String.prototype.trim);

var regExpTest = unapply(RegExp.prototype.test);
var regExpCreate = unconstruct(RegExp);

var typeErrorCreate = unconstruct(TypeError);

function unapply(func) {
  return function (thisArg) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return apply(func, thisArg, args);
  };
}

function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return construct(func, args);
  };
}

/* Add properties to a lookup table */
function addToSet(set, array) {
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }

  var l = array.length;
  while (l--) {
    var element = array[l];
    if (typeof element === 'string') {
      var lcElement = stringToLowerCase(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }

        element = lcElement;
      }
    }

    set[element] = true;
  }

  return set;
}

/* Shallow clone an object */
function clone(object) {
  var newObject = {};

  var property = void 0;
  for (property in object) {
    if (apply(hasOwnProperty, object, [property])) {
      newObject[property] = object[property];
    }
  }

  return newObject;
}

var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

// SVG
var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern']);

var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

var text$1 = freeze(['#text']);

var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocomplete', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'coords', 'crossorigin', 'datetime', 'default', 'dir', 'disabled', 'download', 'enctype', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'integrity', 'ismap', 'label', 'lang', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns']);

var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g // eslint-disable-line no-control-regex
);

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};

/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
 * @param {Document} document The document object (to determine policy name suffix)
 * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
 * are not supported).
 */
var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
  if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof$1(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }

  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  var suffix = null;
  var ATTR_NAME = 'data-tt-policy-suffix';
  if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
    suffix = document.currentScript.getAttribute(ATTR_NAME);
  }

  var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML: function createHTML(html$$1) {
        return html$$1;
      }
    });
  } catch (error) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};

function createDOMPurify() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

  var DOMPurify = function DOMPurify(root) {
    return createDOMPurify(root);
  };

  /**
   * Version label, exposed for easier checks
   * if DOMPurify is up to date or not
   */
  DOMPurify.version = '2.0.8';

  /**
   * Array of elements that DOMPurify removed during sanitation.
   * Empty if nothing was removed.
   */
  DOMPurify.removed = [];

  if (!window || !window.document || window.document.nodeType !== 9) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;

    return DOMPurify;
  }

  var originalDocument = window.document;
  var useDOMParser = false;
  var removeTitle = false;

  var document = window.document;
  var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      Text = window.Text,
      Comment = window.Comment,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;

  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.

  if (typeof HTMLTemplateElement === 'function') {
    var template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }

  var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
  var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';

  var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      getElementsByTagName = _document.getElementsByTagName,
      createDocumentFragment = _document.createDocumentFragment;
  var importNode = originalDocument.importNode;


  var hooks = {};

  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && document.documentMode !== 9;

  var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
      ERB_EXPR$$1 = ERB_EXPR,
      DATA_ATTR$$1 = DATA_ATTR,
      ARIA_ATTR$$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
  var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */

  /* allowed element names */

  var ALLOWED_TAGS = null;
  var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(svgFilters), _toConsumableArray(mathMl), _toConsumableArray(text$1)));

  /* Allowed attribute names */
  var ALLOWED_ATTR = null;
  var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(mathMl$1), _toConsumableArray(xml)));

  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  var FORBID_TAGS = null;

  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  var FORBID_ATTR = null;

  /* Decide if ARIA attributes are okay */
  var ALLOW_ARIA_ATTR = true;

  /* Decide if custom data attributes are okay */
  var ALLOW_DATA_ATTR = true;

  /* Decide if unknown protocols are okay */
  var ALLOW_UNKNOWN_PROTOCOLS = false;

  /* Output should be safe for jQuery's $() factory? */
  var SAFE_FOR_JQUERY = false;

  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  var SAFE_FOR_TEMPLATES = false;

  /* Decide if document with <html>... should be returned */
  var WHOLE_DOCUMENT = false;

  /* Track whether config is already set on this instance of DOMPurify. */
  var SET_CONFIG = false;

  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  var FORCE_BODY = false;

  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  var RETURN_DOM = false;

  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  var RETURN_DOM_FRAGMENT = false;

  /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
   * `Node` is imported into the current `Document`. If this flag is not enabled the
   * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
   * DOMPurify. */
  var RETURN_DOM_IMPORT = false;

  /* Try to return a Trusted Type object instead of a string, retrun a string in
   * case Trusted Types are not supported  */
  var RETURN_TRUSTED_TYPE = false;

  /* Output should be free from DOM clobbering attacks? */
  var SANITIZE_DOM = true;

  /* Keep element content when removing element? */
  var KEEP_CONTENT = true;

  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  var IN_PLACE = false;

  /* Allow usage of profiles like html, svg and mathMl */
  var USE_PROFILES = {};

  /* Tags to ignore content of when KEEP_CONTENT is true */
  var FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

  /* Tags that are safe for data: URIs */
  var DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image']);

  /* Attributes safe for values like "javascript:" */
  var URI_SAFE_ATTRIBUTES = null;
  var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

  /* Keep a reference to config to pass to hooks */
  var CONFIG = null;

  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */

  var formElement = document.createElement('form');

  /**
   * _parseConfig
   *
   * @param  {Object} cfg optional config literal
   */
  // eslint-disable-next-line complexity
  var _parseConfig = function _parseConfig(cfg) {
    if (CONFIG && CONFIG === cfg) {
      return;
    }

    /* Shield configuration object from tampering */
    if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof$1(cfg)) !== 'object') {
      cfg = {};
    }

    /* Set configuration parameters */
    ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
    URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
    FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
    FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
    USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    SAFE_FOR_JQUERY = cfg.SAFE_FOR_JQUERY || false; // Default false
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }

    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }

    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(text$1)));
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html);
        addToSet(ALLOWED_ATTR, html$1);
      }

      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl);
        addToSet(ALLOWED_ATTR, mathMl$1);
        addToSet(ALLOWED_ATTR, xml);
      }
    }

    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }

      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
    }

    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }

      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
    }

    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
    }

    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }

    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }

    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }

    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }

    CONFIG = cfg;
  };

  /**
   * _forceRemove
   *
   * @param  {Node} node a DOM node
   */
  var _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, { element: node });
    try {
      node.parentNode.removeChild(node);
    } catch (error) {
      node.outerHTML = emptyHTML;
    }
  };

  /**
   * _removeAttribute
   *
   * @param  {String} name an Attribute name
   * @param  {Node} node a DOM node
   */
  var _removeAttribute = function _removeAttribute(name, node) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: node.getAttributeNode(name),
        from: node
      });
    } catch (error) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: node
      });
    }

    node.removeAttribute(name);
  };

  /**
   * _initDocument
   *
   * @param  {String} dirty a string of dirty markup
   * @return {Document} a DOM, filled with the dirty markup
   */
  var _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    var doc = void 0;
    var leadingWhitespace = void 0;

    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      var matches = stringMatch(dirty, /^[\s]+/);
      leadingWhitespace = matches && matches[0];
    }

    var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /* Use DOMParser to workaround Firefox bug (see comment below) */
    if (useDOMParser) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, 'text/html');
      } catch (error) {}
    }

    /* Remove title to fix a mXSS bug in older MS Edge */
    if (removeTitle) {
      addToSet(FORBID_TAGS, ['title']);
    }

    /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
    Safari (see comment below) */
    if (!doc || !doc.documentElement) {
      doc = implementation.createHTMLDocument('');
      var _doc = doc,
          body = _doc.body;

      body.parentNode.removeChild(body.parentNode.firstElementChild);
      body.outerHTML = dirtyPayload;
    }

    if (dirty && leadingWhitespace) {
      doc.body.insertBefore(document.createTextNode(leadingWhitespace), doc.body.childNodes[0] || null);
    }

    /* Work on whole document or just its body */
    return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
  };

  // Firefox uses a different parser for innerHTML rather than
  // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
  // which means that you *must* use DOMParser, otherwise the output may
  // not be safe if used in a document.write context later.
  //
  // So we feature detect the Firefox bug and use the DOMParser if necessary.
  //
  // Chrome 77 and other versions ship an mXSS bug that caused a bypass to
  // happen. We now check for the mXSS trigger and react accordingly.
  if (DOMPurify.isSupported) {
    (function () {
      try {
        var doc = _initDocument('<svg><p><textarea><img src="</textarea><img src=x abc=1//">');
        if (doc.querySelector('svg img')) {
          useDOMParser = true;
        }
      } catch (error) {}
    })();

    (function () {
      try {
        var doc = _initDocument('<x/><title>&lt;/title&gt;&lt;img&gt;');
        if (regExpTest(/<\/title/, doc.querySelector('title').innerHTML)) {
          removeTitle = true;
        }
      } catch (error) {}
    })();
  }

  /**
   * _createIterator
   *
   * @param  {Document} root document/fragment to create iterator for
   * @return {Iterator} iterator instance
   */
  var _createIterator = function _createIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
      return NodeFilter.FILTER_ACCEPT;
    }, false);
  };

  /**
   * _isClobbered
   *
   * @param  {Node} elm element to check for clobbering attacks
   * @return {Boolean} true if clobbered, false if safe
   */
  var _isClobbered = function _isClobbered(elm) {
    if (elm instanceof Text || elm instanceof Comment) {
      return false;
    }

    if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string') {
      return true;
    }

    return false;
  };

  /**
   * _isNode
   *
   * @param  {Node} obj object to check whether it's a DOM node
   * @return {Boolean} true is object is a DOM node
   */
  var _isNode = function _isNode(obj) {
    return (typeof Node === 'undefined' ? 'undefined' : _typeof$1(Node)) === 'object' ? obj instanceof Node : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof$1(obj)) === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string';
  };

  /**
   * _executeHook
   * Execute user configurable hooks
   *
   * @param  {String} entryPoint  Name of the hook's entry point
   * @param  {Node} currentNode node to work on with the hook
   * @param  {Object} data additional hook parameters
   */
  var _executeHook = function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }

    arrayForEach(hooks[entryPoint], function (hook) {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };

  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   *
   * @param   {Node} currentNode to check for permission to exist
   * @return  {Boolean} true if node was killed, false if left alive
   */
  // eslint-disable-next-line complexity
  var _sanitizeElements = function _sanitizeElements(currentNode) {
    var content = void 0;

    /* Execute a hook if present */
    _executeHook('beforeSanitizeElements', currentNode, null);

    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Now let's check the element's type and name */
    var tagName = stringToLowerCase(currentNode.nodeName);

    /* Execute a hook if present */
    _executeHook('uponSanitizeElement', currentNode, {
      tagName: tagName,
      allowedTags: ALLOWED_TAGS
    });

    /* Take care of an mXSS pattern using p, br inside svg, math */
    if ((tagName === 'svg' || tagName === 'math') && currentNode.querySelectorAll('p, br').length !== 0) {
      _forceRemove(currentNode);
      return true;
    }

    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Keep content except for black-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
        try {
          var htmlToInsert = currentNode.innerHTML;
          currentNode.insertAdjacentHTML('AfterEnd', trustedTypesPolicy ? trustedTypesPolicy.createHTML(htmlToInsert) : htmlToInsert);
        } catch (error) {}
      }

      _forceRemove(currentNode);
      return true;
    }

    /* Remove in case a noscript/noembed XSS is suspected */
    if (tagName === 'noscript' && regExpTest(/<\/noscript/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }

    if (tagName === 'noembed' && regExpTest(/<\/noembed/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Convert markup to cover jQuery behavior */
    if (SAFE_FOR_JQUERY && !currentNode.firstElementChild && (!currentNode.content || !currentNode.content.firstElementChild) && regExpTest(/</g, currentNode.textContent)) {
      arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
      if (currentNode.innerHTML) {
        currentNode.innerHTML = stringReplace(currentNode.innerHTML, /</g, '&lt;');
      } else {
        currentNode.innerHTML = stringReplace(currentNode.textContent, /</g, '&lt;');
      }
    }

    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
      /* Get the element's text content */
      content = currentNode.textContent;
      content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
      content = stringReplace(content, ERB_EXPR$$1, ' ');
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
        currentNode.textContent = content;
      }
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeElements', currentNode, null);

    return false;
  };

  /**
   * _isValidAttribute
   *
   * @param  {string} lcTag Lowercase tag name of containing element.
   * @param  {string} lcName Lowercase attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }

    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      return false;

      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
      return false;
    }

    return true;
  };

  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param  {Node} currentNode to sanitize
   */
  // eslint-disable-next-line complexity
  var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    var attr = void 0;
    var value = void 0;
    var lcName = void 0;
    var idAttr = void 0;
    var l = void 0;
    /* Execute a hook if present */
    _executeHook('beforeSanitizeAttributes', currentNode, null);

    var attributes = currentNode.attributes;

    /* Check if we have attributes; if not we might have a text node */

    if (!attributes) {
      return;
    }

    var hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    l = attributes.length;

    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      attr = attributes[l];
      var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;

      value = stringTrim(attr.value);
      lcName = stringToLowerCase(name);

      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }

      /* Remove attribute */
      // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
      // remove a "name" attribute from an <img> tag that has an "id"
      // attribute at the time.
      if (lcName === 'name' && currentNode.nodeName === 'IMG' && attributes.id) {
        idAttr = attributes.id;
        attributes = arraySlice(attributes, []);
        _removeAttribute('id', currentNode);
        _removeAttribute(name, currentNode);
        if (arrayIndexOf(attributes, idAttr) > l) {
          currentNode.setAttribute('id', idAttr.value);
        }
      } else if (
      // This works around a bug in Safari, where input[type=file]
      // cannot be dynamically set after type has been removed
      currentNode.nodeName === 'INPUT' && lcName === 'type' && value === 'file' && hookEvent.keepAttr && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
        continue;
      } else {
        // This avoids a crash in Safari v9.0 with double-ids.
        // The trick is to first set the id to be empty and then to
        // remove the attribute
        if (name === 'id') {
          currentNode.setAttribute(name, '');
        }

        _removeAttribute(name, currentNode);
      }

      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }

      /* Work around a security issue in jQuery 3.0 */
      if (SAFE_FOR_JQUERY && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }

      /* Take care of an mXSS pattern using namespace switches */
      if (regExpTest(/svg|math/i, currentNode.namespaceURI) && regExpTest(regExpCreate('</(' + arrayJoin(objectKeys(FORBID_CONTENTS), '|') + ')', 'i'), value)) {
        _removeAttribute(name, currentNode);
        continue;
      }

      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
        value = stringReplace(value, ERB_EXPR$$1, ' ');
      }

      /* Is `value` valid for this attribute? */
      var lcTag = currentNode.nodeName.toLowerCase();
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }

      /* Handle invalid data-* attribute set by try-catching it */
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
          currentNode.setAttribute(name, value);
        }

        arrayPop(DOMPurify.removed);
      } catch (error) {}
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeAttributes', currentNode, null);
  };

  /**
   * _sanitizeShadowDOM
   *
   * @param  {DocumentFragment} fragment to iterate over recursively
   */
  var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    var shadowNode = void 0;
    var shadowIterator = _createIterator(fragment);

    /* Execute a hook if present */
    _executeHook('beforeSanitizeShadowDOM', fragment, null);

    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);

      /* Sanitize tags and elements */
      if (_sanitizeElements(shadowNode)) {
        continue;
      }

      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(shadowNode);
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };

  /**
   * Sanitize
   * Public method providing core sanitation functionality
   *
   * @param {String|Node} dirty string or DOM node
   * @param {Object} configuration object
   */
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty, cfg) {
    var body = void 0;
    var importedNode = void 0;
    var currentNode = void 0;
    var oldNode = void 0;
    var returnNode = void 0;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    if (!dirty) {
      dirty = '<!-->';
    }

    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      // eslint-disable-next-line no-negated-condition
      if (typeof dirty.toString !== 'function') {
        throw typeErrorCreate('toString is not a function');
      } else {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      }
    }

    /* Check we can run. Otherwise fall back or ignore */
    if (!DOMPurify.isSupported) {
      if (_typeof$1(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
        if (typeof dirty === 'string') {
          return window.toStaticHTML(dirty);
        }

        if (_isNode(dirty)) {
          return window.toStaticHTML(dirty.outerHTML);
        }
      }

      return dirty;
    }

    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }

    /* Clean up removed elements */
    DOMPurify.removed = [];

    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }

    if (IN_PLACE) ; else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!-->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && RETURN_TRUSTED_TYPE && dirty.indexOf('<') === -1) {
        return trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }

      /* Initialize the document to work on */
      body = _initDocument(dirty);

      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : emptyHTML;
      }
    }

    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }

    /* Get node iterator */
    var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Fix IE's strange behavior with manipulated textNodes #89 */
      if (currentNode.nodeType === 3 && currentNode === oldNode) {
        continue;
      }

      /* Sanitize tags and elements */
      if (_sanitizeElements(currentNode)) {
        continue;
      }

      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(currentNode);

      oldNode = currentNode;
    }

    oldNode = null;

    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }

    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);

        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }

      if (RETURN_DOM_IMPORT) {
        /* AdoptNode() is not used because internal state is not reset
               (e.g. the past names map of a HTMLFormElement), this is safe
               in theory but we would rather not risk another attack vector.
               The state that is cloned by importNode() is explicitly defined
               by the specs. */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }

      return returnNode;
    }

    var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
      serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
    }

    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };

  /**
   * Public method to set the configuration once
   * setConfig
   *
   * @param {Object} cfg configuration object
   */
  DOMPurify.setConfig = function (cfg) {
    _parseConfig(cfg);
    SET_CONFIG = true;
  };

  /**
   * Public method to remove the configuration
   * clearConfig
   *
   */
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };

  /**
   * Public method to check if an attribute value is valid.
   * Uses last set config, if any. Otherwise, uses config defaults.
   * isValidAttribute
   *
   * @param  {string} tag Tag name of containing element.
   * @param  {string} attr Attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
   */
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }

    var lcTag = stringToLowerCase(tag);
    var lcName = stringToLowerCase(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };

  /**
   * AddHook
   * Public method to add DOMPurify hooks
   *
   * @param {String} entryPoint entry point for the hook to add
   * @param {Function} hookFunction function to execute
   */
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }

    hooks[entryPoint] = hooks[entryPoint] || [];
    arrayPush(hooks[entryPoint], hookFunction);
  };

  /**
   * RemoveHook
   * Public method to remove a DOMPurify hook at a given entryPoint
   * (pops it from the stack of hooks if more are present)
   *
   * @param {String} entryPoint entry point for the hook to remove
   */
  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      arrayPop(hooks[entryPoint]);
    }
  };

  /**
   * RemoveHooks
   * Public method to remove all DOMPurify hooks at a given entryPoint
   *
   * @param  {String} entryPoint entry point for the hooks to remove
   */
  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };

  /**
   * RemoveAllHooks
   * Public method to remove all DOMPurify hooks
   *
   */
  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };

  return DOMPurify;
}

var purify = createDOMPurify();

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n      strong,\n      span {\n        font-weight: 300 !important;\n      }\n      span {\n        font-family: Roboto, sans-serif !important;\n        font-size: ", " !important;\n        color: ", " !important;\n        line-height: 1.6 !important;\n      }\n      a {\n        color: ", ";\n        text-decoration: underline;\n        cursor: pointer;\n        &:hover {\n          color: ", ";\n        }\n      }\n      ", "\n    "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", " !important;\n  strong,\n  span {\n    font-weight: 400 !important;\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.6;\n  font-weight: 300;\n  p,\n  ul {\n    margin-bottom: 10px;\n  }\n\n  ol {\n    list-style-position: inside;\n    text-indent: -16px;\n    padding-left: 16px;\n  }\n\n  ul {\n    list-style-type: none;\n    padding-left: 15px;\n    li {\n      transform: translateX(10px);\n      position: relative;\n      &:before {\n        content: \"\";\n        display: inline-block;\n        vertical-align: middle;\n        width: 2px;\n        height: 2px;\n        background-color: ", ";\n        transform: translateX(-10px);\n        border-radius: 50%;\n        position: absolute;\n        top: 9px;\n      }\n    }\n  }\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$11() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.6;\n  font-weight: 300;\n  text-transform: none;\n  word-break: break-word;\n  ul {\n    list-style-type: none;\n  }\n"]);

  _templateObject$11 = function _templateObject() {
    return data;
  };

  return data;
}
var defaultStyles = css(_templateObject$11(), function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.components.injectHtml["default"].color;
});
var presentationStyles = css(_templateObject2$b(), function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.components.injectHtml.presentationStyles.color;
}, function (props) {
  return props.theme.components.injectHtml.presentationStyles.before;
});
var lightStyles = css(_templateObject3$3(), function (props) {
  return props.theme.components.injectHtml.lightStyles.color;
}, function (props) {
  return props.theme.sizes.sm;
});

function Modifier(variant) {
  switch (variant) {
    case "presentation":
      return presentationStyles;

    case "light":
      return lightStyles;

    default:
      return defaultStyles;
  }
}

function InjectHtml(_ref) {
  var content = _ref.content,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    dangerouslySetInnerHTML: {
      __html: purify.sanitize(content)
    }
  });
}

InjectHtml.propTypes = {
  content: PropTypes$1.any,
  className: PropTypes$1.string
};
var InjectHtml$1 = styled(InjectHtml)(_templateObject4$2(), function (props) {
  return props.variant !== "removeStyles" && css(_templateObject5$1(), function (props) {
    return props.theme.sizes.sm;
  }, function (props) {
    return props.theme.components.injectHtml.span;
  }, function (props) {
    return props.theme.components.injectHtml.link.color;
  }, function (props) {
    return props.theme.components.injectHtml.link.hoverColor;
  }, Modifier(props.variant));
});

function _templateObject$12() {
  var data = _taggedTemplateLiteral(["\n  //For the button\n  .container {\n    position: relative;\n  }\n"]);

  _templateObject$12 = function _templateObject() {
    return data;
  };

  return data;
}

var Default = function Default(_ref) {
  var className = _ref.className,
      onKeyDown = _ref.onKeyDown,
      onKeyPress = _ref.onKeyPress,
      href = _ref.href,
      _native = _ref["native"],
      data = _ref.data,
      ariaLabel = _ref.ariaLabel,
      alt = _ref.alt,
      onMouseMove = _ref.onMouseMove,
      text = _ref.text,
      title = _ref.title,
      styles = _ref.styles,
      theme = _ref.theme,
      displayTab = _ref.displayTab;

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement(ContentContainer, {
    className: className,
    position: "relative",
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    rel: "noopener noreferrer",
    tabIndex: 0,
    display: "block",
    hasHover: false,
    "native": _native,
    target: displayTab
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    data: data,
    "aria-label": ariaLabel,
    alt: alt,
    hasEndpoint: false,
    onMouseMove: onMouseMove,
    endpoint: function endpoint() {
      return null;
    },
    size: "lg",
    useHeight: true
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    backgroundColor: theme.highContrast.backgroundColor || styles.backgroundColor,
    paddingTop: "20px",
    paddingBottom: "20px",
    mdPaddingTop: "20px",
    position: "absolute",
    width: "100%",
    bottom: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Triangle, {
    withContent: true,
    contentColor: theme.highContrast.text || styles.textColor,
    color: theme.highContrast.backgroundColor || styles.backgroundColor,
    size: "40px",
    top: "-60px",
    right: "15px",
    contentSize: "50px",
    XsContentSize: "40px",
    XsSize: "30px",
    XsTop: "-50px"
  }), /*#__PURE__*/React.createElement(LineTruncate, null, /*#__PURE__*/React.createElement(Text, {
    text: text,
    color: theme.highContrast.text || styles.textColor,
    fontSize: "16px",
    mobileXsFontSize: "14px"
  })), /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "xxLarge",
    sizeXsSize: "large",
    fontWeight: "500",
    color: theme.highContrast.text || styles.textColor,
    lineHeight: "1.5"
  }, title)))));
};

Default.propTypes = {
  className: PropTypes$1.string,
  onKeyDown: PropTypes$1.func,
  onKeyPress: PropTypes$1.func,
  href: PropTypes$1.string,
  "native": PropTypes$1.bool,
  data: PropTypes$1.array,
  ariaLabel: PropTypes$1.string,
  alt: PropTypes$1.string,
  onMouseMove: PropTypes$1.func,
  text: PropTypes$1.string,
  title: PropTypes$1.string,
  styles: PropTypes$1.object,
  theme: PropTypes$1.object,
  displayTab: PropTypes$1.string
};
var DefaultWithStyles = styled(Default)(_templateObject$12());

function _templateObject$13() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n\n  .content-container {\n    background-color: ", ";\n    width: 350px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n\n    .title-container {\n      position: relative;\n      .triangle-container {\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 0;\n      }\n    }\n\n    .title-container,\n    .warning-container {\n      padding: 30px;\n    }\n\n    .warning-container {\n      min-height: 175px;\n      background-color: ", ";\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .content-container {\n      height: auto;\n      width: 100%;\n      top: initial;\n      bottom: 0;\n\n      .title-container {\n        flex-grow: initial;\n        .triangle-container {\n          height: 0;\n          top: -20px;\n          width: 100%;\n          align-items: center;\n          .triangle {\n            transform: rotate(0);\n            left: initial;\n          }\n        }\n      }\n\n      .title-container,\n      .warning-container {\n        padding: 30px 15px;\n      }\n\n      .warning-container {\n        min-height: initial;\n      }\n    }\n  }\n"]);

  _templateObject$13 = function _templateObject() {
    return data;
  };

  return data;
}

var SubWeb = function SubWeb(_ref) {
  var className = _ref.className,
      onKeyDown = _ref.onKeyDown,
      onKeyPress = _ref.onKeyPress,
      href = _ref.href,
      _native = _ref["native"],
      data = _ref.data,
      ariaLabel = _ref.ariaLabel,
      alt = _ref.alt,
      onMouseMove = _ref.onMouseMove,
      text = _ref.text,
      title = _ref.title,
      theme = _ref.theme,
      summary = _ref.summary,
      hasWarning = _ref.hasWarning,
      displayTab = _ref.displayTab;

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    rel: "noopener noreferrer",
    tabIndex: 0,
    display: "block",
    hasHover: false,
    "native": _native,
    target: displayTab
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    data: data,
    "aria-label": ariaLabel,
    alt: alt,
    hasEndpoint: false,
    onMouseMove: onMouseMove,
    endpoint: function endpoint() {
      return null;
    },
    size: "lg",
    useHeight: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "content-container d-flex flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-container d-flex flex-column flex-grow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "triangle-container d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement(Triangle, {
    className: "triangle",
    withContent: true,
    transform: "rotate(-90deg)",
    position: "absolute",
    left: "-60px",
    contentColor: theme.components.header.subWeb.iconColor,
    color: theme.components.header.subWeb.bgColor,
    size: "40px",
    contentSize: "50px"
  })), /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    fontWeight: "400",
    color: theme.components.header.subWeb.titleColor,
    size: "xLarge"
  }, title)), hasWarning && /*#__PURE__*/React.createElement("div", {
    className: "warning-container"
  }, /*#__PURE__*/React.createElement(LineTruncate, null, /*#__PURE__*/React.createElement(Text, {
    text: text,
    color: theme.components.header.subWeb.warning.textColor,
    size: "small"
  })), /*#__PURE__*/React.createElement(Text, {
    text: summary,
    color: theme.components.header.subWeb.warning.textColor,
    marginTop: "20px",
    fontWeight: "400",
    size: "mediumSmall"
  })))));
};

SubWeb.propTypes = {
  className: PropTypes$1.string,
  onKeyDown: PropTypes$1.func,
  onKeyPress: PropTypes$1.func,
  href: PropTypes$1.string,
  "native": PropTypes$1.bool,
  data: PropTypes$1.array,
  ariaLabel: PropTypes$1.string,
  alt: PropTypes$1.string,
  onMouseMove: PropTypes$1.func,
  text: PropTypes$1.string,
  title: PropTypes$1.string,
  theme: PropTypes$1.object,
  summary: PropTypes$1.string,
  hasWarning: PropTypes$1.bool,
  displayTab: PropTypes$1.string
};
SubWeb.defaultProps = {
  hasWarning: false
};
var SubWebWithStyles = styled(SubWeb)(_templateObject$13(), function (props) {
  return props.theme.components.header.subWeb.bgColor;
}, function (props) {
  return props.theme.components.header.subWeb.warning.bgColor;
});

function _templateObject$14() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  max-height: ", ";\n  background-color: ", ";\n\n  button.play-video {\n    background-color: rgba(0, 0, 0, 0.2);\n    border: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n  }\n\n  button.audio-description {\n    position: absolute;\n    right: 16px;\n    top: 70px;\n    background-color: transparent;\n    border: none;\n    height: 36px;\n    width: 36px;\n    z-index: 1;\n    cursor: pointer;\n    opacity: 0;\n    -moz-transition: opacity 0.1s cubic-bezier(0.4, 0, 1, 1);\n    -webkit-transition: opacity 0.1s cubic-bezier(0.4, 0, 1, 1);\n    transition: opacity 0.1s cubic-bezier(0.4, 0, 1, 1);\n\n    &:hover {\n      &:after {\n        content: attr(aria-label);\n        position: absolute;\n        background-color: ", ";\n        color: ", ";\n        font-weight: 500;\n        font-size: 13px;\n        width: auto;\n        bottom: -39px;\n        right: 0;\n        padding: 6px 8px;\n        border-radius: 2px;\n        white-space: nowrap;\n        text-align: center;\n        text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n      }\n    }\n  }\n\n  &:hover {\n    button.audio-description {\n      opacity: 1;\n    }\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    button.audio-description {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject$14 = function _templateObject() {
    return data;
  };

  return data;
}

var Video = function Video(_ref) {
  var className = _ref.className,
      url = _ref.url,
      audioDescription = _ref.audioDescription,
      theme = _ref.theme,
      onClick = _ref.onClick,
      placeholder = _ref.placeholder,
      hasAdButton = _ref.hasAdButton,
      changeSlide = _ref.changeSlide,
      onVideoPlay = _ref.onVideoPlay,
      onVideoEnd = _ref.onVideoEnd,
      props = _objectWithoutProperties(_ref, ["className", "url", "audioDescription", "theme", "onClick", "placeholder", "hasAdButton", "changeSlide", "onVideoPlay", "onVideoEnd"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      onPlay = _useState2[0],
      setPlay = _useState2[1];

  var onPlayVideo = function onPlayVideo() {
    setPlay(true);
    onVideoPlay();
  };

  var onEndVideo = function onEndVideo() {
    setPlay(false);
    onVideoEnd();
  };

  useEffect(function () {
    setPlay(false);
  }, [changeSlide]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, hasAdButton && /*#__PURE__*/React.createElement("button", {
    className: "audio-description",
    onClick: onClick,
    "aria-label": "Audio description"
    /*
      aria-label={intl.formatMessage({
        id: "app.header.video.button.audioDescription",
        defaultMessage: "Audio description"
      })}
      */

  }, /*#__PURE__*/React.createElement(Icon, {
    name: audioDescription ? theme.icons.audio_description_active : theme.icons.audio_description,
    size: "medium",
    color: theme.components.header.video.adButton.iconColor
  })), onPlay ? /*#__PURE__*/React.createElement(VideoPlayer$1, _extends({
    url: url,
    paddingTop: "0",
    marginBottom: "0",
    marginTop: "0",
    height: "100%",
    onEnded: onEndVideo,
    playing: onPlay,
    config: {
      youtube: {
        playerVars: {
          showinfo: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          rel: 0,
          autoplay: 0,
          fs: 1
        }
      }
    }
  }, props)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "play-video",
    onClick: onPlayVideo,
    "aria-label": "Watch V\xEDdeo"
    /*
    aria-label={intl.formatMessage({
      id: "app.header.video.button.play",
      defaultMessage: "Watch Vídeo"
    })}
     */

  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.youtube_play,
    size: "xxxLarge",
    color: theme.components.header.video.imagePlaceholder.iconColor
  })), /*#__PURE__*/React.createElement(PictureContainer, {
    src: placeholder,
    alt: "imagem",
    height: "100%"
  })));
};

Video.propTypes = {
  className: PropTypes$1.string,
  url: PropTypes$1.string,
  audioDescription: PropTypes$1.bool,
  placeholder: PropTypes$1.string,
  theme: PropTypes$1.object,
  onClick: PropTypes$1.func,
  hasAdButton: PropTypes$1.bool,
  onVideoPlay: PropTypes$1.func,
  onVideoEnd: PropTypes$1.func
};
Video.defaultProps = {
  hasAdButton: true
};
var VideoWithStyles = styled(Video)(_templateObject$14(), function (props) {
  return props.theme.components.header.maxHeight;
}, function (props) {
  return props.theme.components.header.video.bgColor;
}, function (props) {
  return props.theme.components.header.video.adButton.toolTipBgColor;
}, function (props) {
  return props.theme.components.header.video.adButton.toolTipColor;
});

function _templateObject$15() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  //To Remove Space, slick-slider needs same height as image\n  .slick-slider,\n  .slick-track,\n  img {\n    max-height: ", ";\n    height: ", ";\n  }\n\n  .slick-slider {\n    overflow-y: hidden;\n    &:hover {\n      .slick-next,\n      .slick-prev {\n        background-color: ", ";\n        i {\n          color: ", ";\n        }\n      }\n    }\n  }\n\n  .slick-slide {\n    height: inherit;\n    > div {\n      height: inherit;\n    }\n  }\n\n  /* Medium devices (tablets, less than 992px)*/\n  @media (max-width: 991px) {\n    .slick-slider,\n    .slick-track,\n    img {\n      height: ", ";\n    }\n  }\n\n  .onEdgeRightArrow > .slick-next,\n  .onEdgeLeftArrow > .slick-prev {\n    i {\n      color: ", ";\n    }\n    background-color: ", ";\n  }\n\n  .slick-next,\n  .slick-prev {\n    width: 50px;\n    height: 50px;\n    top: calc(50% - 25px);\n    background-color: transparent;\n\n    &:hover {\n      background-color: ", ";\n    }\n    &:focus {\n      i {\n        color: ", ";\n      }\n      background-color: ", ";\n    }\n\n    i {\n      color: transparent;\n    }\n  }\n\n  .slick-prev {\n    left: 0;\n  }\n\n  .slick-next {\n    right: 0;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n"]);

  _templateObject$15 = function _templateObject() {
    return data;
  };

  return data;
}
var Header$1 = memo(function Header(_ref) {
  var className = _ref.className,
      data = _ref.data,
      styles = _ref.styles,
      urlExtension = _ref.urlExtension,
      theme = _ref.theme,
      onChangeVideo = _ref.onChangeVideo,
      video = _ref.video,
      autoplay = _ref.autoplay,
      scrollMoreRef = _ref.scrollMoreRef,
      scrollDown = _ref.scrollDown,
      onVideoPlay = _ref.onVideoPlay,
      onVideoEnd = _ref.onVideoEnd;
  var sliderRef = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      changeSlide = _useState2[0],
      setChangeSlide = _useState2[1];

  var onHandleTabNavigation = function onHandleTabNavigation(e) {
    if (e.key === "Tab" && e.shiftKey) {
      sliderRef.current.slickPrev();
    }

    if (e.key === "Tab") {
      sliderRef.current.slickNext();
    }
  };

  var onHandleEnter = function onHandleEnter(e, url) {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      window.open(url, "_blank");
    }
  };

  var onSelectLayout = function onSelectLayout(item, key, type) {
    var isExternaLink = item.url !== undefined && item.url.includes("http");

    switch (type) {
      case "leftColumns":
        return /*#__PURE__*/React.createElement(SubWebWithStyles, {
          key: key,
          onKeyDown: onHandleTabNavigation,
          onKeyPress: function onKeyPress(e) {
            return onHandleEnter(e, item.url);
          },
          href: isExternaLink ? item.url : "".concat(urlExtension).concat(item.url),
          displayTab: item.displayTab ? "_blank" : "_self",
          "native": isExternaLink,
          data: {
            url: item.image !== null && item.image.url !== null ? item.image.url : ""
          },
          ariaLabel: item.image !== null && item.image.alt !== null ? item.image.alt : "",
          alt: item.image !== null && item.image.alt !== null ? item.image.alt : "",
          text: item.warningTitle,
          title: item.title,
          summary: item.warningDescription,
          styles: styles,
          theme: theme,
          hasWarning: item.hasWarning
        });

      case "video":
        return /*#__PURE__*/React.createElement(VideoWithStyles, {
          key: key,
          url: video["default"] ? item["default"] : item.accessible,
          onClick: onChangeVideo,
          audioDescription: !video["default"],
          theme: theme,
          placeholder: item.placeholder,
          hasAdButton: item.accessible,
          changeSlide: changeSlide,
          onVideoPlay: onVideoPlay,
          onVideoEnd: onVideoEnd
        });

      default:
        return /*#__PURE__*/React.createElement(DefaultWithStyles, {
          key: key,
          onKeyDown: onHandleTabNavigation,
          onKeyPress: function onKeyPress(e) {
            return onHandleEnter(e, item.url);
          },
          href: isExternaLink ? item.url : "".concat(urlExtension).concat(item.url),
          displayTab: item.displayTab ? "_blank" : "_self",
          "native": isExternaLink,
          data: {
            url: item.image !== null && item.image.url !== null ? item.image.url : ""
          },
          ariaLabel: item.image.alt,
          alt: item.image.alt,
          text: item.description,
          title: item.title,
          styles: styles,
          theme: theme
        });
    }
  };

  return /*#__PURE__*/React.createElement("section", {
    className: className
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(TitleWithStyles, {
    text: "Destaques Institucionais"
  })), /*#__PURE__*/React.createElement(Slider, {
    ref: sliderRef,
    afterChange: function afterChange() {
      return setChangeSlide(function (prevState) {
        return prevState + 1;
      });
    },
    autoplay: autoplay,
    autoplaySpeed: 5000,
    useTransform: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    dots: false,
    arrows: true,
    infinite: true,
    accessibility: true,
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      arrowSize: "medium",
      ariaLabel: "slide anterior",
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      arrowSize: "medium",
      ariaLabel: "pr\xF3ximo slide",
      darken: true
    })
  }, data.list.map(function (item, index) {
    return onSelectLayout(item, index, item.type);
  })), /*#__PURE__*/React.createElement(ScrollMore$1, {
    ref: scrollMoreRef,
    onClick: scrollDown,
    position: "absolute",
    bottom: "-50px"
  }));
});
var types$D = {
  className: PropTypes$1.string,
  data: PropTypes$1.object.isRequired,
  loading: PropTypes$1.bool,
  size: PropTypes$1.object,
  styles: PropTypes$1.object,
  theme: PropTypes$1.object,
  urlExtension: PropTypes$1.string,
  onChangeVideo: PropTypes$1.func,
  video: PropTypes$1.shape({
    "default": PropTypes$1.bool
  }),
  autoplay: PropTypes$1.bool,
  scrollMoreRef: PropTypes$1.any,
  scrollDown: PropTypes$1.func,
  hasWarning: PropTypes$1.bool,
  onVideoPlay: PropTypes$1.func,
  onVideoEnd: PropTypes$1.func
};
var defaults$A = {
  video: {
    "default": true
  },
  autoplay: true,
  scrollDown: function scrollDown() {
    return null;
  }
};
Header$1.propTypes = types$D;
Header$1.defaultProps = defaults$A;
var HeaderWithStyles = styled(Header$1)(_templateObject$15(), function (props) {
  return props.theme.components.header.maxHeight;
}, function (props) {
  return props.isSubWeb ? props.theme.components.header.subWeb.height : props.theme.components.header.height;
}, function (props) {
  return props.theme.components.header.arrowBackgroundColor;
}, function (props) {
  return props.theme.components.header.arrowColor;
}, function (props) {
  return props.isSubWeb ? props.theme.components.header.subWeb.mobileHeight : props.theme.components.header.mobileHeight;
}, function (props) {
  return props.theme.components.header.arrowColor;
}, function (props) {
  return props.theme.components.header.arrowBackgroundColor;
}, function (props) {
  return props.theme.components.header.arrowBackgroundColor;
}, function (props) {
  return props.theme.components.header.arrowColor;
}, function (props) {
  return props.theme.components.header.arrowBackgroundColor;
});

var HeaderContainer = function HeaderContainer(props) {
  var _useConfig = useConfig(),
      isIE = _useConfig.isIE;

  return /*#__PURE__*/React.createElement(HeaderWithStyles, _extends({
    isIE: isIE
  }, props));
};

var index$2 = compose(withTheme)(HeaderContainer); //Only used for the Storybook Props Table

function _templateObject$16() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  max-height: ", ";\n  background-color: ", ";\n  .container {\n    position: relative;\n  }\n  .triangle {\n    width: 60px;\n    height: 60px;\n    position: absolute;\n    right: 25px;\n    background-color: ", ";\n    top: -30px;\n    z-index: 2;\n    transform: rotate(45deg);\n  }\n\n  /* Medium devices (tablets, less than 992px)*/\n  @media (max-width: 991px) {\n    height: ", ";\n  }\n"]);

  _templateObject$16 = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$d = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$2 = function LoadingCard(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "105px",
    backgroundColor: props.theme.loadings.bgColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "triangle"
  }, "\xA0"), /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "105px"
  }, /*#__PURE__*/React.createElement(Mask$d, _extends({
    height: "20px",
    right: "0",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$d, _extends({
    height: "20px",
    top: "20px",
    right: "0",
    width: "85%"
  }, props)), /*#__PURE__*/React.createElement(Mask$d, _extends({
    height: "15px",
    top: "40px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$d, _extends({
    height: "30px",
    top: "55px",
    right: "0",
    width: "70%"
  }, props)), /*#__PURE__*/React.createElement(Mask$d, _extends({
    height: "20px",
    top: "85px",
    right: "0",
    width: "100%"
  }, props)))));
};

var Loading$l = function Loading(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " d-flex flex-column")
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-items-center flex-grow-1"
  }, props.isVideo && /*#__PURE__*/React.createElement(Icon, {
    name: props.theme.icons.youtube_play,
    color: props.theme.loadings.iconColor,
    size: "xxxLarge"
  })), !props.isVideo && /*#__PURE__*/React.createElement(LoadingCard$2, props));
};

Loading$l.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  isVideo: PropTypes$1.bool
};
var LoadingWithStyles$3 = styled(Loading$l)(_templateObject$16(), function (props) {
  return props.theme.components.header.height;
}, function (props) {
  return props.theme.components.header.maxHeight;
}, function (props) {
  return props.theme.loadings.iconContainerBgColor;
}, function (props) {
  return props.theme.loadings.bgColor;
}, function (props) {
  return props.theme.components.header.mobileHeight;
});
var Loading$m = withTheme(LoadingWithStyles$3);

function _templateObject$17() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  max-height: ", ";\n  background-color: ", ";\n  position: relative;\n\n  .content-container {\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 350px;\n    background-color: ", ";\n\n    .text-container,\n    .warning {\n      padding: 30px;\n    }\n\n    .warning {\n      min-height: 175px;\n      background-color: ", ";\n    }\n\n    .text-container {\n      position: relative;\n      .triangle-container {\n        position: absolute;\n        left: -30px;\n        height: 100%;\n        top: 0;\n        z-index: 0;\n        .triangle {\n          width: 60px;\n          height: 60px;\n          background-color: ", ";\n          z-index: 2;\n          transform: rotate(45deg);\n        }\n      }\n    }\n  }\n\n  /* Medium devices (tablets, less than 992px)*/\n  @media (max-width: 991px) {\n    height: ", ";\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .content-container {\n      height: auto;\n      position: absolute;\n      top: initial;\n      bottom: 0;\n      right: 0;\n      width: 100%;\n\n      .warning {\n        min-height: initial;\n      }\n\n      .text-container {\n        flex-grow: initial;\n        .triangle-container {\n          left: 0;\n          height: auto;\n          top: -30px;\n          right: 0;\n          justify-content: center;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$17 = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$e = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

Mask$e.propTypes = {
  theme: PropTypes$1.string
};

var LoadingCard$3 = function LoadingCard(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "105px"
  }, /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "25px",
    top: "0",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "15px",
    top: "25px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "25px",
    top: "40px",
    right: "0",
    width: "15%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "15px",
    top: "65px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "25px",
    top: "80px",
    right: "0",
    width: "20%"
  }, props)));
};

var LoadingWarning = function LoadingWarning(_ref2) {
  var props = _extends({}, _ref2);

  return /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "70px"
  }, /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "15px",
    top: "0",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "20px",
    top: "15px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "15px",
    top: "35px",
    right: "0",
    width: "15%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "5px",
    top: "50px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$e, _extends({
    height: "15px",
    top: "55px",
    right: "0",
    width: "20%"
  }, props)));
};

var SubWebLoading = function SubWebLoading(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " d-flex align-items-center justify-content-center")
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container d-flex flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-container d-flex flex-column flex-grow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "triangle-container d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "triangle"
  }, "\xA0")), /*#__PURE__*/React.createElement(LoadingCard$3, props)), /*#__PURE__*/React.createElement("div", {
    className: "warning"
  }, /*#__PURE__*/React.createElement(LoadingWarning, _extends({
    backgroundColor: props.theme.loadings.iconColor
  }, props)))));
};

SubWebLoading.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var SubWebLoadingWithStyles = styled(SubWebLoading)(_templateObject$17(), function (props) {
  return props.theme.components.header.subWeb.height;
}, function (props) {
  return props.theme.components.header.maxHeight;
}, function (props) {
  return props.theme.loadings.iconContainerBgColor;
}, function (props) {
  return props.theme.loadings.bgColor;
}, function (props) {
  return props.theme.loadings.iconColor;
}, function (props) {
  return props.theme.loadings.bgColor;
}, function (props) {
  return props.theme.components.header.subWeb.mobileHeight;
});
var SubWebLoading$1 = withTheme(SubWebLoadingWithStyles);

var Loading$n = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-12 col-12 order-lg-first order-last"
  }, /*#__PURE__*/React.createElement(AgendaCardLoading, props), /*#__PURE__*/React.createElement(AgendaCardLoading, props), /*#__PURE__*/React.createElement(AgendaCardLoading, props), /*#__PURE__*/React.createElement(AgendaCardLoading, _extends({}, props, {
    borderBottom: "1px solid ".concat(props.theme.loadings.cardBorderColor)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-12 col-12 order-lg-last order-first"
  }, /*#__PURE__*/React.createElement(AgendaFeaturedLoading, _extends({}, props, {
    mdMarginBottom: "50px"
  })))));
};

Loading$n.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var Loading$o = withTheme(Loading$n);

var Agenda = memo(function Agenda(_ref) {
  var className = _ref.className,
      showHeader = _ref.showHeader,
      title = _ref.title,
      resource = _ref.resource,
      backgroundColor = _ref.backgroundColor,
      eventStyles = _ref.eventStyles,
      hasError = _ref.hasError,
      href = _ref.href,
      loading = _ref.loading,
      data = _ref.data,
      size = _ref.size,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var onRenderNews = function onRenderNews(data) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    return data.listEvents.filter(function (items, index) {
      return index >= start && index <= end && items;
    }).map(function (item, index) {
      var isSameDay = moment(item.startDate).isSame(item.endDate, "day");
      var highContrastBgColor = theme.highContrast.backgroundColor;
      var agendaCardTextColor = theme.components.agenda.agendaCardTextColor;
      var highContrastTextColor = theme.highContrast.text;
      var highContrastActionColor = theme.highContrast.action;
      return /*#__PURE__*/React.createElement(AgendaCard$1, {
        key: index,
        textColorHover: highContrastBgColor || backgroundColor,
        iconColorHover: highContrastBgColor || backgroundColor,
        squareColorHover: highContrastActionColor || theme.components.agenda.squareColorHover,
        buttonOutlineColorHover: highContrastBgColor || backgroundColor,
        href: item.url,
        category: item.category,
        title: item.title,
        text: item.local,
        date: isSameDay ? "".concat(moment(item.startDate).format("DD MMMM YYYY")) : "".concat(moment(item.startDate).format("DD MMMM"), " - ").concat(moment(item.endDate).format("DD MMMM YYYY")),
        hasDateSlider: !isSameDay,
        iconColor: highContrastActionColor || agendaCardTextColor,
        categoryColor: agendaCardTextColor,
        titleColor: agendaCardTextColor,
        textColor: highContrastTextColor || agendaCardTextColor
      }, !isSameDay ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "initial-date"
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: "28px",
        text: moment(item.startDate, "YYYY/MM/DD").format("DD"),
        color: highContrastTextColor || eventStyles.date.textColor,
        fontWeight: "900",
        lineHeight: "1"
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: "18px",
        text: moment(item.startDate, "YYYY/MM/DD").format("MMM"),
        color: highContrastTextColor || eventStyles.date.textColor,
        textTransform: "uppercase",
        lineHeight: "1",
        "aria-label": moment(item.startDate, "YYYY/MM/DD").format("MMMM")
      })), /*#__PURE__*/React.createElement("div", {
        className: "today"
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: "28px",
        text: moment(new Date(), "YYYY/MM/DD").format("DD"),
        color: highContrastTextColor || eventStyles.date.textColor,
        fontWeight: "900",
        lineHeight: "1"
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: "18px",
        text: moment(new Date(), "YYYY/MM/DD").format("MMM"),
        color: highContrastTextColor || eventStyles.date.textColor,
        textTransform: "uppercase",
        lineHeight: "1",
        "aria-label": moment(new Date(), "YYYY/MM/DD").format("MMMM")
      })), /*#__PURE__*/React.createElement("div", {
        className: "end-date"
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: "28px",
        text: moment(item.endDate, "YYYY/MM/DD").format("DD"),
        color: highContrastTextColor || eventStyles.date.textColor,
        fontWeight: "900",
        lineHeight: "1"
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: "18px",
        text: moment(item.endDate, "YYYY/MM/DD").format("MMM"),
        color: highContrastTextColor || eventStyles.date.textColor,
        textTransform: "uppercase",
        lineHeight: "1",
        "aria-label": moment(item.endDate, "YYYY/MM/DD").format("MMMM")
      }))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "no-slider"
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: "28px",
        text: moment(item.startDate, "YYYY/MM/DD").format("DD"),
        color: highContrastTextColor || eventStyles.date.textColor,
        fontWeight: "900",
        lineHeight: "1"
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: "18px",
        text: moment(item.startDate, "YYYY/MM/DD").format("MMM"),
        color: highContrastTextColor || eventStyles.date.textColor,
        textTransform: "uppercase",
        lineHeight: "1",
        "aria-label": moment(item.startDate, "YYYY/MM/DD").format("MMMM")
      }))));
    });
  };

  var AgendaNewsColumn = function AgendaNewsColumn() {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xl-6 col-lg-6 col-md-12 col-12 order-lg-first order-last"
    }, onRenderNews(data));
  };

  var AgendaFeaturedColumn = function AgendaFeaturedColumn() {
    var agendaFeaturedTextColor = theme.components.agenda.agendaFeaturedTextColor;
    var highContrastBgColor = theme.highContrast.backgroundColor;
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xl-6 col-lg-6 col-md-12 col-12 order-lg-last order-first"
    }, Object.entries(data.listEventsHighlight).length > 0 ? /*#__PURE__*/React.createElement(ContentContainer, {
      mdMarginBottom: "50px"
    }, /*#__PURE__*/React.createElement(AgendaFeatured$1, {
      href: data.listEventsHighlight[0].url,
      dateContainerBgColor: theme.components.agenda.agendaFeaturedDateContainerBgColor,
      dateContainerTextColor: highContrastBgColor || backgroundColor,
      buttonBgColor: highContrastBgColor || backgroundColor,
      animationBgColor: highContrastBgColor || backgroundColor,
      plusButtonHoverBgColor: highContrastBgColor || backgroundColor,
      textColorHover: agendaFeaturedTextColor,
      buttonTextColor: agendaFeaturedTextColor,
      textColor: agendaFeaturedTextColor,
      titleColor: agendaFeaturedTextColor,
      borderColor: "#fff",
      dateContainerDay: moment(data.listEventsHighlight[0].startDate, "YYYY/MM/DD").format("DD"),
      dateContainerMonth: moment(data.listEventsHighlight[0].startDate, "YYYY/MM/DD").format("MMM") //Aria-Label
      ,
      dateContainerMonthAriaLabel: moment(data.listEventsHighlight[0].startDate, "YYYY/MM/DD").format("MMMM"),
      text: data.listEventsHighlight[0].local,
      title: data.listEventsHighlight[0].title,
      date: moment(data.listEventsHighlight[0].startDate).isSame(data.listEventsHighlight[0].endDate, "day") ? "".concat(moment(data.listEventsHighlight[0].startDate).format("DD MMMM YYYY")) : "".concat(moment(data.listEventsHighlight[0].startDate).format("DD MMMM"), " - ").concat(moment(data.listEventsHighlight[0].endDate).format("DD MMMM YYYY"))
    })) : onRenderNews(data, 4, 8));
  }; // TODO Corrigir endereço href no json


  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor
  }, showHeader ? /*#__PURE__*/React.createElement(SectionHeader, {
    textColor: theme.components.agenda.titleColor,
    href: href
  }, resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: title
  }) : title) : null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$o, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor
  }) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, size.width >= 992 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(AgendaNewsColumn, null), /*#__PURE__*/React.createElement(AgendaFeaturedColumn, null)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(AgendaFeaturedColumn, null), /*#__PURE__*/React.createElement(AgendaNewsColumn, null))))));
});
var defaults$B = {
  showHeader: true,
  title: "Title",
  data: []
};
var types$E = {
  className: PropTypes$1.string,
  showHeader: PropTypes$1.bool,
  title: PropTypes$1.string,
  textColor: PropTypes$1.string,
  cardBorderColor: PropTypes$1.string,
  eventStyles: PropTypes$1.object.isRequired,
  backgroundColor: PropTypes$1.string,
  resource: PropTypes$1.string,
  hasError: PropTypes$1.bool,
  href: PropTypes$1.string,
  loading: PropTypes$1.bool,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  size: PropTypes$1.object,
  theme: PropTypes$1.object
};
Agenda.propTypes = types$E;
Agenda.defaultProps = defaults$B;
var index$3 = compose(withSize(), withTheme)(Agenda); //Only used for the Storybook Props Table

function _templateObject$18() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  //145 is navs height\n  min-height: calc(100vh - 145px);\n  padding: 70px 0;\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    min-height: calc(100vh - 125px);\n  }\n"]);

  _templateObject$18 = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$p = function Loading(_ref) {
  var className = _ref.className,
      hasDelay = _ref.hasDelay,
      backgroundColor = _ref.backgroundColor;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  useEffect(function () {
    if (hasDelay) {
      var timeout = setTimeout(function () {
        setShow(true);
      }, 500);
      return function () {
        clearTimeout(timeout);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  if (!show && hasDelay) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(LoadingWithStyles$2, {
    maskBgColor: backgroundColor
  })))));
};

var types$F = {
  className: PropTypes$1.string,
  hasDelay: PropTypes$1.bool,
  backgroundColor: PropTypes$1.string
};
EmptyStyles.propTypes = types$F;
var LoadingWithStyles$4 = styled(Loading$p)(_templateObject$18(), function (props) {
  return props.theme.components.loading.backgroundColor;
});
var Loading$q = withTheme(LoadingWithStyles$4); //Only used for the Storybook Props Table

var Loading$r = function Loading(_ref) {
  var backgroundColor = _ref.backgroundColor,
      height = _ref.height,
      mdHeight = _ref.mdHeight,
      linksGutter = _ref.linksGutter,
      hasIcons = _ref.hasIcons,
      mobileMenuIconOnly = _ref.mobileMenuIconOnly,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: height,
    mdHeight: mdHeight,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.loadings.bgColor,
    borderBottom: theme.highContrast.border,
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginRight: "30px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px",
    width: "100px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    display: "flex",
    mobileMdDisplay: "none"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginRight: linksGutter
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px",
    width: "77px"
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginRight: linksGutter
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px",
    width: "61px"
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginRight: linksGutter
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px",
    width: "38px"
  })), /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px",
    width: "78px"
  }))), hasIcons && /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    backgroundColor: theme.loadings.mainBgColor
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginLeft: "12px",
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    backgroundColor: theme.loadings.mainBgColor
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginLeft: "12px",
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    backgroundColor: theme.loadings.mainBgColor
  }))), !hasIcons && mobileMenuIconOnly && /*#__PURE__*/React.createElement(ContentContainer, {
    className: "col-auto",
    display: "none",
    mobileMdDisplay: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginLeft: "12px",
    height: "14px",
    width: "14px",
    borderRadius: "50%",
    backgroundColor: theme.loadings.mainBgColor
  }))))));
};

Loading$r.propTypes = {
  className: PropTypes$1.string,
  height: PropTypes$1.string,
  mdHeight: PropTypes$1.string,
  linksGutter: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  hasIcons: PropTypes$1.bool,
  mobileMenuIconOnly: PropTypes$1.bool,
  theme: PropTypes$1.object
};
Loading$r.defaultProps = {
  height: "105px",
  mdHeight: "85px",
  linksGutter: "30px",
  hasIcons: true,
  mobileMenuIconOnly: false
};
var Navigation = withTheme(Loading$r);

function _templateObject$19() {
  var data = _taggedTemplateLiteral(["\n  // Medium devices (tablets, 768px and up)\n  @media (max-width: 768px) {\n    .hide-sm {\n      display: none;\n    }\n  }\n\n  // Large devices (desktops, 992px and up)\n  @media (max-width: 992px) {\n    .hide-md {\n      display: none;\n    }\n  }\n"]);

  _templateObject$19 = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$s = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 hide-sm"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg hide-md"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null)))));
};

Loading$s.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$5 = styled(Loading$s)(_templateObject$19());

function _templateObject$1a() {
  var data = _taggedTemplateLiteral(["\n  .news-container {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .slick-slide {\n    min-height: 398px;\n  }\n\n  .slick-prev {\n    left: -25px;\n  }\n  .slick-next {\n    right: -25px;\n  }\n  .slick-next,\n  .slick-prev {\n    width: auto;\n    height: 36px;\n    top: 100px;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n\n  // Large devices (desktops, 992px and up to 1199)\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .slick-prev {\n      left: -15px;\n    }\n    .slick-next {\n      right: -15px;\n    }\n  }\n\n  //Full height slider with flexBox\n  ", "\n"]);

  _templateObject$1a = function _templateObject() {
    return data;
  };

  return data;
}
var News = memo(function News(_ref) {
  var className = _ref.className,
      showHeader = _ref.showHeader,
      title = _ref.title,
      resource = _ref.resource,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      cardStyles = _ref.cardStyles,
      titleProps = _ref.titleProps,
      onAction = _ref.onAction,
      onEnter = _ref.onEnter,
      size = _ref.size,
      theme = _ref.theme,
      arrowColor = _ref.arrowColor,
      isMobilePreview = _ref.isMobilePreview,
      props = _objectWithoutProperties(_ref, ["className", "showHeader", "title", "resource", "textColor", "backgroundColor", "data", "loading", "hasError", "cardStyles", "titleProps", "onAction", "onEnter", "size", "theme", "arrowColor", "isMobilePreview"]);

  var sliderRef = useRef(null);

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var onHandleTabNavigation = function onHandleTabNavigation(e) {
    if (e.key === "Tab" && e.shiftKey) {
      sliderRef.current.slickPrev();
    }

    if (e.key === "Tab") {
      sliderRef.current.slickNext();
    }
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(TitleWithStyles, {
    text: "Not\xEDcias"
  })), showHeader && /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.highContrast.link || textColor
  }, titleProps, {
    href: props.categoryUrl
  }), resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: title
  }) : title), /*#__PURE__*/React.createElement("div", {
    className: "container news-container"
  }, loading ? /*#__PURE__*/React.createElement(LoadingWithStyles$5, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Slider, {
    ref: sliderRef,
    useTransform: false,
    slidesToShow: isMobilePreview ? 1 : 3,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    initialSlide: 0,
    customPaging: function customPaging(i) {
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "Not\xEDcia ".concat(i + 1)
      }, "\xA0");
    },
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "slide anterior",
      color: arrowColor || theme.components.customArrow.customArrowColor,
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "pr\xF3ximo slide",
      color: arrowColor || theme.components.customArrow.customArrowColor,
      darken: true
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: isMobilePreview ? 1 : 3
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: isMobilePreview ? 1 : 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }]
  }, data.listNews.map(function (item) {
    if (item.style === 1 || item.style === 2) {
      var hasImageCover = item.imageCover !== null;
      var imageSrc = hasImageCover && item.imageCover.url !== null ? item.imageCover.url : "";
      var imageAlt = hasImageCover && item.imageCover.alt !== null ? item.imageCover.alt : "";
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "col"
      }, /*#__PURE__*/React.createElement(PersonCard$1, {
        title: item.title,
        name: item.pretitle,
        src: imageSrc,
        url: item.url,
        alt: imageAlt,
        titleIsSerif: true,
        size: size,
        share: item.share,
        history: props.history,
        backgroundColor: item.style === 2 ? theme.components.news.personCard.style2BgColor : "",
        textColor: item.style === 2 ? theme.components.news.personCard.style2Color : "",
        minHeight: "398px"
      }));
    } else {
      return /*#__PURE__*/React.createElement(NewsCard$1, {
        key: item.id,
        data: item,
        onClick: function onClick(e) {
          return onAction(e, item.url);
        },
        onKeyPress: function onKeyPress(e) {
          return onEnter(e, item.url);
        },
        hasCategoryTitle: props.categoryId !== item.categoryID,
        cardBgColor: theme.highContrast.lightBackgroundColor || cardStyles.backgroundColor,
        imageBgColor: cardStyles.backgroundColor,
        linkColor: cardStyles.textColor,
        onKeyDown: onHandleTabNavigation,
        history: props.history,
        hasShareIcon: props.hasShareIcon,
        size: size
      });
    }
  }))));
});
var defaults$C = {
  title: "Title",
  text: "Text",
  data: [],
  cardStyles: {
    backgroundColor: ""
  },
  onAction: function onAction() {
    return null;
  },
  onEnter: function onEnter() {
    return null;
  },
  isMobilePreview: false
};
var types$G = {
  title: PropTypes$1.string,
  text: PropTypes$1.string,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  cardStyles: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,
  showHeader: PropTypes$1.bool,
  textColor: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  resource: PropTypes$1.string,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  onAction: PropTypes$1.func.isRequired,
  onEnter: PropTypes$1.func.isRequired,
  categoryUrl: PropTypes$1.string,
  categoryId: PropTypes$1.number,
  history: PropTypes$1.object,
  size: PropTypes$1.object,
  hasShareIcon: PropTypes$1.bool,
  theme: PropTypes$1.object,
  arrowColor: PropTypes$1.string,
  isMobilePreview: PropTypes$1.bool
};
News.propTypes = types$G;
News.defaultProps = defaults$C;
var NewsWithStyles = styled(News)(_templateObject$1a(), function (props) {
  return props.theme.components.reactSlickSlider.buttonBgColor;
}, function (props) {
  return props.hasFullHeightSlider && "\n    .slick-list,\n    .slick-track {\n      display: flex;\n    }\n\n    .slick-slide {\n      display: flex;\n      flex-direction: column;\n\n      > div {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n      }\n    }\n  ";
});
var News$1 = compose(withSize(), withTheme)(NewsWithStyles); //Only used for the Storybook Props Table

var Loading$t = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "65px",
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-12 col-12"
  }, /*#__PURE__*/React.createElement(AgendaCardLoading, props), /*#__PURE__*/React.createElement(AgendaCardLoading, props), /*#__PURE__*/React.createElement(AgendaCardLoading, props), /*#__PURE__*/React.createElement(AgendaCardLoading, _extends({}, props, {
    borderBottom: "1px solid ".concat(props.theme.loadings.cardBorderColor)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-12 col-12"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mdMargintop: "50px"
  }, /*#__PURE__*/React.createElement(AgendaFeaturedLoading, props)))));
};

Loading$t.propTypes = {
  className: PropTypes$1.string
};
var Loading$u = withTheme(Loading$t);

function _templateObject$1b() {
  var data = _taggedTemplateLiteral(["\n  /*Calendar Styles*/\n  .calendar-card-today {\n    .top {\n      height: 30px;\n      background-color: ", ";\n      position: relative;\n      &:after {\n        content: \"\";\n        width: 1px;\n        height: inherit;\n        background-color: ", ";\n        position: absolute;\n        right: -1px;\n      }\n    }\n    .bottom {\n      height: 70px;\n      background-color: ", ";\n    }\n\n    &:focus {\n      ", ";\n    }\n  }\n\n  .calendar-card {\n    height: 70px;\n    width: 100%;\n    background-color: ", ";\n    border: ", ";\n    border-right: none;\n\n    &:hover {\n      background-color: ", ";\n      cursor: pointer;\n      h1,\n      p {\n        color: ", ";\n      }\n    }\n\n    &:focus {\n      ", ";\n      outline-offset: -2px;\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n  }\n\n  .calendar-card,\n  .calendar-card-today .top,\n  .calendar-card-today .bottom {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  button.open-calendar {\n    height: 70px;\n    width: 70px;\n    background-color: ", ";\n    color: ", ";\n    border: none;\n    cursor: pointer;\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:focus {\n      ", ";\n    }\n  }\n\n  .calendar-cards-container {\n    position: relative;\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    .events-agenda-featured {\n      margin-top: 50px;\n    }\n    .calendar-cards-container {\n      .col:nth-child(7),\n      .col:nth-child(8) {\n        display: none;\n      }\n    }\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .calendar-cards-container {\n      .col:nth-child(5),\n      .col:nth-child(6) {\n        display: none;\n      }\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .calendar-cards-container {\n      .col:nth-child(3),\n      .col:nth-child(4) {\n        display: none;\n      }\n    }\n  }\n"]);

  _templateObject$1b = function _templateObject() {
    return data;
  };

  return data;
}

var Events = function Events(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      content = _ref.content,
      hasError = _ref.hasError,
      range = _ref.range,
      categories = _ref.categories,
      channels = _ref.channels,
      openCalendar = _ref.openCalendar,
      onChangeDate = _ref.onChangeDate,
      onResetDate = _ref.onResetDate,
      onChangeCategory = _ref.onChangeCategory,
      onChangeChannel = _ref.onChangeChannel,
      onLoadMore = _ref.onLoadMore,
      currentDate = _ref.currentDate,
      setOpen = _ref.setOpen,
      isOpen = _ref.isOpen,
      isAccessibleFocus = _ref.isAccessibleFocus,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage,
      useIntl = _useConfig.useIntl;

  var intl = useIntl();
  var agendaCardRefs = [];
  useEffect(function () {
    if (isAccessibleFocus) {
      agendaCardRefs[0] && agendaCardRefs[0].focus();
    }
  }, [isAccessibleFocus, agendaCardRefs]);

  var onRenderList = function onRenderList() {
    if (Object.keys(content.listEvents).length === 0) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "app.events.empty",
        defaultMessage: "Sem Resultados de eventos"
      }));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "agenda-cards"
    }, content.listEvents.map(function (item, index) {
      var isLimitHour = moment(item.startDate).format("LT") === "00:00" || moment(item.endDate).format("LT") === "23:59";
      var isSameDay = moment(item.startDate).isSame(item.endDate, "day");
      var agendaCard = theme.components.events.agendaCard;
      return /*#__PURE__*/React.createElement(AgendaCard$1, {
        key: index,
        href: item.url,
        outlineColor: agendaCard.outlineColor,
        buttonOutlineColorHover: agendaCard.buttonOutlineColorHover,
        iconColorHover: agendaCard.iconColorHover,
        iconColor: agendaCard.iconColor,
        category: item.category,
        categoryColor: agendaCard.categoryColor,
        title: item.title,
        titleColor: agendaCard.titleColor,
        text: item.local,
        textColor: agendaCard.textColor,
        date: isSameDay ? "".concat(moment(item.startDate).format("DD MMMM YYYY")) : "".concat(moment(item.startDate).format("DD MMMM"), " - ").concat(moment(item.endDate).format("DD MMMM YYYY")),
        dateColor: agendaCard.dateColor,
        squareColorHover: agendaCard.squareColorHover,
        textColorHover: agendaCard.textColorHover,
        borderColor: agendaCard.borderColor,
        agendaCardRef: function agendaCardRef(ref) {
          return agendaCardRefs[index] = ref;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "no-slider"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        text: "".concat(isLimitHour ? "Todo" : moment(item.startDate).format("LT"), " "),
        fontWeight: "400"
      }), /*#__PURE__*/React.createElement(Text, {
        size: "small",
        text: "".concat(isLimitHour ? "o dia" : moment(item.endDate).format("LT"), " "),
        color: isLimitHour ? agendaCard.isLimitHour : agendaCard.isNotLimitHour,
        fontWeight: isLimitHour ? "400" : "300"
      })));
    }));
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.events.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "50px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto align-self-center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xLarge",
    fontWeight: "500",
    as: "h2"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.nav.public.social.agenda",
    defaultMessage: "Agenda"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-2 col-lg-3 col-md-4 col-sm-5"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsMarginTop: "20px",
    "aria-label": "Lista de categorias"
  }, /*#__PURE__*/React.createElement(Select, {
    onChange: onChangeCategory,
    isLoading: categories.length <= 0,
    variant: "black",
    options: categories,
    placeholder: intl({
      id: "app.events.select.categories",
      defaultMessage: "categorias"
    }),
    label: "Lista de categorias",
    isClearable: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-2 col-lg-3 col-md-4 col-sm-5"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsMarginTop: "20px",
    "aria-label": "Lista de canais"
  }, /*#__PURE__*/React.createElement(Select, {
    variant: "black",
    onChange: onChangeChannel,
    isLoading: channels.length <= 0,
    options: channels,
    placeholder: intl({
      id: "app.events.select.channel",
      defaultMessage: "canal"
    }),
    label: "Lista de canais",
    isClearable: true
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "calendar-cards-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters align-items-end"
  }, range.map(function (item, index) {
    if (index === 0) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "col"
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        className: "calendar-card-today",
        style: {
          cursor: moment(currentDate).isSame(new Date(), "day") ? "default" : "pointer"
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: onResetDate,
        className: "top"
      }, /*#__PURE__*/React.createElement(Text, {
        textTransform: "capitalize",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.5",
        color: theme.components.events.calendarCardToday.titleColor
      }, moment(currentDate).isSame(new Date(), "day") ? intl({
        id: "app.events.action.today",
        defaultMessage: "hoje"
      }) : intl({
        id: "app.events.action.back",
        defaultMessage: "voltar"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "bottom"
      }, /*#__PURE__*/React.createElement(Text, {
        textTransform: "capitalize",
        fontWeight: "400",
        fontSize: "18px",
        lineHeight: "1.5",
        color: theme.components.events.calendarCardToday.textColor
      }, item.day), /*#__PURE__*/React.createElement(PlusButton, {
        backgroundColor: theme.components.events.calendarCardToday.plusButtonBgColor,
        size: "30px",
        bottom: "-15px",
        "aria-hidden": "true",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: "24px",
        fontWeight: "100",
        color: theme.components.events.calendarCardToday.plusButtonTextColor,
        text: theme.icons.plus,
        lineHeight: "1",
        tabIndex: -1
      })))));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "col"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return onChangeDate(item.m, false);
        },
        className: "calendar-card",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement(Text, {
        textTransform: "capitalize",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.5",
        color: theme.components.events.calendarCard.textColor
      }, item.day), /*#__PURE__*/React.createElement(Text, {
        textTransform: "uppercase",
        fontWeight: "300",
        fontSize: "14px",
        lineHeight: "1.5",
        color: theme.components.events.calendarCard.textColor,
        "aria-label": item.monthExtended
      }, item.month)));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onChange: function onChange() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "open-calendar",
    onClick: openCalendar
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.calendar,
    color: theme.components.events.calendarButton.iconColor,
    fontSize: "32px",
    "aria-label": "Abrir calend\xE1rio"
  })), isOpen && /*#__PURE__*/React.createElement(ReactCalendarWithStyles, {
    value: currentDate,
    onChange: onChangeDate
  }))))), isLoading ? /*#__PURE__*/React.createElement(Loading$u, {
    backgroundColor: theme.highContrast.backgroundColor
  }) : hasError ? /*#__PURE__*/React.createElement("div", null, "Error..") : /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "65px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-12 col-12"
  }, onRenderList()), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-12 col-12"
  }, content.topEvent !== null ? content.topEvent.map(function (item, index) {
    var isSameDay = moment(item.startDate).isSame(item.endDate, "day");
    var agendaFeatured = theme.components.events.agendaFeatured;
    return /*#__PURE__*/React.createElement(AgendaFeatured$1, {
      className: "events-agenda-featured",
      key: index,
      href: item.url,
      dateContainerBgColor: agendaFeatured.dateContainerBgColor,
      borderColor: agendaFeatured.borderColor,
      dateContainerTextColor: agendaFeatured.dateContainerTextColor,
      buttonBgColor: agendaFeatured.buttonBgColor,
      buttonTextColor: agendaFeatured.buttonTextColor,
      titleColor: agendaFeatured.titleColor,
      textColor: agendaFeatured.textColor,
      dateColor: agendaFeatured.dateColor,
      textColorHover: agendaFeatured.textColorHover,
      animationBgColor: agendaFeatured.animationBgColor,
      plusButtonHoverBgColor: agendaFeatured.plusButtonHoverBgColor,
      dateContainerDay: moment(item.startDate, "YYYY/MM/DD").format("DD"),
      dateContainerMonth: moment(item.startDate, "YYYY/MM/DD").format("MMM") //Aria-Label
      ,
      dateContainerMonthAriaLabel: moment(item.startDate, "YYYY/MM/DD").format("MMMM"),
      text: item.category,
      title: item.title,
      date: isSameDay ? "".concat(moment(item.startDate).format("DD MMMM YYYY")) : "".concat(moment(item.startDate).format("DD MMMM"), " - ").concat(moment(item.endDate).format("DD MMMM YYYY")),
      marginTop: "".concat(index === 0 ? "0" : "50px")
    });
  }) : onRenderList()))), !isLoading && Object.keys(content.listEvents).length !== content.pagination.totalResults && /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "50px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onLoadMore,
    variant: "default",
    "aria-label": "Carregar mais"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.organism.button.LoadMore",
    defaultMessage: "Carregar mais"
  })))))));
};

var defaults$D = {
  content: {},
  range: [],
  categories: {},
  channels: [],
  openCalendar: function openCalendar() {
    return null;
  },
  onChangeDate: function onChangeDate() {
    return null;
  },
  onResetDate: function onResetDate() {
    return null;
  },
  onChangeCategory: function onChangeCategory() {
    return null;
  },
  onLoadMore: function onLoadMore() {
    return null;
  },
  setOpen: function setOpen() {
    return null;
  },
  isOpen: false,
  onChangeChannel: function onChangeChannel() {
    return null;
  },
  theme: PropTypes$1.object
};
var types$H = {
  className: PropTypes$1.string,
  intl: PropTypes$1.object,
  isLoading: PropTypes$1.bool,
  content: PropTypes$1.object.isRequired,
  hasError: PropTypes$1.bool,
  range: PropTypes$1.array.isRequired,
  categories: PropTypes$1.array.isRequired,
  channels: PropTypes$1.array.isRequired,
  openCalendar: PropTypes$1.func.isRequired,
  onChangeDate: PropTypes$1.func.isRequired,
  onResetDate: PropTypes$1.func.isRequired,
  onChangeCategory: PropTypes$1.func.isRequired,
  onLoadMore: PropTypes$1.func.isRequired,
  currentDate: PropTypes$1.instanceOf(Date),
  setOpen: PropTypes$1.func.isRequired,
  isOpen: PropTypes$1.bool.isRequired,
  onChangeChannel: PropTypes$1.func.isRequired,
  theme: PropTypes$1.object
};
Events.propTypes = types$H;
Events.defaultProps = defaults$D;
var EventsWithStyles = styled(Events)(_templateObject$1b(), function (props) {
  return props.theme.components.events.calendarCardToday.backgroundColor;
}, function (props) {
  return props.theme.components.events.calendarCardToday.afterBgColor;
}, function (props) {
  return props.theme.components.events.calendarCardToday.bottomBgColor;
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.theme.components.events.calendarCard.backgroundColor;
}, function (props) {
  return props.theme.components.events.calendarCard.border;
}, function (props) {
  return props.theme.components.events.calendarCard.hoverBgColor;
}, function (props) {
  return props.theme.components.events.calendarCard.textColorHover;
}, function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.theme.components.events.calendarCard.activeBgColor;
}, function (props) {
  return props.theme.components.events.calendarButton.backgroundColor;
}, function (props) {
  return props.theme.components.events.calendarButton.color;
}, function (props) {
  return props.theme.components.events.calendarButton.hoverBgColor;
}, function (props) {
  return props.theme.mixins.focus;
});
var index$4 = withTheme(EventsWithStyles); //Only used for the Storybook Props Table

function _templateObject$1c() {
  var data = _taggedTemplateLiteral(["\n  min-height: 400px;\n"]);

  _templateObject$1c = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$f = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$4 = function LoadingCard(_ref) {
  var theme = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "40px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "40px"
  }, /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "20px",
    right: "0",
    width: "70%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "15px",
    top: "20px",
    width: "100%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "5px",
    top: "35px",
    right: "0",
    width: "90%"
  }, theme)))), /*#__PURE__*/React.createElement(ContentContainer, {
    position: "relative",
    top: "50px",
    height: "90px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "90px"
  }, /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "15px",
    top: "0",
    right: "0",
    width: "40%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "10px",
    top: "15px",
    width: "100%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "15px",
    top: "25px",
    right: "0",
    width: "40%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "10px",
    top: "40px",
    width: "100%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "15px",
    top: "50px",
    right: "0",
    width: "50%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "10px",
    top: "65px",
    width: "100%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$f, _extends({
    height: "15px",
    top: "75px",
    right: "0",
    width: "60%"
  }, theme)))));
};

var Loading$v = function Loading(_ref2) {
  var className = _ref2.className,
      theme = _ref2.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(LoadingCard$4, {
    theme: theme
  }))));
};

Loading$v.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$6 = styled(Loading$v)(_templateObject$1c());
var Loading$w = withTheme(LoadingWithStyles$6);

var Presentation = memo(function Presentation(_ref) {
  var className = _ref.className,
      hasSubTitle = _ref.hasSubTitle,
      hasLine = _ref.hasLine,
      showMore = _ref.showMore,
      showImage = _ref.showImage,
      showButton = _ref.showButton,
      lang = _ref.lang,
      openMore = _ref.openMore,
      onOpenMore = _ref.onOpenMore,
      action = _ref.action,
      loading = _ref.loading,
      content = _ref.content,
      hasError = _ref.hasError,
      learnMore = _ref.learnMore,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.presentation.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$w, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "40px"
  }, hasSubTitle && /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    text: content.data.subTitle,
    fontWeight: "300",
    marginBottom: "5px",
    size: "large",
    firstLetter: "capitalize"
  }), /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    text: content.data.title,
    marginBottom: "10px",
    size: "xLarge",
    fontWeight: "500",
    firstLetter: "capitalize"
  }), hasLine && /*#__PURE__*/React.createElement(Line, {
    color: theme.components.presentation.lineColor
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, content.data.description !== null && /*#__PURE__*/React.createElement(InjectHtml$1, {
    content: truncateOnWord(content.data.description, 1500, openMore, content.data.description.length >= 1500 ? "..." : ""),
    variant: "presentation"
  }), showMore && content.data.description !== null && content.data.description.length >= 1500 && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "15px"
  }, /*#__PURE__*/React.createElement(Link, {
    text: "".concat(openMore ? "ver mais" : "ver menos"),
    "aria-label": "".concat(openMore ? "ver mais" : "ver menos"),
    textDecoration: "underline",
    fontSize: "14px",
    color: theme.components.presentation.linkColor,
    fontWeight: "300",
    hoverColor: theme.components.presentation.linkHoverColor,
    onClick: onOpenMore,
    "default": true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl offset-xl-0 col-lg-4 offset-lg-4 col-md-6 col-sm-7 col-8"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginLeft: "30px",
    mobileLgMarginLeft: "0",
    lgMargintop: "40px",
    borderTop: theme.components.presentation.card.border,
    borderBottom: theme.components.presentation.card.border,
    paddingTop: "10px"
  }, /*#__PURE__*/React.createElement(ImageCard$1, {
    alt: content.data.image.title,
    title: content.data.image.title,
    name: content.data.image.name,
    email: content.data.image.email,
    hasPhoto: showImage,
    url: content.data.image.id != null ? "/".concat(lang, "/p/").concat(content.data.image.id) : null,
    src: ""
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    mobileLgMarginLeft: "0",
    marginTop: "10px",
    paddingTop: "10px",
    borderTop: "1px solid ".concat(theme.components.presentation.card.thinBorderColor)
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "500",
    marginBottom: "10px",
    fontSize: "14px",
    lineHeight: "1"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.course.shortInfo.departamentsAndSchools",
    defaultMessage: "Departamentos/Escolas polit\xE9cnicas"
  })), content.data.list.map(function (item) {
    return /*#__PURE__*/React.createElement(Link, {
      key: item.id,
      text: item.name.value,
      title: item.name.value,
      href: item.url.value,
      target: "_blank",
      color: theme.components.presentation.linkColor,
      fontWeight: "300",
      fontSize: "14px",
      textDecoration: "underline",
      hoverColor: theme.components.presentation.linkHoverColor,
      display: "block",
      lineHeight: "1.4",
      marginBottom: "10px",
      "default": true,
      "native": true
    });
  }))), showButton && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginLeft: "30px",
    mobileLgMarginLeft: "0"
  }, /*#__PURE__*/React.createElement(Button, {
    width: "100%",
    onClick: function onClick() {
      return action(content.data.payload.id);
    },
    variant: "default"
  }, content.data.payload.coursePlanLabel), learnMore.show && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "30px"
  }, /*#__PURE__*/React.createElement(Button, {
    width: "100%",
    variant: "default",
    onClick: learnMore.action
  }, learnMore.text))))))));
});
var defaults$E = {
  hasSubTitle: false,
  hasLine: false,
  showMore: false,
  showImage: false,
  hasEndpoint: true,
  learnMore: {
    action: function action() {
      return null;
    },
    text: "Mais Informações",
    show: true
  }
};
var types$I = {
  className: PropTypes$1.string,
  hasSubTitle: PropTypes$1.bool,
  hasLine: PropTypes$1.bool,
  showMore: PropTypes$1.bool,
  history: PropTypes$1.object,
  showImage: PropTypes$1.bool,
  showButton: PropTypes$1.bool,
  match: PropTypes$1.object.isRequired,
  lang: PropTypes$1.string,
  openMore: PropTypes$1.bool,
  onOpenMore: PropTypes$1.func,
  action: PropTypes$1.func,
  loading: PropTypes$1.bool,
  content: PropTypes$1.object,
  hasError: PropTypes$1.bool,
  theme: PropTypes$1.object,
  learnMore: PropTypes$1.object
};
Presentation.propTypes = types$I;
Presentation.defaultProps = defaults$E;
var index$5 = withTheme(Presentation); //Only used for the Storybook Props Table

var Mask$g = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.backgroundColor || props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$5 = function LoadingCard(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "90px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "90px"
  }, /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "25px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "10px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "5px",
    right: "0",
    top: "35px",
    width: "90%"
  })), /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "10px",
    top: "40px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "50px",
    width: "10%"
  })), /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "10px",
    top: "65px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$g, _extends({}, props, {
    height: "15px",
    right: "0",
    top: "75px",
    width: "15%"
  }))));
};

var Loading$x = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-5 col-lg-5 col-md-6 col-sm-7 col-8"
  }, /*#__PURE__*/React.createElement(LoadingCard$5, props)))));
};

Loading$x.propTypes = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
var Loading$y = withTheme(Loading$x);

var TwoCols = function TwoCols(_ref) {
  var data = _ref.data,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage;

  if (data === null || Object.keys(data.description).length <= 0) return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.description.map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "col-xl col-lg col-md-12"
    }, /*#__PURE__*/React.createElement(InjectHtml$1, {
      content: res.value,
      variant: "presentation"
    }), index === 1 && data.url !== null && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Text, {
      lineHeight: "1.6",
      fontSize: "14px",
      fontWeight: "400",
      text: data.url.title,
      color: theme.components.contents.twoCols.textColor
    }), data.url.urls !== null && data.url.urls.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Link, {
        key: index,
        lineHeight: "1.6",
        fontSize: "14px",
        fontWeight: "300",
        color: theme.components.contents.twoCols.linkColor,
        text: item.label,
        "aria-label": item.label,
        href: item.value,
        textDecoration: "underline",
        hoverColor: theme.components.contents.twoCols.linkHoverColor,
        display: "block",
        "default": true,
        "native": true
      });
    })));
  }));
};

TwoCols.propTypes = {
  data: PropTypes$1.object.isRequired,
  theme: PropTypes$1.object
};
var TwoCols$1 = withTheme(TwoCols);

var OneCol = function OneCol(_ref) {
  var data = _ref.data,
      theme = _ref.theme,
      oneColAction = _ref.oneColAction;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.components.contents.oneCol.textColor,
    size: "article",
    lineHeight: "1.6",
    text: data
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "25px"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    backgroundColor: theme.components.contents.oneCol.buttonBgColor,
    onClick: oneColAction
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.course.curricular",
    defaultMessage: "Plano Curricular"
  })))))));
};

OneCol.propTypes = {
  data: PropTypes$1.string.isRequired,
  backgroundColor: PropTypes$1.string.isRequired,
  theme: PropTypes$1.object,
  oneColAction: PropTypes$1.func.isRequired
};
var OneCol$1 = withTheme(OneCol);

var NestedRow = function NestedRow(_ref) {
  var data = _ref.data,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.contents.map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "col-xl col-lg col-md-12"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h2",
      size: "xLarge",
      fontWeight: "500",
      text: res.title,
      marginBottom: "10px"
    }), res.list.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        mdMarginBottom: index === 0 && "50px"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "h3",
        size: "small",
        fontWeight: "500",
        text: item.title,
        marginTop: "10px",
        marginBottom: "10px"
      }), item.contents.map(function (item, index) {
        return /*#__PURE__*/React.createElement(ContentContainer, {
          key: index
        }, item.type === "link" ? /*#__PURE__*/React.createElement(Link, {
          lineHeight: "1.6",
          fontSize: "15px",
          fontWeight: "300",
          text: item.info.value,
          href: item.extra,
          "aria-label": item.info.value,
          target: "_blank",
          textDecoration: "underline",
          color: theme.components.contents.nestedRow.linkColor,
          hoverColor: theme.components.contents.nestedRow.linkHoverColor,
          display: "block",
          "default": true,
          "native": true
        }) : item.type === "image" ? /*#__PURE__*/React.createElement(Link, {
          href: item.info.value,
          "default": true
        }, /*#__PURE__*/React.createElement(Image, {
          src: item.extra,
          title: item.info.label,
          alt: item.info.label
        })) : /*#__PURE__*/React.createElement(Text, {
          lineHeight: "1.6",
          size: "article",
          fontWeight: "300",
          text: item.info.value
        }));
      }));
    }));
  }));
};

NestedRow.propTypes = {
  data: PropTypes$1.object.isRequired,
  theme: PropTypes$1.object
};
var NestedRow$1 = withTheme(NestedRow);

var Modifier$1 = function Modifier(variant, props, data) {
  switch (variant) {
    case "TwoCols":
      return /*#__PURE__*/React.createElement(TwoCols$1, _extends({}, props, {
        data: data
      }));

    case "OneCol":
      return /*#__PURE__*/React.createElement(OneCol$1, _extends({}, props, {
        data: data
      }));

    case "NestedRow":
      return /*#__PURE__*/React.createElement(NestedRow$1, _extends({}, props, {
        data: data
      }));

    default:
      return /*#__PURE__*/React.createElement(OneCol$1, _extends({}, props, {
        data: data
      }));
  }
};

var Contents = function Contents(_ref) {
  var titleProp = _ref.title,
      textColor = _ref.textColor,
      variant = _ref.variant,
      hasTitle = _ref.hasTitle,
      hasLine = _ref.hasLine,
      loading = _ref.loading,
      content = _ref.content,
      hasError = _ref.hasError,
      lang = _ref.lang,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["title", "textColor", "variant", "hasTitle", "hasLine", "loading", "content", "hasError", "lang", "theme"]);

  var title = useMemo(function () {
    return titleProp[lang] || titleProp;
  }, [titleProp, lang]); //Removes the component if there is not content

  if (!loading && content.data !== undefined) {
    if (variant === "TwoCols" && content.data.description && content.data.description.length <= 0) return null;

    if (variant === "NestedRow" && content.data.contents[0].list.length <= 0 && content.data.contents[1].list.length <= 0) {
      return null;
    }
  }

  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.highContrast.backgroundColor || props.backgroundColor
  }, loading ? /*#__PURE__*/React.createElement(Loading$y, {
    backgroundColor: theme.highContrast.backgroundColor || props.backgroundColor
  }) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, hasTitle && /*#__PURE__*/React.createElement(SectionHeader, {
    title: title,
    textColor: theme.highContrast.text || textColor,
    hasLine: hasLine,
    hasLink: hasLine
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, Modifier$1(variant, props, content.data))));
};

var defaults$F = {
  hasDelay: false,
  hasTitle: true,
  title: "Title",
  content: {},
  lang: "pt"
};
var types$J = {
  title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
  textColor: PropTypes$1.string,
  variant: PropTypes$1.string.isRequired,
  hasTitle: PropTypes$1.bool,
  hasLine: PropTypes$1.bool,
  loading: PropTypes$1.bool,
  content: PropTypes$1.object,
  hasError: PropTypes$1.bool,
  lang: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  theme: PropTypes$1.object
};
Contents.propTypes = types$J;
Contents.defaultProps = defaults$F;
var index$6 = withTheme(Contents); //Only used for the Storybook Props Table

/* eslint-disable no-nested-ternary */

var Contests = function Contests(_ref) {
  var hasError = _ref.hasError,
      loading = _ref.loading,
      tabs = _ref.tabs,
      data = _ref.data,
      contestsTitle = _ref.contestsTitle,
      theme = _ref.theme,
      activeTab = _ref.activeTab,
      onChangeTab = _ref.onChangeTab,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, loading ? /*#__PURE__*/React.createElement(Loading$q, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, contestsTitle && /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    fontWeight: "500",
    size: "xLarge",
    marginBottom: "40px"
  }, contestsTitle), tabs.length > 1 && /*#__PURE__*/React.createElement(ScrollableTabsWithStyles, {
    marginBottom: "30px"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(ScrollableTab, {
      key: tab.id,
      isActive: tab.id === activeTab,
      text: tab.text,
      theme: theme,
      activeColor: activeColor,
      onClick: function onClick() {
        return onChangeTab(tab.id);
      }
    });
  })), !data.contests.length && /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "Nenhum conte\xFAdo para exibir"
  })), data.contests.map(function (contest) {
    return /*#__PURE__*/React.createElement(ContentContainer, {
      marginBottom: "15px",
      key: contest.contestId
    }, /*#__PURE__*/React.createElement(Contest, {
      contest: contest,
      activeColor: activeColor
    }));
  }))))));
};

var defaults$G = {};
var types$K = {
  hasError: PropTypes$1.bool,
  loading: PropTypes$1.bool,
  tabs: PropTypes$1.arrayOf(PropTypes$1.object),
  contestsTitle: PropTypes$1.string,
  theme: PropTypes$1.object,
  activeTab: PropTypes$1.number,
  onChangeTab: PropTypes$1.func,
  data: PropTypes$1.shape({
    //TODO: reuse contest type
    contests: PropTypes$1.arrayOf(PropTypes$1.shape({
      title: PropTypes$1.string,
      subTitle: PropTypes$1.string,
      files: PropTypes$1.arrayOf(PropTypes$1.shape({
        fileId: PropTypes$1.number,
        url: PropTypes$1.string,
        description: PropTypes$1.string
      })),
      submissionDeadlineFormattedDate: PropTypes$1.string,
      contestState: PropTypes$1.string
    }))
  })
};
Contests.propTypes = types$K;
Contests.defaultProps = defaults$G;

var Mask$h = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$6 = function LoadingCard(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "394px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "394px"
  }, /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "25px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "10px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "5px",
    right: "0",
    top: "35px",
    width: "90%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "40px",
    top: "40px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    backgroundColor: props.theme.loadings.bgColor,
    height: "40px",
    top: "80px",
    width: "100%",
    border: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "40px",
    top: "120px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "160px",
    width: "100%",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "15px",
    top: "172px",
    right: "0",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "187px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "199px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "15px",
    top: "211px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "226px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "238px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "15px",
    top: "250px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "265px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "277px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "15px",
    top: "289px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "304px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "316px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "15px",
    top: "328px",
    right: "0",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "343px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "355px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "15px",
    top: "367px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$h, _extends({}, props, {
    height: "12px",
    top: "382px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  }))));
};

var Loading$z = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(LoadingCard$6, props)))));
};

Loading$z.propTypes = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
var Loading$A = withTheme(Loading$z);

var SingleFilterItem = function SingleFilterItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      _onChange = _ref.onChange,
      _ref$usesThreeFilters = _ref.usesThreeFiltersInRow,
      usesThreeFiltersInRow = _ref$usesThreeFilters === void 0 ? false : _ref$usesThreeFilters;
  return /*#__PURE__*/React.createElement("div", {
    className: usesThreeFiltersInRow ? "col-xl col-lg col-md col-sm col-12" : "col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsMarginTop: usesThreeFiltersInRow ? "20px" : index % 2 == 0 ? "0" : "20px"
  }, /*#__PURE__*/React.createElement(Select, {
    variant: "black",
    options: item.options,
    placeholder: item.title,
    "aria-label": item.title,
    inputProps: {
      "aria-label": item.title
    },
    label: item.title,
    onChange: function onChange(option) {
      return _onChange(option, item.jsonField);
    },
    isClearable: true
  })));
};

function Courses(_ref2) {
  var titleColor = _ref2.titleColor,
      textColor = _ref2.textColor,
      textSize = _ref2.textSize,
      textLineHeight = _ref2.textLineHeight,
      className = _ref2.className,
      content = _ref2.content,
      loading = _ref2.loading,
      onFilter = _ref2.onFilter,
      data = _ref2.data,
      filters = _ref2.filters,
      hasLine = _ref2.hasLine,
      lang = _ref2.lang,
      hasHash = _ref2.hasHash,
      theme = _ref2.theme,
      activeColor = _ref2.activeColor;

  var _useConfig = useConfig(),
      Link = _useConfig.link;
  /*
  const GlobalStore = useContext(StoreContext);
    const {
    state: { activeColor }
  } = GlobalStore;
  */


  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.courses.backgroundColor,
    hasHighContrastBorderTop: false
  }, loading ? /*#__PURE__*/React.createElement(Loading$A, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 offset-lg-4 col-lg col-12"
  }, /*#__PURE__*/React.createElement(TitleWithStyles, {
    tag: "h1",
    text: content.title,
    color: theme.highContrast.text || titleColor,
    marginBottom: "10px",
    firstLetter: "capitalize"
  }), hasLine && /*#__PURE__*/React.createElement(Line, {
    color: theme.components.courses.lineColor,
    marginBottom: "25px"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    mobileMdDisplay: "none"
  }, /*#__PURE__*/React.createElement(Text, {
    text: content.description,
    color: theme.highContrast.text || textColor,
    fontWeight: "300",
    fontSize: textSize,
    lineHeight: textLineHeight
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginBottom: "40px"
  }, filters.length === 3 ? /*#__PURE__*/React.createElement("div", {
    className: "row",
    key: 0,
    style: {
      marginTop: 20
    }
  }, filters.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SingleFilterItem, {
      item: item,
      index: index,
      onChange: onFilter,
      usesThreeFiltersInRow: true
    });
  })) : filters.map(function (item, index) {
    return index % 2 === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "row",
      key: index,
      style: {
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(SingleFilterItem, {
      item: item,
      index: index,
      onChange: onFilter
    }), filters[index + 1] && /*#__PURE__*/React.createElement(SingleFilterItem, {
      item: filters[index + 1],
      index: index + 1,
      onChange: onFilter
    })) : null;
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginRight: "0",
    mobileXsMarginRight: "0"
  }, /*#__PURE__*/React.createElement(VerticalList, null, Object.keys(data).length <= 0 ? /*#__PURE__*/React.createElement(ErrorWithStyles, null, "Sem conte\xFAdos para o filtro.") : data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.id,
      paddingTop: "10px",
      paddingBottom: "10px",
      borderBottom: "1px solid ".concat(theme.components.courses.borderColor),
      borderTop: index === 0 ? "1px solid ".concat(theme.components.courses.borderColor) : "none"
    }, item.type === "link" ? /*#__PURE__*/React.createElement(Link, {
      href: "".concat(lang === "pt" ? "".concat(hasHash, "/").concat(lang, "/curso") : "".concat(hasHash, "/").concat(lang, "/course")).concat(item.url),
      fontSize: "14px",
      fontWeight: "300",
      "aria-label": item.name + " " + item.note,
      "default": true,
      color: theme.components.courses.listLinkColor,
      textDecorationColor: theme.highContrast.linkHover || activeColor
    }, item.name, " ", item.note && /*#__PURE__*/React.createElement(Text, {
      as: "span",
      size: "small",
      color: theme.components.courses.noteColor
    }, item.note)) : /*#__PURE__*/React.createElement(Text, {
      color: theme.components.courses.textColor,
      fontSize: "14px",
      fontWeight: "300",
      "aria-label": item.name
    }, item.name));
  }))))))));
}

var defaults$H = {
  content: {},
  data: [],
  onFilter: function onFilter() {
    return null;
  },
  filters: [],
  lang: "pt",
  hasHash: false,
  activeColor: "#0EB4BD"
};
var types$L = {
  className: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  textColor: PropTypes$1.string,
  textSize: PropTypes$1.string,
  textLineHeight: PropTypes$1.string,
  content: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.array]),
  data: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.array]),
  hasLine: PropTypes$1.bool,
  loading: PropTypes$1.bool,
  onFilter: PropTypes$1.func.isRequired,
  filters: PropTypes$1.array.isRequired,
  lang: PropTypes$1.string,
  hasHash: PropTypes$1.bool,
  theme: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
Courses.propTypes = types$L;
Courses.defaultProps = defaults$H;
var index$7 = withTheme(Courses); //Only used for the Storybook Props Table

var Mask$i = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$7 = function LoadingCard(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "394px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "394px"
  }, /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "25px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "10px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "5px",
    right: "0",
    top: "35px",
    width: "90%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "40px",
    top: "40px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    backgroundColor: props.theme.loadings.bgColor,
    height: "40px",
    top: "80px",
    width: "100%",
    border: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "40px",
    top: "120px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "160px",
    width: "100%",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "15px",
    top: "172px",
    right: "0",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "187px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "199px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "15px",
    top: "211px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "226px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "238px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "15px",
    top: "250px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "265px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "277px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "15px",
    top: "289px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "304px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "316px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "15px",
    top: "328px",
    right: "0",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "343px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "355px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "15px",
    top: "367px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$i, _extends({}, props, {
    height: "12px",
    top: "382px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  }))));
};

var Loading$B = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(LoadingCard$7, props));
};

Loading$B.propTypes = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
var Loading$C = withTheme(Loading$B);

var Edicts = function Edicts(_ref) {
  var title = _ref.title,
      className = _ref.className,
      lang = _ref.lang,
      hasHash = _ref.hasHash,
      isLoading = _ref.isLoading,
      hasError = _ref.hasError,
      tables = _ref.tables,
      filters = _ref.filters,
      onChangeFaseFilter = _ref.onChangeFaseFilter,
      onChangeDegreeFilter = _ref.onChangeDegreeFilter,
      faseFilterValue = _ref.faseFilterValue,
      degreeFilterValue = _ref.degreeFilterValue,
      size = _ref.size,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage,
      useIntl = _useConfig.useIntl;

  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    mdPaddingTop: "122px",
    backgroundColor: theme.components.edicts.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, isLoading ? /*#__PURE__*/React.createElement(Loading$C, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    fontWeight: "500",
    size: "xLarge",
    marginBottom: "10px",
    firstLetter: "capitalize"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.course.edicts",
    defaultMessage: title
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginBottom: "20px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filters.filter(function (res) {
    return res.jsonField === "degree";
  }).map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "col-sm col-12"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      mobileXsMarginBottom: "20px"
    }, /*#__PURE__*/React.createElement(Select, {
      id: item.jsonField,
      variant: "black",
      options: item.options,
      placeholder: item.title,
      label: item.title,
      onChange: function onChange(option) {
        return onChangeDegreeFilter(option, item.jsonField);
      },
      isClearable: true
    })));
  }), filters.filter(function (res) {
    return res.jsonField === "fase";
  }).map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "col-sm col-12"
    }, /*#__PURE__*/React.createElement(Select, {
      id: item.jsonField,
      variant: "black",
      options: item.options,
      placeholder: item.title,
      label: item.title,
      onChange: function onChange(option) {
        return onChangeFaseFilter(option, item.jsonField);
      },
      isClearable: true
    }));
  }))), size.width <= 575 ? tables.filter(function (_, index) {
    return index !== 0;
  }).map(function (res, i) {
    return /*#__PURE__*/React.createElement(BorderedCardWithStyles, {
      key: i,
      cardIsLink: false
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      marginBottom: "10px"
    }, res.columns[0].text), /*#__PURE__*/React.createElement(Text, {
      size: "small",
      marginBottom: "10px"
    }, res.columns[1].text), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(HorizontalList, {
      display: "inline-block"
    }, /*#__PURE__*/React.createElement(ListItem, {
      paddingRight: "5px",
      borderRight: "1px solid #000",
      lineHeight: "1"
    }, /*#__PURE__*/React.createElement(Link, {
      as: res.columns[3].href ? "a" : "span",
      fontWeight: "300",
      display: "inline-block",
      textDecoration: "underline",
      target: res.columns[3].href ? "_blank" : null,
      href: res.columns[3].href ? res.columns[3].href : null,
      color: res.columns[3].href ? theme.components.edicts.iconColor : theme.components.edicts.emptyIconColor,
      cursor: res.columns[3].href ? "pointer" : "default",
      hasHover: res.columns[3].href && true,
      "aria-label": res.columns[3].href ? res.columns[3].href : intl({
        id: "app.course.edicts.icon.empty.documents",
        defaultMessage: "Ausência de documentos"
      }),
      "native": true
    }, "ver ata")), /*#__PURE__*/React.createElement(ListItem, {
      paddingLeft: "5px",
      lineHeight: "1"
    }, /*#__PURE__*/React.createElement(Link, {
      as: res.columns[2].href ? "a" : "span",
      fontWeight: "300",
      display: "inline-block",
      textDecoration: "underline",
      target: res.columns[2].href ? "_blank" : null,
      href: res.columns[2].href ? res.columns[2].href : null,
      color: res.columns[2].href ? theme.components.edicts.iconColor : theme.components.edicts.emptyIconColor,
      cursor: res.columns[2].href ? "pointer" : "default",
      hasHover: res.columns[2].href && true,
      "aria-label": res.columns[2].href ? intl({
        id: "app.course.edicts.icon.documents",
        defaultMessage: "Aceder aos documentos"
      }) : intl({
        id: "app.course.edicts.icon.empty.documents",
        defaultMessage: "Ausência de documentos"
      }),
      "native": true
    }, "ver edital")))));
  }) : /*#__PURE__*/React.createElement(TableWithStyles, {
    marginTop: "0",
    col2Size: "230px",
    col3Size: "65px",
    col4Size: "30px",
    col2SizeMobile: "145px",
    col3SizeMobile: "65px",
    col4SizeMobile: "30px",
    tableRowSpace: "10px",
    borders: true
  }, Object.keys(tables).length <= 1 ? /*#__PURE__*/React.createElement(ErrorWithStyles, null, "N\xE3o existe informa\xE7\xE3o para esta fase", " ", /*#__PURE__*/React.createElement("b", null, faseFilterValue.label || degreeFilterValue.label)) : /*#__PURE__*/React.createElement(Fragment, null, tables.filter(function (item) {
    return item.isHeader;
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement("thead", {
      key: "table-".concat(item.fase, "-").concat(index)
    }, /*#__PURE__*/React.createElement("tr", null, item.columns.map(function (cols, index) {
      return /*#__PURE__*/React.createElement("th", {
        key: index
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: "14px",
        fontWeight: "400"
      }, cols.text));
    })));
  }), /*#__PURE__*/React.createElement("tbody", null, tables.filter(function (item) {
    return !item.isHeader;
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, item.columns.map(function (cols) {
      return cols.type === "link" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
        color: theme.components.edicts.linkColor,
        fontSize: "14px",
        fontWeight: "300",
        href: "".concat(hasHash, "/").concat(lang, "/curso/").concat(cols.id),
        "aria-label": cols.text
      }, cols.text)) : cols.type === "icon" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
        as: cols.href ? "a" : "span",
        href: cols.href ? cols.href : null,
        "aria-label": cols.href ? intl({
          id: "app.course.edicts.icon.documents",
          defaultMessage: "Aceder aos documentos"
        }) : intl({
          id: "app.course.edicts.icon.empty.documents",
          defaultMessage: "Ausência de documentos"
        }),
        target: cols.href && "_blank",
        hasHover: cols.href,
        cursor: cols.href ? "pointer" : "default",
        "native": true
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "fal fa-file",
        color: cols.href === "" ? theme.components.edicts.emptyIconColor : theme.components.edicts.iconColor,
        fontSize: "14px"
      }))) : /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Text, {
        fontSize: "14px",
        fontWeight: "300"
      }, cols.text));
    }));
  })))))))));
};

var defaults$I = {
  title: "Title",
  lang: "pt",
  hasHash: "",
  tables: [],
  filters: [],
  onChangeFaseFilter: function onChangeFaseFilter() {
    return null;
  },
  onChangeDegreeFilter: function onChangeDegreeFilter() {
    return null;
  }
};
var types$M = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  lang: PropTypes$1.string,
  hasHash: PropTypes$1.string,
  isLoading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  tables: PropTypes$1.array.isRequired,
  filters: PropTypes$1.array.isRequired,
  onChangeFaseFilter: PropTypes$1.func.isRequired,
  onChangeDegreeFilter: PropTypes$1.func.isRequired,
  faseFilterValue: PropTypes$1.string.isRequired,
  degreeFilterValue: PropTypes$1.string.isRequired,
  size: PropTypes$1.object,
  theme: PropTypes$1.object
};
Edicts.propTypes = types$M;
Edicts.defaultProps = defaults$I;
var index$8 = compose(withSize(), withTheme)(Edicts); //Only used for the Storybook Props Table

var Mask$j = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$8 = function LoadingCard(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "314px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "314px"
  }, /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "25px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "10px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "5px",
    right: "0",
    top: "35px",
    width: "90%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "40px",
    top: "40px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "80px",
    width: "100%",
    borderTop: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "15px",
    top: "92px",
    right: "0",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "107px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "119px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "15px",
    top: "131px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "146px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "158px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "15px",
    top: "170px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "185px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "197px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "15px",
    top: "209px",
    right: "0",
    width: "70%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "224px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "236px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "15px",
    top: "248px",
    right: "0",
    width: "60%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "263px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "275px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "15px",
    top: "287px",
    right: "0",
    width: "65%"
  })), /*#__PURE__*/React.createElement(Mask$j, _extends({}, props, {
    height: "12px",
    top: "302px",
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  }))));
};

var Loading$D = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(LoadingCard$8, props)))));
};

Loading$D.propTypes = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
var Loading$E = withTheme(Loading$D);

var ContentList = function ContentList(_ref) {
  var title = _ref.title,
      resource = _ref.resource,
      loading = _ref.loading,
      hasError = _ref.hasError,
      data = _ref.data,
      titleColor = _ref.titleColor,
      className = _ref.className,
      hasLine = _ref.hasLine,
      lang = _ref.lang,
      theme = _ref.theme,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage;
  /*
  const GlobalStore = useContext(StoreContext);
    const {
    state: { activeColor }
  } = GlobalStore;
  */


  return /*#__PURE__*/React.createElement(Section, {
    hasHighContrastBorderTop: false,
    className: className,
    backgroundColor: theme.components.contentList.backgroundColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$E, null) : hasError ? /*#__PURE__*/React.createElement("div", null, "No content to display") : /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 offset-lg-4 col-lg col-12"
  }, /*#__PURE__*/React.createElement(TitleWithStyles, {
    tag: "h1",
    color: theme.highContrast.text || titleColor,
    marginBottom: "10px",
    firstLetter: "capitalize"
  }, resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: title
  }) : title), hasLine && /*#__PURE__*/React.createElement(Line, {
    color: theme.components.contentList.lineColor,
    marginBottom: "25px"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginRight: "0",
    mobileXsMarginRight: "0"
  }, data.list.map(function (res, index) {
    return /*#__PURE__*/React.createElement(VerticalList, {
      key: index
    }, /*#__PURE__*/React.createElement(ListItem, {
      paddingTop: "10px",
      paddingBottom: "10px",
      borderBottom: "1px solid ".concat(theme.components.contentList.borderColor),
      marginTop: index !== 0 ? "40px" : "0"
    }, /*#__PURE__*/React.createElement(Text, {
      "aria-label": res.title,
      color: theme.components.contentList.listTitleColor,
      fontSize: "14px",
      fontWeight: "400"
    }, res.title)), res.list.map(function (item, index) {
      var url = lang === "pt" ? "cursos/".concat(item.type, "/").concat(item.value) : "courses/".concat(item.type, "/").concat(item.value);
      var slugUrl = "cursos/tipo/".concat(item.slug);
      var hasSlug = item.slug !== undefined || item.slug;
      return /*#__PURE__*/React.createElement(ListItem, {
        key: index,
        paddingTop: "10px",
        paddingBottom: "10px",
        borderBottom: "1px solid ".concat(theme.components.contentList.borderColor)
      }, /*#__PURE__*/React.createElement(Link, {
        href: {
          pathname: hasSlug ? slugUrl : url,
          state: {
            slug: hasSlug,
            type: item.type,
            value: item.value
          }
        },
        "aria-label": item.label,
        fontSize: "14px",
        fontWeight: "300",
        "default": true,
        color: theme.components.contentList.listLinkColor,
        textDecorationColor: theme.highContrast.linkHover || activeColor
      }, item.label, " ", item.note && /*#__PURE__*/React.createElement(Text, {
        as: "span",
        size: "small",
        color: theme.components.courses.noteColor
      }, item.note)));
    }));
  }))))));
};

var defaults$J = {
  title: "Title",
  data: [],
  lang: "pt",
  activeColor: "#0EB4BD"
};
var types$N = {
  title: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  data: PropTypes$1.array.isRequired,
  className: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  resource: PropTypes$1.string,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  lang: PropTypes$1.string,
  theme: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
ContentList.propTypes = types$N;
ContentList.defaultProps = defaults$J;
var index$9 = withTheme(ContentList); //Only used for the Storybook Props Table

function _templateObject$1d() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 70px;\n"]);

  _templateObject$1d = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$k = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.highContrast.backgroundColor || "#F3F3F4",
    position: "absolute"
  }, props));
};

var LoadingCard$9 = function LoadingCard(_ref) {
  var theme = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "55px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "55px"
  }, /*#__PURE__*/React.createElement(Mask$k, _extends({
    height: "20px",
    right: "0",
    width: "50%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$k, _extends({
    height: "5px",
    top: "20px",
    width: "100%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$k, _extends({
    height: "15px",
    right: "0",
    top: "25px",
    width: "30%"
  }, theme)), /*#__PURE__*/React.createElement(Mask$k, _extends({
    height: "15px",
    top: "40px",
    width: "100%"
  }, theme))));
};

var Loading$F = function Loading(_ref2) {
  var className = _ref2.className,
      theme = _objectWithoutProperties(_ref2, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mdPadding: "70px 0 0 0"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mdPadding: "70px 0 0 0"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme)))), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "70px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mdPadding: "70px 0 0 0"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mdPadding: "70px 0 0 0"
  }, /*#__PURE__*/React.createElement(LoadingCard$9, theme)))))));
};

Loading$F.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$7 = styled(Loading$F)(_templateObject$1d());
var Loading$G = withTheme(LoadingWithStyles$7);

function Curricular(_ref) {
  var backgroundColor = _ref.backgroundColor,
      styles = _ref.styles,
      loading = _ref.loading,
      hasError = _ref.hasError,
      content = _ref.content,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.curricular.backgroundColor,
    paddingTop: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$G, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, {
    text: "No content to display"
  }) : content.data.list.map(function (res, index) {
    return /*#__PURE__*/React.createElement(ContentContainer, {
      key: index,
      paddingTop: "70px"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, res.content.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "col-xl col-lg col-6"
      }, /*#__PURE__*/React.createElement(ContentContainer, {
        mdMargintop: index > 1 ? "70px" : "0"
      }, /*#__PURE__*/React.createElement(Text, _extends({
        text: item.value
      }, styles.text, {
        color: theme.highContrast.text
      })), /*#__PURE__*/React.createElement(TitleWithStyles, _extends({
        tag: "h3",
        text: item.label
      }, styles.title, {
        color: theme.highContrast.text
      }))));
    })));
  })));
}

var defaults$K = {
  content: {}
};
var types$O = {
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  content: PropTypes$1.object.isRequired,
  backgroundColor: PropTypes$1.string,
  styles: PropTypes$1.object.isRequired,
  theme: PropTypes$1.object
};
Curricular.propTypes = types$O;
Curricular.defaultProps = defaults$K;
var index$a = withTheme(Curricular); //Only used for the Storybook Props Table

var Mask$l = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$a = function LoadingCard(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "170px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "170px"
  }, /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "25px",
    right: "0",
    width: "80%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "10px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "5px",
    right: "0",
    top: "35px",
    width: "93%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "40px",
    top: "40px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    backgroundColor: props.theme.loadings.bgColor,
    height: "40px",
    top: "80px",
    width: "100%",
    border: "1px solid ".concat(props.theme.loadings.lightBorderColor)
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "50px",
    top: "120px",
    width: "100%"
  })))), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "237px"
  }, /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "25px",
    right: "0",
    width: "85%",
    mobileXsWidth: "70%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "35px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "60px",
    right: "0",
    width: "75%",
    mobileXsWidth: "45%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "75px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "87px",
    right: "0",
    width: "80%",
    mobileXsWidth: "50%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "102px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "114px",
    right: "0",
    width: "70%",
    mobileXsWidth: "40%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "129px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "141px",
    right: "0",
    width: "75%",
    mobileXsWidth: "45%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "156px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "168px",
    right: "0",
    width: "80%",
    mobileXsWidth: "50%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "183px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "195px",
    right: "0",
    width: "70%",
    mobileXsWidth: "40%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "210px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "222px",
    right: "0",
    width: "75%",
    mobileXsWidth: "45%"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "110px",
    mobileXsWidth: "80px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "237px"
  }, /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "35px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "60px",
    right: "0",
    width: "10%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "75px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "87px",
    right: "0",
    width: "80%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "102px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "114px",
    right: "0",
    width: "80%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "129px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "141px",
    right: "0",
    width: "80%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "156px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "168px",
    right: "0",
    width: "80%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "183px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "195px",
    right: "0",
    width: "80%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "210px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "222px",
    right: "0",
    width: "80%"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "40px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "237px"
  }, /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "35px",
    top: "25px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "60px",
    right: "0",
    width: "10%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "75px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "87px",
    right: "0",
    width: "75%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "102px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "114px",
    right: "0",
    width: "75%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "129px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "141px",
    right: "0",
    width: "75%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "156px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "168px",
    right: "0",
    width: "75%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "183px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "195px",
    right: "0",
    width: "75%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "12px",
    top: "210px",
    width: "100%"
  })), /*#__PURE__*/React.createElement(Mask$l, _extends({}, props, {
    height: "15px",
    top: "222px",
    right: "0",
    width: "75%"
  }))))))));
};

var Loading$H = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(LoadingCard$a, props));
};

Loading$H.propTypes = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
};
var Loading$I = withTheme(Loading$H);

function CurricularPlan(_ref) {
  var className = _ref.className,
      hasLine = _ref.hasLine,
      isLoading = _ref.isLoading,
      hasError = _ref.hasError,
      content = _ref.content,
      tables = _ref.tables,
      filters = _ref.filters,
      hasHash = _ref.hasHash,
      onFilter = _ref.onFilter,
      theme = _ref.theme,
      lang = _ref.lang,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      Link = _useConfig.link;
  /*
  const GlobalStore = useContext(StoreContext);
    const {
    state: { activeColor }
  } = GlobalStore;
   */


  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.curricularPlan.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, isLoading ? /*#__PURE__*/React.createElement(Loading$I, null) : hasError ? /*#__PURE__*/React.createElement(Loading$I, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "xLarge",
    text: content.title,
    marginBottom: "10px",
    lineHeight: "1.4",
    firstLetter: "capitalize",
    fontWeight: "500"
  }), hasLine && /*#__PURE__*/React.createElement(Line, {
    color: theme.components.curricularPlan.lineColor,
    marginBottom: "5px"
  }), filters.map(function (item, index) {
    if (Object.keys(item.options).length > 0) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginTop: "40px",
        marginBottom: "40px"
      }, /*#__PURE__*/React.createElement(Select, {
        variant: "black",
        options: item.options,
        placeholder: item.title,
        label: item.title,
        onChange: onFilter,
        isClearable: true
      }));
    }

    return true;
  }), tables.map(function (item, index) {
    return /*#__PURE__*/React.createElement(TableWithStyles, {
      key: index,
      col2Size: "150px",
      col3Size: "100px",
      col2SizeMobile: "120px",
      col3SizeMobile: "65px",
      activeColor: activeColor
    }, /*#__PURE__*/React.createElement("caption", null, item.tableTitle), item.table.map(function (items, tableIndex) {
      if (items.isHeader) {
        return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, items.columns.map(function (col, index) {
          return /*#__PURE__*/React.createElement("th", {
            key: index
          }, /*#__PURE__*/React.createElement(Text, {
            size: "article",
            lineHeight: "1.6",
            fontWeight: "400"
          }, col.text));
        })));
      } else {
        return /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, items.columns.map(function (col) {
          if (col.indent) {
            return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(IndentWithStyles, {
              "double": true
            }, /*#__PURE__*/React.createElement(Link, {
              fontSize: "15px",
              lineHeight: "1.6",
              fontWeight: "300",
              "aria-label": col.text,
              href: "".concat(hasHash, "/").concat(lang, "/uc/").concat(col.id),
              "default": true,
              color: theme.components.curricularPlan.linkColor,
              textDecorationColor: theme.highContrast.link || activeColor
            }, col.text)));
          }

          if (Object.keys(item.table).length === tableIndex + 1) {
            return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Text, {
              className: "last-child",
              size: "article",
              lineHeight: "1.6",
              fontWeight: "400"
            }, col.text));
          } else {
            return /*#__PURE__*/React.createElement("td", null, col.type === "text" ? /*#__PURE__*/React.createElement(Text, {
              className: "".concat(col.isOption ? "option" : "", " ").concat(col.isMinor ? "minor" : "", " ").concat(col.doubleIdent ? "option-inside-minor" : "", " "),
              size: "article",
              lineHeight: "1.6",
              fontWeight: "300",
              title: col.title
            }, col.text) : /*#__PURE__*/React.createElement(Link, {
              className: "".concat(col.isOption ? "option" : "", " ").concat(col.isMinor ? "minor" : "", " ").concat(col.doubleIdent ? "option-inside-minor" : "", " "),
              href: "".concat(hasHash, "/").concat(lang, "/uc/").concat(col.id),
              fontSize: "15px",
              lineHeight: "1.6",
              fontWeight: "300",
              "aria-label": col.text,
              "default": true,
              color: theme.components.curricularPlan.linkColor,
              textDecorationColor: theme.highContrast.link || activeColor
            }, col.text));
          }
        })));
      }
    }));
  }))))));
}

var defaults$L = {
  content: {},
  tables: [],
  filters: [],
  hasHash: false,
  onFilter: function onFilter() {
    return null;
  },
  lang: "pt",
  activeColor: "#0EB4BD"
};
var types$P = {
  className: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  isLoading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  content: PropTypes$1.object.isRequired,
  tables: PropTypes$1.array.isRequired,
  filters: PropTypes$1.array.isRequired,
  hasHash: PropTypes$1.bool,
  onFilter: PropTypes$1.func,
  lang: PropTypes$1.string,
  theme: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
CurricularPlan.propTypes = types$P;
CurricularPlan.defaultProps = defaults$L;
var index$b = withTheme(CurricularPlan); //Only used for the Storybook Props Table

function _templateObject$1e() {
  var data = _taggedTemplateLiteral(["\n  .candidature-container {\n    padding: 0;\n  }\n\n  .slick-next,\n  .slick-prev {\n    height: auto;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  //Cards all same height\n  .slick-track {\n    display: flex;\n  }\n\n  .slick-slide {\n    height: auto;\n    margin: 15px;\n  }\n\n  .slick-slide > div {\n    height: 100%;\n    background-color: ", ";\n  }\n"]);

  _templateObject$1e = function _templateObject() {
    return data;
  };

  return data;
}
var Cards = memo(function Cards(_ref) {
  var title = _ref.title,
      textColor = _ref.textColor,
      titleColor = _ref.titleColor,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      hasLine = _ref.hasLine,
      slidesToShow = _ref.slidesToShow,
      content = _ref.content,
      activeColor = _ref.activeColor,
      state = _ref.state,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.cards.backgroundColor
  }, /*#__PURE__*/React.createElement(Fragment, null, title && /*#__PURE__*/React.createElement(SectionHeader, {
    marginBottom: "30px",
    title: title,
    textColor: titleColor || theme.components.cards.titleColor,
    hasLine: hasLine,
    hasLink: hasLine
  }), /*#__PURE__*/React.createElement("div", {
    className: "container candidature-container"
  }, /*#__PURE__*/React.createElement(Slider, {
    useTransform: false,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    arrows: content.length >= slidesToShow,
    initialSlide: 0,
    customPaging: function customPaging(i) {
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "".concat(i + 1, "\xAA Fase")
      }, "\xA0");
    },
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      color: theme.components.cards.arrowColor,
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      color: theme.components.cards.arrowColor,
      darken: true
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }]
  }, content.map(function (card, index) {
    return /*#__PURE__*/React.createElement(ContentContainer, {
      backgroundColor: theme.highContrast.lightBackgroundColor || "inherit",
      position: "relative",
      height: "inherit",
      key: index
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      height: "inherit",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("div", null, card.title && /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      text: card.title,
      size: "mediumSmall",
      fontWeight: "500",
      color: theme.highContrast.text || textColor
    }), /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "20px",
      color: textColor
    }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
      content: card.content,
      activeColor: activeColor || state.activeColor
    }))), card.href !== null && /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "30px"
    }, /*#__PURE__*/React.createElement(Button, {
      as: "a",
      variant: "default",
      className: "card-button",
      display: "inline-flex",
      width: "fit-content",
      textDecoration: "none",
      href: card.href,
      target: card.externalLink ? "_blank" : "_self",
      "native": card.externalLink,
      backgroundColor: theme.highContrast.lightBackgroundColor
    }, card.buttonTitle || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "app.organism.button.knowMore",
      defaultMessage: "saber mais"
    })))));
  })))));
});
var defaults$M = {
  hasLine: false,
  slidesToShow: 3,
  title: null,
  activeColor: null
};
var types$Q = {
  textColor: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  className: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  slidesToShow: PropTypes$1.number,
  content: PropTypes$1.array.isRequired,
  title: PropTypes$1.string,
  activeColor: PropTypes$1.string,
  state: PropTypes$1.object,
  theme: PropTypes$1.object
};
Cards.propTypes = types$Q;
Cards.defaultProps = defaults$M;
var CardsWithStyles = styled(Cards)(_templateObject$1e(), function (props) {
  return props.theme.components.cards.dotsColor;
}, function (props) {
  return props.theme.components.cards.slideBackgroundColor;
});
var index$c = withTheme(CardsWithStyles); //Only used for the Storybook Props Table

function _templateObject$1f() {
  var data = _taggedTemplateLiteral(["\n  // Medium devices (tablets, 768px and up)\n  @media (max-width: 768px) {\n    .hide-sm {\n      display: none;\n    }\n  }\n\n  // Large devices (desktops, 992px and up)\n  @media (max-width: 992px) {\n    .hide-md {\n      display: none;\n    }\n  }\n"]);

  _templateObject$1f = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$J = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(CandidatureCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 hide-sm"
  }, /*#__PURE__*/React.createElement(CandidatureCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg hide-md"
  }, /*#__PURE__*/React.createElement(CandidatureCardLoading, null)))));
};

Loading$J.propTypes = {
  className: PropTypes$1.string
};
var Loading$K = styled(Loading$J)(_templateObject$1f());

function _templateObject$1g() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 40px;\n  img {\n    max-height: 620px;\n  }\n"]);

  _templateObject$1g = function _templateObject() {
    return data;
  };

  return data;
}
var MarkdownContainer = styled.div(_templateObject$1g());
var Article = memo(function Presentation(_ref) {
  var className = _ref.className,
      hasSubTitle = _ref.hasSubTitle,
      hasLine = _ref.hasLine,
      hasBottomSpacing = _ref.hasBottomSpacing,
      data = _ref.data,
      showLangMessage = _ref.showLangMessage,
      lang = _ref.lang,
      activeColor = _ref.activeColor,
      gridClasses = _ref.gridClasses,
      hasContent = _ref.hasContent,
      hasTitleDefault = _ref.hasTitleDefault,
      defaultContent = _ref.defaultContent,
      hasTitle = _ref.hasTitle,
      theme = _ref.theme,
      isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Section, {
    autoFocus: true,
    className: className,
    backgroundColor: theme.components.article.backgroundColor,
    hasBottomSpacing: hasBottomSpacing,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: gridClasses
  }, hasSubTitle && /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "small",
    text: data.subtitle,
    firstLetter: "capitalize",
    fontSize: "14px",
    fontWeight: "400"
  }), !hasContent && showLangMessage && /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "40px"
  }, /*#__PURE__*/React.createElement(Text, {
    color: activeColor
  }, "We are working in the translation of this content to", lang === "pt" ? " Portuguese" : " English", ". The original version of the content is presented below.")), (hasTitle || hasTitleDefault) && /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    fontWeight: "500",
    text: !hasTitle ? defaultContent.title : data.title,
    size: "xLarge",
    firstLetter: "capitalize"
  }), hasLine && /*#__PURE__*/React.createElement(Line, {
    color: "#000",
    marginBottom: "25px"
  }), /*#__PURE__*/React.createElement(MarkdownContainer, null, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: !hasContent ? defaultContent.content : data.content,
    activeColor: activeColor,
    isMobile: isMobile
  })))))));
});
var defaults$N = {
  hasSubTitle: false,
  hasLine: false,
  data: {
    title: null,
    activeColor: null
  },
  hasBottomSpacing: true,
  showLangMessage: false,
  lang: "en"
};
var types$R = {
  data: PropTypes$1.shape({
    title: PropTypes$1.string,
    subtitle: PropTypes$1.string,
    activeColor: PropTypes$1.string,
    content: PropTypes$1.string
  }).isRequired,
  className: PropTypes$1.string,
  hasSubTitle: PropTypes$1.bool,
  hasLine: PropTypes$1.bool,
  hasBottomSpacing: PropTypes$1.bool,
  showLangMessage: PropTypes$1.bool,
  gridClasses: PropTypes$1.string,
  hasContent: PropTypes$1.bool,
  hasTitleDefault: PropTypes$1.bool,
  defaultContent: PropTypes$1.object,
  hasTitle: PropTypes$1.bool,
  theme: PropTypes$1.object,
  isMobile: PropTypes$1.bool,
  activeColor: PropTypes$1.string,
  lang: PropTypes$1.string
};
Article.propTypes = types$R;
Article.defaultProps = defaults$N;
var index$d = withTheme(Article); //Only used for the Storybook Props Table

function _templateObject$1h() {
  var data = _taggedTemplateLiteral(["\n  min-height: 400px;\n"]);

  _templateObject$1h = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$m = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: "#fff",
    position: "absolute"
  }, props));
};

var LoadingCard$b = function LoadingCard() {
  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "155px",
    width: "100%",
    mobileXlWidth: "80%",
    mobileMdWidth: "90%",
    mobileXsWidth: "100%"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "155px"
  }, /*#__PURE__*/React.createElement(Mask$m, {
    height: "20px",
    right: "0",
    width: "70%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "15px",
    top: "20px",
    width: "100%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "5px",
    top: "35px",
    right: "0",
    width: "90%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "25px",
    top: "40px",
    width: "100%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "15px",
    top: "65px",
    right: "0",
    width: "20%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "10px",
    top: "80px",
    width: "100%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "15px",
    top: "90px",
    right: "0",
    width: "20%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "10px",
    top: "105px",
    width: "100%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "15px",
    top: "115px",
    right: "0",
    width: "20%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "10px",
    top: "130px",
    width: "100%"
  }), /*#__PURE__*/React.createElement(Mask$m, {
    height: "15px",
    top: "140px",
    right: "0",
    width: "60%"
  })));
};

var Loading$L = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(LoadingCard$b, null))));
};

Loading$L.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$8 = styled(Loading$L)(_templateObject$1h());

function _templateObject$1i() {
  var data = _taggedTemplateLiteral(["\n  // Medium devices (tablets, 768px and up)\n  @media (max-width: 768px) {\n    .hide-sm {\n      display: none;\n    }\n  }\n\n  // Large devices (desktops, 992px and up)\n  @media (max-width: 992px) {\n    .hide-md {\n      display: none;\n    }\n  }\n"]);

  _templateObject$1i = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$M = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(CandidatureCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 hide-sm"
  }, /*#__PURE__*/React.createElement(CandidatureCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg hide-md"
  }, /*#__PURE__*/React.createElement(CandidatureCardLoading, null)))));
};

Loading$M.propTypes = {
  className: PropTypes$1.string
};
var Loading$N = styled(Loading$M)(_templateObject$1i());

function _templateObject$1j() {
  var data = _taggedTemplateLiteral(["\n  .candidature-container {\n    padding: 0;\n  }\n\n  .slick-next,\n  .slick-prev {\n    height: auto;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  //Cards all same height\n  .slick-track {\n    display: flex;\n  }\n\n  .slick-slide {\n    height: auto;\n    margin: 15px;\n  }\n\n  .slick-slide > div {\n    height: 100%;\n  }\n"]);

  _templateObject$1j = function _templateObject() {
    return data;
  };

  return data;
}
var Candidature = memo(function Candidature(_ref) {
  var textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      hasLine = _ref.hasLine,
      content = _ref.content,
      loading = _ref.loading,
      hasError = _ref.hasError,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.candidature.backgroundColor
  }, loading ? /*#__PURE__*/React.createElement(Loading$N, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, {
    text: "No content to display"
  }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(SectionHeader, {
    marginBottom: "30px",
    title: content.data.title,
    textColor: textColor,
    hasLine: hasLine,
    hasLink: hasLine
  }), /*#__PURE__*/React.createElement("div", {
    className: "container candidature-container"
  }, /*#__PURE__*/React.createElement(Slider, {
    useTransform: false,
    slidesToShow: Object.keys(content.data.list).length >= 3 ? 3 : 2,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    arrows: Object.keys(content.data.list).length >= 3,
    initialSlide: 0,
    customPaging: function customPaging(i) {
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "".concat(i + 1, "\xAA Fase")
      }, "\xA0");
    },
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      color: theme.components.candidature.arrowColor,
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      color: theme.components.candidature.arrowColor,
      darken: true
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }]
  }, content.data.list.map(function (res, index) {
    return /*#__PURE__*/React.createElement(CandidatureCard$1, {
      key: index,
      title: res.title,
      buttonBgColor: backgroundColor
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex flex-column flex-grow-1"
    }, res.contents.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginTop: "20px"
      }, /*#__PURE__*/React.createElement(Text, {
        text: item.info.label,
        size: "article",
        fontWeight: "400"
      }), /*#__PURE__*/React.createElement(Fragment, null, item.type === "link" ? /*#__PURE__*/React.createElement(Link, {
        href: item.info.value,
        "aria-label": item.info.value,
        fontWeight: "300",
        fontSize: "15px",
        textDecoration: "underline",
        color: theme.components.candidature.card.linkColor,
        hoverColor: theme.highContrast.link || backgroundColor || theme.components.candidature.card.linkHoverColor,
        "default": true,
        "native": true
      }, item.info.value) : /*#__PURE__*/React.createElement(InjectHtml$1, {
        content: item.info.value
      })));
    }), res.extras !== null && res.extras.map(function (res, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginTop: "20px"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row no-gutters"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement(Text, {
        text: res.title,
        size: "article",
        fontWeight: "300"
      })), res.contents.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12"
        }, /*#__PURE__*/React.createElement(Text, {
          text: item.info.label,
          size: "article",
          fontWeight: "300"
        })), /*#__PURE__*/React.createElement("div", {
          className: "col-12"
        }, item.type === "link" ? /*#__PURE__*/React.createElement(Link, {
          href: item.info.value,
          "aria-label": item.info.value,
          fontWeight: "300",
          fontSize: "15px",
          textDecoration: "underline",
          color: theme.components.candidature.card.linkColor,
          hoverColor: theme.highContrast.link || backgroundColor || theme.components.candidature.card.linkHoverColor,
          "default": true,
          "native": true
        }, item.info.value) : /*#__PURE__*/React.createElement(InjectHtml$1, {
          content: item.info.value
        })));
      })));
    })), res.button !== null && /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "30px"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "default",
      as: "a",
      display: "flex",
      width: "fit-content",
      textDecoration: "none",
      href: res.button.url,
      backgroundColor: theme.highContrast.lightBackgroundColor
    }, res.button.label)));
  })), (content.data.minimalNumberStudents || content.data.mobility !== null) && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginLeft: "15px"
  }, /*#__PURE__*/React.createElement(InjectHtml$1, {
    content: content.data.minimalNumberStudents,
    variant: "light"
  }), /*#__PURE__*/React.createElement("div", null, content.data.mobility && /*#__PURE__*/React.createElement(Link, {
    href: content.data.mobility.value,
    color: theme.highContrast.link || "#fff",
    fontSize: "15px",
    fontWeight: "400",
    textDecoration: "underline",
    "default": true
  }, content.data.mobility.label))))));
});
var defaults$O = {
  hasLine: false,
  hasError: false
};
var types$S = {
  textColor: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  className: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  content: PropTypes$1.object.isRequired,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  theme: PropTypes$1.object
};
Candidature.propTypes = types$S;
Candidature.defaultProps = defaults$O;
var CandidatureWithStyles = styled(Candidature)(_templateObject$1j(), function (props) {
  return props.theme.components.candidature.dotsColor;
});
var index$e = withTheme(CandidatureWithStyles); //Only used for the Storybook Props Table

function _templateObject$1k() {
  var data = _taggedTemplateLiteral(["\n  min-height: 350px;\n"]);

  _templateObject$1k = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$n = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    position: "absolute"
  }, props));
};

var LoadingCard$c = function LoadingCard(_ref) {
  var theme = _ref.theme;
  var maskColor = theme.loadings.bgColor;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "40px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "40px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "20px",
    right: "0",
    width: "70%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "20px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "5px",
    top: "35px",
    right: "0",
    width: "90%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement(ContentContainer, {
    position: "relative",
    top: "45px",
    height: "90px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "90px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "0",
    right: "0",
    width: "40%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "15px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "25px",
    right: "0",
    width: "40%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "40px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "50px",
    right: "0",
    width: "50%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "65px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "75px",
    right: "0",
    width: "60%",
    backgroundColor: maskColor
  }))));
};

LoadingCard$c.propTypes = {
  theme: PropTypes$1.object
};

var Loading$O = function Loading(_ref2) {
  var className = _ref2.className,
      theme = _ref2.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(LoadingCard$c, {
    theme: theme
  }))));
};

Loading$O.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var LoadingWithStyles$9 = styled(Loading$O)(_templateObject$1k());
var LoadingAvatar = function LoadingAvatar(_ref3) {
  var theme = _ref3.theme;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    position: "relative",
    width: "100%"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    backgroundColor: theme.loadings.iconContainerBgColor,
    height: "155px",
    width: "155px",
    marginBottom: "10px",
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fas fa-image",
    color: theme.loadings.iconColor,
    fontSize: "24px"
  })), /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "0",
    right: "0",
    width: "40%",
    backgroundColor: theme.loadings.bgColor
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "10px"
  }, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(ListItem, {
    marginRight: "5px",
    height: "22px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "22px",
    width: "22px",
    backgroundColor: theme.loadings.iconColor,
    borderRadius: "50%"
  }, "\xA0")), /*#__PURE__*/React.createElement(ListItem, {
    marginRight: "5px",
    height: "22px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "22px",
    width: "22px",
    backgroundColor: theme.loadings.iconColor,
    borderRadius: "50%"
  }, "\xA0")), /*#__PURE__*/React.createElement(ListItem, {
    marginRight: "5px",
    height: "22px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    height: "22px",
    width: "22px",
    backgroundColor: theme.loadings.iconColor,
    borderRadius: "50%"
  }, "\xA0")))));
};
LoadingAvatar.propTypes = {
  theme: PropTypes$1.object
};
var LoadingTable = function LoadingTable(_ref4) {
  var theme = _ref4.theme;
  var maskColor = theme.loadings.bgColor;
  var borderColor = theme.loadings.lightBorderColor;
  var bgColor = theme.loadings.bgColor;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "25px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "0",
    right: "0",
    width: "80%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "1px solid ".concat(borderColor),
    borderBottom: "1px solid ".concat(borderColor)
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "10px solid ".concat(bgColor),
    borderBottom: "10px solid ".concat(bgColor)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "0",
    right: "0",
    width: "40%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "5px",
    top: "15px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "20px",
    right: "0",
    width: "50%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "0",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "10px",
    right: "0",
    width: "60%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "25px",
    width: "100%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "45px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "0",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "10px",
    right: "0",
    width: "15%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "25px",
    width: "100%",
    backgroundColor: maskColor
  }))))))), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "10px solid ".concat(bgColor),
    borderBottom: "10px solid ".concat(bgColor)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "0",
    right: "0",
    width: "40%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "5px",
    top: "15px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "20px",
    right: "0",
    width: "50%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "0",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "10px",
    right: "0",
    width: "60%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "25px",
    width: "100%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "45px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "0",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "10px",
    right: "0",
    width: "15%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "25px",
    width: "100%",
    backgroundColor: maskColor
  }))))))), /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "1px solid ".concat(borderColor),
    borderBottom: "1px solid ".concat(borderColor)
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "10px solid ".concat(bgColor),
    borderBottom: "10px solid ".concat(bgColor)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "0",
    right: "0",
    width: "40%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "5px",
    top: "15px",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "20px",
    right: "0",
    width: "50%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "0",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "10px",
    right: "0",
    width: "60%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "25px",
    width: "100%",
    backgroundColor: maskColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "45px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "35px"
  }, /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "0",
    width: "100%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "15px",
    top: "10px",
    right: "0",
    width: "15%",
    backgroundColor: maskColor
  }), /*#__PURE__*/React.createElement(Mask$n, {
    height: "10px",
    top: "25px",
    width: "100%",
    backgroundColor: maskColor
  }))))))));
};
LoadingTable.propTypes = {
  theme: PropTypes$1.object
};
var Loading$P = withTheme(LoadingWithStyles$9);

function _templateObject$1l() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  p {\n    padding-bottom: ", ";\n  }\n  .profile-item-title {\n    padding-right: ", ";\n  }\n"]);

  _templateObject$1l = function _templateObject() {
    return data;
  };

  return data;
}
var Profile = memo(function Profile(_ref) {
  var hasLine = _ref.hasLine,
      showPhoto = _ref.showPhoto,
      pubsContent = _ref.pubsContent,
      photoContent = _ref.photoContent,
      content = _ref.content,
      isLoadingPublications = _ref.isLoadingPublications,
      isLoadingPerson = _ref.isLoadingPerson,
      hasError = _ref.hasError,
      setShowPhoto = _ref.setShowPhoto,
      lang = _ref.lang,
      theme = _ref.theme,
      activeColor = _ref.activeColor,
      externalContent = _ref.externalContent,
      externalPubsContent = _ref.externalPubsContent;

  var computeIsColumn = function computeIsColumn(item, index) {
    return index > 3 || item.label === "Atribuições funcionais";
  };

  var onRenderTable = function onRenderTable(data) {
    return data.map(function (res, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginBottom: "60px"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "h3",
        text: res.title,
        fontWeight: "400",
        color: theme.highContrast.text || activeColor,
        marginBottom: "5px",
        size: "medium",
        firstLetter: "capitalize"
      }), /*#__PURE__*/React.createElement(TableWithStyles, {
        marginTop: "0",
        col2Size: "30%",
        col3Size: "30%",
        tableRowSpace: "10px",
        lightBorders: true
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, res.headers !== null ? res.headers.map(function (title) {
        return /*#__PURE__*/React.createElement("th", {
          key: title
        }, /*#__PURE__*/React.createElement(Text, {
          fontSize: "14px",
          fontWeight: "400"
        }, title));
      }) : /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Text, {
        fontSize: "14px",
        fontWeight: "400"
      }, "T\xEDtulo")))), /*#__PURE__*/React.createElement("tbody", null, res.type === "list" && res.list.map(function (item, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: index
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
          fontSize: "14px",
          fontWeight: "300",
          color: theme.components.profile.linkColor,
          href: item.extra,
          hoverColor: theme.highContrast.link || activeColor
        }, item.info.value)));
      }), res.type === "table" && res.table.map(function (res, i) {
        return /*#__PURE__*/React.createElement("tr", {
          key: i
        }, res.rows.map(function (item, index) {
          return /*#__PURE__*/React.createElement("td", {
            key: index
          }, item.type === "link" && /*#__PURE__*/React.createElement(Link, {
            fontSize: "14px",
            fontWeight: "300",
            color: theme.components.profile.linkColor,
            href: item.extra,
            hoverColor: theme.highContrast.link || activeColor
          }, item.info.value), item.type === "text" && /*#__PURE__*/React.createElement(Text, {
            fontSize: "14px",
            fontWeight: "300",
            margin: "0 5px 0 0",
            display: "inline-block"
          }, item.info.value), item.type === "date" && /*#__PURE__*/React.createElement(Text, {
            fontSize: "14px",
            fontWeight: "300",
            margin: "0 5px 0 0",
            display: "inline-block"
          }, moment(item.info.value).format("DD/MM/YYYY")));
        }));
      }))));
    });
  };

  if (isLoadingPerson) return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.components.profile.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Loading$P, {
    theme: theme
  })));
  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.components.profile.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "40px"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    size: "xLarge",
    text: content.name,
    marginBottom: "10px",
    lineHeight: "1",
    firstLetter: "capitalize",
    fontWeight: "500"
  }), hasLine && /*#__PURE__*/React.createElement(Line, {
    color: "#000"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0 order-xl-1 order-2"
  }, content.units && content.units.map(function (res) {
    return /*#__PURE__*/React.createElement(ContentContainer, {
      key: res.id,
      marginBottom: "40px"
    }, /*#__PURE__*/React.createElement(SectionHeader, {
      href: res.url,
      tag: "h3",
      fontSize: "18px",
      mobileSmFontSize: "18px",
      mobileXsFontSize: "18px",
      hasContainer: false,
      hasLine: true,
      hasLink: true,
      textColor: theme.highContrast.link || activeColor,
      marginBottom: "15px",
      size: "medium",
      fontWeight: "400"
    }, res.name), res.info.filter(function (item) {
      return item.value && item.value !== "";
    }).map(function (item, index) {
      return /*#__PURE__*/React.createElement(ProfileItem, {
        isColumn: computeIsColumn(item, index),
        key: index
      }, /*#__PURE__*/React.createElement(Text, {
        key: index,
        text: "".concat(item.label, ": "),
        fontWeight: "400",
        size: "small",
        display: "inline-block",
        className: "profile-item-title",
        wordBreak: "initial"
      }), /*#__PURE__*/React.createElement(MarkdownRenderer, {
        content: item.value,
        isInline: true,
        isProfile: true
      }));
    }));
  }), content.biography && /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "40px"
  }, /*#__PURE__*/React.createElement(Text, {
    text: content.biography.label,
    color: theme.highContrast.text || activeColor,
    fontWeight: "400",
    marginBottom: "5px",
    fontSize: "14px",
    as: "h2",
    firstLetter: "capitalize"
  }), /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: content.biography.value
  })), content.extra !== undefined && Object.keys(content.extra).length > 0 && onRenderTable(content.extra), externalContent.loading ? /*#__PURE__*/React.createElement(LoadingTable, {
    theme: theme
  }) : externalContent.data && externalContent.data.length > 0 && onRenderTable(externalContent.data), isLoadingPublications ? /*#__PURE__*/React.createElement(LoadingTable, {
    theme: theme
  }) : pubsContent.publications && pubsContent.publications.length > 0 && pubsContent.publications.filter(function (res) {
    return res.title !== null && res.publications.length > 0;
  }).map(function (res, index) {
    return /*#__PURE__*/React.createElement(ContentContainer, {
      key: index,
      marginBottom: "60px"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      text: res.title,
      fontWeight: "400",
      color: theme.highContrast.text || activeColor,
      marginBottom: "5px",
      size: "medium",
      firstLetter: "capitalize"
    }), /*#__PURE__*/React.createElement(TableWithStyles, {
      marginTop: "0",
      col2Size: "40%",
      col3Size: "45px",
      tableRowSpace: "10px",
      lightBorders: true
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Text, {
      fontSize: "14px",
      fontWeight: "400"
    }, "t\xEDtulo")), /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Text, {
      fontSize: "14px",
      fontWeight: "400"
    }, "autoria")), /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Text, {
      fontSize: "14px",
      fontWeight: "400"
    }, "ano")))), /*#__PURE__*/React.createElement("tbody", null, res.publications.map(function (item, index) {
      return /*#__PURE__*/React.createElement("tr", {
        key: index
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
        fontSize: "14px",
        fontWeight: "300",
        color: theme.components.profile.linkColor,
        href: item.title.value,
        hoverColor: theme.highContrast.link || activeColor,
        target: "_blank",
        "native": true,
        "default": true
      }, item.title.label)), /*#__PURE__*/React.createElement("td", {
        className: "if-has-links"
      }, item.authors.map(function (a, index) {
        if (a.id === null) {
          return /*#__PURE__*/React.createElement(Text, {
            key: index,
            fontSize: "14px",
            fontWeight: "300",
            margin: "0 5px 0 0",
            display: "inline-block"
          }, a.name, "\xA0");
        } else {
          return /*#__PURE__*/React.createElement(Link, {
            key: index //href={`${hasHash}/${lang}/p/${a.id}`}
            ,
            href: "/".concat(lang, "/p/").concat(a.id),
            fontSize: "14px",
            fontWeight: "300",
            color: theme.components.profile.linkColor,
            margin: "0 5px 0 0",
            hoverColor: theme.highContrast.link || activeColor,
            "default": true
          }, a.name);
        }
      })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Text, {
        fontSize: "14px",
        fontWeight: "300"
      }, item.year)));
    }))));
  }), externalPubsContent.loading ? /*#__PURE__*/React.createElement(LoadingTable, {
    theme: theme
  }) : !externalPubsContent.error && externalPubsContent.data && /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "40px"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    text: externalPubsContent.title,
    fontWeight: "400",
    color: theme.highContrast.text || activeColor,
    marginBottom: "5px",
    size: "medium",
    firstLetter: "capitalize"
  }), /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: externalPubsContent.data
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-2 offset-xl-0 col-lg-2 offset-lg-4 col-md-3 col-5 order-xl-2 order-1"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginLeft: "30px",
    mobileLgMarginLeft: "0",
    lgMarginBottom: "40px"
  }, isLoadingPerson ? /*#__PURE__*/React.createElement(LoadingAvatar, {
    theme: theme
  }) : photoContent.image && showPhoto && /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(Image, {
    onError: function onError() {
      return setShowPhoto(false);
    },
    width: "100%",
    src: photoContent.image.src,
    alt: photoContent.name
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "10px",
    marginBottom: "5px"
  }, photoContent.image && photoContent.image.emails && photoContent.image.emails.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Link, {
      text: item,
      href: "mailto:".concat(item),
      target: "_top",
      textDecoration: "underline",
      fontSize: "12px",
      color: theme.components.profile.linkColor,
      fontWeight: "300",
      hoverColor: theme.highContrast.link || activeColor,
      lineHeight: "1.6",
      "default": true,
      "native": true
    }));
  })), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, photoContent.image && photoContent.image.links && photoContent.image.links.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      marginTop: "5px",
      marginRight: "5px",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Link, {
      fontDecoration: "none",
      target: "_blank",
      href: item.url,
      display: "inherit",
      height: "22px",
      width: "22px",
      background: item.hasIcon ? "transparent" : theme.highContrast.link,
      "native": true
    }, item.hasIcon ? /*#__PURE__*/React.createElement(Icon, {
      name: "".concat(item.icon),
      cursor: "pointer",
      color: theme.components.profile.iconColor,
      fontSize: "21px",
      title: item.title,
      darken: true
    }) : /*#__PURE__*/React.createElement(Image, {
      alt: "logo do ORCID",
      height: "21px",
      src: "/icons/".concat(item.icon)
    })));
  })))))))));
});
var types$T = {
  className: PropTypes$1.string,
  subTitle: PropTypes$1.string,
  title: PropTypes$1.string,
  localFetch: PropTypes$1.func.isRequired,
  match: PropTypes$1.object.isRequired,
  history: PropTypes$1.object.isRequired,
  hasLine: PropTypes$1.bool,
  showPhoto: PropTypes$1.bool,
  pubsContent: PropTypes$1.object,
  photoContent: PropTypes$1.object,
  content: PropTypes$1.object,
  externalContent: PropTypes$1.object,
  externalPubsContent: PropTypes$1.object,
  isLoadingPublications: PropTypes$1.bool,
  isLoadingPerson: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  setShowPhoto: PropTypes$1.bool,
  lang: PropTypes$1.string,
  theme: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
var defaults$P = {
  activeColor: "#95CA3D",
  externalContent: {
    loading: false,
    error: false,
    data: []
  },
  externalPubsContent: {
    loading: false,
    error: false,
    title: "",
    data: ""
  }
};
Profile.propTypes = types$T;
Profile.defaultProps = defaults$P;
var ProfileItem = styled.div(_templateObject$1l(), function (props) {
  return props.isColumn ? "column" : "auto";
}, function (props) {
  return props.isColumn ? "inherit" : "0";
}, function (props) {
  return props.theme.spacing.xs3;
});
var index$f = withTheme(Profile); //Only used for the Storybook Props Table

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  height: 28px;\n  width: 28px;\n  &:focus {\n    ", ";\n  }\n  margin-left: ", ";\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n\n  .slick-prev {\n    left: -30px;\n  }\n  .slick-next {\n    right: -30px;\n  }\n  .slick-next,\n  .slick-prev {\n    width: auto;\n    height: 36px;\n    top: calc(50% - 18px);\n  }\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  position: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto;\n  padding: 25px 0;\n  background-color: ", ";\n  @media (max-width: 575.98px) {\n    .container {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n  &.fade-in {\n    -webkit-animation: fade-in 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n    animation: fade-in 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n  }\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  &.fade-out {\n    -webkit-animation: fade-out 0.3s ease-out both;\n    animation: fade-out 0.3s ease-out both;\n  }\n  @keyframes fade-out {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1m() {
  var data = _taggedTemplateLiteral(["\n  body {\n    overflow: hidden;\n  }\n"]);

  _templateObject$1m = function _templateObject() {
    return data;
  };

  return data;
}
var GlobalStyle = createGlobalStyle(_templateObject$1m());
var SectionContainer = styled.section(_templateObject2$c(), function (props) {
  return props.position;
}, function (props) {
  return props.theme.components.gallery.theater.backgroundColor;
});
var SliderContainer = styled.div(_templateObject3$4());
var IconButton = styled.button(_templateObject4$3(), function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.marginLeft;
});

var Theater = function Theater(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      images = _ref.images,
      position = _ref.position,
      onClose = _ref.onClose,
      currentSlide = _ref.currentSlide,
      activeColor = _ref.activeColor,
      isMobile = _ref.isMobile;
  var textColor = theme.components.gallery.theater.textColor;
  var settings = {
    useTransform: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    initialSlide: 0
  };

  var onDownload = function onDownload() {
    if (typeof window !== "undefined") {
      var link = document.createElement("a");
      link.href = images[currentSlide].src;
      link.download = "Download.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(SectionContainer, {
    className: className,
    position: position
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex justify-content-between",
    marginBottom: "15px",
    mobileXsPadding: "0 15px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fal fa-times",
    size: "medium",
    color: textColor
  })), /*#__PURE__*/React.createElement(IconButton, {
    marginLeft: "30px",
    onClick: onDownload
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fal fa-arrow-to-bottom",
    size: "medium",
    color: textColor
  })))), /*#__PURE__*/React.createElement(SliderContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Slider, _extends({}, settings, {
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      tabIndex: "0",
      arrowSize: "medium",
      ariaLabel: "slide anterior",
      color: textColor,
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      tabIndex: "0",
      arrowSize: "medium",
      ariaLabel: "pr\xF3ximo slide",
      color: textColor,
      darken: true
    }),
    responsive: [{
      breakpoint: 575,
      settings: {
        arrows: false
      }
    }],
    initialSlide: currentSlide
  }), images.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
      ratio: "sixteenByNine"
    }, /*#__PURE__*/React.createElement(PictureContainer, {
      backgroundSize: "cover",
      src: item.src,
      alt: item.alt,
      height: "100%"
    })), /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "15px",
      mobileXsPadding: "0 15px"
    }, /*#__PURE__*/React.createElement(Text, {
      color: textColor
    }, /*#__PURE__*/React.createElement(Text, {
      color: textColor,
      as: "span",
      fontWeight: "400"
    }, item.title), " ", /*#__PURE__*/React.createElement(MarkdownRenderer, {
      content: isEmpty$1(item.description) ? "" : item.description,
      activeColor: activeColor,
      isThemeReverse: true,
      isMobile: isMobile
    }))));
  }))))));
};

var defaults$Q = {
  currentSlide: 0,
  position: "fixed",
  images: [{
    src: "https://static.ua.pt/images/ua/placeholder-bw.png",
    alt: "Imagem sem alt",
    title: "Title",
    description: "Text"
  }],
  onClose: function onClose() {
    return null;
  }
};
var types$U = {
  className: PropTypes$1.string,
  currentSlide: PropTypes$1.number,
  title: PropTypes$1.string,
  description: PropTypes$1.string,
  position: PropTypes$1.string,
  onClose: PropTypes$1.func,
  activeColor: PropTypes$1.string,
  isMobile: PropTypes$1.bool
};
Theater.propTypes = types$U;
Theater.defaultProps = defaults$Q;
var Theater$1 = withTheme(Theater); //Only used for the Storybook Props Table

function _templateObject$1n() {
  var data = _taggedTemplateLiteral(["\n  .row {\n    margin-right: -10px;\n    margin-left: -10px;\n  }\n  [class^=\"col-\"] {\n    margin-bottom: 20px;\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n"]);

  _templateObject$1n = function _templateObject() {
    return data;
  };

  return data;
}
var LoadingContainer = styled.div(_templateObject$1n());

var Card = function Card() {
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-6"
  }, /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
    ratio: "treeByTwo"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "20px",
    width: "80%"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "20px"
  })));
};

var Loading$Q = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(LoadingContainer, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Card, null), /*#__PURE__*/React.createElement(Card, null), /*#__PURE__*/React.createElement(Card, null), /*#__PURE__*/React.createElement(Card, null), /*#__PURE__*/React.createElement(Card, null), /*#__PURE__*/React.createElement(Card, null))));
};

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  [class^=\"col-\"] {\n    margin-bottom: 30px;\n    &:nth-last-of-type(-n + 2) {\n      margin-bottom: 0;\n    }\n  }\n  img {\n    object-fit: initial;\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    margin: auto;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n      text-decoration: none;\n      &:focus {\n        ", ";\n      }\n    "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n      cursor: pointer;\n      border: none;\n      background-color: transparent;\n      text-align: left;\n      &:focus {\n        ", ";\n      }\n    "]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  display: -ms-grid;\n  display: grid;\n  align-items: start;\n  -ms-grid-columns: (1fr) [ ", "];\n  grid-template-columns: repeat(", ", 1fr);\n  @media (max-width: 767.98px) {\n    -ms-grid-columns: (1fr) [2];\n    grid-template-columns: repeat(2, 1fr);\n  }\n  -ms-grid-rows: auto;\n  grid-template-rows: auto;\n  grid-gap: ", ";\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1o() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: 768px) {\n    width: 50%;\n  }\n  margin-bottom: 30px;\n"]);

  _templateObject$1o = function _templateObject() {
    return data;
  };

  return data;
}
var DescriptionContainer = styled.div(_templateObject$1o());
var GridContainer = styled.div(_templateObject2$d(), function (props) {
  return props.columns || 1;
}, function (props) {
  return props.columns || 1;
}, function (props) {
  return props.gridGap + "px" || "30px";
});
var ImageContainer$2 = styled.div(_templateObject3$5(), function (props) {
  return props.as === "button" && css(_templateObject4$4(), function (props) {
    return props.theme.mixins.focus;
  });
}, function (props) {
  return props.as === "a" && css(_templateObject5$2(), function (props) {
    return props.theme.mixins.focus;
  });
});
var FallbackContainer = styled.div(_templateObject6());

var Gallery = function Gallery(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      title = _ref.title,
      description = _ref.description,
      hasDescription = _ref.hasDescription,
      images = _ref.images,
      hasLink = _ref.hasLink,
      href = _ref.href,
      columns = _ref.columns,
      hasTheater = _ref.hasTheater,
      isLoading = _ref.isLoading,
      activeColor = _ref.activeColor,
      isMobile = _ref.isMobile;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      fadeIn = _useState4[0],
      setFadeIn = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentSlide = _useState6[0],
      setCurrentSlide = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      supportsGrid = _useState8[0],
      setSupportsGrid = _useState8[1];

  var onOpenTheater = function onOpenTheater(hasTheater, currentSlide) {
    setCurrentSlide(currentSlide);
    setFadeIn(true);
    setOpen(hasTheater);
  };

  var onCloseTheater = function onCloseTheater() {
    setFadeIn(false);
    setTimeout(function () {
      setOpen(false);
    }, 300);
  };

  useEffect(function () {
    var el = document.createElement("div");
    var supportsGrid = typeof el.style.grid === "string";
    setSupportsGrid(supportsGrid);
  }, []);
  return /*#__PURE__*/React.createElement(Section, {
    className: className
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    textColor: hasLink ? theme.highContrast.link : theme.components.gallery.titleColor,
    hasLink: hasLink,
    hasLine: hasLink,
    hasContainer: true,
    href: href
  }, title), !isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, hasDescription && /*#__PURE__*/React.createElement(DescriptionContainer, null, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: description,
    activeColor: activeColor,
    isMobile: isMobile
  })), supportsGrid ? /*#__PURE__*/React.createElement(GridContainer, {
    columns: columns,
    gridGap: 20
  }, images.map(function (item, i) {
    return /*#__PURE__*/React.createElement(ImageContainer$2, {
      key: i,
      as: !item.hasLink && hasTheater ? "button" : item.hasLink ? "a" : "div",
      onClick: function onClick() {
        return onOpenTheater(!item.hasLink && hasTheater, i);
      },
      href: item.href
    }, /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
      ratio: "treeByTwo"
    }, /*#__PURE__*/React.createElement(PictureContainer, {
      backgroundSize: "contain",
      src: item.src,
      alt: item.alt,
      height: "100%"
    })), item.hasTitle && /*#__PURE__*/React.createElement(Text, {
      marginTop: "20px",
      size: "article"
    }, item.title));
  })) : /*#__PURE__*/React.createElement(FallbackContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, images.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-6",
      key: i
    }, /*#__PURE__*/React.createElement(ImageContainer$2, {
      as: !item.hasLink && hasTheater ? "button" : item.hasLink ? "a" : "div",
      onClick: function onClick() {
        return onOpenTheater(!item.hasLink && hasTheater, i);
      },
      href: item.href
    }, /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
      ratio: "treeByTwo"
    }, /*#__PURE__*/React.createElement(PictureContainer, {
      backgroundSize: "contain",
      src: item.src,
      alt: item.alt,
      height: "100%"
    })), item.hasTitle && /*#__PURE__*/React.createElement(Text, {
      marginTop: "20px",
      size: "article"
    }, item.title)));
  })))) : /*#__PURE__*/React.createElement(Loading$Q, null), hasTheater && isOpen && /*#__PURE__*/React.createElement(Theater$1, {
    className: fadeIn ? "fade-in" : "fade-out",
    onClose: onCloseTheater,
    images: images,
    currentSlide: currentSlide
  }));
};

var defaults$R = {
  href: "#",
  hasTheater: false,
  hasLink: false,
  title: "Title",
  description: "Text",
  hasDescription: false,
  columns: 4,
  images: [{
    src: "https://static.ua.pt/images/ua/placeholder-bw.png",
    alt: "Imagem sem alt",
    hasTitle: false,
    imageTitle: "Title"
  }],
  isLoading: false,
  activeColor: null,
  isMobile: false
};
var types$V = {
  href: PropTypes$1.string,
  className: PropTypes$1.string,
  columns: PropTypes$1.number,
  title: PropTypes$1.string,
  description: PropTypes$1.string,
  hasDescription: PropTypes$1.bool,
  hasTheater: PropTypes$1.bool,
  imageTitle: PropTypes$1.string,
  images: PropTypes$1.array,
  hasLink: PropTypes$1.bool,
  isLoading: PropTypes$1.bool,
  activeColor: PropTypes$1.string,
  isMobile: PropTypes$1.bool,
  theme: PropTypes$1.object
};
Gallery.propTypes = types$V;
Gallery.defaultProps = defaults$R;
var index$g = withTheme(Gallery); //Only used for the Storybook Props Table

function _templateObject$1p() {
  var data = _taggedTemplateLiteral(["\n  .about-container {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .slick-prev {\n    left: -25px;\n  }\n  .slick-next {\n    right: -25px;\n  }\n  .slick-next,\n  .slick-prev {\n    width: auto;\n    height: 36px;\n    top: 96px;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n"]);

  _templateObject$1p = function _templateObject() {
    return data;
  };

  return data;
}

var Testimonials = function Testimonials(_ref) {
  var className = _ref.className,
      title = _ref.title,
      textColor = _ref.textColor,
      data = _ref.data,
      showHeader = _ref.showHeader,
      titleProps = _ref.titleProps,
      backgroundColor = _ref.backgroundColor,
      theme = _ref.theme,
      isEditor = _ref.isEditor;
  var sliderRef = useRef(null);

  var onHandleTabNavigation = function onHandleTabNavigation(e) {
    if (e.key === "Tab" && e.shiftKey) {
      sliderRef.current.slickPrev();
    }

    if (e.key === "Tab") {
      sliderRef.current.slickNext();
    }
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.about.backgroundColor
  }, showHeader ? /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.highContrast.text || textColor
  }, titleProps), title) : null, /*#__PURE__*/React.createElement("div", {
    className: "container testimonials-container p-0"
  }, /*#__PURE__*/React.createElement(Slider, {
    ref: sliderRef,
    tabIndex: -1,
    useTransform: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    initialSlide: 0,
    customPaging: function customPaging(i) {
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "Testemunho ".concat(i + 1)
      }, "\xA0");
    },
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "slide anterior",
      color: theme.components.about.arrowColor,
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "pr\xF3ximo slide",
      color: theme.components.about.arrowColor,
      darken: true
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }]
  }, data.length > 0 && data.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "content col-sm-12 col-xs-12 ",
      key: index
    }, /*#__PURE__*/React.createElement(StudentCardLink$1, {
      text: item.text,
      src: item.person.image,
      alt: item.person.alt,
      name: item.person.name,
      about: item.person.about,
      imageBgColor: item.backgroundColor,
      onKeyDown: onHandleTabNavigation,
      href: item.cardUrl,
      isEditor: isEditor
    }));
  }))));
};

var defaults$S = {
  title: "Title",
  showHeader: true,
  data: [],
  isEditor: false
};
var types$W = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  textColor: PropTypes$1.string,
  showHeader: PropTypes$1.bool,
  theme: PropTypes$1.object,
  titleProps: PropTypes$1.object,
  data: PropTypes$1.oneOfType([PropTypes$1.array, PropTypes$1.object]),
  backgroundColor: PropTypes$1.string,
  isEditor: PropTypes$1.bool
};
Testimonials.propTypes = types$W;
Testimonials.defaultProps = defaults$S;
var TestimonialsWithStyles = styled(Testimonials)(_templateObject$1p(), function (props) {
  return props.theme.components.reactSlickSlider.buttonBgColor;
});
var index$h = withTheme(TestimonialsWithStyles); //Only used for the Storybook Props Table

var Selects = function Selects(_ref) {
  var theme = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "94px",
    marginBottom: "54px",
    marginTop: "70px",
    className: "justify-content-between",
    mobileXsHeight: "auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters justify-content-between "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col col-xl-4 col-lg-3 col-md-3 col-sm-4 col-7 "
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "80%",
    mobileXsMarginBottom: "30px",
    marginBottom: "10px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "40px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 col-lg-12 col-md-12 col-sm-12  no-gutters mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-6 col-sm-6  col-12 d-inline-block"
  }, /*#__PURE__*/React.createElement(SelectLoading, theme)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-6 col-sm-6  col-12 d-inline-block"
  }, /*#__PURE__*/React.createElement(SelectLoading, theme))))));
};

var Card$1 = function Card(_ref2) {
  var borderBottom = _ref2.borderBottom,
      theme = _objectWithoutProperties(_ref2, ["borderBottom"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "1px solid ".concat(theme.loadings.lightBorderColor),
    borderBottom: borderBottom,
    padding: "20px 0",
    height: "140px"
  }, /*#__PURE__*/React.createElement(LoadingWithStyles$2, {
    fullSize: false
  }));
};

Card$1.propTypes = {
  borderBottom: PropTypes$1.string
};

var Loading$R = function Loading(_ref3) {
  var className = _ref3.className,
      theme = _ref3.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col mb-5"
  }, /*#__PURE__*/React.createElement(Selects, theme), /*#__PURE__*/React.createElement(ContentContainer, {
    width: "100px",
    marginBottom: "33px",
    marginTop: "50px"
  })), /*#__PURE__*/React.createElement("div", {
    className: " col-xl-12  col-lg-12 col"
  }, /*#__PURE__*/React.createElement(Card$1, theme), /*#__PURE__*/React.createElement(Card$1, theme), /*#__PURE__*/React.createElement(Card$1, theme), /*#__PURE__*/React.createElement(Card$1, theme), /*#__PURE__*/React.createElement(Card$1, _extends({}, theme, {
    borderBottom: "1px solid ".concat(theme.loadings.lightBorderColor)
  }))))))));
};

Loading$R.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var Loading$S = withTheme(Loading$R);

function _templateObject2$e() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1q() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"]);

  _templateObject$1q = function _templateObject() {
    return data;
  };

  return data;
}
var InjectHtmlRow = styled.div(_templateObject$1q());
var Card$2 = memo(function Card(_ref) {
  var data = _ref.data,
      session = _ref.session,
      highlightColor = _ref.highlightColor,
      theme = _ref.theme,
      lang = _ref.lang;
  var buttonProps = {
    hoverColor: "#fff",
    color: highlightColor,
    hoverBackgroundColor: highlightColor,
    focusColor: "#fff",
    focusBackgroundColor: lighten(0.1, highlightColor),
    border: "1px solid ".concat(highlightColor)
  };
  moment.locale("".concat(lang));
  var isEmpty = (!data || data.length === 0) && !(session === null || session === void 0 ? void 0 : session.registrationLink) && !(session === null || session === void 0 ? void 0 : session.startDate);
  if (isEmpty) return /*#__PURE__*/React.createElement(ErrorWithStyles, {
    text: lang === "pt" ? "Sem Conteúdo" : "No Content",
    className: "col",
    minHeight: "100px"
  });
  return /*#__PURE__*/React.createElement(BorderedCardWithStyles, {
    borderColor: theme.components.xperimenta.card.borderColor,
    contentContainerPadding: "0",
    cardIsLink: false
  }, (data === null || data === void 0 ? void 0 : data.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, data.map(function (item, index) {
    var _item$label;

    var isLastChild = (data === null || data === void 0 ? void 0 : data.length) === index + 1;
    return /*#__PURE__*/React.createElement(InjectHtmlRow, {
      key: index,
      className: isLastChild ? "col-sm col-12" : "col"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "article",
      color: theme.components.xperimenta.card.subTitle,
      marginTop: "8px"
    }, item.value), /*#__PURE__*/React.createElement(InjectHtml$1, {
      content: ((_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.length) ? item.label : lang === "pt" ? "Sem informação" : "No information"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, (session === null || session === void 0 ? void 0 : session.startDate) && /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-4 col-md-4 col-lg-4 col-xl-4"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: theme.components.xperimenta.sessionDateAndTimeColor,
    lineHeight: "1.3"
  }, lang === "pt" ? "Esclarece as tuas dúvidas" : "Get the answers to your questions"), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: theme.components.xperimenta.sessionDateAndTimeColor,
    fontWeight: "400",
    lineHeight: "1.3"
  }, moment(session.startDate).format("DD MMM, ").toLowerCase(), moment(session.startDate).format("HH:mm") + ((session === null || session === void 0 ? void 0 : session.endDate) ? "-".concat(moment(session.endDate).format("HH:mm")) : ""))), (session === null || session === void 0 ? void 0 : session.registrationLink) && /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("a", {
    href: session === null || session === void 0 ? void 0 : session.registrationLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    variant: "default",
    title: "inscri\xE7\xE3o"
  }, buttonProps), lang === "pt" ? "inscrição" : "registration")))));
});

var Accordion$2 = function Accordion(_ref2) {
  var section = _ref2.section,
      item = _ref2.item,
      sessions = _ref2.sessions,
      theme = _ref2.theme,
      lang = _ref2.lang;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/React.createElement(Accordion$1, {
    onChange: function onChange() {
      return setOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement(AccordionItem, null, /*#__PURE__*/React.createElement(AccordionItemTitle, null, /*#__PURE__*/React.createElement(AccordionHeaderWithStyles, null, section.title), /*#__PURE__*/React.createElement(AccordionTitleWithStyles, {
    isOpen: isOpen,
    theme: theme,
    url: "/".concat(lang, "/").concat(lang === "pt" ? "curso" : "course", "/").concat(item.id)
  }, item.name)), /*#__PURE__*/React.createElement(AccordionItemBody, null, /*#__PURE__*/React.createElement(Card$2, {
    key: item.id,
    theme: theme,
    data: item.list,
    session: sessions.length > 0 && sessions.find(function (session) {
      return item.id === (session === null || session === void 0 ? void 0 : session.id);
    }),
    highlightColor: theme.components.xperimenta.sessionColor,
    lang: lang
  }))));
};

var Xperimenta = function Xperimenta(_ref3) {
  var className = _ref3.className,
      isLoading = _ref3.isLoading,
      hasError = _ref3.hasError,
      data = _ref3.data,
      sessions = _ref3.sessions,
      theme = _ref3.theme,
      buttons = _ref3.buttons,
      defaultValues = _ref3.defaultValues,
      filters = _ref3.filters,
      onChangeFilter = _ref3.onChangeFilter,
      lang = _ref3.lang,
      title = _ref3.title;
  var hasList = data.find(function (degree) {
    return degree.list.length > 0;
  });
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    hasHighContrastBorderTop: false
  }, isLoading ? /*#__PURE__*/React.createElement(Loading$S, {
    theme: theme
  }) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters "
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 offset-lg-4 offset-md-0 col-xl-7 col-lg-8 col-md-12 col "
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-10 col-lg-10 col-md-10 col-sm-10"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xLarge",
    fontWeight: "500",
    mobileXsMarginBottom: "40px",
    marginBottom: "40px"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-6 col-sm-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    paddingRight: "12px",
    mobileXsPaddingRight: "0px",
    mobileSmPaddingRight: "12px",
    mobileMdPaddingRight: "12px"
  }, buttons.map(function (btn, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Select, {
      variant: "black",
      options: btn.options,
      placeholder: btn.title,
      label: btn.title,
      closeMenuOnSelect: false,
      isMulti: true,
      valueContainer: true,
      hasMultiCustomStyles: true,
      isSearchable: false,
      defaultValue: defaultValues.degree,
      onChange: function onChange(action, option) {
        return onChangeFilter(option.option || option.removedValue, btn.jsonField);
      }
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-md-6 col-sm-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    paddingLeft: "12px",
    mobileXsPaddingLeft: "0px",
    mobileSmPaddingLeft: "12px",
    mobileMdPaddingLeft: "12px"
  }, filters.map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "row no-gutters mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0 mt-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement(Select, {
      variant: "black",
      defaultValue: defaultValues.knowledgeAreas,
      options: res.options,
      placeholder: res.title,
      label: res.title,
      isMulti: true,
      valueContainer: true,
      hasMultiCustomStyles: true,
      isClearable: true,
      closeMenuOnSelect: false,
      onChange: function onChange(action, option) {
        return onChangeFilter(option.option || option.removedValue, res.jsonField);
      }
    })));
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col mt-5"
  }, !hasList ? /*#__PURE__*/React.createElement(ErrorWithStyles, {
    text: lang === "pt" ? "Sem Conteúdo" : "No Content",
    className: "offset-xl-3 offset-lg-4 offset-md-0 col-xl-7 col-lg-8 col-md-12 col ",
    minHeight: "100px"
  }) : data.filter(function (opt) {
    var _opt$list;

    return (opt === null || opt === void 0 ? void 0 : (_opt$list = opt.list) === null || _opt$list === void 0 ? void 0 : _opt$list.length) > 0;
  }).map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section.title
    }, section.list.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        className: "row no-gutters",
        key: item.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-3 offset-lg-4 offset-md-0 col-xl-7 col-lg-8 col-md-12 col"
      }, /*#__PURE__*/React.createElement(Accordion$2, {
        section: section,
        item: item,
        sessions: sessions,
        theme: theme,
        lang: lang,
        title: title
      })));
    }));
  }))))));
};

Xperimenta.defaultProps = {
  title: "Cursos",
  className: "",
  isLoading: false,
  hasError: false,
  defaultValues: {
    degree: "",
    knowledgeAreas: ""
  },
  buttons: [],
  filters: [],
  data: [],
  sessions: []
};
var sessionType = PropTypes$1.shape({
  id: PropTypes$1.number,
  registrationLink: PropTypes$1.string,
  startDate: PropTypes$1.string,
  endDate: PropTypes$1.string
});
var types$X = {
  title: PropTypes$1.string,
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  isLoading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  data: PropTypes$1.arrayOf(PropTypes$1.shape({
    list: PropTypes$1.arrayOf(PropTypes$1.shape({
      label: PropTypes$1.string,
      value: PropTypes$1.string
    })),
    title: PropTypes$1.string,
    titlePlural: PropTypes$1.string,
    type: PropTypes$1.number
  })),
  sessions: PropTypes$1.arrayOf(sessionType),
  buttons: PropTypes$1.arrayOf(PropTypes$1.shape({
    jsonField: PropTypes$1.string,
    options: PropTypes$1.arrayOf(PropTypes$1.shape({
      label: PropTypes$1.string,
      value: PropTypes$1.string
    })),
    order: PropTypes$1.number,
    title: PropTypes$1.string
  })),
  defaultValues: PropTypes$1.shape({
    degree: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.shape({
      label: PropTypes$1.string,
      value: PropTypes$1.string
    }))]),
    knowledgeAreas: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.shape({
      label: PropTypes$1.string,
      value: PropTypes$1.string
    }))])
  }),
  filters: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    options: PropTypes$1.arrayOf(PropTypes$1.shape({
      label: PropTypes$1.string,
      value: PropTypes$1.string
    })),
    jsonField: PropTypes$1.string,
    order: PropTypes$1.number
  })),
  onChangeFilter: PropTypes$1.func,
  lang: PropTypes$1.string
};
Card$2.propTypes = {
  title: PropTypes$1.string,
  data: PropTypes$1.array,
  theme: PropTypes$1.object,
  url: PropTypes$1.string,
  sectionTitle: PropTypes$1.string,
  session: sessionType,
  highlightColor: PropTypes$1.string,
  lang: PropTypes$1.string
};
Accordion$2.propTypes = {
  section: PropTypes$1.object,
  item: PropTypes$1.object,
  sessions: PropTypes$1.arrayOf(sessionType),
  theme: PropTypes$1.object,
  lang: PropTypes$1.string
};
Xperimenta.propTypes = types$X;
var XperimentaWithStyles = styled(Xperimenta)(_templateObject2$e());
var index$i = compose(withTheme)(XperimentaWithStyles); //Only used for the Storybook Props Table

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  button {\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n    height: 100%;\n    width: 75px;\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1r() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", ";\n  background-color: ", ";\n\n  ", "\n"]);

  _templateObject$1r = function _templateObject() {
    return data;
  };

  return data;
}

var AlertBar = function AlertBar(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      hasAction = _ref.hasAction,
      props = _objectWithoutProperties(_ref, ["children", "isOpen", "onClose", "hasAction"]);

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = function handleClick() {
    setOpen(false);
    onClose();
  };

  if (open) return /*#__PURE__*/React.createElement(Bar, props, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Bar.Message, {
    className: "col"
  }, children), hasAction && /*#__PURE__*/React.createElement(Bar.Action, {
    className: "col-auto",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("button", null, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times"
  }))))));
  return null;
};

var Bar = styled.div(_templateObject$1r(), function (props) {
  return props.theme.spacing.xs;
}, function (props) {
  return props.backgroundColor ? props.backgroundColor : props.theme.colors.green;
}, function (props) {
  return !props.noAnimation && " animation: slide-in 1s ease-in-out;\n\n@keyframes slide-in {\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n}";
});
Bar.Message = styled.div(_templateObject2$f());
Bar.Action = styled.div(_templateObject3$6());
AlertBar.propTypes = {
  children: PropTypes$1.node.isRequired,
  isOpen: PropTypes$1.bool,
  onClose: PropTypes$1.func,
  hasAction: PropTypes$1.bool
};
AlertBar.defaultProps = {
  isOpen: true,
  onClose: function onClose() {
    return null;
  },
  noAnimation: false,
  hasAction: true
};

var Facts = function Facts(_ref) {
  var className = _ref.className,
      resource = _ref.resource,
      backgroundColor = _ref.backgroundColor,
      source = _ref.source,
      text = _ref.text,
      titleStyles = _ref.titleStyles,
      title = _ref.title,
      hasSource = _ref.hasSource,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor,
    paddingTop: "107px",
    paddingBottom: "107px",
    className: className
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(TitleWithStyles, {
    text: "Cita\xE7\xE3o"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, _extends({
    tabIndex: 0,
    fontFamily: "'Miller Display', 'Playfair Display', 'Georgia', serif"
  }, titleStyles, {
    lineHeight: "1.6",
    color: theme.highContrast.text || titleStyles.color
  }), resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: title
  }) : title))), hasSource && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "65px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    tabIndex: 0,
    text: source,
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "5px"
  }), /*#__PURE__*/React.createElement(Text, {
    tabIndex: 0,
    text: text,
    textTransform: "uppercase",
    fontSize: "16px",
    lineHeight: "1.6"
  }))))));
};

Facts.defaultProps = {
  text: "Text",
  source: "Source",
  title: "Content",
  hasSource: true
};
Facts.propTypes = {
  text: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  source: PropTypes$1.string,
  titleStyles: PropTypes$1.object,
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  resource: PropTypes$1.string,
  hasSource: PropTypes$1.bool,
  theme: PropTypes$1.object
};
var index$j = withTheme(Facts);

function _templateObject$1s() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    font-size: ", ";\n  }\n"]);

  _templateObject$1s = function _templateObject() {
    return data;
  };

  return data;
}

var OneFact = function OneFact(_ref) {
  var data = _ref.data,
      backgroundColor = _ref.backgroundColor,
      isThemeReverse = _ref.isThemeReverse,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.oneFact.backgroundColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, data.map(function (columnContent, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xl col-lg col-md-12",
      key: index
    }, index === 0 ? /*#__PURE__*/React.createElement(Number$1, {
      isThemeReverse: isThemeReverse,
      numberMobileSmFontSize: "80px"
    }, columnContent) : /*#__PURE__*/React.createElement(Text, {
      fontSize: "20px",
      mobileSmFontSize: "16px",
      lineHeight: "1.8",
      isThemeReverse: isThemeReverse,
      isSerif: true
    }, columnContent));
  }))));
};

var Number$1 = styled.div(_templateObject$1s(), function (props) {
  return props.theme.type.serif;
}, function (props) {
  return props.theme.sizes.xll;
}, function (props) {
  return props.theme.highContrast.text || props.isThemeReverse ? props.theme.components.text.colorReverse : props.textColor || props.theme.components.text.color;
}, function (props) {
  return props.numberMobileSmFontSize;
});
OneFact.defaultProps = {
  hasLine: false,
  data: [],
  isThemeReverse: false
};
OneFact.propTypes = {
  backgroundColor: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  data: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  isThemeReverse: PropTypes$1.bool,
  numberMobileSmFontSize: PropTypes$1.string,
  theme: PropTypes$1.object
};
var OneFact$1 = withTheme(OneFact);

function _templateObject$1t() {
  var data = _taggedTemplateLiteral(["\n  .about-container {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .slick-prev {\n    left: -25px;\n  }\n  .slick-next {\n    right: -25px;\n  }\n  .slick-next,\n  .slick-prev {\n    width: auto;\n    height: 36px;\n    top: 96px;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n"]);

  _templateObject$1t = function _templateObject() {
    return data;
  };

  return data;
}

var About = function About(_ref) {
  var className = _ref.className,
      title = _ref.title,
      textColor = _ref.textColor,
      data = _ref.data,
      showHeader = _ref.showHeader,
      titleProps = _ref.titleProps,
      backgroundColor = _ref.backgroundColor,
      theme = _ref.theme;
  var sliderRef = useRef(null);

  var onHandleTabNavigation = function onHandleTabNavigation(e) {
    if (e.key === "Tab" && e.shiftKey) {
      sliderRef.current.slickPrev();
    }

    if (e.key === "Tab") {
      sliderRef.current.slickNext();
    }
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.about.backgroundColor
  }, showHeader ? /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.highContrast.text || textColor
  }, titleProps), title) : null, /*#__PURE__*/React.createElement("div", {
    className: "container about-container"
  }, /*#__PURE__*/React.createElement(Slider, {
    ref: sliderRef,
    tabIndex: -1,
    useTransform: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    initialSlide: 0,
    customPaging: function customPaging(i) {
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "Aluno ".concat(i + 1)
      }, "\xA0");
    },
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "slide anterior",
      color: theme.components.about.arrowColor,
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "pr\xF3ximo slide",
      color: theme.components.about.arrowColor,
      darken: true
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }]
  }, data.length > 0 && data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(StudentCard$1, {
      key: index,
      text: item.text,
      src: item.person.image,
      alt: item.person.alt,
      name: item.person.name,
      about: item.person.about,
      imageBgColor: item.backgroundColor,
      onKeyDown: onHandleTabNavigation
    });
  }))));
};

var defaults$T = {
  title: "Title",
  showHeader: true,
  data: []
};
var types$Y = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  textColor: PropTypes$1.string,
  showHeader: PropTypes$1.bool,
  theme: PropTypes$1.object,
  titleProps: PropTypes$1.object,
  data: PropTypes$1.oneOfType([PropTypes$1.array, PropTypes$1.object]),
  backgroundColor: PropTypes$1.string
};
About.propTypes = types$Y;
About.defaultProps = defaults$T;
var AboutWithStyles = styled(About)(_templateObject$1t(), function (props) {
  return props.theme.components.reactSlickSlider.buttonBgColor;
});
var index$k = withTheme(AboutWithStyles); //Only used for the Storybook Props Table

function _templateObject$1u() {
  var data = _taggedTemplateLiteral(["\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .campus-items {\n      display: none;\n    }\n  }\n"]);

  _templateObject$1u = function _templateObject() {
    return data;
  };

  return data;
}

var Campus = function Campus(_ref) {
  var className = _ref.className,
      textColor = _ref.textColor,
      title = _ref.title,
      resource = _ref.resource,
      showHeader = _ref.showHeader,
      size = _ref.size,
      titleProps = _ref.titleProps,
      showPlusButton = _ref.showPlusButton,
      isMarkdown = _ref.isMarkdown,
      contentMaxHeight = _ref.contentMaxHeight,
      height = _ref.height,
      data = _ref.data,
      theme = _ref.theme,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage; // doing this logic within a string literal
  // for example: `${position === 'right' ? '-30px' : null}`
  // would result in right="null" (null becoming a string)
  // now null isnt converted to a string and only the necessary prop is added


  var computedPlusButtonPosition = function computedPlusButtonPosition(position) {
    return {
      right: position === "right" ? "-30px" : null,
      left: position === "right" ? null : "-30px"
    };
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    paddingTop: "".concat(showHeader ? "70px" : "0"),
    paddingBottom: "".concat(showHeader ? "0" : "0"),
    mdPaddingTop: "0",
    backgroundColor: theme.highContrast.backgroundColor
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(TitleWithStyles, {
    text: "\xC1reas"
  })), showHeader ? /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.highContrast.text || textColor,
    marginBottom: "50px"
  }, titleProps), resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: title
  }) : title) : null, data.map(function (_ref2, index) {
    var _ref2$backgroundPosit = _ref2.backgroundPosition,
        backgroundPosition = _ref2$backgroundPosit === void 0 ? "center 40%" : _ref2$backgroundPosit,
        item = _objectWithoutProperties(_ref2, ["backgroundPosition"]);

    var changeBg = index % 2 === 0 ? theme.highContrast.lightBackgroundColor : theme.highContrast.backgroundColor;
    var backgroundColor = changeBg || item.backgroundColor;
    return /*#__PURE__*/React.createElement(ContentContainer, {
      key: index,
      backgroundColor: backgroundColor,
      height: item.height || height,
      overflow: "hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row no-gutters align-items-center h-100"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-".concat(item.col[0], " col-lg-").concat(item.col[0], " col-md-").concat(item.col[0], " col-sm-6 col-6 ").concat(item.position === "right" ? "order-1" : null)
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      marginLeft: "".concat(item.position === "right" ? "70px" : "".concat((size.width - 1140) / 2 + 15, "px")),
      mobileLgMarginLeft: "".concat(item.position === "right" ? "50px" : "".concat((size.width - 960) / 2 + 15, "px")),
      mobileMdMarginLeft: "".concat(item.position === "right" ? "50px" : "".concat((size.width - 720) / 2 + 15, "px")),
      mobileSmMarginLeft: "".concat(item.position === "right" ? "30px" : "".concat((size.width - 540) / 2 + 15, "px")),
      mobileXsMarginLeft: "".concat(item.position === "right" ? "30px" : "15px"),
      overflow: "hidden",
      marginRight: "".concat(item.position !== "right" ? "70px" : "".concat((size.width - 1140) / 2 + 15, "px")),
      mobileLgMarginRight: "".concat(item.position !== "right" ? "50px" : "".concat((size.width - 960) / 2 + 15, "px")),
      mobileMdMarginRight: "".concat(item.position !== "right" ? "50px" : "".concat((size.width - 720) / 2 + 15, "px")),
      mobileSmMarginRight: "".concat(item.position !== "right" ? "30px" : "".concat((size.width - 540) / 2 + 15, "px")),
      mobileXsMarginRight: "".concat(item.position !== "right" ? "30px" : "15px"),
      position: "relative",
      zIndex: "2"
    }, /*#__PURE__*/React.createElement(SectionHeader, {
      "aria-label": item.text,
      tag: "h3",
      fontSize: "28px",
      textColor: theme.highContrast.link || item.textColor,
      href: item.href,
      mobileSmFontSize: "26px",
      mobileXsFontSize: "20px",
      hasContainer: false,
      marginBottom: "0px",
      outlineOffset: "-2px",
      externalLink: item.externalLink
    }, item.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: item.resource,
      defaultMessage: item.text
    }) : item.text), /*#__PURE__*/React.createElement("div", {
      className: "campus-items"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "15px",
      maxHeight: contentMaxHeight,
      overflow: "hidden"
    }, item.hasText ? isMarkdown ? /*#__PURE__*/React.createElement(MarkdownRenderer, {
      content: item.description,
      activeColor: activeColor
    }) : /*#__PURE__*/React.createElement(Text, {
      lineHeight: "1.6",
      size: "article",
      fontWeight: "300",
      text: theme.highContrast.text || item.description
    }) : /*#__PURE__*/React.createElement(VerticalList, null, item.list.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ListItem, {
        marginBottom: "5px",
        key: index
      }, /*#__PURE__*/React.createElement(Link, {
        cursor: "pointer",
        fontSize: "18px",
        color: theme.highContrast.link || item.color,
        "aria-label": item.text,
        href: item.href,
        outlineOffset: "-2px"
      }, item.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
        id: item.resource,
        defaultMessage: item.text
      }) : item.text));
    })))))), /*#__PURE__*/React.createElement("div", {
      className: "col-xl-".concat(item.col[1], " col-lg-").concat(item.col[1], " col-md-").concat(item.col[1], " col-sm-6 col-6 ").concat(item.position === "right" ? "order-0" : null)
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      height: item.height || height
    }, showPlusButton && /*#__PURE__*/React.createElement(PlusButton, _extends({
      backgroundColor: backgroundColor,
      size: "60px",
      height: "100%",
      zIndex: "1"
    }, computedPlusButtonPosition(item.position), {
      as: "a",
      href: item.href
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: "50px",
      fontWeight: "100",
      color: theme.highContrast.link || item.textColor,
      text: theme.icons.plus,
      lineHeight: "1"
    })), /*#__PURE__*/React.createElement(ImageWrapper, {
      height: "350px",
      size: "md",
      backgroundColor: backgroundColor,
      data: {
        url: item.backgroundImage
      },
      "aria-label": item.alt,
      alt: item.alt,
      imagePosition: backgroundPosition,
      hasEndpoint: false,
      endpoint: function endpoint() {
        return null;
      },
      isVector: item.isVector !== undefined ? item.isVector : false,
      isLocal: item.isLocal
    })))));
  }));
};

var types$Z = {
  className: PropTypes$1.string,
  textColor: PropTypes$1.string,
  title: PropTypes$1.string,
  data: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.shape({
    backgroundPosition: null
  })), PropTypes$1.object]),
  showHeader: PropTypes$1.bool,
  size: PropTypes$1.object,
  titleProps: PropTypes$1.object,
  showPlusButton: PropTypes$1.bool,
  isMarkdown: PropTypes$1.bool,
  contentMaxHeight: PropTypes$1.string,
  height: PropTypes$1.string,
  resource: PropTypes$1.string,
  theme: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
var defaults$U = {
  showPlusButton: true,
  isMarkdown: false,
  contentMaxHeight: "190px",
  height: "350px",
  activeColor: "#0EB4BD"
};
Campus.propTypes = types$Z;
Campus.defaultProps = defaults$U;
var CampusWithStyles = styled(Campus)(_templateObject$1u());
var index$l = compose(withSize(), withTheme)(CampusWithStyles); //Only used for the Storybook Props Table

var Campos = function Campos(_ref) {
  var className = _ref.className,
      showHeader = _ref.showHeader,
      title = _ref.title,
      theme = _ref.theme,
      titleProps = _ref.titleProps,
      textColor = _ref.textColor,
      data = _ref.data,
      resource = _ref.resource,
      isMarkdown = _ref.isMarkdown,
      supportsCssGrid = _ref.supportsCssGrid,
      activeColor = _ref.activeColor,
      showPlusButton = _ref.showPlusButton,
      backgroundColor = _ref.backgroundColor;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var themeTextColor = theme.components.campos.textColor;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    paddingTop: "".concat(showHeader ? "70px" : "0"),
    paddingBottom: "".concat(showHeader ? "0" : "0"),
    mdPaddingTop: "0"
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "\xC1reas"
  })), showHeader ? /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.highContrast.text || textColor || themeTextColor,
    marginBottom: "50px"
  }, titleProps), resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: title
  }) : title) : null, data.map(function (item, index) {
    var isOdd = index % 2;
    return supportsCssGrid ? /*#__PURE__*/React.createElement(ColumnsCard$1, _extends({
      key: index,
      src: item.backgroundImage,
      title: item.text,
      links: item.list,
      inverted: isMarkdown ? isOdd : item.inverted,
      imageGridColumn: isMarkdown ? isOdd ? "1 / 7" : "7 / -1" : item.inverted,
      textGridColumn: isMarkdown ? isOdd ? "7 / 12" : "2 / 7" : item.inverted,
      isMarkdown: isMarkdown,
      activeColor: activeColor,
      showPlusButton: showPlusButton,
      backgroundColor: backgroundColor
    }, item)) :
    /*#__PURE__*/

    /* Fallback Card*/
    React.createElement(LayeredCard$1, _extends({
      key: index,
      src: item.backgroundImage,
      title: item.text,
      links: item.list,
      isMarkdown: isMarkdown,
      inverted: isMarkdown ? isOdd : item.inverted,
      activeColor: activeColor,
      showPlusButton: showPlusButton,
      backgroundColor: backgroundColor
    }, item));
  }));
};

var types$_ = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  textColor: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  showHeader: PropTypes$1.bool,
  supportsCssGrid: PropTypes$1.bool,
  activeColor: PropTypes$1.string,
  showPlusButton: PropTypes$1.bool
};
var defaults$V = {
  showHeader: false,
  isMarkdown: false,
  supportsCssGrid: true,
  showPlusButton: true,
  activeColor: "#0EB4BD"
};
Campos.propTypes = types$_;
Campos.defaultProps = defaults$V;
var index$m = withTheme(Campos); //Only used for the Storybook Props Table

var LastUpdate = function LastUpdate(_ref) {
  var date = _ref.date,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.components.lastUpdate.bgColor,
    paddingTop: "0",
    paddingBottom: "0",
    height: "45px",
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3"
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.components.lastUpdate.textColor,
    size: "xSmall"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.lastUpdate.text",
    defaultMessage: "\xFAltima atualiza\xE7\xE3o a"
  }), " ", date))));
};

LastUpdate.propTypes = {
  date: PropTypes$1.string,
  theme: PropTypes$1.object
};
LastUpdate.defaultProps = {
  date: "dd/mm/yyyy"
};
var index$n = withTheme(LastUpdate);

function _templateObject$1v() {
  var data = _taggedTemplateLiteral(["\n  .hide-column {\n    display: none;\n  }\n\n  .text-container {\n    margin-bottom: ", ";\n    max-width: 160px;\n  }\n\n  // Extra large devices (large desktops, 1200px and up)\n  @media (min-width: 1200px) {\n    .number {\n      width: 250px;\n    }\n  }\n\n  // Extra large devices (large desktops, 1200px and down)\n  @media (max-width: 1200px) {\n    .number-1,\n    .number-2 {\n      margin-bottom: 80px;\n    }\n  }\n\n  // Small devices (landscape phones, 576px and down)\n  @media (max-width: 576px) {\n    .number-1,\n    .number-2,\n    .number-3 {\n      margin-bottom: 60px;\n    }\n  }\n"]);

  _templateObject$1v = function _templateObject() {
    return data;
  };

  return data;
}

var Numbers = function Numbers(_ref) {
  var className = _ref.className,
      backgroundColor = _ref.backgroundColor,
      titleColor = _ref.titleColor,
      textColor = _ref.textColor,
      lineColor = _ref.lineColor,
      data = _ref.data,
      removeCol01 = _ref.removeCol01,
      removeCol04 = _ref.removeCol04,
      sectionTitle = _ref.sectionTitle,
      hasSectionTitle = _ref.hasSectionTitle,
      sectionTitleColor = _ref.sectionTitleColor,
      resource = _ref.resource,
      hasDate = _ref.hasDate,
      theme = _ref.theme,
      date = _ref.date;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var highContrastTextColor = theme.highContrast.text;

  var getClasses = function getClasses() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    switch (position) {
      case 0:
        return removeCol01 ? "hide-column" : "col-xl-auto col-lg-4 offset-lg-0 col-sm-4 offset-sm-0 col-8 offset-1";

      case 1:
        return removeCol01 ? "col-xl-auto col-lg-4 offset-lg-0 col-md-4 col-sm-4 offset-sm-0 col-8 offset-1" : "col-xl-auto offset-xl-0 col-lg-4 offset-lg-4 col-md-4 offset-md-4 col-sm-4 offset-sm-4 col offset-5";

      case 2:
        return removeCol01 ? "col-xl-auto offset-xl-0 col-lg-4 offset-lg-4 col-md-4 offset-md-4 col-sm-4 offset-sm-4 col offset-5" : "col-xl-auto offset-xl-0 col-lg-4 offset-lg-0 col-md-4 col-sm-4 offset-sm-0 col-8 offset-1";

      case 3:
        return removeCol04 ? "hide-column" : "col-xl-auto offset-xl-0 col-lg-4 offset-lg-4 col-md-4 offset-md-4 col-sm-4 offset-sm-4 col offset-5";

      default:
        return "col-xl-auto col-lg-4 offset-lg-0 col-sm-4 offset-sm-0 col-8 offset-1";
    }
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    paddingTop: "120px",
    paddingBottom: "120px",
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Estat\xEDsticas"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, hasSectionTitle && /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    color: highContrastTextColor || sectionTitleColor || theme.components.numbers.sectionTitleColor,
    size: "xLarge",
    fontWeight: "500",
    marginBottom: hasDate ? "20px" : "50px"
  }, resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource,
    defaultMessage: sectionTitle
  }) : sectionTitle), hasDate && /*#__PURE__*/React.createElement(Text, {
    size: "article",
    marginBottom: "50px"
  }, date), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: getClasses(index)
    }, /*#__PURE__*/React.createElement("div", {
      className: "number number-".concat(index + 1),
      "aria-label": item.title + " " + item.number
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      text: item.number,
      fontSize: "80px",
      mobileSmFontSize: "40px",
      color: highContrastTextColor || titleColor,
      fontWeight: "900",
      marginBottom: "0",
      lineHeight: "1",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/React.createElement(Text, {
      text: item.title,
      color: highContrastTextColor || textColor,
      size: "article",
      "aria-hidden": "true"
    })), /*#__PURE__*/React.createElement(Line, {
      color: highContrastTextColor || lineColor
    })));
  }))));
};

var types$$ = {
  backgroundColor: PropTypes$1.string,
  titleColor: PropTypes$1.string,
  textColor: PropTypes$1.string,
  lineColor: PropTypes$1.string,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  className: PropTypes$1.string,
  removeCol01: PropTypes$1.bool,
  removeCol04: PropTypes$1.bool,
  hasSectionTitle: PropTypes$1.bool,
  sectionTitle: PropTypes$1.string,
  sectionTitleColor: PropTypes$1.string,
  resource: PropTypes$1.string,
  date: PropTypes$1.string,
  hasDate: PropTypes$1.bool,
  theme: PropTypes$1.object
};
var defaults$W = {
  hasDate: true,
  date: "Data"
};
Numbers.propTypes = types$$;
Numbers.defaultProps = defaults$W;
var NumbersWithStyles = styled(Numbers)(_templateObject$1v(), function (props) {
  return props.theme.spacing.xs;
});
var index$o = withTheme(NumbersWithStyles); //Only used for the Storybook Props Table

function _templateObject$1w() {
  var data = _taggedTemplateLiteral(["\n  .noughts-crosses {\n    position: relative;\n\n    //Hover fade in Play button\n    &:hover {\n      .play-button-container {\n        opacity: 1;\n      }\n    }\n\n    //Button Container\n    .play-button-container {\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 100%;\n      background-color: ", ";\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      opacity: 0;\n      -webkit-transition: opacity 0.5s ease-in-out;\n      transition: opacity 0.5s ease-in-out;\n    }\n\n    .board-row:after {\n      clear: both;\n      content: \"\";\n      display: table;\n    }\n\n    //Square\n    .square {\n      background: transparent;\n      color: ", ";\n      border: none;\n      float: left;\n      font-size: ", ";\n      font-weight: ", ";\n      line-height: 34px;\n      height: ", ";\n      width: ", ";\n      padding: 0;\n      text-align: center;\n      font-family: Roboto;\n      &:focus {\n        outline: none;\n      }\n    }\n\n    .board-row {\n      &:nth-child(2) {\n        border-bottom: ", "\n          solid ", ";\n        border-top: ", "\n          solid ", ";\n      }\n      .square {\n        &:nth-child(2) {\n          border-right: ", "\n            solid ", ";\n          border-left: ", "\n            solid ", ";\n        }\n      }\n    }\n  }\n  /*\n  -- Adjust Square Sizes for mobile\n  */\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .noughts-crosses {\n      .square {\n        height: ", ";\n        width: ", ";\n      }\n    }\n  }\n  // Extra small devices (portrait phones, less than 300px)\n  @media (max-width: 300px) {\n    .noughts-crosses {\n      .square {\n        height: ", ";\n        width: ", ";\n      }\n    }\n  }\n"]);

  _templateObject$1w = function _templateObject() {
    return data;
  };

  return data;
}

var Placeholder = function Placeholder(_ref) {
  var className = _ref.className,
      onHandlePlay = _ref.onHandlePlay;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "noughts-crosses"
  }, /*#__PURE__*/React.createElement("div", {
    className: "board-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "\xA0"), /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "\xA0"), /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: "board-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "4"), /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "0"), /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: "board-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "\xA0"), /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "\xA0"), /*#__PURE__*/React.createElement("button", {
    className: "square"
  }, "4")), /*#__PURE__*/React.createElement("div", {
    className: "play-button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: onHandlePlay
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.journal.errorHandler.button.play",
    defaultMessage: "Jogar"
  })))));
};

Placeholder.propTypes = {
  className: PropTypes$1.string,
  onHandlePlay: PropTypes$1.func
};
var PlaceholderWithStyles = styled(Placeholder)(_templateObject$1w(), function (props) {
  return props.theme.components.errorHandler.playButtonContainerBgColor;
}, function (props) {
  return props.theme.components.errorHandler.color;
}, function (props) {
  return props.theme.components.errorHandler.gameFontSize;
}, function (props) {
  return props.theme.components.errorHandler.gameFontWeight;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareSize;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareMobileSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareMobileSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareXXXSmallMobileSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareXXXSmallMobileSize;
});
var Placeholder$1 = withTheme(PlaceholderWithStyles);

function _templateObject$1x() {
  var data = _taggedTemplateLiteral(["\n  .board-row:after {\n    clear: both;\n    content: \"\";\n    display: table;\n  }\n\n  //Game Container\n  .game {\n    position: relative;\n\n    //Game Info Container\n    .game-info-container {\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 100%;\n      background-color: ", ";\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  //Square\n  .square {\n    background: transparent;\n    color: ", ";\n    border: none;\n    float: left;\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: 34px;\n    height: ", ";\n    width: ", ";\n    padding: 0;\n    text-align: center;\n    font-family: ", ";\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .square-active {\n    &:hover {\n      background-color: ", ";\n      cursor: pointer;\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n  }\n\n  .board-row {\n    &:nth-child(2) {\n      border-bottom: ", "\n        solid ", ";\n      border-top: ", "\n        solid ", ";\n    }\n    .square {\n      &:nth-child(2) {\n        border-right: ", "\n          solid ", ";\n        border-left: ", "\n          solid ", ";\n      }\n    }\n  }\n\n  /*\n  -- Adjust Square Sizes for mobile\n  */\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .square {\n      height: ", ";\n      width: ", ";\n    }\n  }\n  // Extra small devices (portrait phones, less than 300px)\n  @media (max-width: 300px) {\n    .square {\n      height: ", ";\n      width: ", ";\n    }\n  }\n"]);

  _templateObject$1x = function _templateObject() {
    return data;
  };

  return data;
}

function Square(_ref) {
  var isDisable = _ref.isDisable,
      onClick = _ref.onClick,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("button", {
    className: "square ".concat(isDisable ? "" : "square-active"),
    onClick: onClick
  }, value);
}

Square.propTypes = {
  isDisable: PropTypes$1.bool,
  onClick: PropTypes$1.func,
  value: PropTypes$1.string
};

function Board(_ref2) {
  var squares = _ref2.squares,
      _onClick = _ref2.onClick,
      isDisable = _ref2.isDisable;

  var renderSquare = function renderSquare(i) {
    return /*#__PURE__*/React.createElement(Square, {
      value: squares[i],
      onClick: function onClick() {
        return _onClick(i);
      },
      isDisable: isDisable
    });
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "board-row"
  }, renderSquare(0), renderSquare(1), renderSquare(2)), /*#__PURE__*/React.createElement("div", {
    className: "board-row"
  }, renderSquare(3), renderSquare(4), renderSquare(5)), /*#__PURE__*/React.createElement("div", {
    className: "board-row"
  }, renderSquare(6), renderSquare(7), renderSquare(8)));
}

Board.propTypes = {
  squares: PropTypes$1.array,
  onClick: PropTypes$1.func,
  isDisable: PropTypes$1.bool
};

var Game = /*#__PURE__*/function (_React$Component) {
  _inherits(Game, _React$Component);

  var _super = _createSuper(Game);

  function Game(props) {
    var _this;

    _classCallCheck(this, Game);

    _this = _super.call(this, props);
    _this.state = {
      history: [{
        squares: Array(9).fill(null)
      }],
      stepNumber: 0,
      xIsNext: true,
      status: "",
      resource: "app.journal.errorHandler.next.player",
      isDisable: false
    };
    return _this;
  }

  _createClass(Game, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onStatus();
    }
  }, {
    key: "handleClick",
    value: function handleClick(i) {
      var _this2 = this;

      var history = this.state.history.slice(0, this.state.stepNumber + 1);
      var current = history[history.length - 1];
      var squares = current.squares.slice();

      if (calculateWinner(squares) || squares[i]) {
        return;
      }

      squares[i] = this.state.xIsNext ? "4" : "0";
      this.setState({
        history: history.concat([{
          squares: squares
        }]),
        stepNumber: history.length,
        xIsNext: !this.state.xIsNext
      });
      setTimeout(function () {
        _this2.onStatus();
      }, 50);
    }
  }, {
    key: "jumpTo",
    value: function jumpTo(step) {
      this.setState({
        stepNumber: step,
        xIsNext: step % 2 === 0,
        status: step === 0 ? "4" : this.state.status,
        resource: "app.journal.errorHandler.next.player",
        isDisable: step !== 0
      });
    }
  }, {
    key: "onStatus",
    value: function onStatus() {
      var history = this.state.history;
      var current = history[this.state.stepNumber];
      var winner = calculateWinner(current.squares);

      if (winner) {
        this.setState({
          status: winner,
          resource: "app.journal.errorHandler.winner",
          isDisable: true
        });
      } else {
        if (history.length > 9) {
          this.setState({
            status: "",
            resource: "app.journal.errorHandler.tie",
            isDisable: true
          });
          return;
        }

        this.setState({
          status: this.state.xIsNext ? "4" : "0",
          resource: "app.journal.errorHandler.next.player",
          isDisable: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var history = this.state.history;
      var current = history[this.state.stepNumber];
      var FormattedMessage = this.context.formattedMessage;
      return /*#__PURE__*/React.createElement("div", {
        className: "game"
      }, /*#__PURE__*/React.createElement("div", {
        className: "game-board"
      }, /*#__PURE__*/React.createElement(Board, {
        squares: current.squares,
        onClick: function onClick(i) {
          return _this3.handleClick(i);
        },
        isDisable: this.state.isDisable
      })), this.state.isDisable === true && /*#__PURE__*/React.createElement(FadeIn, {
        animationTime: 0.5,
        className: "game-info-container"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "large",
        fontWeight: "400",
        marginBottom: "30px"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: this.state.resource,
        defaultMessage: this.state.status,
        values: {
          player: this.state.status
        }
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "default",
        onClick: function onClick() {
          return _this3.jumpTo(0);
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "app.journal.errorHandler.button.restart",
        defaultMessage: "Jogar de novo"
      }))));
    }
  }]);

  return Game;
}(React.Component);

Game.contextType = ConfigContext;

function calculateWinner(squares) {
  var lines = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [0, 3, 6], [1, 4, 7], [2, 5, 8], [0, 4, 8], [2, 4, 6]];

  for (var i = 0; i < lines.length; i++) {
    var _lines$i = _slicedToArray(lines[i], 3),
        a = _lines$i[0],
        b = _lines$i[1],
        c = _lines$i[2];

    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }

  return null;
}

var ErrorHandler = function ErrorHandler(_ref3) {
  var className = _ref3.className,
      theme = _ref3.theme,
      description = _ref3.description,
      errorCode = _ref3.errorCode,
      searchHref = _ref3.searchHref,
      isFileExpired = _ref3.isFileExpired;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPlaying = _useState2[0],
      setPlaying = _useState2[1];

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage;

  var onPlay = function onPlay() {
    setPlaying(true);
  };

  var message = function message(errorCode) {
    switch (errorCode) {
      case 404:
        return {
          title: isFileExpired ? "app.journal.errorHandler.fileExpired.message.title" : "app.journal.errorHandler.message.title",
          firstPart: isFileExpired ? "app.journal.errorHandler.fileExpired.message.firstPart" : "app.journal.errorHandler.message.firstPart",
          secondPart: "app.journal.errorHandler.message.secondPart",
          homepageLink: "app.journal.errorHandler.homepage.link",
          searchLink: "app.journal.errorHandler.search.link"
        };

      default:
        return {
          title: "app.journal.errorHandler.general.message.title",
          firstPart: "app.journal.errorHandler.general.message.firstPart",
          secondPart: "app.journal.errorHandler.general.message.secondPart",
          homepageLink: "app.journal.errorHandler.general.homepage.link",
          searchLink: "app.journal.errorHandler.general.search.link"
        };
    }
  };

  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.components.errorHandler.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center justify-content-md-start justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 offset-0 col-md col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    color: theme.components.errorHandler.color,
    size: "large",
    fontWeight: "400"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: message(errorCode).title,
    defaultMessage: "Ups! Página não encontrada"
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "30px",
    marginRight: "60px",
    mobileMdMarginRight: "30px",
    mobileSmMarginRight: "0",
    smMarginbottom: "50px"
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme.components.errorHandler.color,
    fontSize: "14px",
    fontWeight: "300",
    lineHeight: "1.6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: message(errorCode).firstPart,
    defaultMessage: "A p\xE1gina \xE0 qual tentou aceder n\xE3o se encontra dispon\xEDvel . Esta pode ter sido removida, estar temporariamente indispon\xEDvel ou o seu endere\xE7o estar incorreto. Fa\xE7a uma "
  }), " ", /*#__PURE__*/React.createElement(Link, {
    href: searchHref,
    color: theme.components.errorHandler.linkColor,
    fontSize: "14px",
    textDecoration: "underline",
    fontWeight: "300",
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: message(errorCode).searchLink,
    defaultMessage: "pesquisa"
  })), " ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: message(errorCode).secondPart,
    defaultMessage: "ou volte \xE0"
  }), " ", /*#__PURE__*/React.createElement(Link, {
    href: "/",
    color: theme.components.errorHandler.linkColor,
    fontSize: "14px",
    textDecoration: "underline",
    fontWeight: "300",
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: message(errorCode).homepageLink,
    defaultMessage: "p\xE1gina inicial"
  })), ".")), description && description.url && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "30px",
    marginRight: "60px",
    mobileMdMarginRight: "30px",
    mobileSmMarginRight: "0",
    smMarginbottom: "50px"
  }, /*#__PURE__*/React.createElement(Link, {
    href: description.location,
    color: theme.components.errorHandler.linkColor,
    fontSize: "14px",
    textDecoration: "underline",
    fontWeight: "300",
    cursor: "pointer"
  }, description.url))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, errorCode === 404 ? isPlaying ? /*#__PURE__*/React.createElement(Game, null) : /*#__PURE__*/React.createElement(Placeholder$1, {
    onHandlePlay: onPlay
  }) : null)))));
};

var types$10 = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  description: PropTypes$1.object,
  errorCode: PropTypes$1.number,
  searchHref: PropTypes$1.string,
  isFileExpired: PropTypes$1.bool
};
var defaults$X = {
  description: {
    url: ""
  },
  searchHref: "/",
  errorCode: 404,
  isFileExpired: false
};
ErrorHandler.propTypes = types$10;
ErrorHandler.defaultProps = defaults$X;
var ErrorHandlerWithStyles = styled(ErrorHandler)(_templateObject$1x(), function (props) {
  return props.theme.components.errorHandler.playButtonContainerBgColor;
}, function (props) {
  return props.theme.components.errorHandler.color;
}, function (props) {
  return props.theme.components.errorHandler.gameFontSize;
}, function (props) {
  return props.theme.components.errorHandler.gameFontWeight;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareSize;
}, function (props) {
  return props.theme.type.base;
}, function (props) {
  return props.theme.components.errorHandler.hoverColor;
}, function (props) {
  return props.theme.components.errorHandler.activeColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameBorderSize;
}, function (props) {
  return props.theme.components.errorHandler.borderColor;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareMobileSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareMobileSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareXXXSmallMobileSize;
}, function (props) {
  return props.theme.components.errorHandler.gameSquareXXXSmallMobileSize;
});
var index$p = withTheme(ErrorHandlerWithStyles); //Only used for the Storybook Props Table

var CurricularUnit = memo(function CurricularUnit(_ref) {
  var hasLine = _ref.hasLine,
      loading = _ref.loading,
      hasError = _ref.hasError,
      data = _ref.data,
      lang = _ref.lang,
      hasHash = _ref.hasHash,
      size = _ref.size,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  var LeftColumn = function LeftColumn() {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0 order-xl-first order-last"
    }, hasLine && /*#__PURE__*/React.createElement(Line, {
      color: theme.components.curricularUnit.lineColor
    }), Object.keys(data.description).length > 0 && data.description.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginTop: "40px"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "h2",
        size: "large",
        text: item.label,
        color: theme.components.curricularUnit.titleColor,
        fontWeight: "400",
        marginBottom: "5px"
      }), /*#__PURE__*/React.createElement(InjectHtml$1, {
        content: item.value,
        variant: "presentation"
      }));
    }), Object.keys(data.contents).length > 0 && /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "40px"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h2",
      size: "large",
      text: lang === "pt" ? "Conteúdos" : "Contents",
      color: theme.components.curricularUnit.titleColor,
      fontWeight: "400",
      marginBottom: "5px"
    }), data.contents.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginTop: "20px"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "h2",
        size: "large",
        text: item.label,
        color: "#000",
        fontWeight: "500",
        marginBottom: "5px"
      }), /*#__PURE__*/React.createElement(InjectHtml$1, {
        content: item.value,
        variant: "presentation"
      }));
    })), Object.keys(data.links).length > 0 && data.links.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        marginTop: "40px"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "h2",
        size: "large",
        text: item.label,
        color: theme.components.curricularUnit.titleColor,
        fontWeight: "400",
        marginBottom: "5px"
      }), /*#__PURE__*/React.createElement(InjectHtml$1, {
        content: item.value,
        variant: "presentation"
      }));
    }));
  };

  var RightColumn = function RightColumn() {
    return /*#__PURE__*/React.createElement(Fragment, null, Object.keys(data.sideInfo).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "col-xl offset-xl-0 col-lg-4 offset-lg-4 col-md-6 order-xl-last order-first"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      marginTop: "50px",
      marginLeft: "30px",
      mobileLgMarginLeft: "0",
      lgMargintop: "40px"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      padding: "5px 0",
      borderTop: "3px solid ".concat(theme.components.curricularUnit.containerBorderColor),
      borderBottom: "3px solid ".concat(theme.components.curricularUnit.containerBorderColor)
    }, data.sideInfo.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ContentContainer, {
        key: index,
        padding: "5px 0",
        borderBottom: "1px solid ".concat(theme.components.curricularUnit.infoContainerBorderColor),
        lastChildBorderBottom: "none"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row no-gutters"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "h3",
        size: "small",
        text: "".concat(item.info.label, ":"),
        fontWeight: "500"
      }), item.type === "link" ? /*#__PURE__*/React.createElement(Link, {
        text: item.info.value,
        title: item.info.value,
        color: theme.components.curricularUnit.linkColor,
        fontWeight: "300",
        fontSize: "14px",
        textDecoration: "underline",
        hoverColor: theme.components.curricularUnit.linkHoverColor,
        href: "".concat(hasHash, "/").concat(lang, "/p/").concat(item.extra)
      }) : /*#__PURE__*/React.createElement(InjectHtml$1, {
        content: item.info.value,
        variant: "presentation"
      }))));
    })))));
  };

  return /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.components.curricularUnit.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-lg-8 offset-lg-4 col-12 order-0"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mdMargintop: "50px"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    size: "xLarge",
    fontWeight: "500",
    text: data.subTitle,
    lineHeight: "1.4",
    firstLetter: "capitalize",
    marginTop: "0",
    marginBottom: "0"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, loading ? /*#__PURE__*/React.createElement("div", null, "A carregar...") : hasError ? /*#__PURE__*/React.createElement("div", null, "No content to display") : /*#__PURE__*/React.createElement(Fragment, null, size.width >= 1199 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(LeftColumn, null), /*#__PURE__*/React.createElement(RightColumn, null)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(RightColumn, null), /*#__PURE__*/React.createElement(LeftColumn, null))))));
});
var defaults$Y = {
  data: {},
  lang: "pt",
  hasHash: false
};
var types$11 = {
  data: PropTypes$1.object.isRequired,
  hasLine: PropTypes$1.bool,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  lang: PropTypes$1.string,
  hasHash: PropTypes$1.bool,
  size: PropTypes$1.object,
  theme: PropTypes$1.object
};
CurricularUnit.propTypes = types$11;
CurricularUnit.defaultProps = defaults$Y;
var index$q = compose(withTheme, withSize())(CurricularUnit); //Only used for the Storybook Props Table

var Departments = function Departments(_ref) {
  var title = _ref.title,
      titleSize = _ref.titleSize,
      titleWeight = _ref.titleWeight,
      description = _ref.description,
      textWeight = _ref.textWeight,
      textSize = _ref.textSize,
      textLineHeight = _ref.textLineHeight,
      className = _ref.className,
      resource = _ref.resource,
      subTitle = _ref.subTitle,
      polytechnics = _ref.polytechnics,
      data = _ref.data,
      theme = _ref.theme;

  var _useContext = useContext(ConfigContext),
      Link = _useContext.link,
      FormattedMessage = _useContext.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.departments.backgroundColor,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 offset-lg-4 col-lg col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    fontWeight: "500",
    size: "xLarge",
    text: title,
    marginBottom: "40px",
    firstLetter: "capitalize"
  }, resource.title ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource.title,
    defaultMessage: title
  }) : title), /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "large",
    color: theme.components.departments.titleColor,
    fontWeight: titleWeight,
    marginBottom: "10px",
    firstLetter: "uppercase",
    fontSize: titleSize
  }, resource.subTitle ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource.subTitle,
    defaultMessage: subTitle
  }) : subTitle), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(Text, {
    fontWeight: textWeight,
    marginBottom: "15px",
    fontSize: textSize,
    lineHeight: textLineHeight
  }, resource.description ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource.description,
    defaultMessage: description
  }) : description)), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginRight: "0",
    marginBottom: "80px",
    mobileXsMarginRight: "0"
  }, /*#__PURE__*/React.createElement(VerticalList, null, data.departments.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      paddingTop: "10px",
      paddingBottom: "10px",
      borderBottom: "1px solid ".concat(theme.components.departments.borderColor),
      borderTop: index === 0 ? "1px solid ".concat(theme.components.departments.borderColor) : "none"
    }, /*#__PURE__*/React.createElement(Link, {
      color: theme.components.departments.linkColor,
      href: item.url,
      fontSize: "14px",
      fontWeight: "300",
      "aria-label": item.text
    }, item.text));
  }))), /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "large",
    color: theme.components.departments.titleColor,
    fontWeight: titleWeight,
    marginBottom: "10px",
    firstLetter: "uppercase",
    fontSize: titleSize
  }, resource.polytechnics ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: resource.polytechnics,
    defaultMessage: polytechnics
  }) : polytechnics), data.politec.description.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ContentContainer, {
      key: index,
      mobileMdDisplay: "none"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h2",
      size: "small",
      text: item,
      fontWeight: textWeight,
      marginBottom: "15px",
      fontSize: textSize,
      lineHeight: textLineHeight
    }));
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px",
    marginRight: "0",
    mobileXsMarginRight: "0"
  }, /*#__PURE__*/React.createElement(VerticalList, null, data.politec.data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      paddingTop: "10px",
      paddingBottom: "10px",
      borderBottom: "1px solid ".concat(theme.components.departments.borderColor),
      borderTop: index === 0 ? "1px solid ".concat(theme.components.departments.borderColor) : "none"
    }, /*#__PURE__*/React.createElement(Link, {
      color: theme.components.departments.linkColor,
      href: item.url,
      fontSize: "14px",
      fontWeight: "300",
      "aria-label": item.text
    }, item.text));
  })))))));
};

var defaults$Z = {
  title: "Title",
  subTitle: "SubTitle",
  description: "Description",
  data: {},
  polytechnics: "Another title"
};
var types$12 = {
  title: PropTypes$1.string,
  subTitle: PropTypes$1.string,
  resource: PropTypes$1.object,
  titleColor: PropTypes$1.string,
  titleSize: PropTypes$1.string,
  titleWeight: PropTypes$1.string,
  description: PropTypes$1.string,
  data: PropTypes$1.object,
  textWeight: PropTypes$1.string,
  textSize: PropTypes$1.string,
  textLineHeight: PropTypes$1.string,
  className: PropTypes$1.string,
  polytechnics: PropTypes$1.string,
  theme: PropTypes$1.object
};
Departments.propTypes = types$12;
Departments.defaultProps = defaults$Z;
var index$r = withTheme(Departments); //Only used for the Storybook Props Table

function _templateObject$1y() {
  var data = _taggedTemplateLiteral(["\n  column-count: ", ";\n\n  @media (max-width: 767px) {\n    column-count: 1;\n  }\n  ", "\n"]);

  _templateObject$1y = function _templateObject() {
    return data;
  };

  return data;
}

var MultiColumns = function MultiColumns(_ref) {
  var content = _ref.content,
      data = _ref.data,
      title = _ref.title,
      hasLine = _ref.hasLine,
      href = _ref.href,
      backgroundColor = _ref.backgroundColor,
      isThemeReverse = _ref.isThemeReverse,
      columns = _ref.columns,
      activeColor = _ref.activeColor,
      titleColor = _ref.titleColor,
      theme = _ref.theme,
      externalLink = _ref.externalLink;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Section, {
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor
  }, title && /*#__PURE__*/React.createElement(SectionHeader, {
    title: title,
    hasLine: hasLine,
    hasLink: hasLine,
    textColor: theme.highContrast.link || titleColor,
    href: href,
    externalLink: externalLink
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, content && /*#__PURE__*/React.createElement(Content, {
    className: "col-xl col-lg col-md-12",
    columns: columns
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: content,
    isThemeReverse: isThemeReverse,
    activeColor: activeColor
  })), data && data.map(function (_ref2, index) {
    var title = _ref2.title,
        content = _ref2.content,
        href = _ref2.href;
    return /*#__PURE__*/React.createElement(Content, {
      className: "col-xl-6 col-md-12",
      key: index,
      columns: columns,
      isArray: true
    }, title && /*#__PURE__*/React.createElement(SectionHeader, {
      hasContainer: false,
      title: title,
      hasLine: !!href,
      hasLink: !!href,
      textColor: theme.highContrast.link || titleColor,
      href: href
    }), /*#__PURE__*/React.createElement(MarkdownRenderer, {
      content: content,
      isThemeReverse: isThemeReverse,
      className: "stick-bottom",
      activeColor: activeColor
    }));
  })))));
};

MultiColumns.defaultProps = {
  backgroundColor: "#fff",
  titleColor: "#000",
  href: null,
  columns: 2,
  content: "",
  isThemeReverse: false,
  activeColor: null,
  externalLink: false
};
MultiColumns.propTypes = {
  title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
  backgroundColor: PropTypes$1.string,
  columns: PropTypes$1.number,
  href: PropTypes$1.string,
  content: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
  isThemeReverse: PropTypes$1.bool,
  data: PropTypes$1.oneOfType([PropTypes$1.array, PropTypes$1.object]),
  activeColor: PropTypes$1.string,
  hasLine: PropTypes$1.bool,
  titleColor: PropTypes$1.string,
  theme: PropTypes$1.object,
  externalLink: PropTypes$1.string
};
var Content = styled.div(_templateObject$1y(), function (props) {
  return props.columns || 2;
}, function (props) {
  return props.isArray && "\n    display: flex;\n    flex-direction: column;\n  ";
});
var index$s = withTheme(MultiColumns);

var Services = function Services(_ref) {
  var className = _ref.className,
      title = _ref.title,
      theme = _ref.theme,
      data = _ref.data,
      setFavorite = _ref.setFavorite,
      removeFavorite = _ref.removeFavorite,
      demoFavorites = _ref.demoFavorites;
  return /*#__PURE__*/React.createElement(Section, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 col-12 offset-xl-3"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xLarge",
    fontWeight: "500"
  }, title), data.map(function (service, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Text, {
      size: "large",
      color: theme.components.services.groupTitleColor,
      fontWeight: "400",
      marginTop: "50px",
      marginBottom: "20px",
      mobileXsMarginBottom: "10px"
    }, service.title), /*#__PURE__*/React.createElement(ContentContainer, {
      className: "d-flex flex-wrap"
    }, service.list.map(function (item, i) {
      return /*#__PURE__*/React.createElement(IconCard$1, {
        key: i,
        margin: "10px 60px 10px 0",
        mobileXsMargin: "10px 20px 10px 0",
        linkText: item.text,
        iconName: item.icon,
        linkProps: {
          href: item.href
        },
        favorite: {
          show: demoFavorites,
          check: item.favorite,
          set: function set() {
            return setFavorite(item.id);
          },
          remove: function remove() {
            return removeFavorite(item.id);
          }
        }
      });
    })));
  })))));
};

var defaults$_ = {
  title: "Título",
  setFavorite: function setFavorite() {
    return null;
  },
  removeFavorite: function removeFavorite() {
    return null;
  },
  demoFavorites: false
};
var types$13 = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  theme: PropTypes$1.object,
  data: PropTypes$1.array.isRequired,
  setFavorite: PropTypes$1.func,
  removeFavorite: PropTypes$1.func,
  demoFavorites: PropTypes$1.bool
};
Services.propTypes = types$13;
Services.defaultProps = defaults$_;
var index$t = withTheme(Services); //Only used for the Storybook Props Table

function _templateObject$1z() {
  var data = _taggedTemplateLiteral(["\n  overflow-x: auto;\n\n  table {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: 1.6;\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    color: ", ";\n    font-weight: 300;\n  }\n\n  caption,\n  th,\n  td {\n    text-align: left;\n  }\n\n  th,\n  strong,\n  b {\n    font-weight: 400;\n  }\n\n  caption {\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.4;\n    margin-bottom: 25px;\n  }\n\n  th {\n    padding: 0 5px 0 5px;\n    &:first-child {\n      padding: 0 5px 0 0;\n    }\n    &:last-child {\n      padding: 0 0 0 5px;\n    }\n  }\n\n  td {\n    padding: 10px 5px;\n    min-width: 75px;\n    border-top: ", ";\n    border-bottom: ", ";\n    &:first-child {\n      padding: 10px 5px 10px 0;\n    }\n    &:last-child {\n      padding: 10px 0 10px 5px;\n    }\n  }\n\n  a {\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject$1z = function _templateObject() {
    return data;
  };

  return data;
}
var TablesContainer = styled.div(_templateObject$1z(), function (props) {
  return props.theme.type.base;
}, function (props) {
  return props.theme.sizes.sm;
}, function (props) {
  return props.theme.components.table.textColor;
}, function (props) {
  return props.theme.sizes.xl3m;
}, function (props) {
  return "1px solid ".concat(props.theme.components.table.borderLightColor);
}, function (props) {
  return "1px solid ".concat(props.theme.components.table.borderLightColor);
}, function (props) {
  return props.theme.components.tables.linkColor;
}, function (props) {
  return props.activeColor;
});

var Tables = function Tables(_ref) {
  var className = _ref.className,
      hasSectionTitle = _ref.hasSectionTitle,
      title = _ref.title,
      theme = _ref.theme,
      data = _ref.data,
      isFullWidth = _ref.isFullWidth,
      activeColor = _ref.activeColor;
  return /*#__PURE__*/React.createElement(Section, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: isFullWidth ? "col-12" : "col-xl-6 offset-xl-3 col-lg-8 offset-lg-4 col-12 offset-0"
  }, hasSectionTitle && /*#__PURE__*/React.createElement(SectionHeader, {
    textColor: theme.components.tables.titleColor,
    hasLink: false,
    hasLine: false,
    hasContainer: false
  }, title), /*#__PURE__*/React.createElement(TablesContainer, {
    activeColor: activeColor
  }, /*#__PURE__*/React.createElement(InjectHtml$1, {
    variant: "removeStyles",
    content: data
  }))))));
};

var defaults$$ = {
  title: "Title",
  hasSectionTitle: false,
  data: "",
  isFullWidth: false,
  activeColor: "#0EB4BD"
};
var types$14 = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  data: PropTypes$1.string,
  isFullWidth: PropTypes$1.bool,
  activeColor: PropTypes$1.bool
};
Tables.propTypes = types$14;
Tables.defaultProps = defaults$$;
var index$u = withTheme(Tables); //Only used for the Storybook Props Table

function _templateObject$1A() {
  var data = _taggedTemplateLiteral(["\n  overflow-x: auto;\n\n  table {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: 1.6;\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    color: ", ";\n    font-weight: 300;\n  }\n\n  caption,\n  th,\n  td {\n    text-align: left;\n  }\n\n  th,\n  strong,\n  b,\n  td:first-child {\n    font-weight: 400;\n  }\n\n  caption {\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.4;\n    margin-bottom: 25px;\n  }\n\n  th {\n    padding: 0 5px 0 5px;\n    &:first-child {\n      padding: 0 5px 0 0;\n    }\n    &:last-child {\n      padding: 0 0 0 5px;\n    }\n  }\n\n  td,\n  th {\n    padding: 10px 5px;\n    min-width: 75px;\n    &:first-child {\n      padding: 10px 5px 10px 0;\n    }\n    &:last-child {\n      padding: 10px 0 10px 5px;\n    }\n  }\n\n  td {\n    border-top: ", ";\n    border-bottom: ", ";\n  }\n\n  a {\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject$1A = function _templateObject() {
    return data;
  };

  return data;
}
var TableStyles = styled.div(_templateObject$1A(), function (props) {
  return props.theme.type.base;
}, function (props) {
  return props.theme.sizes.s;
}, function (props) {
  return props.theme.components.table.textColor;
}, function (props) {
  return props.theme.sizes.xl3m;
}, function (props) {
  return "1px solid ".concat(props.theme.components.table.borderColor);
}, function (props) {
  return "1px solid ".concat(props.theme.components.table.borderColor);
}, function (props) {
  return props.theme.components.tables.linkColor;
}, function (props) {
  return props.activeColor;
});

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 70px;\n  @media (max-width: 767.98px) {\n    margin-bottom: 50px;\n  }\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1B() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  height: 24px;\n  width: 24px;\n  &:focus {\n    ", ";\n  }\n  margin-left: ", ";\n"]);

  _templateObject$1B = function _templateObject() {
    return data;
  };

  return data;
}
var IconButton$1 = styled.button(_templateObject$1B(), function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.marginLeft;
});
var HeaderContainer$1 = styled.div(_templateObject2$g());

var Files = function Files(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      title = _ref.title,
      downloadAll = _ref.downloadAll,
      activeColor = _ref.activeColor,
      data = _ref.data,
      onDownload = _ref.onDownload,
      onDownloadAll = _ref.onDownloadAll,
      size = _ref.size,
      isLoading = _ref.isLoading,
      lang = _ref.lang;
  var textColor = theme.components.files.textColor;
  var lightTextColor = theme.components.files.lightText;
  var localeData = useMemo(function () {
    return {
      pt: {
        name: "nome",
        type: "tipo",
        date: "data",
        description: "descrição",
        size: "tamanho",
        downloadAll: "Descarregar todos"
      },
      en: {
        name: "name",
        type: "type",
        date: "date",
        description: "description",
        size: "size",
        downloadAll: "Download all"
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(Section, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(HeaderContainer$1, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "xLarge",
    fontWeight: "500",
    color: textColor
  }, title), size.width >= 767.98 && /*#__PURE__*/React.createElement(Link, {
    as: "button",
    border: "none",
    background: "transparent",
    size: "mediumSmall",
    textDecoration: "underline",
    lighten: true,
    onClick: function onClick() {
      return onDownloadAll(data);
    },
    color: theme.components.files.buttonColor
  }, downloadAll)), isLoading ? /*#__PURE__*/React.createElement(LoadingWithStyles$2, null) : /*#__PURE__*/React.createElement(Fragment, null, size.width >= 767.98 ? /*#__PURE__*/React.createElement(TableStyles, {
    activeColor: activeColor
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, localeData[lang].name), /*#__PURE__*/React.createElement("th", null, localeData[lang].type), /*#__PURE__*/React.createElement("th", null, localeData[lang].description), /*#__PURE__*/React.createElement("th", null, localeData[lang].date), /*#__PURE__*/React.createElement("th", null, localeData[lang].size), /*#__PURE__*/React.createElement("th", null, "\xA0"))), /*#__PURE__*/React.createElement("tbody", null, data.map(function (item) {
    return /*#__PURE__*/React.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React.createElement("td", null, item.name), /*#__PURE__*/React.createElement("td", null, item.type.toUpperCase()), /*#__PURE__*/React.createElement("td", null, item.description), /*#__PURE__*/React.createElement("td", null, item.date
    /*moment(item.date).format()*/
    ), /*#__PURE__*/React.createElement("td", null, item.size), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(IconButton$1, {
      onClick: function onClick() {
        return onDownload(item);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "fal fa-arrow-to-bottom",
      size: "small",
      color: textColor
    }))));
  })))) : /*#__PURE__*/React.createElement(ContentContainer, null, data.map(function (item) {
    return /*#__PURE__*/React.createElement(BorderedCardWithStyles, {
      key: item.id,
      cardIsLink: false
    }, /*#__PURE__*/React.createElement(Text, {
      marginBottom: "5px",
      fontWeight: "400"
    }, item.name), /*#__PURE__*/React.createElement(Text, {
      marginBottom: "20px"
    }, item.description), /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement(Text, {
      color: lightTextColor
    }, item.size), /*#__PURE__*/React.createElement(Text, {
      color: lightTextColor,
      marginLeft: "20px",
      marginRight: "20px"
    }, item.type.toUpperCase()), /*#__PURE__*/React.createElement(IconButton$1, {
      marginLeft: "auto",
      onClick: function onClick() {
        return onDownload(item);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "fal fa-arrow-to-bottom",
      size: "small",
      color: textColor
    }))));
  })), size.width <= 767.98 && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "50px",
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onDownloadAll(data);
    },
    variant: "default"
  }, localeData[lang].downloadAll)))));
};

var defaults$10 = {
  title: "Title",
  downloadAll: "descarregar todos",
  activeColor: "#0EB4BD",
  onDownload: function onDownload() {
    return null;
  },
  onDownloadAll: function onDownloadAll() {
    return null;
  },
  isLoading: false,
  lang: "pt"
};
var types$15 = {
  className: PropTypes$1.string,
  title: PropTypes$1.string,
  downloadAll: PropTypes$1.string,
  activeColor: PropTypes$1.string,
  data: PropTypes$1.array,
  onDownload: PropTypes$1.func,
  onDownloadAll: PropTypes$1.func,
  size: PropTypes$1.object,
  isLoading: PropTypes$1.bool,
  lang: PropTypes$1.string
};
Files.propTypes = types$15;
Files.defaultProps = defaults$10;
var index$v = compose(withTheme, withSize())(Files); //Only used for the Storybook Props Table

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n  @media (max-width: 575.98px) {\n    .container {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1C() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  // 16:9 aspect ratio\n  padding-top: 56.25%;\n  position: relative;\n  iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n    left: 0;\n    position: absolute;\n    top: 0;\n  }\n"]);

  _templateObject$1C = function _templateObject() {
    return data;
  };

  return data;
}

var IframeContainer = styled.div(_templateObject$1C());

var Streaming = function Streaming(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      title = _ref.title,
      description = _ref.description,
      url = _ref.url,
      isMobile = _ref.isMobile,
      props = _objectWithoutProperties(_ref, ["className", "theme", "title", "description", "url", "isMobile"]);

  var textColor = theme.components.streaming.textColor;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.streaming.backgroundColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsPadding: "0 15px"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    textColor: textColor,
    hasLink: false,
    hasLine: false,
    hasContainer: false,
    marginBottom: "50px"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, ReactPlayer.canPlay(url) ? /*#__PURE__*/React.createElement(VideoPlayer$1, {
    className: className,
    url: url
  }) : /*#__PURE__*/React.createElement(IframeContainer, null, /*#__PURE__*/React.createElement("iframe", {
    src: url,
    title: title
  }, "\xA0")), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsPadding: "0 15px",
    smMargintop: "20px"
  }, /*#__PURE__*/React.createElement(Text, {
    color: textColor,
    whiteSpace: "pre-line"
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: isEmpty$1(description) ? "" : description,
    activeColor: textColor,
    linkColor: textColor,
    isMobile: isMobile,
    isStreaming: true,
    isThemeReverse: true
  })))))));
};

var defaults$11 = {
  title: "Title",
  description: "Text",
  url: ""
};
var types$16 = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  title: PropTypes$1.string,
  description: PropTypes$1.string,
  url: PropTypes$1.string,
  isMobile: PropTypes$1.bool
};
Streaming.propTypes = types$16;
Streaming.defaultProps = defaults$11;
var StreamingWithStyles = styled(Streaming)(_templateObject2$h());
var index$w = withTheme(StreamingWithStyles); //Only used for the Storybook Props Table

function _templateObject$1D() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  position: relative;\n\n  .contacts {\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n\n    .content-container {\n      height: ", ";\n      padding: 50px 0;\n      .card {\n        height: 100%;\n        padding: 50px 40px;\n        background-color: ", ";\n      }\n    }\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .contacts {\n      display: none;\n    }\n  }\n"]);

  _templateObject$1D = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$T = function Loading(_ref) {
  var className = _ref.className,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " d-flex")
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex align-items-center justify-content-center flex-grow-1",
    backgroundColor: theme.loadings.iconContainerBgColor
  }), /*#__PURE__*/React.createElement("div", {
    className: "contacts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters justify-content-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 col-md-8 col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement(LoadingWithStyles$2, null))))))));
};

Loading$T.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var LoadingWithStyles$a = styled(Loading$T)(_templateObject$1D(), function (props) {
  return props.theme.components.subWebContacts.height;
}, function (props) {
  return props.theme.components.subWebContacts.height;
}, function (props) {
  return props.theme.components.subWebContacts.card.bgColor;
});
var Loading$U = withTheme(LoadingWithStyles$a);

function _templateObject$1E() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  .iframe-container {\n    height: ", ";\n    iframe {\n      height: 100%;\n      width: 100%;\n      border: none;\n    }\n  }\n\n  /*\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 40px;\n    top: 40px;\n    bottom: 40px;\n    left: 50%;\n    background-color: #fff;\n    z-index: 0;\n  }\n  */\n\n  .contacts {\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    //z-index: 1;\n\n    .content-container {\n      height: ", ";\n      padding: 50px 0;\n      .card {\n        pointer-events: all;\n        height: 100%;\n        padding: 50px 40px;\n        background-color: ", ";\n\n        .social-media-link {\n          width: 30px;\n          height: 30px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          text-decoration: none;\n          &:hover {\n            i {\n              color: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .contacts {\n      position: relative;\n      .container {\n        max-width: initial;\n      }\n      .content-container {\n        height: auto;\n        .card {\n          padding: 0;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$1E = function _templateObject() {
    return data;
  };

  return data;
}

var SocialMediaButton = function SocialMediaButton(_ref) {
  var name = _ref.name,
      theme = _ref.theme,
      href = _ref.href;
  return /*#__PURE__*/React.createElement("a", {
    className: "social-media-link",
    rel: "noopener noreferrer",
    href: href,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: name,
    color: theme.components.subWebContacts.card.iconColor,
    size: "xSmall"
  }));
};

SocialMediaButton.propTypes = {
  name: PropTypes$1.string,
  onClick: PropTypes$1.func,
  theme: PropTypes$1.object,
  href: PropTypes$1.string
};

var Card$3 = function Card(_ref2) {
  var theme = _ref2.theme,
      title = _ref2.title,
      data = _ref2.data,
      main = _ref2.main,
      social = _ref2.social,
      activeColor = _ref2.activeColor;
  return /*#__PURE__*/React.createElement("div", {
    className: "card d-flex flex-column"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: "xLarge",
    marginBottom: "25px",
    fontWeight: "500"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-grow-1"
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: main
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "25px"
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    activeColor: activeColor,
    content: data
  }))), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "25px"
  }, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, social.map(function (item, i) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: i
    }, /*#__PURE__*/React.createElement(SocialMediaButton, {
      name: theme.icons[item.type],
      href: item.url,
      theme: theme
    }));
  }))));
};

Card$3.propTypes = {
  theme: PropTypes$1.object,
  title: PropTypes$1.string,
  data: PropTypes$1.array,
  main: PropTypes$1.array,
  social: PropTypes$1.array
};

var Contacts = function Contacts(_ref3) {
  var className = _ref3.className,
      isLoading = _ref3.isLoading,
      theme = _ref3.theme,
      title = _ref3.title,
      data = _ref3.data,
      main = _ref3.main,
      mapUrl = _ref3.mapUrl,
      social = _ref3.social,
      activeColor = _ref3.activeColor;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    paddingTop: "0",
    hasBottomSpacing: false
  }, isLoading ? /*#__PURE__*/React.createElement(Loading$U, {
    theme: theme
  }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "iframe-container"
  }, /*#__PURE__*/React.createElement("iframe", {
    title: "google_maps",
    id: "gmap_canvas",
    src: mapUrl,
    frameBorder: "0",
    scrolling: "no",
    marginHeight: "0",
    marginWidth: "0"
  }, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: "contacts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters justify-content-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 col-md-8 col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(Card$3, {
    title: title,
    data: data,
    theme: theme,
    main: main,
    social: social,
    activeColor: activeColor
  }))))))));
};

var types$17 = {
  className: PropTypes$1.string,
  isLoading: PropTypes$1.bool,
  theme: PropTypes$1.object,
  title: PropTypes$1.string,
  data: PropTypes$1.array,
  main: PropTypes$1.array,
  mapUrl: PropTypes$1.string,
  activeColor: PropTypes$1.string,
  social: PropTypes$1.array
};
var defaults$12 = {
  activeColor: "#0EB4BD",
  isLoading: false,
  title: "Contactos do departamento",
  mapUrl: "https://maps.google.com/maps?q=university%20of%20aveiro&t=&z=13&ie=UTF8&iwloc=&output=embed"
};
Contacts.propTypes = types$17;
Contacts.defaultProps = defaults$12;
var ContactsWithStyles = styled(Contacts)(_templateObject$1E(), function (props) {
  return props.theme.components.subWebContacts.height;
}, function (props) {
  return props.theme.components.subWebContacts.height;
}, function (props) {
  return props.theme.components.subWebContacts.card.bgColor;
}, function (props) {
  return lighten(0.5, props.theme.components.subWebContacts.card.iconColor);
});
var index$x = withTheme(ContactsWithStyles); //Only used for the Storybook Props Table

var Loading$V = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(ScrollableTabsLoading, null), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "30px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 col-md-8 col"
  }, /*#__PURE__*/React.createElement(LoadingWithStyles$2, null))))));
};

Loading$V.propTypes = {
  className: PropTypes$1.string
};

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1F() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n  @media (min-width: 768px) {\n    display: flex;\n    justify-content: center;\n  }\n"]);

  _templateObject$1F = function _templateObject() {
    return data;
  };

  return data;
}
var ButtonContainer = styled.div(_templateObject$1F());
var CardContainer$3 = styled.div(_templateObject2$i());

var Card$4 = function Card(_ref) {
  var text = _ref.text,
      subTitle = _ref.subTitle,
      title = _ref.title,
      titleColor = _ref.titleColor,
      hasMoreLink = _ref.hasMoreLink,
      hasTitle = _ref.hasTitle,
      theme = _ref.theme,
      linkHoverColor = _ref.linkHoverColor,
      isMobile = _ref.isMobile;

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement(CardContainer$3, null, hasTitle && /*#__PURE__*/React.createElement(Text, {
    size: "article",
    color: theme.highContrast.text || titleColor || theme.components.subWebWarnings.card.titleColor,
    fontWeight: "400"
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    marginBottom: "15px",
    fontWeight: "400"
  }, subTitle), /*#__PURE__*/React.createElement(Text, {
    size: "article"
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: text,
    activeColor: titleColor,
    isMobile: isMobile
  }), hasMoreLink && /*#__PURE__*/React.createElement(Link, {
    fontSize: "inherit",
    fontWeight: "inherit",
    textDecoration: "underline",
    color: theme.components.subWebWarnings.card.linkColor,
    hoverColor: linkHoverColor
  }, "ler mais")));
};

Card$4.propTypes = {
  title: PropTypes$1.string,
  subTitle: PropTypes$1.string,
  text: PropTypes$1.string,
  hasMoreLink: PropTypes$1.bool,
  hasTitle: PropTypes$1.bool,
  theme: PropTypes$1.object,
  titleColor: PropTypes$1.string,
  activeColor: PropTypes$1.string,
  linkHoverColor: PropTypes$1.string,
  isMobile: PropTypes$1.bool
};
Card$4.defaultProps = {
  title: "Título",
  subTitle: "SubTítulo",
  text: "Texto",
  hasMoreLink: false,
  hasTitle: true,
  linkHoverColor: "#0EB4BD"
};

var Warnings = function Warnings(_ref2) {
  var className = _ref2.className,
      isLoading = _ref2.isLoading,
      theme = _ref2.theme,
      data = _ref2.data,
      tabs = _ref2.tabs,
      title = _ref2.title,
      action = _ref2.action,
      activeTab = _ref2.activeTab,
      onChangeTab = _ref2.onChangeTab,
      hasLink = _ref2.hasLink,
      activeColor = _ref2.activeColor,
      isMobile = _ref2.isMobile;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.subWebWarnings.backgroundColor
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: "/",
    hasContainer: true,
    hasLine: hasLink,
    hasLink: hasLink,
    textColor: theme.components.subWebWarnings.titleColor,
    marginBottom: tabs.length <= 0 && "0"
  }, title), isLoading ? /*#__PURE__*/React.createElement(Loading$V, null) : /*#__PURE__*/React.createElement(Fragment, null, tabs.length > 1 && /*#__PURE__*/React.createElement(ScrollableTabsWithStyles, {
    marginBottom: "0"
  }, tabs.map(function (tab, i) {
    return /*#__PURE__*/React.createElement(ScrollableTab, {
      key: i,
      isActive: tab.id === activeTab,
      text: tab.text,
      theme: theme,
      activeColor: activeColor,
      onClick: function onClick() {
        return onChangeTab(tab.id);
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, data.chunk(2).map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "row"
    }, res.map(function (content, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "col-sm-6 col-12"
      }, /*#__PURE__*/React.createElement(Card$4, _extends({}, content, {
        theme: theme,
        titleColor: activeColor,
        isMobile: isMobile,
        linkHoverColor: theme.highContrast.link || activeColor
      })));
    }));
  }), action.show && /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: action.onClick
  }, action.text)))));
};

var types$18 = {
  className: PropTypes$1.string,
  isLoading: PropTypes$1.bool,
  theme: PropTypes$1.object,
  data: PropTypes$1.array.isRequired,
  tabs: PropTypes$1.array.isRequired,
  title: PropTypes$1.string,
  activeTab: PropTypes$1.number,
  onChangeTab: PropTypes$1.func,
  action: PropTypes$1.object,
  hasLink: PropTypes$1.bool,
  activeColor: PropTypes$1.string,
  isMobile: PropTypes$1.bool
};
var defaults$13 = {
  isLoading: false,
  title: "Avisos",
  hasLink: true,
  action: {
    text: "ver mais",
    show: false,
    onClick: function onClick() {
      return null;
    }
  },
  activeColor: "#0EB4BD"
};
Warnings.propTypes = types$18;
Warnings.defaultProps = defaults$13;
var index$y = withTheme(Warnings); //Only used for the Storybook Props Table

function _templateObject$1G() {
  var data = _taggedTemplateLiteral(["\n  .row:first-child {\n    margin-bottom: 60px;\n  }\n"]);

  _templateObject$1G = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$W = function Loading(_ref) {
  var className = _ref.className,
      CardBgColor = _ref.CardBgColor,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-4"
  }, /*#__PURE__*/React.createElement(ShowMoreCardLoading, {
    CardBgColor: CardBgColor || theme.components.subWebCourses.backgroundColor
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-4"
  }, /*#__PURE__*/React.createElement(ShowMoreCardLoading, {
    CardBgColor: CardBgColor || theme.components.subWebCourses.backgroundColor
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-4"
  }, /*#__PURE__*/React.createElement(ShowMoreCardLoading, {
    CardBgColor: CardBgColor || theme.components.subWebCourses.backgroundColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-4"
  }, /*#__PURE__*/React.createElement(ShowMoreCardLoading, {
    CardBgColor: CardBgColor || theme.components.subWebCourses.backgroundColor
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-4"
  }, /*#__PURE__*/React.createElement(ShowMoreCardLoading, {
    CardBgColor: CardBgColor || theme.components.subWebCourses.backgroundColor
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-4"
  }, /*#__PURE__*/React.createElement(ShowMoreCardLoading, {
    CardBgColor: CardBgColor || theme.components.subWebCourses.backgroundColor
  })))));
};

Loading$W.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  CardBgColor: PropTypes$1.string
};
var LoadingWithStyles$b = styled(Loading$W)(_templateObject$1G());
var Loading$X = withTheme(LoadingWithStyles$b);

function _templateObject$1H() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: 576px) {\n    .row {\n      margin-left: -25px;\n      margin-right: -25px;\n    }\n\n    [class^=\"col-\"] {\n      padding-right: 25px;\n      padding-left: 25px;\n    }\n  }\n"]);

  _templateObject$1H = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled.div(_templateObject$1H());

var Courses$1 = function Courses(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      hasError = _ref.hasError,
      data = _ref.data,
      title = _ref.title,
      href = _ref.href,
      activeColor = _ref.activeColor;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    paddingBottom: "20px",
    smPaddingBottom: "55px",
    backgroundColor: theme.highContrast.backgroundColor || activeColor || theme.components.subWebCourses.backgroundColor
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: href,
    hasContainer: true,
    hasLine: true,
    hasLink: true,
    textColor: theme.components.subWebCourses.titleColor
  }, title), isLoading ? /*#__PURE__*/React.createElement(Loading$X, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Container, {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.map(function (course, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "col-md-4 col-6"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      height: "100%",
      padding: "0 0 50px 0",
      mobileSmPadding: "0 0 15px 0"
    }, /*#__PURE__*/React.createElement(ShowMoreCard$1, {
      title: course.info.value,
      href: course.extra,
      titleHoverColor: activeColor
    })));
  }))));
};

var types$19 = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  isLoading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  data: PropTypes$1.object,
  title: PropTypes$1.string.isRequired,
  activeColor: PropTypes$1.string,
  href: PropTypes$1.string
};
var defaults$14 = {
  title: "Cursos",
  href: "/"
};
Courses$1.defaultProps = defaults$14;
Courses$1.propTypes = types$19;
var index$z = withTheme(Courses$1); //Only used for the Storybook Props Table

function _templateObject$1I() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  min-height: ", ";\n\n  .image-container {\n    height: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 50%;\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .image-container {\n      position: relative;\n      width: 100%;\n    }\n  }\n"]);

  _templateObject$1I = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$Y = function Loading(_ref) {
  var className = _ref.className,
      maskBgColor = _ref.maskBgColor,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6 col-12"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    padding: "70px 0"
  }, /*#__PURE__*/React.createElement(LoadingWithStyles$2, {
    maskBgColor: maskBgColor
  }))))), /*#__PURE__*/React.createElement(ContentContainer, {
    className: "image-container",
    backgroundColor: theme.loadings.iconContainerBgColor
  }));
};

Loading$Y.propTypes = {
  className: PropTypes$1.string,
  maskBgColor: PropTypes$1.string,
  theme: PropTypes$1.object
};
var LoadingWithStyles$c = styled(Loading$Y)(_templateObject$1I(), function (props) {
  return props.theme.components.subWebDepartment.height;
}, function (props) {
  return props.theme.components.subWebDepartment.height;
});
var Loading$Z = withTheme(LoadingWithStyles$c);

function _templateObject$1J() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  min-height: ", ";\n\n  .content-container {\n    padding: 70px 30px 70px 0;\n  }\n\n  //Department Image\n  .dptGE {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 50%;\n\n    img {\n      min-height: ", ";\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .content-container {\n      padding: 70px 0;\n    }\n    //Department Image\n    .dptGE {\n      position: relative;\n      width: 100%;\n    }\n  }\n"]);

  _templateObject$1J = function _templateObject() {
    return data;
  };

  return data;
}

var Department = function Department(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      hasError = _ref.hasError,
      data = _ref.data,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    paddingTop: "0",
    hasBottomSpacing: false,
    backgroundColor: theme.components.subWebDepartment.backgroundColor
  }, isLoading ? /*#__PURE__*/React.createElement(Loading$Z, {
    maskBgColor: theme.components.subWebDepartment.backgroundColor
  }) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6 col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    hasContainer: false,
    hasLine: false,
    hasLink: false,
    textColor: theme.components.subWebDepartment.titleColor
  }, data.title), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    marginBottom: "50px"
  }, data.description), data.link !== null && /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: data.link,
    textDecoration: "none",
    variant: "default",
    backgroundColor: theme.components.subWebDepartment.backgroundColor
  }, data.buttonTitle === null || data.buttonTitle === undefined ? [
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-key
  React.createElement(FormattedMessage, {
    id: "app.organism.button.knowMore",
    defaultMessage: "Saber mais"
  })] : [data.buttonTitle]))))), /*#__PURE__*/React.createElement(PictureContainer, {
    className: "dptGE",
    src: data.imageUrl,
    alt: data.title,
    isLocal: false,
    hasEndpoint: false,
    height: "100%"
  })));
};

var types$1a = {
  className: PropTypes$1.string,
  isLoading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  data: PropTypes$1.object,
  theme: PropTypes$1.object
};
var defaults$15 = {
  isLoading: false
};
Department.propTypes = types$1a;
Department.defaultProps = defaults$15;
var DepartmentWithStyles = styled(Department)(_templateObject$1J(), function (props) {
  return props.theme.components.subWebDepartment.height;
}, function (props) {
  return props.theme.components.subWebDepartment.height;
});
var index$A = withTheme(DepartmentWithStyles); //Only used for the Storybook Props Table

var Selects$1 = function Selects(_ref) {
  var theme = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "42px",
    marginBottom: "54px",
    className: "d-flex flex-column justify-content-center",
    mobileXsHeight: "auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "80%",
    mobileXsMarginBottom: "40px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "30px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(SelectLoading, theme)), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(SelectLoading, theme))))));
};

var Card$5 = function Card(_ref2) {
  var borderBottom = _ref2.borderBottom,
      theme = _objectWithoutProperties(_ref2, ["borderBottom"]);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    borderTop: "1px solid ".concat(theme.loadings.lightBorderColor),
    borderBottom: borderBottom,
    padding: "20px 0",
    height: "140px"
  }, /*#__PURE__*/React.createElement(LoadingWithStyles$2, {
    fullSize: false
  }));
};

Card$5.propTypes = {
  borderBottom: PropTypes$1.string
};

var Loading$_ = function Loading(_ref3) {
  var className = _ref3.className,
      theme = _ref3.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 col"
  }, /*#__PURE__*/React.createElement(Selects$1, theme), /*#__PURE__*/React.createElement(ContentContainer, {
    width: "100px",
    marginBottom: "33px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "26px"
  })), /*#__PURE__*/React.createElement(Card$5, theme), /*#__PURE__*/React.createElement(Card$5, theme), /*#__PURE__*/React.createElement(Card$5, theme), /*#__PURE__*/React.createElement(Card$5, _extends({}, theme, {
    borderBottom: "1px solid ".concat(theme.loadings.lightBorderColor)
  }))))));
};

Loading$_.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var Loading$$ = withTheme(Loading$_);

function _templateObject$1K() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1K = function _templateObject() {
    return data;
  };

  return data;
}

var Card$6 = function Card(_ref) {
  var title = _ref.title,
      theme = _ref.theme,
      data = _ref.data,
      url = _ref.url,
      note = _ref.note;
  return /*#__PURE__*/React.createElement(BorderedCardWithStyles, {
    borderColor: theme.components.subWebDepartmentCourses.card.borderColor,
    contentContainerPadding: "20px 0",
    cardIsLink: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: url,
    hasContainer: false,
    hasLine: true,
    hasLink: true,
    textColor: theme.components.subWebDepartmentCourses.card.titleColor,
    fontSize: "18px",
    marginBottom: "20px",
    fontWeight: "400"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "article",
    color: theme.components.subWebDepartmentCourses.card.subTitle,
    marginBottom: "2px",
    textAlign: "end",
    marginTop: "2px"
  }, note))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, data.map(function (item, index) {
    var isLastChild = data.length === index + 1;
    var props = isLastChild ? {
      marginBottom: "2px",
      mobileXsMarginTop: "10px"
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: isLastChild ? "col-sm col-12" : "col"
    }, /*#__PURE__*/React.createElement(Text, _extends({
      size: "article",
      color: theme.components.subWebDepartmentCourses.card.subTitle,
      marginBottom: "2px"
    }, props), item.value), /*#__PURE__*/React.createElement(Text, {
      size: "article"
    }, item.label));
  })));
};

Card$6.propTypes = {
  title: PropTypes$1.string,
  theme: PropTypes$1.object,
  data: PropTypes$1.object,
  url: PropTypes$1.string,
  note: PropTypes$1.string
};
Card$6.defaultProps = {
  title: "Título",
  scientificArea: "Texto",
  regime: "Texto",
  semesters: "Texto",
  time: "Texto"
};

var DepartmentCourses = function DepartmentCourses(_ref2) {
  var className = _ref2.className,
      theme = _ref2.theme,
      isLoading = _ref2.isLoading,
      hasError = _ref2.hasError,
      data = _ref2.data,
      lang = _ref2.lang,
      filters = _ref2.filters,
      onChangeFilter = _ref2.onChangeFilter;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    hasHighContrastBorderTop: false
  }, isLoading ? /*#__PURE__*/React.createElement(Loading$$, {
    theme: theme
  }) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "xLarge",
    fontWeight: "500",
    mobileXsMarginBottom: "40px"
  }, "Cursos")), /*#__PURE__*/React.createElement("div", {
    className: "col d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filters.map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "col"
    }, /*#__PURE__*/React.createElement(Select, {
      variant: "black",
      onChange: function onChange(e) {
        return onChangeFilter(e, res.jsonField);
      } //isLoading={channels.length <= 0}
      ,
      defaultValue: res.defaultValues,
      options: res.options,
      placeholder: res.title,
      label: res.title,
      isClearable: true
    }));
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-3 col-xl-7 col"
  }, Object.keys(data).length <= 0 ? /*#__PURE__*/React.createElement(ErrorWithStyles, null, "Sem conte\xFAdos para o filtro.") : data.filter(function (result) {
    return result.list.length > 0;
  }).map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section.title
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      size: "large",
      fontWeight: "400",
      marginBottom: "30px",
      marginTop: "50px",
      color: theme.components.subWebDepartmentCourses.subTitleColor
    }, section.title, section.subtitle && /*#__PURE__*/React.createElement(Text, {
      as: "span",
      size: "large",
      fontWeight: "200",
      marginLeft: "10px",
      color: theme.components.subWebDepartmentCourses.subTitleColor
    }, section.subtitle)), section.list.map(function (item) {
      return /*#__PURE__*/React.createElement(Card$6, {
        url: "/".concat(lang, "/").concat(lang === "pt" ? "curso" : "course", "/").concat(item.id),
        key: item.id,
        title: item.name,
        theme: theme,
        data: item.list,
        note: item.note
      });
    }));
  }))))));
};

var types$1b = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object,
  isLoading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  data: PropTypes$1.object,
  lang: PropTypes$1.string,
  filters: PropTypes$1.array,
  onChangeFilter: PropTypes$1.func
};
DepartmentCourses.propTypes = types$1b;
var DepartmentCoursesWithStyles = styled(DepartmentCourses)(_templateObject$1K());
var index$B = compose(withTheme)(DepartmentCoursesWithStyles); //Only used for the Storybook Props Table

var Loading$10 = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    className: className,
    marginBottom: "70px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-12"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    lgMarginBottom: "30px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "30px",
    width: "110px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-md-3 col-sm-4 col-6"
  }, /*#__PURE__*/React.createElement(PeopleCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-md-3 col-sm-4 col-6"
  }, /*#__PURE__*/React.createElement(PeopleCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-md-3 col-sm-4 col-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsMarginTop: "70px"
  }, /*#__PURE__*/React.createElement(PeopleCardLoading, null)))))), /*#__PURE__*/React.createElement(ContentContainer, {
    className: "row no-gutters",
    marginTop: "110px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-12"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    lgMarginBottom: "30px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "30px",
    width: "110px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-md-3 col-sm-4 col-6"
  }, /*#__PURE__*/React.createElement(PeopleCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-md-3 col-sm-4 col-6"
  }, /*#__PURE__*/React.createElement(PeopleCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3 col-md-3 col-sm-4 col-6"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    mobileXsMarginTop: "70px"
  }, /*#__PURE__*/React.createElement(PeopleCardLoading, null))))))));
};

Loading$10.propTypes = {
  className: PropTypes$1.string
};
var Loading$11 = withTheme(Loading$10);

function _templateObject$1L() {
  var data = _taggedTemplateLiteral(["\n  .people-row:not(:last-child) {\n    margin-bottom: 40px;\n  }\n"]);

  _templateObject$1L = function _templateObject() {
    return data;
  };

  return data;
}

var People = function People(_ref) {
  var title = _ref.title,
      className = _ref.className,
      isLoading = _ref.isLoading,
      selected = _ref.selected,
      tabs = _ref.tabs,
      data = _ref.data,
      hasError = _ref.hasError,
      theme = _ref.theme,
      onChangeTab = _ref.onChangeTab,
      isTabsLoading = _ref.isTabsLoading,
      lang = _ref.lang,
      popcorn = _ref.popcorn,
      activeColor = _ref.activeColor;

  var _useConfig = useConfig(),
      portalAPI = _useConfig.portalAPI;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    hasBottomSpacing: false,
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-lg-3 col"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "xLarge",
    fontWeight: "500",
    marginBottom: "70px"
  }, title)))), isTabsLoading ? /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "50px"
  }, /*#__PURE__*/React.createElement(ScrollableTabsLoading, {
    offsetClasses: "offset-lg-3"
  })) : /*#__PURE__*/React.createElement(ScrollableTabsWithStyles, {
    offSetClasses: "offset-lg-3"
  }, tabs.map(function (item, i) {
    return /*#__PURE__*/React.createElement(ScrollableTab, _extends({
      key: i,
      text: item.label,
      isActive: item.value === selected,
      onClick: function onClick() {
        return onChangeTab(item.value);
      },
      activeColor: activeColor
    }, theme));
  })), isLoading ? /*#__PURE__*/React.createElement(Loading$11, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, data.map(function (res, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "row no-gutters people-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-lg-3 col-12"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      width: "60%",
      mobileMdWidth: "100%",
      mdMarginBottom: "30px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "large",
      color: theme.highContrast.text || activeColor || theme.components.subWebPeople.titleColor,
      fontWeight: "400"
    }, res.title))), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, res.list.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.uuid !== undefined ? item.uuid : item.id,
        className: "col-lg-3 col-md-3 col-sm-4 col-6"
      }, /*#__PURE__*/React.createElement(PeopleCard$1, {
        src: popcorn ? "".concat(portalAPI, "/person/").concat(item.id, "/photo?getdefault=true") : item.image,
        name: item.name,
        email: item.email[0],
        extension: item.contactsList,
        href: "/".concat(lang, "/p/").concat(item.id),
        hasPhoto: item.showPhoto,
        lang: lang
      }));
    }))));
  }))));
};

var types$1c = {
  className: PropTypes$1.string,
  isLoading: PropTypes$1.bool,
  selected: PropTypes$1.bool,
  tabs: PropTypes$1.array,
  data: PropTypes$1.array,
  hasError: PropTypes$1.bool,
  theme: PropTypes$1.object,
  onChangeTab: PropTypes$1.func,
  isTabsLoading: PropTypes$1.bool,
  lang: PropTypes$1.string,
  popcorn: PropTypes$1.bool,
  activeColor: PropTypes$1.string,
  title: PropTypes$1.string
};
var defaults$16 = {
  title: "Pessoas",
  lang: "pt",
  popcorn: false,
  activeColor: "#0EB4BD"
};
People.defaultProps = defaults$16;
People.propTypes = types$1c;
var PeopleWithStyles = styled(People)(_templateObject$1L());
var index$C = compose(withSize(), withTheme)(PeopleWithStyles); //Only used for the Storybook Props Table

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n  p.markdown {\n    color: ", ";\n    padding-bottom: 0;\n    a {\n      color: ", ";\n      text-decoration-color: ", ";\n      padding-bottom: 0;\n      &:hover {\n        color: ", ";\n        text-decoration-color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1M() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: 768px) {\n    column-count: 2;\n    -moz-column-count: 2;\n    -webkit-column-count: 2;\n    column-gap: 30px;\n    -moz-column-gap: 30px;\n    -webkit-column-gap: 30px;\n  }\n"]);

  _templateObject$1M = function _templateObject() {
    return data;
  };

  return data;
}
var TextContainer$2 = styled.div(_templateObject$1M());

var Schedule = function Schedule(_ref) {
  var className = _ref.className,
      title = _ref.title,
      subTitle = _ref.subTitle,
      description = _ref.description,
      action = _ref.action,
      isLoading = _ref.isLoading,
      isClosed = _ref.isClosed,
      hasLink = _ref.hasLink,
      href = _ref.href,
      withColumns = _ref.withColumns,
      theme = _ref.theme,
      data = _ref.data,
      activeColor = _ref.activeColor;
  var backgroundColor = isClosed ? theme.components.subWebSchedule.backgroundColor.isClosed : theme.components.subWebSchedule.backgroundColor.isOpen;
  var textColor = isClosed ? theme.components.subWebSchedule.textColor.isClosed : theme.components.subWebSchedule.textColor.isOpen;
  var linkColor = isClosed ? theme.components.subWebSchedule.linkColor.isClosed : theme.components.subWebSchedule.linkColor.isOpen;
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: href,
    hasLine: hasLink,
    hasLink: hasLink,
    hasContainer: true,
    textColor: hasLink ? linkColor : textColor
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, isLoading ? /*#__PURE__*/React.createElement(LoadingWithStyles$2, {
    maskBgColor: backgroundColor
  }) : /*#__PURE__*/React.createElement(Fragment, null, withColumns ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md col-12 d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    smMarginbottom: "50px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    fontWeight: "400",
    color: textColor
  }, subTitle), /*#__PURE__*/React.createElement(Text, {
    size: "article",
    color: textColor
  }, description))), data.length > 0 && data.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "col-md col-12"
    }, /*#__PURE__*/React.createElement(ContentContainer, {
      smMarginbottom: "50px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "article",
      fontWeight: "400",
      color: textColor,
      marginBottom: "20px"
    }, item.title), /*#__PURE__*/React.createElement(Text, {
      size: "large",
      fontWeight: "400",
      color: textColor
    }, /*#__PURE__*/React.createElement("time", null, item.subTitle)), /*#__PURE__*/React.createElement(Text, {
      size: "article",
      color: textColor,
      marginBottom: "20px"
    }, item.description), /*#__PURE__*/React.createElement(MarkdownRenderer, {
      activeColor: activeColor,
      content: item.content
    })));
  })) : /*#__PURE__*/React.createElement(TextContainer$2, null, data.length > 0 && data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MarkdownRenderer, {
      activeColor: activeColor,
      key: index,
      content: item.content
    });
  })), action.show && /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: withColumns ? "15px" : "50px",
    smMargintop: "50px"
  }, /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: action.href,
    display: "inline-flex",
    textDecoration: "none",
    border: "1px solid ".concat(textColor),
    color: textColor,
    hoverColor: backgroundColor,
    hoverBackgroundColor: textColor,
    backgroundColor: backgroundColor
  }, action.text)))));
};

var types$1d = {
  className: PropTypes$1.string,
  isLoading: PropTypes$1.bool,
  theme: PropTypes$1.object,
  title: PropTypes$1.string,
  subTitle: PropTypes$1.string,
  description: PropTypes$1.string,
  isClosed: PropTypes$1.bool,
  href: PropTypes$1.string,
  hasLink: PropTypes$1.bool,
  withColumns: PropTypes$1.bool,
  data: PropTypes$1.array.isRequired,
  action: PropTypes$1.object,
  activeColor: PropTypes$1.string
};
var defaults$17 = {
  title: "Horário de atendimento",
  subTitle: "Fechado",
  description: "abre ás 09h00",
  isLoading: false,
  isClosed: true,
  hasLink: false,
  withColumns: true,
  href: "#",
  action: {
    text: "Saber mais",
    href: "/caminho",
    show: false
  },
  activeColor: "#0EB4BD"
};
Schedule.propTypes = types$1d;
Schedule.defaultProps = defaults$17;
var ScheduleWithStyles = styled(Schedule)(_templateObject2$j(), function (props) {
  return props.isClosed ? props.theme.components.subWebSchedule.textColor.isClosed : props.theme.components.subWebSchedule.textColor.isOpen;
}, function (props) {
  return props.isClosed ? props.theme.components.subWebSchedule.linkColor.isClosed : props.theme.components.subWebSchedule.linkColor.isOpen;
}, function (props) {
  return props.isClosed ? props.theme.components.subWebSchedule.linkColor.isClosed : props.theme.components.subWebSchedule.linkColor.isOpen;
}, function (props) {
  return props.theme.highContrast.link || props.activeColor || props.theme.components.subWebSchedule.linkColor.hover;
}, function (props) {
  return props.theme.highContrast.link || props.activeColor || props.theme.components.subWebSchedule.linkColor.hover;
});
var index$D = withTheme(ScheduleWithStyles); //Only used for the Storybook Props Table

var Loading$12 = function Loading(_ref) {
  var className = _ref.className,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    className: className,
    marginTop: "50px",
    backgroundColor: theme.loadings.mainBgColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg col-12"
  }, /*#__PURE__*/React.createElement(EventCardLoading, {
    cardBgColor: theme.components.subWebEvents.card.bgColor.lightGray
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-lg col-12"
  }, /*#__PURE__*/React.createElement(EventCardLoading, {
    orderClasses: ["order-lg-0 order-md-1 order-sm-1 order-1", "order-lg-1 order-md-0 order-sm-0 order-0"]
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg col-12"
  }, /*#__PURE__*/React.createElement(EventCardLoading, {
    orderClasses: ["order-lg-1 order-md-0 order-sm-0 order-0", "order-lg-0 order-md-1 order-sm-1 order-1"]
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-lg col-12"
  }, /*#__PURE__*/React.createElement(EventCardLoading, {
    orderClasses: ["order-1", "order-0"]
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters justify-content-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 col-12"
  }, /*#__PURE__*/React.createElement(EventCardLoading, {
    cardBgColor: theme.components.subWebEvents.card.bgColor.darkGray,
    orderClasses: ["order-lg-1 order-md-0 order-sm-0 order-0", "order-lg-0 order-md-1 order-sm-1 order-1"]
  }))));
};

Loading$12.propTypes = {
  className: PropTypes$1.string,
  theme: PropTypes$1.object
};
var Loading$13 = withTheme(Loading$12);

function _templateObject$1N() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 50px;\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    .card-md-order-left {\n      .triangle {\n        right: initial;\n        left: -48px;\n        transform: rotate(-90deg);\n      }\n    }\n\n    .card-md-order-right {\n      .triangle {\n        left: initial;\n        right: -48px;\n        transform: rotate(90deg);\n      }\n    }\n  }\n"]);

  _templateObject$1N = function _templateObject() {
    return data;
  };

  return data;
}
var CardsContainer = styled.div(_templateObject$1N());

var Events$1 = function Events(_ref) {
  var title = _ref.title,
      description = _ref.description,
      href = _ref.href,
      hasLink = _ref.hasLink,
      theme = _ref.theme,
      hasImageSection = _ref.hasImageSection,
      imageCover = _ref.imageCover,
      alt = _ref.alt,
      isLoading = _ref.isLoading,
      buttonLink = _ref.buttonLink,
      hasButton = _ref.hasButton,
      data = _ref.data,
      isMobilePreview = _ref.isMobilePreview;

  var getRowTypeProps = function getRowTypeProps(type) {
    switch (type) {
      case "left":
        return [{
          className: "card-md-order-right",
          changeXlTriangleOrder: true,
          orderClasses: ["order-lg-1 order-md-0 order-sm-0 order-0", "order-lg-0 order-md-1 order-sm-1 order-1"]
        }, {
          changeXlTriangleOrder: true,
          orderClasses: ["order-1", "order-0"]
        }];

      case "extend":
        return [{
          className: "card-md-order-right",
          changeXlTriangleOrder: true,
          textColor: theme.components.subWebEvents.card.text.light,
          backgroundColor: theme.components.subWebEvents.card.bgColor.darkGray,
          columnClasses: ["col", "col-lg-9 col"],
          orderClasses: ["order-lg-1 order-md-0 order-sm-0 order-0", "order-lg-0 order-md-1 order-sm-1 order-1"]
        }];

      default:
        return [{
          textColor: theme.components.subWebEvents.card.text.light,
          backgroundColor: theme.components.subWebEvents.card.bgColor.lightGray
        }, {
          className: "card-md-order-left",
          orderClasses: ["order-lg-0 order-md-1 order-sm-1 order-1", "order-lg-1 order-md-0 order-sm-0 order-0"]
        }];
    }
  };

  var mobilePreviewEventCardStyle = {
    flexBasis: "inherit"
  };
  return /*#__PURE__*/React.createElement(Fragment, null, hasImageSection && /*#__PURE__*/React.createElement(Section, {
    paddingTop: "0",
    paddingBottom: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, isLoading ? /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
    ratio: "sixteenByNine"
  }) : /*#__PURE__*/React.createElement(AspectRatioWithStyles, {
    ratio: "sixteenByNine"
  }, /*#__PURE__*/React.createElement(PictureContainer, {
    src: imageCover,
    alt: alt,
    height: "100%"
  })))), /*#__PURE__*/React.createElement(Section, {
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    href: href,
    marginBottom: "0",
    hasLine: hasLink,
    hasLink: hasLink,
    hasContainer: false,
    textColor: hasLink ? theme.components.subWebEvents.linkColor : theme.components.subWebEvents.color
  }, title)), hasButton ? /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(Link, {
    color: hasLink ? theme.components.subWebEvents.linkColor : theme.components.subWebEvents.color,
    href: buttonLink,
    size: "mediumSmall",
    textDecoration: "underline",
    lighten: true
  }, description)) : /*#__PURE__*/React.createElement(React.Fragment, null)), isLoading ? /*#__PURE__*/React.createElement(Loading$13, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CardsContainer, null, data.map(function (row, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "row no-gutters"
    }, row.cards.map(function (card, i) {
      var type = row.type;

      if (isMobilePreview) {
        if (i % 2 === 1 && type === "right") type = "left";else if (i % 2 === 0 && type === "left") type = "right";
      }

      var typeProps = getRowTypeProps(type);
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        style: isMobilePreview ? mobilePreviewEventCardStyle : {},
        className: row.type === "extend" ? "col-12" : "col-lg col-12"
      }, /*#__PURE__*/React.createElement(EventCard$1, _extends({}, typeProps[i], card)));
    }));
  })), hasButton ? /*#__PURE__*/React.createElement(ContentContainer, {
    className: "d-flex justify-content-center",
    marginTop: "50px"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    as: "a",
    href: buttonLink
  }, description)) : /*#__PURE__*/React.createElement(React.Fragment, null)))));
};

var types$1e = {
  href: PropTypes$1.string,
  hasLink: PropTypes$1.bool,
  hasImageSection: PropTypes$1.bool,
  imageCover: PropTypes$1.string,
  title: PropTypes$1.string,
  theme: PropTypes$1.object,
  alt: PropTypes$1.string,
  isLoading: PropTypes$1.string,
  description: PropTypes$1.string,
  buttonLink: PropTypes$1.string,
  hasButton: PropTypes$1.bool,
  data: PropTypes$1.array.isRequired,
  isMobilePreview: PropTypes$1.bool
};
var defaults$18 = {
  title: "Título",
  href: "#",
  hasLink: true,
  hasImageSection: true,
  imageCover: "",
  alt: "imagem sem alt",
  isLoading: false,
  description: "ver programa completo",
  data: [],
  buttonLink: "",
  hasButton: false,
  isMobilePreview: false
};
Events$1.propTypes = types$1e;
Events$1.defaultProps = defaults$18;
var index$E = withTheme(Events$1); //Only used for the Storybook Props Table

function _templateObject$1O() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .loading-card-animated-background {\n      height: 122px;\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n  .loading-card-animated-background {\n    height: 100px;\n  }\n"]);

  _templateObject$1O = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$14 = function Loading(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["className", "theme"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "horizontal-cards"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(HorizontalNewsCardLoading, _extends({}, props, {
    contentContainerBgColor: theme.loadings.journalHighlights.horizontalNewsCard.bgColor,
    maskBgColor: theme.loadings.journalHighlights.horizontalNewsCard.maskColor,
    columnFullSize: true,
    changeMdOrder: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-12"
  }, /*#__PURE__*/React.createElement(HorizontalNewsCardLoading, props)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-6 col-lg-6 col-12"
  }, /*#__PURE__*/React.createElement(HorizontalNewsCardLoading, _extends({}, props, {
    changeMdOrder: true
  }))))));
};

Loading$14.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$d = styled(Loading$14)(_templateObject$1O(), function (props) {
  return props.theme.loadings.journalHighlights.backgroundColor;
});
var Loading$15 = withTheme(LoadingWithStyles$d);

function _templateObject$1P() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    //Change triangle position on card with different order\n    .change-order-card {\n      .triangle {\n        left: -33px;\n        right: unset;\n        transform: rotate(-90deg);\n      }\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .highlight-card {\n      .image-container {\n        .news-plus-button {\n          top: unset;\n          bottom: 170px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$1P = function _templateObject() {
    return data;
  };

  return data;
}

var Highlights = function Highlights(_ref) {
  var className = _ref.className,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      size = _ref.size,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["className", "data", "loading", "hasError", "size", "theme"]);

  return /*#__PURE__*/React.createElement("section", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$15, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, data.list.filter(function (_, index) {
    return index === 0;
  }).map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id
    }, size.width <= 575 ? /*#__PURE__*/React.createElement(NewsCard$1, _extends({
      className: "highlight-card",
      data: _objectSpread2({
        imageCover: _objectSpread2({}, item.image),
        alt: item.image.alt !== null ? item.image.alt : ""
      }, item),
      cardBgColor: theme.components.journalHighlights.highlightCardBgColor,
      plusButtonBgColor: theme.components.journalHighlights.highlightCardBgColor,
      imageBgColor: "#fff",
      hasShareIcon: true,
      size: size,
      share: item.share,
      history: props.history,
      changeImageVerticalOrder: true,
      centerPlusButton: true,
      hasColAuto: false
    }, props)) : /*#__PURE__*/React.createElement(HorizontalNewsCard$1, _extends({
      className: "change-order-card",
      src: item.image !== null && item.image.url !== null ? item.image.url : "",
      alt: item.image !== null && item.image.alt !== null ? item.image.alt : "",
      href: item.url,
      category: item.category,
      title: item.title,
      date: moment(item.startDate).format("DD MMMM YYYY"),
      categoryUrl: item.categoryUrl,
      share: item.share,
      contentContainerBgColor: theme.components.journalHighlights.highlightCardBgColor,
      triangleBgColor: theme.components.journalHighlights.highlightCardBgColor,
      size: size,
      changeMdOrder: true
    }, props)));
  }), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, data.list.filter(function (_, index) {
    return index >= 1 && index <= 3;
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "col-xl col-lg col-md-12"
    }, /*#__PURE__*/React.createElement(HorizontalNewsCard$1, _extends({
      className: index === 1 && "change-order-card",
      src: item.image !== null && item.image.url !== null ? item.image.url : "",
      href: item.url,
      alt: item.image.alt,
      category: item.category,
      title: item.title,
      date: moment(item.startDate).format("DD MMMM YYYY"),
      changeMdOrder: index === 1,
      categoryUrl: item.categoryUrl,
      share: item.share,
      size: size
    }, props)));
  })))));
};

var types$1f = {
  className: PropTypes$1.string,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  hasHash: PropTypes$1.string,
  route: PropTypes$1.string,
  lang: PropTypes$1.string,
  categoryId: PropTypes$1.number,
  history: PropTypes$1.object.isRequired,
  size: PropTypes$1.object,
  theme: PropTypes$1.object
};
Highlights.propTypes = types$1f;
var HighlightsWithStyles = styled(Highlights)(_templateObject$1P(), function (props) {
  return props.theme.components.journalHighlights.backgroundColor;
});
var index$F = compose(withSize(), withTheme)(HighlightsWithStyles); //Only used for the Storybook Props Table

function _templateObject$1Q() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: ", ";\n  .row {\n    height: ", ";\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    height: ", ";\n    .row {\n      height: ", ";\n    }\n  }\n"]);

  _templateObject$1Q = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$o = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.bgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$d = function LoadingCard(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 col-lg-auto col"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "125px",
    mobileLgMarginRight: "30px"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    width: "104px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "20px"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-auto"
  }, size.width >= 991 ? /*#__PURE__*/React.createElement(ContentContainer, {
    width: "635px"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "15px"
  }, /*#__PURE__*/React.createElement(Mask$o, _extends({
    height: "15px",
    left: "52px",
    width: "20px"
  }, props)), /*#__PURE__*/React.createElement(Mask$o, _extends({
    height: "15px",
    left: "112px",
    width: "20px"
  }, props)), /*#__PURE__*/React.createElement(Mask$o, _extends({
    height: "15px",
    left: "184px",
    width: "20px"
  }, props)), /*#__PURE__*/React.createElement(Mask$o, _extends({
    height: "15px",
    left: "279px",
    width: "20px"
  }, props)), /*#__PURE__*/React.createElement(Mask$o, _extends({
    height: "15px",
    left: "423px",
    width: "20px"
  }, props)), /*#__PURE__*/React.createElement(Mask$o, _extends({
    height: "15px",
    left: "502px",
    width: "20px"
  }, props)))) : /*#__PURE__*/React.createElement(Icon, {
    name: "fal fa-ellipsis-v",
    color: props.theme.loadings.journalNavigation.iconColor,
    size: "large"
  })));
};

LoadingCard$d.propTypes = {
  size: PropTypes$1.object
};

var Loading$16 = function Loading(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(LoadingCard$d, props)));
};

Loading$16.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$e = styled(Loading$16)(_templateObject$1Q(), function (props) {
  return props.theme.loadings.bgColor;
}, function (props) {
  return props.navigationLoadingHeight || "139px";
}, function (props) {
  return props.navigationLoadingHeight || "139px";
}, function (props) {
  return props.mobileNavigationLoadingHeight || "72px";
}, function (props) {
  return props.mobileNavigationLoadingHeight || "72px";
});
Loading$16.propTypes = {
  navigationLoadingHeight: PropTypes$1.string,
  mobileNavigationLoadingHeight: PropTypes$1.string
};
var Loading$17 = compose(withSize(), withTheme)(LoadingWithStyles$e);

function _templateObject$1R() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  z-index: 98;\n  // Add Shadow on Journal Navigation After 40px scroll\n  ", "\n\n  .nav-container {\n    height: auto;\n    .link-container {\n      min-width: 125px;\n      margin-right: 30px;\n    }\n    .row {\n      transition: height 0.4s ease;\n      -webkit-transition: height 0.4s ease;\n      height: ", ";\n    }\n    li {\n      margin-right: 18px;\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n    button {\n      background-color: transparent;\n      border: none;\n      cursor: pointer;\n      &:hover {\n        i {\n          color: ", ";\n        }\n      }\n    }\n  }\n  // Medium devices (tablets, less than 1200px)\n  @media (max-width: 1199px) {\n    .nav-container {\n      position: relative;\n      height: auto;\n      z-index: 3;\n\n      .row {\n        height: ", ";\n        transition: height 0.2s ease;\n        -webkit-transition: height 0.2s ease;\n      }\n\n      ", "\n    }\n\n    .nav-container,\n    .menu-list {\n      background-color: ", ";\n    }\n\n    /*Menu List*/\n    .menu-list {\n      z-index: 2;\n      position: absolute;\n      top: calc(", " - 20px);\n      width: 100%;\n      overflow: hidden;\n      background-color: ", ";\n      .list-container {\n        padding: 20px 0;\n      }\n      li {\n        margin-right: 0;\n        margin-bottom: 5px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n      a {\n        display: block;\n        padding: 10px 0;\n      }\n      box-shadow: ", ";\n      -moz-box-shadow: ", ";\n      -webkit-box-shadow: ", ";\n      -o-box-shadow: ", ";\n    }\n\n    /*Initial state*/\n    .closed-menu {\n      max-height: 0;\n      height: 0;\n      visibility: hidden;\n    }\n\n    /*Animation*/\n    .open-menu {\n      transition: max-height ", " ease-in;\n      visibility: visible;\n      max-height: 440px;\n      a {\n        -webkit-animation: fade-in-jn-items 0.6s ease-in;\n        -moz-animation: fade-in-jn-items 0.6s ease-in;\n        animation: fade-in-jn-items 0.6s ease-in;\n      }\n    }\n\n    .close-menu {\n      transition: all ", " ease-out;\n      visibility: hidden;\n      max-height: 0;\n      a {\n        -webkit-animation: fade-out-jn-items 0.2s ease-out forwards;\n        -moz-animation: fade-out-jn-items 0.2s ease-out forwards;\n        animation: fade-out-jn-items 0.2s ease-out forwards;\n      }\n    }\n\n    /*Fade-in Fade-out*/\n    @keyframes fade-out-jn-items {\n      0% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0;\n      }\n    }\n\n    @keyframes fade-in-jn-items {\n      0% {\n        opacity: 0;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  }\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .nav-container {\n      ", "\n    }\n  }\n\n  //Remove border by giving the same background color to maintain space\n  .nav-container.remove-border {\n    border-bottom-color: ", ";\n  }\n"]);

  _templateObject$1R = function _templateObject() {
    return data;
  };

  return data;
}
var classes = {
  initial: "closed-menu",
  close: "close-menu",
  open: "open-menu"
};
var heightTransitionTime = "0.4s";

var Navigation$1 = function Navigation(_ref) {
  var className = _ref.className,
      size = _ref.size,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      titleUrl = _ref.titleUrl,
      categoryId = _ref.categoryId,
      theme = _ref.theme,
      magazineLink = _ref.magazineLink,
      magazineTitle = _ref.magazineTitle,
      props = _objectWithoutProperties(_ref, ["className", "size", "data", "loading", "hasError", "titleUrl", "categoryId", "theme", "magazineLink", "magazineTitle"]);

  var initial = classes.initial,
      close = classes.close,
      open = classes.open;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(initial),
      _useState4 = _slicedToArray(_useState3, 2),
      menuClass = _useState4[0],
      setMenuClass = _useState4[1];

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage;

  useEffect(function () {
    setOpen(false);
  }, []);

  var onHandleAnimation = function onHandleAnimation() {
    if (isOpen) {
      setMenuClass(close);
      setTimeout(function () {
        setOpen(false);
      }, 600);
      return;
    }

    setMenuClass(open);
    setOpen(true);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, loading ? /*#__PURE__*/React.createElement(Loading$17, {
    navigationLoadingHeight: props.journalNavigationHeight,
    mobileNavigationLoadingHeight: props.journalMobileNavigationHeight
  }) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "nav-container ".concat(isOpen ? "remove-border" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    onClick: size.width < 1200 ? onHandleAnimation : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 col-lg col "
  }, /*#__PURE__*/React.createElement("div", {
    className: "link-container"
  }, /*#__PURE__*/React.createElement(Link, {
    href: titleUrl,
    display: "inline-block",
    color: theme.components.journalNavigation.titleColor
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "xLarge",
    fontWeight: "500",
    color: "inherit"
  }, props.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.resource,
    defaultMessage: props.title
  }) : props.title)))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-auto"
  }, size.width <= 1199 ? /*#__PURE__*/React.createElement("button", {
    "aria-label": isOpen ? "Fechar menu" : "Abrir menu",
    onClick: onHandleAnimation
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fal fa-ellipsis-v",
    color: theme.components.journalNavigation.menuIconColor,
    size: "large"
  })) : /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, data.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.id
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.url,
      fontWeight: "400",
      textDecoration: item.id === categoryId ? "underline" : "none",
      fontSize: "13px",
      color: theme.components.journalNavigation.linksColor
    }, item.name));
  }), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    href: magazineLink,
    fontWeight: "500",
    fontSize: "13px",
    color: theme.components.journalNavigation.linksColor
  }, magazineTitle))))))), size.width <= 1199 && /*#__PURE__*/React.createElement("div", {
    className: "menu-list ".concat(menuClass)
  }, isOpen && /*#__PURE__*/React.createElement("div", {
    className: "list-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "block"
  }, data.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.id
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.url,
      fontWeight: item.id === categoryId ? "500" : "400",
      fontSize: "16px",
      color: theme.components.journalNavigation.linksColor
    }, item.name));
  }), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    href: magazineLink,
    fontWeight: "500",
    fontSize: "16px",
    color: theme.components.journalNavigation.linksColor
  }, magazineTitle))))))));
};

var types$1g = {
  className: PropTypes$1.string,
  resource: PropTypes$1.string,
  title: PropTypes$1.string,
  titleUrl: PropTypes$1.string,
  route: PropTypes$1.string,
  size: PropTypes$1.object,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  categoryId: PropTypes$1.number,
  journalNavigationHeight: PropTypes$1.string,
  journalMobileNavigationHeight: PropTypes$1.string,
  theme: PropTypes$1.object,
  magazineLink: PropTypes$1.string,
  magazineTitle: PropTypes$1.string
};
Navigation$1.propTypes = types$1g;
var NavigationWithStyles = styled(Navigation$1)(_templateObject$1R(), function (props) {
  return props.theme.highContrast.backgroundColor || props.backgroundColor || props.theme.components.journalNavigation.backgroundColor;
}, function (props) {
  return props.journalNavigationShadow && "\n    box-shadow:\n    ".concat(props.theme.components.journalNavigation.boxShadow, ";\n    -moz-box-shadow:\n    ").concat(props.theme.components.journalNavigation.boxShadow, ";\n    -webkit-box-shadow:\n    ").concat(props.theme.components.journalNavigation.boxShadow, ";\n    -o-box-shadow:\n    ").concat(props.theme.components.journalNavigation.boxShadow, ";\n  ");
}, function (props) {
  return props.journalNavigationHeight;
}, lighten(0.5, "#000"), function (props) {
  return props.journalMobileNavigationHeight;
}, function (props) {
  return props.hasMobileMdBorderBottom && "  border-bottom: 1px solid\n            ".concat(props.theme.components.journalNavigation.mobileBorderBottomColor, ";\n     ");
}, function (props) {
  return props.theme.highContrast.backgroundColor || props.mobileBackgroundColor || props.theme.components.journalNavigation.backgroundColor;
}, function (props) {
  return props.journalMobileNavigationHeight;
}, function (props) {
  return props.theme.highContrast.backgroundColor || props.backgroundColor || props.theme.components.journalNavigation.backgroundColor;
}, function (props) {
  return props.theme.components.journalNavigation.boxShadow;
}, function (props) {
  return props.theme.components.journalNavigation.boxShadow;
}, function (props) {
  return props.theme.components.journalNavigation.boxShadow;
}, function (props) {
  return props.theme.components.journalNavigation.boxShadow;
}, heightTransitionTime, heightTransitionTime, function (props) {
  return props.hasMobileBorderBottom && "\n        border-bottom: 1px solid\n          ".concat(props.theme.components.journalNavigation.mobileBorderBottomColor, ";\n      ");
}, function (props) {
  return props.backgroundColor || props.theme.components.journalNavigation.backgroundColor;
});
var defaults$19 = {
  journalNavigationHeight: "139px",
  journalMobileNavigationHeight: "72px",
  hasMobileBorderBottom: false,
  hasMobileMdBorderBottom: false
};
NavigationWithStyles.defaultProps = defaults$19;
var index$G = compose(withSize(), withTheme)(NavigationWithStyles); //Only used for the Storybook Props Table

function _templateObject$1S() {
  var data = _taggedTemplateLiteral(["\n  .mini-cards {\n    margin-top: 20px;\n  }\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    background-color: ", ";\n    span.news-plus-button {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject$1S = function _templateObject() {
    return data;
  };

  return data;
}

var JournalNews = function JournalNews(_ref) {
  var className = _ref.className,
      backgroundColor = _ref.backgroundColor,
      titleProps = _ref.titleProps,
      size = _ref.size,
      sectionTitle = _ref.sectionTitle,
      smPaddingTop = _ref.smPaddingTop,
      loading = _ref.loading,
      hasError = _ref.hasError,
      data = _ref.data,
      theme = _ref.theme,
      arrowColor = _ref.arrowColor,
      props = _objectWithoutProperties(_ref, ["className", "backgroundColor", "titleProps", "size", "sectionTitle", "smPaddingTop", "loading", "hasError", "data", "theme", "arrowColor"]);

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var newsProps = _objectSpread2({
    backgroundColor: backgroundColor || theme.components.journalNews.backgroundColor,
    titleProps: titleProps,
    textColor: theme.components.journalNews.titleColor,
    size: size
  }, props);

  return size.width <= 767 ? /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: newsProps.backgroundColor,
    smPaddingTop: smPaddingTop
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Not\xEDcias"
  })), /*#__PURE__*/React.createElement(SectionHeader, _extends({
    href: props.categoryUrl,
    textColor: theme.components.journalNews.titleColor
  }, titleProps), props.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.resource,
    defaultMessage: sectionTitle
  }) : sectionTitle), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement("div", null, "A carregar...") : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.listNews.length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, data.listNews.filter(function (_, index) {
    return index === 0;
  }).map(function (item) {
    return /*#__PURE__*/React.createElement(NewsCard$1, {
      key: item.id,
      data: item,
      cardBgColor: "#fff",
      hasColAuto: false,
      hasShareIcon: true,
      hasCategoryTitle: props.categoryId !== item.categoryID,
      mobileCardBgColor: theme.components.journalNews.mobileNewsCardBgColor,
      onClick: props.onAction,
      onKeyPress: props.onEnter,
      size: size,
      history: props.history
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mini-cards"
  }, data.listNews.filter(function (_, index) {
    return index >= 1 && index <= 7;
  }).map(function (item) {
    return /*#__PURE__*/React.createElement(MiniHorizontalNewsCard$1, {
      key: item.id,
      src: item.imageCover !== null && item.imageCover.url,
      alt: item.imageCover.alt !== undefined ? item.imageCover.alt : "",
      category: item.category,
      title: item.title,
      date: moment(item.startDate).format("DD MMMM YYYY"),
      href: "".concat(props.hasHash).concat(item.url),
      onClick: props.onAction,
      onKeyPress: props.onEnter,
      history: props.history
    });
  }))))))) : /*#__PURE__*/React.createElement(News$1, _extends({
    title: sectionTitle,
    data: data,
    loading: loading,
    hasError: hasError,
    showHeader: true,
    arrowColor: theme.highContrast.action || arrowColor
  }, newsProps));
};

var types$1h = {
  title: PropTypes$1.string,
  sectionTitle: PropTypes$1.string,
  smPaddingTop: PropTypes$1.string,
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  size: PropTypes$1.object,
  hasError: PropTypes$1.bool,
  loading: PropTypes$1.bool,
  categoryUrl: PropTypes$1.string,
  categoryId: PropTypes$1.number,
  onAction: PropTypes$1.func,
  onEnter: PropTypes$1.func,
  data: PropTypes$1.object,
  history: PropTypes$1.object,
  hasHash: PropTypes$1.string,
  resource: PropTypes$1.string,
  arrowColor: PropTypes$1.string,
  theme: PropTypes$1.object
};
JournalNews.propTypes = types$1h;
var NewsWithStyles$1 = styled(JournalNews)(_templateObject$1S(), function (props) {
  return props.theme.components.journalNews.mobileBackgroundColor;
}, function (props) {
  return props.theme.components.journalNews.mobileNewsCardBgColor;
});
var JournalNews$1 = compose(withSize(), withTheme)(NewsWithStyles$1); //Only used for the Storybook Props Table

var Loading$18 = function Loading(_ref) {
  var className = _ref.className,
      size = _ref.size,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    smMarginbottom: "15px"
  }, /*#__PURE__*/React.createElement(PersonCardLoading, {
    CardBgColor: theme.loadings.journalCards.personCard.bgColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(PersonCardLoading, {
    CardBgColor: theme.loadings.journalCards.personCard.bgColor
  })), size.width >= 992 && /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(PersonCardLoading, {
    CardBgColor: theme.loadings.journalCards.personCard.bgColor
  }))));
};

Loading$18.propTypes = {
  className: PropTypes$1.string,
  size: PropTypes$1.object,
  theme: PropTypes$1.object
};
var Loading$19 = compose(withSize(), withTheme)(Loading$18);

function _templateObject$1T() {
  var data = _taggedTemplateLiteral(["\n  .mobile-person-card {\n    margin-bottom: 20px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .mobile-person-card {\n      margin-bottom: 15px;\n    }\n  }\n"]);

  _templateObject$1T = function _templateObject() {
    return data;
  };

  return data;
}

var Cards$1 = function Cards(_ref) {
  var className = _ref.className,
      backgroundColor = _ref.backgroundColor,
      titleProps = _ref.titleProps,
      size = _ref.size,
      sectionTitle = _ref.sectionTitle,
      cardBackgroundColor = _ref.cardBackgroundColor,
      cardTextColor = _ref.cardTextColor,
      smPaddingTop = _ref.smPaddingTop,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      theme = _ref.theme,
      isSlider = _ref.isSlider,
      props = _objectWithoutProperties(_ref, ["className", "backgroundColor", "titleProps", "size", "sectionTitle", "cardBackgroundColor", "cardTextColor", "smPaddingTop", "data", "loading", "hasError", "theme", "isSlider"]);

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  var newsProps = _objectSpread2({
    backgroundColor: backgroundColor,
    titleProps: titleProps,
    textColor: theme.components.journalNews.titleColor,
    size: size
  }, props); //Renders a slider only in desktop mode


  if (isSlider && size.width >= 767) {
    return /*#__PURE__*/React.createElement(News$1, _extends({
      title: sectionTitle,
      data: data,
      loading: loading,
      hasError: hasError,
      showHeader: true,
      hasFullHeightSlider: true
    }, newsProps));
  }

  return /*#__PURE__*/React.createElement(Section, {
    smPaddingTop: smPaddingTop,
    className: className,
    backgroundColor: backgroundColor || theme.components.journalCards.backgroundColor
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Entrevistas"
  })), /*#__PURE__*/React.createElement(SectionHeader, _extends({
    href: props.categoryUrl,
    textColor: theme.components.journalCards.titleColor
  }, titleProps), props.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.resource,
    defaultMessage: sectionTitle
  }) : sectionTitle), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$19, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : data.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : size.width <= 767 ? data.listNews.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "mobile-person-card"
    }, /*#__PURE__*/React.createElement(PersonCard$1, {
      imageTop: index > 0,
      title: item.title,
      name: item.pretitle,
      src: item.imageCover.url,
      alt: item.imageCover.alt !== undefined ? item.imageCover.alt : "",
      backgroundColor: theme.components.journalCards.personCardBgColor || cardBackgroundColor,
      textColor: theme.components.journalCards.cardTextColor || cardTextColor,
      url: item.url,
      titleIsSerif: true,
      size: size,
      share: item.share,
      history: props.history
    }));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.listNews.filter(function (items, index) {
    return size.width >= 992 ? items : index <= 1;
  }).map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "col"
    }, /*#__PURE__*/React.createElement(PersonCard$1, {
      title: item.title,
      name: item.pretitle,
      src: item.imageCover.url,
      alt: item.imageCover.alt !== undefined ? item.imageCover.alt : "",
      backgroundColor: theme.components.journalCards.personCardBgColor || cardBackgroundColor,
      textColor: theme.components.journalCards.cardTextColor || cardTextColor,
      url: item.url,
      titleIsSerif: true,
      size: size,
      share: item.share,
      history: props.history
    }));
  }))));
};

var defaults$1a = {
  isSlider: false
};
var types$1i = {
  sectionTitle: PropTypes$1.string,
  cardBackgroundColor: PropTypes$1.string,
  title: PropTypes$1.string,
  cardTextColor: PropTypes$1.string,
  smPaddingTop: PropTypes$1.string,
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  size: PropTypes$1.object,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  categoryId: PropTypes$1.number,
  categoryUrl: PropTypes$1.string,
  history: PropTypes$1.object.isRequired,
  resource: PropTypes$1.string,
  theme: PropTypes$1.object,
  isSlider: PropTypes$1.bool
};
Cards$1.propTypes = types$1i;
Cards$1.defaultProps = defaults$1a;
var NewsWithStyles$2 = styled(Cards$1)(_templateObject$1T());
var index$H = compose(withTheme, withSize())(NewsWithStyles$2); //Only used for the Storybook Props Table

function _templateObject$1U() {
  var data = _taggedTemplateLiteral(["\n  // Medium devices (tablets, 768px and up)\n  @media (max-width: 768px) {\n    .margin-sm {\n      margin-top: 15px;\n    }\n  }\n"]);

  _templateObject$1U = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$1a = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12 margin-sm"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null))));
};

Loading$1a.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$f = styled(Loading$1a)(_templateObject$1U());

var Loading$1b = function Loading() {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(BorderedCardLoading, null), /*#__PURE__*/React.createElement(BorderedCardLoading, null), /*#__PURE__*/React.createElement(BorderedCardLoading, null), /*#__PURE__*/React.createElement(BorderedCardLoading, null));
};

function _templateObject$1V() {
  var data = _taggedTemplateLiteral(["\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 50%;\n    background-color: ", ";\n  }\n\n  .container-left {\n    .Section-Header {\n      position: relative;\n      z-index: 1;\n    }\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 15px;\n      right: 0;\n      height: 100%;\n      width: 100%;\n      z-index: 0;\n      background-color: ", ";\n    }\n  }\n\n  .container-left,\n  .container-right {\n    padding: 70px 0;\n  }\n  .container-right {\n    background-color: ", ";\n    padding-left: 30px;\n    height: 100%;\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    &:before {\n      content: none;\n    }\n    .container-left {\n      &:before {\n        content: none;\n      }\n    }\n    .container-right {\n      padding-left: 0;\n    }\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .container-left {\n      .more-news-card {\n        margin-bottom: 20px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .container-left {\n      .more-news-card {\n        margin-bottom: 15px;\n      }\n    }\n  }\n"]);

  _templateObject$1V = function _templateObject() {
    return data;
  };

  return data;
}

var Card$7 = function Card(_ref) {
  var category = _ref.category,
      title = _ref.title,
      date = _ref.date,
      url = _ref.url,
      linkColor = _ref.linkColor,
      props = _objectWithoutProperties(_ref, ["category", "title", "date", "url", "linkColor"]);

  var _useConfig = useConfig(),
      Link = _useConfig.link;

  return /*#__PURE__*/React.createElement(BorderedCardWithStyles, {
    href: url,
    history: props.history
  }, /*#__PURE__*/React.createElement(Link, {
    as: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      props.history.push(props.categoryUrl);
    },
    fontSize: "14px",
    fontWeight: 300,
    style: {
      border: 0,
      backgroundColor: "transparent"
    },
    color: linkColor
  }, category), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    fontWeight: "400"
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "xSmall",
    marginTop: "10px",
    textTransform: "lowercase"
  }, date));
};

Card$7.propTypes = {
  title: PropTypes$1.string,
  category: PropTypes$1.string,
  url: PropTypes$1.string,
  date: PropTypes$1.string,
  categoryUrl: PropTypes$1.string,
  history: PropTypes$1.object.isRequired,
  linkColor: PropTypes$1.string
};

var More$1 = function More(_ref2) {
  var className = _ref2.className,
      backgroundColor = _ref2.backgroundColor,
      titleProps = _ref2.titleProps,
      sectionTitle = _ref2.sectionTitle,
      rightSectionTitle = _ref2.rightSectionTitle,
      size = _ref2.size,
      data = _ref2.data,
      hasError = _ref2.hasError,
      loading = _ref2.loading,
      onEnter = _ref2.onEnter,
      theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, ["className", "backgroundColor", "titleProps", "sectionTitle", "rightSectionTitle", "size", "data", "hasError", "loading", "onEnter", "theme"]);

  var _useConfig2 = useConfig(),
      FormattedMessage = _useConfig2.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.journalMoreNews.backgroundColor,
    paddingTop: "0",
    paddingBottom: "0",
    mdPaddingTop: "0"
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Not\xEDcias"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8 col-lg-8 col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-left"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    hasContainer: false,
    hasLink: false,
    hasLine: false,
    textColor: theme.components.journalMoreNews.titleColor
  }, titleProps), props.resource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.resource,
    defaultMessage: sectionTitle
  }) : sectionTitle), loading ? /*#__PURE__*/React.createElement(LoadingWithStyles$f, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : data.popular.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, data.popular.listNews.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "col-xl col-lg col-md col-12 more-news-card"
    }, /*#__PURE__*/React.createElement(NewsCard$1, {
      data: {
        title: item.title,
        url: item.url,
        category: item.category,
        summary: item.summary,
        startDate: item.startDate,
        categoryUrl: item.categoryUrl,
        share: item.share,
        imageCover: {
          url: item.imageCover !== null && item.imageCover.url
        },
        alt: item.imageCover !== null ? item.imageCover.alt : ""
      },
      onKeyPress: onEnter,
      cardBgColor: theme.components.journalMoreNews.newsCardBgColor,
      hasColAuto: false,
      hasShareIcon: true,
      size: size,
      history: props.history
    }));
  }))))), size.width >= 992 && /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-right"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    hasContainer: false,
    hasLink: false,
    hasLine: false,
    textColor: theme.components.journalMoreNews.titleColor
  }, titleProps), props.rightResource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.rightResource,
    defaultMessage: rightSectionTitle
  }) : rightSectionTitle), loading ? /*#__PURE__*/React.createElement(Loading$1b, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : data.recent.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : /*#__PURE__*/React.createElement(Fragment, null, data.recent.listNews.map(function (item) {
    return /*#__PURE__*/React.createElement(Card$7, _extends({
      key: item.id,
      date: moment(item.startDate).format("DD MMMM YYYY")
    }, item, {
      history: props.history,
      linkColor: theme.components.journalMoreNews.borderedCardLinkColor
    }));
  })))))), size.width <= 991 && /*#__PURE__*/React.createElement("div", {
    className: "container-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    hasContainer: false,
    hasLink: false,
    hasLine: false,
    textColor: theme.components.journalMoreNews.titleColor
  }, titleProps, {
    title: rightSectionTitle
  })), loading ? /*#__PURE__*/React.createElement(Loading$1b, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : data.recent.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : /*#__PURE__*/React.createElement(Fragment, null, data.recent.listNews.map(function (item) {
    return /*#__PURE__*/React.createElement(Card$7, _extends({
      key: item.id,
      date: moment(item.startDate).format("DD MMMM YYYY"),
      history: props.history,
      linkColor: theme.components.journalMoreNews.borderedCardLinkColor
    }, item));
  })))));
};

var types$1j = {
  title: PropTypes$1.string,
  sectionTitle: PropTypes$1.string,
  rightSectionTitle: PropTypes$1.string,
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  size: PropTypes$1.object,
  data: PropTypes$1.object.isRequired,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  onEnter: PropTypes$1.func,
  history: PropTypes$1.object.isRequired,
  resource: PropTypes$1.string,
  rightResource: PropTypes$1.string,
  theme: PropTypes$1.object
};
More$1.propTypes = types$1j;
var MoreWithStyles = styled(More$1)(_templateObject$1V(), function (props) {
  return props.theme.components.journalMoreNews.containerRightBgColor;
}, function (props) {
  return props.theme.highContrast.backgroundColor || props.backgroundColor || props.theme.components.journalMoreNews.backgroundColor;
}, function (props) {
  return props.theme.components.journalMoreNews.containerRightBgColor;
});
var index$I = compose(withTheme, withSize())(MoreWithStyles); //Only used for the Storybook Props Table

var Loading$1c = function Loading() {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(BorderedCardLoading, null), /*#__PURE__*/React.createElement(BorderedCardLoading, null), /*#__PURE__*/React.createElement(BorderedCardLoading, null), /*#__PURE__*/React.createElement(BorderedCardLoading, null));
};

function _templateObject$1W() {
  var data = _taggedTemplateLiteral(["\n  .container-left,\n  .container-center,\n  .container-right {\n    padding: 70px 0;\n  }\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    .container-center,\n    .container-right {\n      padding-top: 0;\n    }\n  }\n"]);

  _templateObject$1W = function _templateObject() {
    return data;
  };

  return data;
}

var Card$8 = function Card(_ref) {
  var title = _ref.title,
      pretitle = _ref.pretitle,
      url = _ref.url,
      _onKeyPress = _ref.onKeyPress,
      history = _ref.history;
  return /*#__PURE__*/React.createElement(BorderedCardWithStyles, {
    href: url,
    onKeyPress: function onKeyPress(e) {
      return _onKeyPress(e, url);
    },
    history: history
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, pretitle), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    fontWeight: "400"
  }, title));
};

Card$8.propTypes = {
  title: PropTypes$1.string,
  pretitle: PropTypes$1.string,
  url: PropTypes$1.string,
  onKeyPress: PropTypes$1.func,
  history: PropTypes$1.object
};

var Columns = function Columns(_ref2) {
  var className = _ref2.className,
      backgroundColor = _ref2.backgroundColor,
      titleProps = _ref2.titleProps,
      leftSectionTitle = _ref2.leftSectionTitle,
      centerSectionTitle = _ref2.centerSectionTitle,
      rightSectionTitle = _ref2.rightSectionTitle,
      leftSectionData = _ref2.leftSectionData,
      centerSectionData = _ref2.centerSectionData,
      rightSectionData = _ref2.rightSectionData,
      theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, ["className", "backgroundColor", "titleProps", "leftSectionTitle", "centerSectionTitle", "rightSectionTitle", "leftSectionData", "centerSectionData", "rightSectionData", "theme"]);

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.journalColumns.backgroundColor || backgroundColor,
    paddingTop: "0",
    paddingBottom: "0",
    mdPaddingTop: "0"
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Not\xEDcias"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-left"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    href: props.categoryUrl.left,
    hasContainer: false,
    textColor: theme.components.journalColumns.titleColor
  }, titleProps), props.leftResource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.leftResource,
    defaultMessage: leftSectionTitle
  }) : leftSectionTitle), leftSectionData.loading ? /*#__PURE__*/React.createElement(Loading$1c, null) : leftSectionData.error ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : leftSectionData.data.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : leftSectionData.data.listNews.map(function (item) {
    return /*#__PURE__*/React.createElement(Card$8, _extends({
      key: item.id
    }, item, {
      onKeyPress: props.onEnter,
      history: props.history
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-center"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    href: props.categoryUrl.center,
    hasContainer: false,
    textColor: theme.components.journalColumns.titleColor
  }, titleProps), props.centerResource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.centerResource,
    defaultMessage: centerSectionTitle
  }) : centerSectionTitle), centerSectionData.loading ? /*#__PURE__*/React.createElement(Loading$1c, null) : centerSectionData.error ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : centerSectionData.data.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : centerSectionData.data.listNews.map(function (item) {
    return /*#__PURE__*/React.createElement(Card$8, _extends({
      key: item.id
    }, item, {
      onKeyPress: props.onEnter,
      history: props.history
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-right"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    href: props.categoryUrl.right,
    hasContainer: false,
    textColor: theme.components.journalColumns.titleColor
  }, titleProps), props.rightResource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.rightResource,
    defaultMessage: rightSectionTitle
  }) : rightSectionTitle), rightSectionData.loading ? /*#__PURE__*/React.createElement(Loading$1c, null) : rightSectionData.error ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : rightSectionData.data.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : rightSectionData.data.listNews.map(function (item) {
    return /*#__PURE__*/React.createElement(Card$8, _extends({
      key: item.id
    }, item, {
      onKeyPress: props.onEnter,
      history: props.history
    }));
  }))))));
};

var types$1k = {
  title: PropTypes$1.string,
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  leftSectionTitle: PropTypes$1.string,
  centerSectionTitle: PropTypes$1.string,
  rightSectionTitle: PropTypes$1.string,
  leftSectionData: PropTypes$1.object.isRequired,
  centerSectionData: PropTypes$1.object.isRequired,
  rightSectionData: PropTypes$1.object.isRequired,
  categoryUrl: PropTypes$1.object,
  onEnter: PropTypes$1.func,
  history: PropTypes$1.object,
  leftResource: PropTypes$1.string,
  centerResource: PropTypes$1.string,
  rightResource: PropTypes$1.string,
  theme: PropTypes$1.object
};
Columns.propTypes = types$1k;
var ColumnsWithStyles = styled(Columns)(_templateObject$1W());
var index$J = withTheme(ColumnsWithStyles); //Only used for the Storybook Props Table

var Mask$p = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.journalDetails.maskBgColor,
    position: "absolute"
  }, props));
};

var Loading$1d = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "361px"
  }, /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "18px",
    right: "0",
    width: "85%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "12px",
    top: "18px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "30px",
    top: "30px",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "10px",
    top: "60px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "30px",
    top: "70px",
    right: "0",
    width: "80%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "28px",
    top: "100px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "18px",
    top: "128px",
    right: "0",
    width: "85%"
  }, props)), /*#__PURE__*/React.createElement(ContentContainer, {
    position: "absolute",
    zIndex: "2",
    backgroundColor: props.theme.loadings.journalDetails.socialMediaIconsColor,
    height: "18px",
    top: "128px",
    right: "2px",
    width: "18px",
    borderRadius: "50%"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    position: "absolute",
    zIndex: "2",
    backgroundColor: props.theme.loadings.journalDetails.socialMediaIconsColor,
    height: "18px",
    top: "128px",
    right: "27px",
    width: "18px",
    borderRadius: "50%"
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    position: "absolute",
    zIndex: "2",
    backgroundColor: props.theme.loadings.journalDetails.socialMediaIconsColor,
    height: "18px",
    top: "128px",
    right: "52px",
    width: "18px",
    borderRadius: "50%"
  }), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "45px",
    top: "146px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "191px",
    right: "0",
    width: "5%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "5px",
    top: "211px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "216px",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "5px",
    top: "236px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "241px",
    right: "0",
    width: "15%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "5px",
    top: "261px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "266px",
    right: "0",
    width: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "5px",
    top: "286px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "291px",
    right: "0",
    width: "20%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "5px",
    top: "311px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "316px",
    right: "0",
    width: "50%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "5px",
    top: "336px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$p, _extends({
    height: "20px",
    top: "341px",
    right: "0",
    width: "80%"
  }, props))))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-12 offset-0"
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    backgroundColor: props.theme.loadings.iconContainerBgColor,
    width: "100%",
    height: "432px",
    marginTop: "38px"
  }))));
};

Loading$1d.propTypes = {
  className: PropTypes$1.string
};
var Loading$1e = withTheme(Loading$1d);

function _templateObject$1X() {
  var data = _taggedTemplateLiteral(["\n  img {\n    max-height: 620px;\n  }\n  a {\n    &:focus {\n      ", ";\n    }\n  }\n  .header-social-links-container {\n    margin: 20px 0 40px 0;\n  }\n  .tags-container {\n    margin-top: 60px;\n    .files-container {\n      margin-top: 20px;\n    }\n    .file-link {\n      border-bottom: 1px solid #000;\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  /*\n  -- Global related event bordered card styles\n  */\n  .related-event-card {\n    hr {\n      height: 1px;\n      border: none;\n      width: 40px;\n      background-color: ", ";\n      transition: width 0.4s ease;\n    }\n    .date-container {\n      margin-bottom: 30px;\n    }\n  }\n  a.related-event-card {\n    &:hover {\n      hr {\n        width: 60px;\n      }\n    }\n  }\n\n  // Large devices (desktops, more than 1200px)\n  @media (min-width: 1200px) {\n    /*\n    -- Related event bordered card styles > 1200px\n    */\n    .related-event-card {\n      margin-right: 55px;\n      .content-container {\n        padding-right: 30px;\n      }\n      .line {\n        height: 1px;\n        width: 40px;\n        background-color: #000;\n      }\n    }\n  }\n\n  // Large devices (desktops, less than 1200px)\n  @media (max-width: 1199px) {\n    /*\n    -- Related event bordered card styles < 1199px\n    */\n    .related-event-card {\n      margin-top: 40px;\n      .content-container {\n        border: none;\n        padding: 0;\n      }\n    }\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    .tags-list {\n      margin-bottom: 20px;\n      a {\n        padding-left: 0;\n        padding-right: 0;\n        margin-right: 15px;\n      }\n      li {\n        &:first-child {\n          p {\n            margin-right: 10px;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject$1X = function _templateObject() {
    return data;
  };

  return data;
}

var RelatedNewsCard = function RelatedNewsCard(_ref) {
  var data = _ref.data;
  var BorderedCardProps = data.internalLink ? {
    hasHover: false,
    cardIsLink: false
  } : {
    href: data.url,
    target: "_blank"
  };
  return /*#__PURE__*/React.createElement(BorderedCardWithStyles, _extends({
    className: "related-event-card",
    contentContainerPadding: "20px 0",
    "native": !data.internalLink
  }, BorderedCardProps), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters date-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 col-auto"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    fontWeight: "400",
    isSerif: true,
    marginRight: "15px",
    "aria-label": moment(data.startDate).format("DD MMMM YYYY")
  }, moment(data.startDate).format("DD MMM"))), !moment(data.startDate).isSame(moment(data.endDate), "day") && /*#__PURE__*/React.createElement("div", {
    className: "col-auto d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Text, {
    size: "large",
    fontWeight: "400",
    isSerif: true,
    marginLeft: "15px",
    "aria-label": moment(data.endDate).format("DD MMMM YYYY")
  }, moment(data.endDate).format("DD MMM")))), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, data.title), /*#__PURE__*/React.createElement(Text, {
    size: "xSmall",
    marginTop: "10px"
  }, "".concat(moment(data.startDate).format("HH"), "h").concat(moment(data.startDate).format("mm"))), /*#__PURE__*/React.createElement(Text, {
    size: "xSmall"
  }, data.local));
};

RelatedNewsCard.propTypes = {
  data: PropTypes$1.object.isRequired
};

var Details = function Details(_ref2) {
  var className = _ref2.className,
      data = _ref2.data,
      loading = _ref2.loading,
      hasError = _ref2.hasError,
      lang = _ref2.lang,
      size = _ref2.size,
      theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, ["className", "data", "loading", "hasError", "lang", "size", "theme"]);

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      useIntl = _useConfig.useIntl;

  var intl = useIntl();

  var onAddUrl = function onAddUrl(data) {
    var items = [];
    data.listNews.map(function (item) {
      items.push(_objectSpread2({}, item, {
        url: "/".concat(lang, "/").concat(props.route, "/").concat(item.categoryID, "/").concat(item.id)
      }));
      return true;
    });
    return {
      listNews: items,
      pagination: data.pagination
    };
  };

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.components.journalDetails.backgroundColor,
    paddingTop: "0",
    mdPaddingTop: "70px",
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Detalhes"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$1e, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 offset-xl-3 col-12 offset-0"
  }, lang !== data.language && /*#__PURE__*/React.createElement(ContentContainer, {
    marginBottom: "40px"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "#00b2bd"
  }, "We are working in the translation of this content to ".concat(lang === "pt" ? "Portuguese" : "English", ". The original version of the content is\n                          presented below."))), /*#__PURE__*/React.createElement(Link, {
    size: "small",
    fontWeight: "300",
    lineHeight: "1.5",
    href: data.categoryUrl
  }, data.category), /*#__PURE__*/React.createElement(Text, {
    size: "xLarge",
    fontWeight: "500",
    isSerif: true
  }, data.title), /*#__PURE__*/React.createElement("div", {
    className: "header-social-links-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(Text, {
    textTransform: "lowercase"
  }, moment(data.startDate).format("DD MMMM YYYY"))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto",
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(HorizontalList, null, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    padding: "5px",
    margin: "0 0 0 5px",
    href: data.facebook,
    target: "_blank" //aria-label="Facebook"
    ,
    tabIndex: "-1",
    title: "Facebook",
    "native": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.facebook,
    size: "xxSmall",
    color: theme.components.journalDetails.socialMediaIconsColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    padding: "5px",
    margin: "0 0 0 5px",
    href: data.twitter,
    target: "_blank" //aria-label="Twitter"
    ,
    tabIndex: "-1",
    title: "Twitter",
    "native": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.twitter,
    size: "xxSmall",
    color: theme.components.journalDetails.socialMediaIconsColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    padding: "5px 0 5px 5px",
    margin: "0 0 0 5px",
    href: data.linkedin,
    target: "_blank" //aria-label="LinkedIn"
    ,
    tabIndex: "-1",
    title: "LinkedIn",
    "native": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.linkedIn,
    size: "xxSmall",
    color: theme.components.journalDetails.socialMediaIconsColor
  }))))))))), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, size.width >= 1200 && !loading && data.event !== null && /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 col-12"
  }, /*#__PURE__*/React.createElement(RelatedNewsCard, {
    data: data.event
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 col-12 ".concat(!loading && data.event !== null ? "" : "offset-xl-3 offset-0")
  }, /*#__PURE__*/React.createElement(Text, {
    size: "mediumSmall"
  }, data.summary), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "40px"
  }, data.imageCover !== null && /*#__PURE__*/React.createElement(SizeMe, {
    monitorHeight: true
  }, function (_ref3) {
    var size = _ref3.size;
    return /*#__PURE__*/React.createElement(PictureContainer, {
      src: data.imageCover !== null && data.imageCover.url,
      alt: data.imageCover !== null ? data.imageCover.alt : "",
      isLocal: false,
      hasEndpoint: false,
      height: "100%",
      width: "100%",
      backgroundSize: size.height >= 619 ? "contain" : "cover",
      imagePosition: "left"
    });
  })), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "15px"
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
    content: data.text,
    "default": true
  })), data.files !== null && data.files.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "files-container"
  }, data.files.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Link, {
      key: index,
      display: "block",
      className: "file-link",
      padding: "5px 0",
      href: item.url,
      target: "_blank",
      "native": true
    }, /*#__PURE__*/React.createElement(HorizontalList, {
      display: "inline-block"
    }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Icon, {
      name: theme.icons.file,
      size: "xSmall",
      color: theme.components.journalDetails.color
    })), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Text, {
      marginLeft: "20px"
    }, item.name))));
  })), size.width <= 1199 && !loading && data.event !== null && /*#__PURE__*/React.createElement(RelatedNewsCard, {
    data: data.event
  }), /*#__PURE__*/React.createElement("div", {
    className: "tags-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto order-xl-0 order-lg-0 order-1"
  }, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    margin: "0 20px 0 0",
    padding: "5px 5px 5px 0",
    title: intl({
      id: "app.journal.news.details.print",
      defaultMessage: "Print"
    }),
    "aria-label": intl({
      id: "app.journal.news.details.print",
      defaultMessage: "Print"
    }),
    onClick: function onClick(e) {
      e.preventDefault();
      window.print();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.fa_print,
    size: "xxSmall",
    color: theme.components.journalDetails.printIconColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto order-xl-1 order-lg-1 order-2"
  }, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    padding: "5px",
    margin: "0 5px 0 0",
    href: data.facebook,
    target: "_blank",
    "aria-label": "Facebook",
    title: "Facebook",
    "native": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.facebook,
    size: "xxSmall",
    color: theme.components.journalDetails.socialMediaIconsColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    padding: "5px",
    margin: "0 5px 0 0",
    href: data.twitter,
    target: "_blank",
    "aria-label": "Twitter",
    title: "Twitter",
    "native": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.twitter,
    size: "xxSmall",
    color: theme.components.journalDetails.socialMediaIconsColor
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Link, {
    display: "inline-block",
    padding: "5px",
    margin: "0 25px 0 0",
    href: data.linkedin,
    target: "_blank",
    "aria-label": "LinkedIn",
    title: "LinkedIn",
    "native": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: theme.icons.linkedIn,
    size: "xxSmall",
    color: theme.components.journalDetails.socialMediaIconsColor
  }))))), data.tags !== null && data.tags.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-12 order-xl-2 order-lg-2 order-0"
  }, /*#__PURE__*/React.createElement(HorizontalList, {
    display: "inline-block",
    className: "tags-list"
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Text, {
    size: "xSmall",
    fontWeight: "500",
    marginRight: "5px"
  }, "Tags:")), data.tags.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.tagId
    }, /*#__PURE__*/React.createElement(Link, {
      display: "inline-block",
      padding: "5px",
      margin: "0 5px 0 0",
      href: "".concat(data.tagUrl, "/").concat(item.tagId, "?tag=true?n=").concat(item.text)
    }, /*#__PURE__*/React.createElement(Text, {
      size: "xSmall",
      color: theme.components.journalDetails.linkColor
    }, item.text)));
  })))))))))), !loading && data.related !== null && data.related.length > 0 && /*#__PURE__*/React.createElement(JournalNews$1, _extends({
    sectionTitle: "Outras Not\xEDcias",
    data: onAddUrl({
      listNews: data.related
    }),
    loading: loading,
    hasError: hasError
  }, props)));
};

var defaults$1b = {
  className: "pt"
};
var types$1l = {
  className: PropTypes$1.string,
  data: PropTypes$1.object.isRequired,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  lang: PropTypes$1.string,
  route: PropTypes$1.string,
  hasHash: PropTypes$1.string,
  size: PropTypes$1.object,
  intl: PropTypes$1.object,
  theme: PropTypes$1.object
};
Details.propTypes = types$1l;
Details.defaultProps = defaults$1b;
var DetailsWithStyles = styled(Details)(_templateObject$1X(), function (props) {
  return props.theme.mixins.focus;
}, function (props) {
  return props.theme.components.journalDetails.borderedCardLineColor;
});
var index$K = compose(withTheme, withSize())(DetailsWithStyles); //Only used for the Storybook Props Table

var Loading$1f = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(BackgroundImageNewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(BackgroundImageNewsCardLoading, null))), /*#__PURE__*/React.createElement(ContentContainer, {
    marginTop: "30px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(BackgroundImageNewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md col-12"
  }, /*#__PURE__*/React.createElement(BackgroundImageNewsCardLoading, null)))));
};

Loading$1f.propTypes = {
  className: PropTypes$1.string
};

function _templateObject$1Y() {
  var data = _taggedTemplateLiteral(["\n  .row {\n    margin-bottom: 30px;\n  }\n\n  .button-container {\n    margin-top: 70px;\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    .row {\n      margin-bottom: 0;\n      .background-image-card {\n        margin-bottom: 20px;\n      }\n    }\n    .button-container {\n      margin-top: 50px;\n    }\n  }\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .row {\n      .background-image-card {\n        margin-bottom: 15px;\n      }\n    }\n    .button-container {\n      margin-top: 55px;\n    }\n  }\n"]);

  _templateObject$1Y = function _templateObject() {
    return data;
  };

  return data;
}

var Dossiers = function Dossiers(_ref) {
  var className = _ref.className,
      backgroundColor = _ref.backgroundColor,
      titleProps = _ref.titleProps,
      sectionTitle = _ref.sectionTitle,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      theme = _ref.theme;

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.journalDossiers.backgroundColor,
    paddingTop: "0",
    mdPaddingTop: "20x",
    hasHighContrastBorderTop: false
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.components.journalDossiers.titleColor
  }, titleProps, {
    title: sectionTitle,
    hasLink: false,
    hasLine: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$1f, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : data.list.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : data.list.chunk(2).map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "row"
    }, res.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "col-md-6 col-12"
      }, /*#__PURE__*/React.createElement(BackgroundImageNewsCard$1, {
        className: "background-image-card",
        title: item.title,
        date: moment(data.startDate).format("DD MMMM YYYY"),
        href: item.url,
        src: item.image !== null && item.image.url !== null ? item.image.url : "",
        alt: item.image !== null && item.image.alt !== null ? item.image.alt : ""
      }));
    }));
  })));
};

var types$1m = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  sectionTitle: PropTypes$1.string,
  cardBackgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  data: PropTypes$1.array.isRequired,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  theme: PropTypes$1.object
};
Dossiers.propTypes = types$1m;
var DossiersWithStyles = styled(Dossiers)(_templateObject$1Y());
var index$L = withTheme(DossiersWithStyles); //Only used for the Storybook Props Table

function _templateObject$1Z() {
  var data = _taggedTemplateLiteral(["\n  .row {\n    :nth-child(2) {\n      margin-top: 30px;\n    }\n  }\n\n  // Large devices (desktops, 992px and up)\n  @media (max-width: 992px) {\n    .hide-md {\n      display: none;\n    }\n  }\n\n  // Medium devices (tablets, 768px and up)\n  @media (max-width: 768px) {\n    .hide-sm {\n      display: none;\n    }\n    .loading-card,\n    .loading-mask {\n      background-color: ", ";\n    }\n    .margin {\n      margin-top: 20px;\n    }\n  }\n\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .margin {\n      margin-top: 15px;\n    }\n  }\n"]);

  _templateObject$1Z = function _templateObject() {
    return data;
  };

  return data;
}

var Loading$1g = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 margin"
  }, /*#__PURE__*/React.createElement(PersonCardLoading, null))), /*#__PURE__*/React.createElement("div", {
    className: "row hide-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(PersonCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 hide-md"
  }, /*#__PURE__*/React.createElement(NewsCardLoading, null))));
};

Loading$1g.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$g = styled(Loading$1g)(_templateObject$1Z(), function (props) {
  return props.theme.loadings.journalListing.mediumDevices.loadingMaskBgColor;
});

function _templateObject$1_() {
  var data = _taggedTemplateLiteral(["\n  .container-row {\n    margin-bottom: 30px;\n  }\n  .button-container {\n    margin-top: 70px;\n  }\n\n  // Small devices (landscape phones, less than 768px)\n  @media (max-width: 767px) {\n    background-color: ", ";\n    span.news-plus-button {\n      background-color: ", ";\n    }\n    button,\n    button:before {\n      background-color: ", ";\n    }\n\n    .container-row {\n      margin-bottom: 0;\n      .listing-card {\n        margin-bottom: 20px;\n      }\n      // Remove border from last horizontal news card\n      &:last-child {\n        .mini-cards {\n          > div {\n            &:last-child {\n              > div {\n                border-bottom: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .button-container {\n      margin-top: 60px;\n    }\n  }\n  // Extra small devices (portrait phones, less than 576px)\n  @media (max-width: 575px) {\n    .container-row {\n      .listing-card {\n        margin-bottom: 15px;\n      }\n    }\n  }\n"]);

  _templateObject$1_ = function _templateObject() {
    return data;
  };

  return data;
}

var Listing = function Listing(_ref) {
  var className = _ref.className,
      backgroundColor = _ref.backgroundColor,
      cardBackgroundColor = _ref.cardBackgroundColor,
      cardTextColor = _ref.cardTextColor,
      size = _ref.size,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      onLoad = _ref.onLoad,
      onEnter = _ref.onEnter,
      theme = _ref.theme,
      translation = _ref.translation,
      props = _objectWithoutProperties(_ref, ["className", "backgroundColor", "cardBackgroundColor", "cardTextColor", "size", "data", "loading", "hasError", "onLoad", "onEnter", "theme", "translation"]);

  var _useConfig = useConfig(),
      FormattedMessage = _useConfig.formattedMessage;

  console.log(data);
  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: backgroundColor || theme.components.journalListing.backgroundColor,
    paddingTop: "0",
    mdPaddingTop: "20px",
    hasHighContrastBorderTop: false
  }, translation ? // eslint-disable-next-line react/jsx-key
  [/*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.translation" // eslint-disable-next-line max-len
    ,
    defaultMessage: "We are working in the translation of this content to English. The original version of the content is presented below."
  })))] : [], /*#__PURE__*/React.createElement(SectionHeader, {
    textColor: theme.components.journalListing.titleColor,
    title: data.categoryTitle,
    hasLink: false,
    hasLine: false
  }), /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Listagem"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, loading ? /*#__PURE__*/React.createElement(LoadingWithStyles$g, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null) : data.listNews.length <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row container-row"
  }, data.listNews.filter(function (_, i) {
    return i <= 1;
  }).map(function (item, index) {
    if (item.style === 0) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "col-xl-6 col-md-6 col-12 order-md-0 order-sm-1 listing-card"
      }, /*#__PURE__*/React.createElement(FadeIn, {
        fadeIn: index > 1,
        height: "100%"
      }, /*#__PURE__*/React.createElement(NewsCard$1, {
        data: {
          title: item.title,
          url: item.url,
          category: item.category,
          summary: item.summary,
          startDate: item.startDate,
          share: _objectSpread2({}, item.share),
          alt: item.imageCover !== null && item.imageCover.alt !== undefined ? item.imageCover.alt : "",
          categoryUrl: item.categoryUrl,
          imageCover: item.imageCover !== null ? _objectSpread2({}, item.imageCover) : null
        },
        hasCategoryTitle: Number(props.categoryId) !== item.categoryID,
        hasColAuto: false,
        hasShareIcon: true,
        mobileCardBgColor: theme.components.journalListing.mobileNewsCardBgColor,
        size: size,
        history: props.history,
        imageSize: 272,
        contentContainerHeight: "128sx",
        centerPlusButton: true,
        titleIsSerif: true,
        plusButtonSize: 55,
        plusButtonFontSize: "38px",
        linkProps: {
          onClick: onEnter
        }
      })));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "col-xl-6 col-md-6 col-12 order-md-1 order-sm-0 listing-card"
      }, /*#__PURE__*/React.createElement(FadeIn, {
        fadeIn: index > 1,
        height: "100%"
      }, /*#__PURE__*/React.createElement(PersonCard$1, {
        title: item.title,
        titleIsSerif: true,
        hasSubTitle: size.width >= 992 && true,
        subTitle: item.summary,
        name: item.pretitle,
        src: item.imageCover !== null ? item.imageCover.url : null,
        alt: item.imageCover !== null && item.imageCover.alt !== undefined ? item.imageCover.alt : "",
        backgroundColor: item.style === 2 ? theme.highContrast.lightBackgroundColor || "#C7C9CB" : cardBackgroundColor,
        textColor: item.style === 2 ? theme.highContrast.text || "#000" : cardTextColor,
        url: item.url,
        size: size,
        history: props.history,
        linkProps: {
          onClick: onEnter
        }
      })));
    }
  })), data.listNews.filter(function (_, index) {
    return index > 1;
  }).chunk(size.width >= 992 ? 3 : 2).map(function (res, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "row container-row"
    }, size.width >= 767 ? /*#__PURE__*/React.createElement(Fragment, null, res.map(function (item) {
      if (item.style === 1 || item.style === 2) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.id,
          className: "col-xl-4 col-lg-4 col-md-6 col-12 listing-card"
        }, /*#__PURE__*/React.createElement(FadeIn, {
          fadeIn: index > 1,
          height: "100%"
        }, /*#__PURE__*/React.createElement(PersonCard$1, {
          title: item.title,
          subTitle: item.summary,
          name: item.pretitle,
          src: item.imageCover !== null ? item.imageCover.url : null,
          alt: item.imageCover !== null && item.imageCover.alt !== undefined ? item.imageCover.alt : "",
          titleIsSerif: true,
          backgroundColor: item.style === 2 ? theme.highContrast.lightBackgroundColor || "#C7C9CB" : cardBackgroundColor,
          textColor: item.style === 2 ? theme.highContrast.text || "#000" : cardTextColor,
          url: item.url,
          size: size,
          history: props.history,
          linkProps: {
            onClick: onEnter
          }
        })));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          key: item.id,
          className: "col-xl-4 col-lg-4 col-md-6 col-12 listing-card"
        }, /*#__PURE__*/React.createElement(FadeIn, {
          fadeIn: index > 1
        }, /*#__PURE__*/React.createElement(NewsCard$1, {
          data: {
            title: item.title,
            url: item.url,
            category: item.category,
            summary: item.summary,
            startDate: item.startDate,
            alt: item.imageCover !== null && item.imageCover.alt !== undefined ? item.imageCover.alt : "",
            categoryUrl: item.categoryUrl,
            imageCover: item.imageCover !== null ? _objectSpread2({}, item.imageCover) : null,
            share: _objectSpread2({}, item.share)
          },
          hasColAuto: false,
          hasShareIcon: true,
          hasCategoryTitle: Number(props.categoryId) !== item.categoryID,
          mobileCardBgColor: theme.components.journalListing.mobileNewsCardBgColor,
          size: size,
          history: props.history,
          linkProps: {
            onClick: onEnter
          }
        })));
      }
    })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "col-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mini-cards"
    }, res.map(function (item) {
      return /*#__PURE__*/React.createElement(FadeIn, {
        fadeIn: index > 2,
        key: item.id,
        height: "100%"
      }, /*#__PURE__*/React.createElement(MiniHorizontalNewsCard$1, {
        src: item.imageCover !== null ? item.imageCover.url : null,
        alt: item.imageCover !== null && item.imageCover.alt !== undefined ? item.imageCover.alt : "",
        href: item.url,
        category: item.category,
        title: item.title,
        date: moment(item.startDate).format("DD MMMM YYYY"),
        history: props.history,
        linkProps: {
          onClick: onEnter
        }
      }));
    })))));
  }))), Object.keys(data.listNews).length < data.pagination.totalResults && /*#__PURE__*/React.createElement("div", {
    className: "button-container d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: onLoad,
    backgroundColor: theme.components.journalListing.backgroundColor
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.organism.button.LoadMore",
    defaultMessage: "Carregar mais"
  }))));
};

var types$1n = {
  className: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  cardBackgroundColor: PropTypes$1.string,
  cardTextColor: PropTypes$1.string,
  size: PropTypes$1.object,
  data: PropTypes$1.object.isRequired,
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  onLoad: PropTypes$1.func.isRequired,
  totalResults: PropTypes$1.number,
  nextPageToken: PropTypes$1.string,
  categoryId: PropTypes$1.string,
  history: PropTypes$1.object,
  onEnter: PropTypes$1.func,
  theme: PropTypes$1.object,
  translation: PropTypes$1.bool
};
var defaults$1c = {
  onLoad: function onLoad() {
    return null;
  }
};
Listing.propTypes = types$1n;
Listing.defaultProps = defaults$1c;
var ListingWithStyles = styled(Listing)(_templateObject$1_(), function (props) {
  return props.theme.components.journalListing.mobileBackgroundColor;
}, function (props) {
  return props.theme.components.journalListing.mobileNewsCardBgColor;
}, function (props) {
  return props.theme.components.journalListing.mobileBackgroundColor;
});
var index$M = compose(withTheme, withSize())(ListingWithStyles); //Only used for the Storybook Props Table

function _templateObject$1$() {
  var data = _taggedTemplateLiteral(["\n  .image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: inherit;\n    visibility: hidden;\n  }\n  // Medium devices (tablets, 768px and up)\n  @media (max-width: 767px) {\n    .hide-sm {\n      display: none;\n    }\n  }\n\n  // Large devices (desktops, 992px and up)\n  @media (max-width: 991px) {\n    .image {\n      visibility: visible;\n    }\n    .loading-image-container {\n      background-color: ", ";\n    }\n    .hide-md {\n      display: none;\n    }\n  }\n"]);

  _templateObject$1$ = function _templateObject() {
    return data;
  };

  return data;
}

var Mask$q = function Mask(props) {
  return /*#__PURE__*/React.createElement(ContentContainer, _extends({
    backgroundColor: props.theme.loadings.maskBgColor,
    position: "absolute"
  }, props));
};

var LoadingCard$e = function LoadingCard(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(ContentContainer, {
    height: "398px",
    backgroundColor: "transparent",
    mobileMdBgColor: props.theme.loadings.cardBgColor
  }, /*#__PURE__*/React.createElement(ContentContainer, {
    backgroundColor: "transparent",
    height: "200px",
    className: "loading-image-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fas fa-image",
    color: props.theme.loadings.iconColor,
    fontSize: "32px"
  }))), /*#__PURE__*/React.createElement(ContentContainer, {
    height: "198px",
    padding: "20px",
    className: "content-container"
  }, /*#__PURE__*/React.createElement(AnimatedBackground, {
    height: "150px"
  }, /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "15px",
    right: "0",
    width: "75%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "20px",
    top: "15px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "18px",
    top: "35px",
    right: "0",
    mobileSmWidth: "20%",
    mobileXsWidth: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "8px",
    top: "53px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "18px",
    top: "61px",
    right: "0",
    mobileSmWidth: "20%",
    mobileXsWidth: "10%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "8px",
    top: "79px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "18px",
    top: "87px",
    right: "0",
    width: "60%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "30px",
    top: "105px",
    width: "100%"
  }, props)), /*#__PURE__*/React.createElement(Mask$q, _extends({
    height: "15px",
    top: "135px",
    right: "0",
    width: "70%"
  }, props)))));
};

var Loading$1h = function Loading(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(LoadingCard$e, props)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg col-md-6 hide-sm"
  }, /*#__PURE__*/React.createElement(LoadingCard$e, props)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl col-lg hide-md"
  }, /*#__PURE__*/React.createElement(LoadingCard$e, props)))));
};

Loading$1h.propTypes = {
  className: PropTypes$1.string
};
var LoadingWithStyles$h = styled(Loading$1h)(_templateObject$1$(), function (props) {
  return props.theme.loadings.iconContainerBgColor;
});
var Loading$1i = withTheme(LoadingWithStyles$h);

function _templateObject$20() {
  var data = _taggedTemplateLiteral(["\n  //Styles for cards in desktop\n  .news-card {\n    background-color: transparent;\n  }\n  .content-container {\n    background-color: ", ";\n  }\n\n  // Medium devices (tablets, more than 992px)\n  @media (min-width: 992px) {\n    span.news-plus-button {\n      display: none;\n    }\n    position: relative;\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 0;\n    }\n    .container {\n      z-index: 2;\n      position: relative;\n    }\n    //Card Design\n    .journal-news-container {\n      height: 398px;\n      display: flex !important;\n      flex-direction: column;\n      justify-content: flex-end;\n      .journal-news-card {\n        height: unset;\n      }\n      .news-card {\n        min-height: unset;\n        flex-grow: unset;\n        height: unset;\n        //Not active state\n        .content-container {\n          background-color: ", ";\n          opacity: 0.9;\n          //Access Elements in NewsCard for active a not active card state\n          .news-card-category,\n          .news-card-title,\n          .news-card-text,\n          .news-card-date,\n          i.fa-share-alt {\n            color: ", ";\n          }\n        }\n      }\n      //Active state\n      .journal-news-card-active .content-container {\n        background-color: ", ";\n        opacity: 1;\n        //Access Elements in NewsCard for active a not active card state\n        .news-card-category,\n        .news-card-title,\n        .news-card-text,\n        .news-card-date,\n        i.fa-share-alt {\n          color: ", ";\n        }\n        button {\n          :hover {\n            i.fa-share-alt {\n              color: ", ";\n            }\n          }\n        }\n      }\n      .image-container {\n        display: none;\n      }\n    }\n\n    //Gradient\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      height: 100%;\n      width: 100%;\n      z-index: 2;\n      background: linear-gradient(\n        ", ",\n        transparent\n      );\n      background: -webkit-linear-gradient(\n        ", ",\n        transparent\n      );\n      background: -o-linear-gradient(\n        ", ",\n        transparent\n      );\n      background: -ms-linear-gradient(\n        ", ",\n        transparent\n      );\n      background: -moz-linear-gradient(\n        ", ",\n        transparent\n      );\n    }\n  }\n\n  // Medium devices (tablets, less than 992px)\n  @media (max-width: 991px) {\n    padding-top: 0;\n    padding-bottom: 0;\n    background-image: unset;\n    .news-card {\n      background-color: ", ";\n    }\n    .content-container {\n      background-color: inherit;\n    }\n    span.news-plus-button {\n      background-color: ", ";\n    }\n    .Section-Header-Line {\n      background-color: ", ";\n    }\n  }\n\n  .slides-container {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .slick-slide {\n    //Safari\n    height: 398px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\n  .slick-prev {\n    left: -25px;\n  }\n  .slick-next {\n    right: -25px;\n  }\n  .slick-next,\n  .slick-prev {\n    width: auto;\n    height: 36px;\n    top: 100px;\n  }\n\n  .slick-next:before,\n  .slick-prev:before {\n    content: none;\n  }\n\n  .slick-dots {\n    width: 100%;\n    bottom: 0;\n    position: relative;\n    margin-top: 10px;\n    text-align: right;\n    padding: 0 15px;\n  }\n\n  .slick-dots li {\n    margin: 0 5px;\n    :last-child {\n      margin-right: 0;\n    }\n  }\n\n  .slick-dots li,\n  .slick-dots li button {\n    width: 8px;\n    height: 8px;\n  }\n\n  .slick-dots li button:before {\n    content: \"\";\n    background-color: ", ";\n    width: 8px;\n    height: 8px;\n  }\n\n  .button-container {\n    margin-top: 70px;\n  }\n\n  // Large devices (desktops, 992px and up to 1199)\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .slick-prev {\n      left: -15px;\n    }\n    .slick-next {\n      right: -15px;\n    }\n  }\n"]);

  _templateObject$20 = function _templateObject() {
    return data;
  };

  return data;
}
var JournalSlides = memo(function JournalSlides(_ref) {
  var className = _ref.className,
      showHeader = _ref.showHeader,
      title = _ref.title,
      resource = _ref.resource,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      titleProps = _ref.titleProps,
      cardBackgroundColor = _ref.cardBackgroundColor,
      imageBackgroundColor = _ref.imageBackgroundColor,
      cardTextColor = _ref.cardTextColor,
      mobileMdTextColor = _ref.mobileMdTextColor,
      onAction = _ref.onAction,
      onEnter = _ref.onEnter,
      data = _ref.data,
      loading = _ref.loading,
      hasError = _ref.hasError,
      size = _ref.size,
      share = _ref.share,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["className", "showHeader", "title", "resource", "textColor", "backgroundColor", "titleProps", "cardBackgroundColor", "imageBackgroundColor", "cardTextColor", "mobileMdTextColor", "onAction", "onEnter", "data", "loading", "hasError", "size", "share", "theme"]);

  var _useState = useState({
    imageCover: {
      url: "https://images.pexels.com/photos/158651/news-newsletter-newspaper-information-158651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      bgImage = _useState2[0],
      setBgImage = _useState2[1];

  var sliderRef = useRef(null);

  var _useConfig = useConfig(),
      Link = _useConfig.link,
      FormattedMessage = _useConfig.formattedMessage;

  var onHandleTabNavigation = function onHandleTabNavigation(e) {
    if (e.key === "Tab" && e.shiftKey) {
      sliderRef.current.slickPrev();
    }

    if (e.key === "Tab") {
      sliderRef.current.slickNext();
    }
  };

  var onSetImage = function onSetImage() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (data.news !== undefined) {
      var image = data.news[position];
      setBgImage(image);
    }
  };

  useEffect(function () {
    if (!loading) {
      onSetImage();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [loading]);

  var onChangeImage = function onChangeImage(position) {
    onSetImage(position);
  };

  return /*#__PURE__*/React.createElement(Section, {
    className: className,
    backgroundColor: theme.highContrast.backgroundColor || backgroundColor || theme.components.journalSlides
  }, /*#__PURE__*/React.createElement(ScreenReaderText, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    text: "Not\xEDcias"
  })), showHeader && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(SectionHeader, _extends({
    textColor: theme.highContrast.link || textColor,
    mobileMdColor: theme.highContrast.link || mobileMdTextColor,
    hasContainer: false
  }, titleProps), title)), size.width >= 992 && /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(Link, {
    color: textColor,
    display: "inline-block",
    href: props.rightHref
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    size: "medium",
    fontWeight: "400",
    lineHeight: "1.5",
    color: theme.highContrast.link || textColor
  }, props.linkResource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.linkResource,
    defaultMessage: props.linkTitle
  }) : props.linkTitle))))), /*#__PURE__*/React.createElement("div", {
    className: "container slides-container"
  }, loading ? /*#__PURE__*/React.createElement(Loading$1i, null) : hasError ? /*#__PURE__*/React.createElement(ErrorWithStyles, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "app.content.empty",
    defaultMessage: "No content to display"
  })) : /*#__PURE__*/React.createElement(Slider, {
    ref: sliderRef,
    useTransform: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    initialSlide: 0,
    customPaging: function customPaging(i) {
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "Not\xEDcia ".concat(i + 1)
      }, "\xA0");
    },
    prevArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "slide anterior",
      left: true,
      darken: true
    }),
    nextArrow: /*#__PURE__*/React.createElement(CustomArrow$1, {
      ariaLabel: "pr\xF3ximo slide",
      darken: true
    }),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }]
  }, data.news.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "journal-news-container"
    }, /*#__PURE__*/React.createElement(NewsCard$1, {
      className: "journal-news-card ".concat(bgImage.id === item.id ? "journal-news-card-active" : ""),
      data: item,
      onClick: function onClick(e) {
        return onAction(e, item.url);
      },
      onKeyPress: function onKeyPress(e) {
        return onEnter(e, item.url);
      },
      cardBgColor: cardBackgroundColor,
      imageBgColor: imageBackgroundColor,
      linkColor: cardTextColor,
      onKeyDown: onHandleTabNavigation,
      hasShareIcon: true,
      onMouseOver: function onMouseOver() {
        return onChangeImage(index);
      },
      size: size,
      share: share,
      history: props.history
    }));
  })), size.width <= 991 && /*#__PURE__*/React.createElement("div", {
    className: "button-container d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: function onClick() {
      return window.location.replace(props.rightHref);
    }
  }, props.linkResource ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: props.linkResource,
    defaultMessage: props.linkTitle
  }) : props.linkTitle))), size.width >= 992 && /*#__PURE__*/React.createElement(FadeIn, {
    key: bgImage.imageCover.url
  }, /*#__PURE__*/React.createElement(Image, {
    src: bgImage.imageCover.url,
    height: "100%",
    width: "100%",
    alt: bgImage.imageCover.alt !== undefined ? bgImage.imageCover.alt : ""
  })));
});
var types$1o = {
  title: PropTypes$1.string,
  rightTitle: PropTypes$1.string,
  text: PropTypes$1.string,
  cardStyles: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,
  showHeader: PropTypes$1.bool,
  textColor: PropTypes$1.string,
  backgroundColor: PropTypes$1.string,
  titleProps: PropTypes$1.object,
  cardBackgroundColor: PropTypes$1.string,
  imageBackgroundColor: PropTypes$1.string,
  cardTextColor: PropTypes$1.string,
  mobileMdTextColor: PropTypes$1.string,
  data: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.array]),
  loading: PropTypes$1.bool,
  hasError: PropTypes$1.bool,
  size: PropTypes$1.object,
  share: PropTypes$1.object,
  rightHref: PropTypes$1.string,
  history: PropTypes$1.object.isRequired,
  resource: PropTypes$1.string,
  onAction: PropTypes$1.func,
  onEnter: PropTypes$1.func,
  linkResource: PropTypes$1.string,
  linkTitle: PropTypes$1.string,
  theme: PropTypes$1.object
};
var defaults$1d = {
  backgroundColor: theme$1.components.journalSlides.backgroundColor,
  textColor: theme$1.components.journalSlides.textColor,
  imageBackgroundColor: theme$1.components.journalSlides.cardBackgroundColor,
  cardTextColor: theme$1.components.journalSlides.cardTextColor,
  mobileMdTextColor: theme$1.components.journalSlides.mobileMdTextColor,
  share: {
    facebook: "https://www.facebook.com/sharer/sharer.php?u=url",
    twitter: "http://twitter.com/share?url=url&text=title",
    linkedin: "https://www.linkedin.com/shareArticle?mini=true&url=url",
    url: "/"
  }
};
JournalSlides.propTypes = types$1o;
JournalSlides.defaultProps = defaults$1d;
var JournalSlidesWithStyles = styled(JournalSlides)(_templateObject$20(), function (props) {
  return props.theme.components.journalSlides.cardBackgroundColor;
}, function (props) {
  return props.theme.components.journalSlides.desktopContentContainerBgColor;
}, function (props) {
  return props.theme.components.journalSlides.desktopContentContainerContentColor;
}, function (props) {
  return props.theme.components.journalSlides.activeCardBgColor;
}, function (props) {
  return props.theme.components.journalSlides.activeCardContentColor;
}, lighten(0.5, "#000"), function (props) {
  return props.theme.components.journalSlides.gradientColor;
}, function (props) {
  return props.theme.components.journalSlides.gradientColor;
}, function (props) {
  return props.theme.components.journalSlides.gradientColor;
}, function (props) {
  return props.theme.components.journalSlides.gradientColor;
}, function (props) {
  return props.theme.components.journalSlides.gradientColor;
}, function (props) {
  return props.theme.components.journalSlides.mobileCardBackgroundColor;
}, function (props) {
  return props.theme.components.journalSlides.mobileCardBackgroundColor;
}, function (props) {
  return props.theme.components.journalSlides.mobileMdTextColor;
}, function (props) {
  return props.theme.components.reactSlickSlider.buttonBgColor;
});
var index$N = compose(withTheme, withSize())(JournalSlidesWithStyles); //Only used for the Storybook Props Table

var activeColors$1 = {
  "default": "#95CA3D",
  about: "#95CA3D",
  study: "#0EB4BD",
  live: "#F3B21B",
  investigation: "#42D3B8",
  cooperate: "#9878D3",
  international: "#F0592A"
};
var viewsColors$1 = {
  root: activeColors$1["default"],
  aboutua: activeColors$1["default"],
  ua: activeColors$1["default"],
  cooperate: activeColors$1.cooperate,
  education: activeColors$1.study,
  "public": activeColors$1["default"],
  index: activeColors$1["default"],
  internal: activeColors$1["default"],
  international: activeColors$1.international,
  live: activeColors$1.live,
  investigation: activeColors$1.investigation
}; //HighContrast

var highContrast$1 = {
  backgroundColor: "#000",
  lightBackgroundColor: "#212121",
  opacityBgColor: "rgba(0, 0, 0, 0.85)",
  lightOpacityBgColor: "rgba(33, 33, 33, 0.9)",
  text: "#fff",
  link: "#ffeb3b",
  linkHover: lighten(0.2, "#ffeb3b"),
  action: "#81d4fa",
  borderColor: "#fff",
  lightBorderColor: "#757575",
  border: "1px solid #fff"
};
var globalStyle$1 = {
  body: {
    backgroundColor: highContrast$1.backgroundColor
  }
};
/*
-- Containers
*/

var accessibilitySelector$1 = {
  whiteLogo: "/imgs/logo.svg",
  mobileWhiteLogo: "/imgs/logo_mobile.svg",
  blackLogo: "/imgs/logo.svg",
  mobileBlackLogo: "/imgs/logo_mobile.svg",
  borderColor: highContrast$1.lightBorderColor,
  backgroundColor: theme.colors.black,
  color: highContrast$1.text,
  isSearchOpenBackgroundColor: highContrast$1.lightBackgroundColor,
  activeLineColor: highContrast$1.link,
  dropDownHoverBackgroundColor: highContrast$1.action,
  dropDownIconColor: highContrast$1.text,
  linksColor: highContrast$1.link,
  iconColor: highContrast$1.action,
  accessibilityActiveBgColor: highContrast$1.action,
  accessibilityIconActiveColor: highContrast$1.backgroundColor,
  accessibilityMenuIconColor: highContrast$1.action,
  accessibilityIconHoverColor: highContrast$1.backgroundColor,
  searchFilterColor: highContrast$1.link,
  accessibilityOnColor: highContrast$1.action
};
/*
-- Atoms
*/
//AnimatedBackground

var animatedBackground$1 = {
  backgroundColor: "#f6f7f8",
  gradientColor: ["#707070", "#9e9e9e", "#707070"]
}; //AspectRatio

var aspectRatio$1 = {
  backgroundColor: highContrast$1.lightBackgroundColor
}; //Button

var button$1 = {
  //Global
  fontSize: theme.sizes.s,
  fontWeight: String(theme.weight.light),
  padding: "10px 20px",
  lineHeight: "1",
  //Primary
  primaryColor: highContrast$1.action,
  primaryBackgroundColor: highContrast$1.backgroundColor,
  primaryBorderColor: highContrast$1.action,
  primaryHoverColor: highContrast$1.backgroundColor,
  primaryHoverBackgroundColor: highContrast$1.action,
  primaryFocus: "rgba(129, 212, 250, 0.4)",
  primaryIconBackgroundColor: highContrast$1.backgroundColor,
  primaryIconColor: highContrast$1.action,
  //Dark
  darkColor: highContrast$1.action,
  darkBackgroundColor: highContrast$1.backgroundColor,
  darkBorderColor: highContrast$1.action,
  darkHoverColor: highContrast$1.backgroundColor,
  darkHoverBackgroundColor: highContrast$1.action,
  darkFocus: "rgba(129, 212, 250, 0.4)",
  darkIconBackgroundColor: highContrast$1.backgroundColor,
  darkIconColor: highContrast$1.action,
  //Light
  lightColor: highContrast$1.action,
  lightBackgroundColor: highContrast$1.backgroundColor,
  lightBorderColor: highContrast$1.action,
  lightHoverColor: highContrast$1.backgroundColor,
  lightHoverBackgroundColor: highContrast$1.action,
  lightFocus: "rgba(129, 212, 250, 0.4)",
  lightIconBackgroundColor: highContrast$1.backgroundColor,
  lightIconColor: highContrast$1.action,
  //Default
  color: highContrast$1.action,
  backgroundColor: highContrast$1.backgroundColor,
  borderColor: highContrast$1.action,
  hoverColor: highContrast$1.backgroundColor,
  hoverBackgroundColor: highContrast$1.action,
  focus: "rgba(129, 212, 250, 0.4)",
  iconBackgroundColor: highContrast$1.backgroundColor,
  iconColor: highContrast$1.action
}; //Icon

var icon$1 = {
  color: theme.colors.white
}; //Input

var input$1 = {
  fontSize: theme.sizes.s,
  color: theme.colors.white,
  height: theme.sizes.xl5,
  focus: "rgba(0, 0, 0, 0.4)"
}; //Line

var line$1 = {
  width: 34,
  height: 5,
  color: highContrast$1.borderColor,
  marginTop: 0,
  marginTopMarkdown: 10,
  widthDifference: 8
}; //Link

var link$1 = {
  color: highContrast$1.link,
  fontSize: theme.typos.link,
  fontWeight: String(theme.weight.xbase)
}; //Picture

var picture$1 = {
  backgroundColor: highContrast$1.lightBackgroundColor,
  color: highContrast$1.text
}; //Pagination

var pagination$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  linkColor: highContrast$1.link,
  linkHoverColor: highContrast$1.linkHover,
  disabledHover: highContrast$1.text,
  linkActive: highContrast$1.text,
  jumpNextColor: highContrast$1.action,
  jumpNextHoverColor: highContrast$1.action,
  jumpPrevColor: highContrast$1.action,
  disabledLinkColor: "#ccc",
  quickJumperInputBgColor: highContrast$1.backgroundColor,
  quickJumperInputHoverColor: highContrast$1.action,
  quickJumperButtonBgColor: highContrast$1.backgroundColor,
  quickJumperButtonColor: highContrast$1.action,
  quickJumperButtonHAFColor: highContrast$1.action,
  quickJumperButtonHAFBgColor: highContrast$1.backgroundColor,
  simplePagerInputBgColor: highContrast$1.backgroundColor,
  simplePagerInputHoverColor: highContrast$1.action,
  simplePagerButtonColor: highContrast$1.action,
  simplePagerButtonBgColor: highContrast$1.backgroundColor,
  simplePagerButtonHAFColor: highContrast$1.action,
  simplePagerButtonHAFBgColor: highContrast$1.action
}; //ScrollMore

var scrollMore$1 = {
  iconColor: highContrast$1.action
}; //Text

var text$2 = {
  fontSize: theme.typos.text,
  color: highContrast$1.text,
  colorReverse: highContrast$1.text,
  fontWeight: String(theme.weight.xbase)
}; //Title

var title$2 = {
  fontSize: theme.typos.title,
  color: highContrast$1.text,
  fontWeight: String(theme.weight.xbase),
  fontFamily: theme.type.base,
  lineHeight: 1.4
}; //Triangle

var triangle$1 = {
  color: highContrast$1.lightBackgroundColor,
  contentColor: highContrast$1.text
};
/*
-- Molecules
*/
//AccessibleAccordion

var accessibleAccordion$1 = {
  color: highContrast$1.link,
  arrowColor: highContrast$1.action
}; //Accordion

var accordion$1 = {
  color: theme.colors.white
}; //Breadcrumbs

var breadcrumbs$1 = {
  height: "32px",
  link: {
    color: highContrast$1.link,
    fontSize: "15px",
    fontWeight: 300
  },
  button: {
    iconColor: highContrast$1.action,
    bgColor: "transparent",
    hoverBgColor: highContrast$1.action
  },
  anchors: {
    buttonBgColor: highContrast$1.action,
    textColor: highContrast$1.backgroundColor
  }
}; // -- CARDS --
//AgendaCard

var agendaCard$1 = {
  categoryColor: highContrast$1.text,
  titleColor: highContrast$1.text,
  textColor: highContrast$1.text,
  dateColor: highContrast$1.text,
  iconColor: highContrast$1.action,
  borderColor: highContrast$1.borderColor,
  textColorHover: highContrast$1.text,
  squareColorHover: highContrast$1.lightBackgroundColor,
  iconColorHover: highContrast$1.action
}; //AgendaFeatured

var agendaFeatured$1 = {
  dateContainerTextColor: highContrast$1.backgroundColor,
  buttonBgColor: highContrast$1.backgroundColor,
  buttonTextColor: highContrast$1.text,
  textColor: highContrast$1.text,
  titleColor: highContrast$1.text,
  dateColor: highContrast$1.text,
  dateContainerBgColor: highContrast$1.text,
  borderColor: highContrast$1.borderColor,
  textColorHover: highContrast$1.text,
  animationBgColor: highContrast$1.backgroundColor,
  plusButtonHoverBgColor: highContrast$1.backgroundColor
}; //BackgroundImageNewsCard

var backgroundImageNewsCard$1 = {
  cardBackgroundColor: highContrast$1.lightBackgroundColor,
  textColor: highContrast$1.text,
  contentContainerBackgroundColor: highContrast$1.opacityBgColor
}; //BorderedCArd

var borderedCard$1 = {
  borderColor: highContrast$1.borderColor
}; //CandidatureCard

var candidatureCard$1 = {
  titleColor: highContrast$1.text,
  cardBackgroundColor: highContrast$1.lightBackgroundColor
}; //ColorExtractCard

var colorExtractCard$1 = {
  backgroundColor: highContrast$1.lightOpacityBgColor,
  iconColor: highContrast$1.text,
  linkColor: highContrast$1.link
}; //Columns Card

var columnsCard$1 = {
  textColor: highContrast$1.text,
  linkColor: highContrast$1.link,
  backgroundColor: highContrast$1.backgroundColor
}; //EventCard

var eventCard$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  color: highContrast$1.text
}; //HorizontalNewsCard

var horizontalNewsCard$1 = {
  backgroundColor: highContrast$1.lightBackgroundColor,
  height: "294px",
  mobileXsHeight: "250px",
  textColor: highContrast$1.text,
  contentContainerBgColor: highContrast$1.lightBackgroundColor,
  triangleContentColor: highContrast$1.text,
  categoryColor: highContrast$1.link
}; //IconCard

var iconCard$1 = {
  iconContainer: {
    backgroundColor: highContrast$1.text,
    iconColor: highContrast$1.backgroundColor
  },
  link: {
    color: highContrast$1.link
  }
}; //ImageCard

var imageCard$1 = {
  link: {
    color: highContrast$1.link,
    hoverColor: highContrast$1.link
  }
}; //Layered Card

var layeredCard$1 = {
  textColor: highContrast$1.text,
  linkColor: highContrast$1.link,
  backgroundColor: highContrast$1.backgroundColor
}; //MiniHorizontalNewsCArd

var miniHorizontalNewsCard$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  height: "75px",
  dateColor: highContrast$1.text,
  borderColor: highContrast$1.borderColor,
  triangleBgColor: highContrast$1.backgroundColor,
  triangleContentColor: highContrast$1.text
}; //NewsCard

var newsCard$1 = {
  plusButtonTextColor: highContrast$1.text,
  plusButtonBgColor: highContrast$1.lightBackgroundColor,
  shareIconColor: highContrast$1.text,
  dateColor: highContrast$1.text,
  cardBackgroundColor: highContrast$1.lightBackgroundColor,
  categoryColor: highContrast$1.link
}; //PersonCard

var personCard$1 = {
  backgroundColor: highContrast$1.lightBackgroundColor,
  textColor: highContrast$1.text,
  imageSize: "115px",
  imageBackgroundColor: highContrast$1.lightBackgroundColor
}; //ShareSocialMedia

var shareSocialMedia$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  copyToClipboardTextColor: highContrast$1.text,
  copyToClipboardBgColor: highContrast$1.backgroundColor,
  iconColor: highContrast$1.text,
  boxShadow: "1px 0px 4px rgba(64, 64, 64, 0.5)"
}; //ShowMoreCard

var showMoreCard$1 = {
  hoverBgColor: highContrast$1.lightBackgroundColor,
  hoverTitleColor: highContrast$1.text,
  borderColor: highContrast$1.borderColor,
  titleColor: highContrast$1.text,
  linkColor: highContrast$1.link
}; //StudentCard

var studentCard$1 = {
  borderColor: highContrast$1.borderColor
};
var studentCardLink$1 = {
  borderColor: "#B3B3B3",
  borderColorHover: theme.colors.white,
  outlineColorPressed: theme.colors.white
}; //Carousel

var carousel$1 = {
  legendColor: highContrast$1.text,
  dotsColor: highContrast$1.action
}; //CustomArrow

var customArrow$1 = {
  customArrowColor: highContrast$1.action
}; //DatePicker

var datePicker$1 = {
  backgroundColor: highContrast$1.action,
  borderColor: theme.colors.black,
  separatorColor: theme.colors.black,
  textColor: theme.colors.black,
  shadowColor: highContrast$1.borderColor,
  hoverBorderColor: highContrast$1.lightBorderColor,
  iconColor: theme.colors.black,
  clearIconHoverColor: "rgba(0, 0, 0, 0.3)"
}; //DropDown

var dropDown$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  minWidth: "210px",
  underlineAnimationColor: highContrast$1.link
}; //DropDownList

var dropdownList$1 = {
  color: highContrast$1.link,
  hoverBackgroundColor: highContrast$1.link
}; //InjectHtml

var injectHtml$1 = {
  "default": {
    color: highContrast$1.text
  },
  presentationStyles: {
    color: highContrast$1.text,
    before: highContrast$1.text
  },
  lightStyles: {
    color: highContrast$1.text
  },
  span: highContrast$1.text,
  link: {
    color: highContrast$1.link,
    hoverColor: highContrast$1.link
  }
}; //IstituteSearch

var instituteSearch$1 = {
  leftIconColor: highContrast$1.text,
  rightIconColor: highContrast$1.action,
  beforeBackgroundColor: highContrast$1.action,
  color: highContrast$1.text,
  borderColor: highContrast$1.borderColor
};
var listItem$1 = {
  lineColor: theme.colors.greyBorder,
  spacingBottom: theme.spacing.s,
  spacingLeft: theme.spacing.s
}; //PlusButton

var plusButton$1 = {
  backgroundColor: theme.colors.white
}; //ReactCalendar

var reactCalendar$1 = {
  titleActiveBgColor: highContrast$1.action,
  titleActiveColor: highContrast$1.backgroundColor,
  backgroundColor: highContrast$1.lightBackgroundColor,
  buttonFocus: highContrast$1.action,
  buttonColor: highContrast$1.text,
  buttonHoverBgColor: highContrast$1.action,
  buttonHoverTextColor: highContrast$1.backgroundColor,
  monthViewWeekDaysColor: highContrast$1.text,
  monthViewWeekDaysNeighboringColor: "rgba(255, 255, 255, 0.5)"
}; //ScrollableTabs

var scrollableTabs$1 = {
  border: "1px solid" + highContrast$1.borderColor,
  button: {
    iconColor: highContrast$1.action,
    bgColor: highContrast$1.backgroundColor
  },
  tab: {
    linkColor: highContrast$1.link,
    underlineColor: highContrast$1.link
  }
}; //Section

var section$1 = {
  paddingTop: theme.spacing.xl4,
  paddingBottom: theme.spacing.xl4,
  backgroundColor: highContrast$1.backgroundColor
}; //SectionHeader

var sectionHeader$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  textColor: highContrast$1.text
}; //Select

var select$1 = {
  textColor: theme.colors.white,
  borderColor: theme.colors.white,
  outlineColor: theme.colors.focus,
  primary25: highContrast$1.action,
  primary: highContrast$1.text,
  primary50: highContrast$1.text,
  indicator: highContrast$1.backgroundColor,
  menuListBgColor: highContrast$1.backgroundColor,
  menuListColor: highContrast$1.text,
  optionHover: highContrast$1.backgroundColor,
  menuListBorder: "1px solid #fff",
  optionIsSelected: highContrast$1.action,
  optionBgColorHover: highContrast$1.action,
  optionIsSelectedColor: highContrast$1.backgroundColor,
  clearIndicator: highContrast$1.backgroundColor,
  variantBlack: {
    color: highContrast$1.backgroundColor,
    bgColor: highContrast$1.action
  },
  optionIsFocusColor: highContrast$1.backgroundColor,
  optionIsFocusBgColor: theme.colors.white
};
var tab$1 = {
  color: theme.colors.black,
  backgroundColor: "transparent"
};
var tabContent$1 = {
  marginTop: theme.spacing.xs2,
  backgroundColor: "transparent"
}; //Table

var table$1 = {
  borderColor: highContrast$1.borderColor,
  borderLightColor: highContrast$1.borderColor,
  optionColor: highContrast$1.text,
  minorColor: highContrast$1.text,
  linksTextDecorationColor: highContrast$1.link,
  indentColor: highContrast$1.text,
  textColor: highContrast$1.text
};
/*
-- Organisms
*/
//About

var about$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  arrowColor: highContrast$1.action
}; //Agenda

var agenda$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.link,
  squareColorHover: highContrast$1.text,
  agendaCardTextColor: highContrast$1.text,
  agendaFeaturedTextColor: highContrast$1.text,
  agendaFeaturedDateContainerBgColor: highContrast$1.text
}; //Article

var article$1 = {
  backgroundColor: highContrast$1.backgroundColor
}; //Campos

var campos$1 = {
  textColor: highContrast$1.text,
  backgroundColor: highContrast$1.backgroundColor
}; //Candidature

var candidature$1 = {
  arrowColor: highContrast$1.action,
  backgroundColor: highContrast$1.backgroundColor,
  dotsColor: highContrast$1.action,
  card: {
    linkColor: highContrast$1.link,
    linkHoverColor: highContrast$1.link
  }
}; //Cards

var cards$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.text,
  dotsColor: highContrast$1.action,
  slideBackgroundColor: highContrast$1.backgroundColor,
  arrowColor: highContrast$1.action
}; //ContentList

var contentList$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.text,
  borderColor: highContrast$1.borderColor,
  listTitleColor: highContrast$1.text,
  listLinkColor: highContrast$1.link
}; //ContentList -- SimpleList

var simpleList$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  borderColor: highContrast$1.borderColor,
  linkColor: highContrast$1.link
}; //Contents

var contents$1 = {
  nestedRow: {
    linkColor: highContrast$1.link,
    linkHoverColor: highContrast$1.link
  },
  oneCol: {
    textColor: highContrast$1.text,
    buttonBgColor: highContrast$1.backgroundColor
  },
  twoCols: {
    textColor: highContrast$1.text,
    linkColor: highContrast$1.link,
    linkHoverColor: highContrast$1.link
  }
}; //Courses

var courses$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.text,
  borderColor: highContrast$1.borderColor,
  textColor: highContrast$1.text,
  listLinkColor: highContrast$1.link,
  noteColor: highContrast$1.text
}; //Curricular

var curricular$1 = {
  backgroundColor: highContrast$1.backgroundColor
}; //CurricularPlan

var curricularPlan$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.borderColor,
  linkColor: highContrast$1.link
}; //CurricularUnit

var curricularUnit$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.borderColor,
  titleColor: highContrast$1.text,
  containerBorderColor: highContrast$1.borderColor,
  infoContainerBorderColor: highContrast$1.borderColor,
  linkColor: highContrast$1.link,
  linkHoverColor: highContrast$1.link
}; //Departments

var departments$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.text,
  borderColor: highContrast$1.borderColor,
  linkColor: highContrast$1.link
}; //Directory

var directory$1 = {
  linkColor: highContrast$1.link,
  linkHoverColor: highContrast$1.link,
  alphabetColor: highContrast$1.link,
  textColor: highContrast$1.text,
  alphabetActiveLetter: highContrast$1.text,
  alphabetBoxSelectedShadow: "0 1px 3px rgba(129,212,250,0.12), 0 1px 2px rgba(129,212,250,0.24)"
}; //Edicts

var edicts$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  iconColor: highContrast$1.action,
  emptyIconColor: highContrast$1.text,
  linkColor: highContrast$1.link
}; //Events

var events$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  agendaCard: {
    borderColor: highContrast$1.borderColor,
    outlineColor: highContrast$1.text,
    buttonOutlineColorHover: highContrast$1.text,
    iconColorHover: highContrast$1.text,
    iconColor: highContrast$1.text,
    categoryColor: highContrast$1.text,
    titleColor: highContrast$1.text,
    textColor: highContrast$1.text,
    dateColor: highContrast$1.text,
    squareColorHover: highContrast$1.lightBackgroundColor,
    textColorHover: highContrast$1.text,
    isLimitHour: highContrast$1.text,
    isNotLimitHour: highContrast$1.text
  },
  agendaFeatured: {
    dateContainerBgColor: highContrast$1.text,
    borderColor: highContrast$1.borderColor,
    dateContainerTextColor: highContrast$1.backgroundColor,
    buttonBgColor: highContrast$1.text,
    buttonTextColor: highContrast$1.backgroundColor,
    titleColor: highContrast$1.text,
    textColor: highContrast$1.text,
    dateColor: highContrast$1.text,
    textColorHover: highContrast$1.text,
    animationBgColor: highContrast$1.backgroundColor,
    plusButtonHoverBgColor: highContrast$1.backgroundColor
  },
  calendarCardToday: {
    backgroundColor: highContrast$1.text,
    titleColor: highContrast$1.backgroundColor,
    textColor: highContrast$1.text,
    afterBgColor: highContrast$1.backgroundColor,
    bottomBgColor: highContrast$1.lightBackgroundColor,
    plusButtonBgColor: highContrast$1.lightBackgroundColor,
    plusButtonTextColor: highContrast$1.text
  },
  calendarCard: {
    backgroundColor: highContrast$1.backgroundColor,
    border: "1px solid" + highContrast$1.action,
    hoverBgColor: highContrast$1.action,
    textColor: highContrast$1.text,
    textColorHover: highContrast$1.backgroundColor,
    activeBgColor: "rgba(77, 147, 255, 0.7)"
  },
  calendarButton: {
    backgroundColor: highContrast$1.action,
    color: highContrast$1.text,
    iconColor: highContrast$1.backgroundColor,
    hoverBgColor: highContrast$1.action
  }
}; //Facts

var oneFact$1 = {
  backgroundColor: theme.colors.white
}; //Files

var files$1 = {
  textColor: highContrast$1.text,
  buttonColor: highContrast$1.action,
  lightText: highContrast$1.text
}; //Gallery

var gallery$1 = {
  titleColor: highContrast$1.text,
  theater: {
    backgroundColor: highContrast$1.backgroundColor,
    textColor: highContrast$1.text
  }
}; //Footer

var footer$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  color: highContrast$1.text,
  linkColor: highContrast$1.link,
  copyColor: highContrast$1.text,
  borderColor: highContrast$1.lightBackgroundColor,
  socialMediaIconsColor: highContrast$1.text,
  logos: {
    compete: "/imgs/logos/logo_compete.jpg",
    eciu: "/imgs/logos/logo_eciu.jpg",
    eche: "/imgs/logos/eche.jpg",
    eps: "/imgs/logos/eps.jpg",
    accessibility: "/imgs/logos/logo_acessibilidade.jpg"
  }
}; //Header

var header$1 = {
  height: "calc(100vh - (40px + 105px + 50px))",
  mobileHeight: "calc(100vh - (40px + 85px + 50px))",
  maxHeight: "992px",
  arrowColor: highContrast$1.backgroundColor,
  arrowBackgroundColor: highContrast$1.action,
  subWeb: {
    height: "calc(100vh - (40px + 105px + 105px + 50px))",
    mobileHeight: "calc(100vh - (40px + 85px + 72px + 50px))",
    titleColor: highContrast$1.text,
    bgColor: highContrast$1.opacityBgColor,
    iconColor: highContrast$1.text,
    warning: {
      bgColor: highContrast$1.backgroundColor,
      textColor: highContrast$1.text
    }
  },
  video: {
    bgColor: highContrast$1.backgroundColor,
    imagePlaceholder: {
      iconColor: theme.colors.white
    },
    adButton: {
      iconColor: highContrast$1.text,
      toolTipBgColor: "rgba(33, 33, 33, 0.8)",
      toolTipColor: highContrast$1.text
    }
  }
}; //Information

var information$1 = {
  lineColor: theme.colors.black,
  titleColor: theme.colors.blue
}; // -- Journal --
//JournalCards

var journalCards$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.link,
  personCardBgColor: highContrast$1.lightBackgroundColor,
  cardTextColor: highContrast$1.text
}; //JournalColumns

var journalColumns$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.link
}; //JournalDetails

var journalDetails$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  color: highContrast$1.text,
  linkColor: highContrast$1.link,
  borderedCardLineColor: highContrast$1.text,
  socialMediaIconsColor: highContrast$1.text,
  printIconColor: highContrast$1.action
}; //JournalDossiers

var journalDossiers$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.text
}; //JournalFooter

var journalFooter$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  color: highContrast$1.link
}; //JournalHighlights

var journalHighlights$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  highlightCardBgColor: highContrast$1.lightBackgroundColor
}; //JournalListing

var journalListing$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  mobileBackgroundColor: highContrast$1.backgroundColor,
  mobileNewsCardBgColor: highContrast$1.lightBackgroundColor,
  titleColor: highContrast$1.text
}; //JournalMoreNews

var journalMoreNews$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  containerRightBgColor: highContrast$1.backgroundColor,
  titleColor: highContrast$1.text,
  borderedCardLinkColor: highContrast$1.link,
  newsCardBgColor: highContrast$1.lightBackgroundColor
}; //JournalNavigation

var journalNavigation$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  mobileBorderBottomColor: highContrast$1.borderColor,
  boxShadow: "0px 1px 0px 0 rgb(255, 255, 255)",
  menuIconColor: highContrast$1.link,
  linksColor: highContrast$1.link,
  titleColor: highContrast$1.link
}; //JournalNews

var journalNews$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  mobileBackgroundColor: highContrast$1.backgroundColor,
  mobileNewsCardBgColor: highContrast$1.lightBackgroundColor,
  titleColor: highContrast$1.link
}; //JournalRelated

var journalRelated$1 = {
  backgroundColor: "#4d93ff"
}; //JournalSlides

var journalSlides$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  textColor: highContrast$1.text,
  cardBackgroundColor: highContrast$1.lightBackgroundColor,
  desktopContentContainerBgColor: highContrast$1.lightBackgroundColor,
  desktopContentContainerContentColor: highContrast$1.text,
  activeCardBgColor: highContrast$1.backgroundColor,
  activeCardContentColor: highContrast$1.text,
  mobileCardBackgroundColor: highContrast$1.lightBackgroundColor,
  cardTextColor: highContrast$1.text,
  mobileMdTextColor: highContrast$1.link,
  gradientColor: "rgba(8, 8, 8, 0.4)"
}; //LastUpdate

var lastUpdate$1 = {
  bgColor: highContrast$1.backgroundColor,
  textColor: highContrast$1.text
}; //Loading

var loading$1 = {
  backgroundColor: highContrast$1.backgroundColor
}; //MobileNavBar

var mobileNavBar$1 = {
  mobileWhiteLogo: "/imgs/logo_mobile.svg",
  mobileBlackLogo: "/imgs/logo_mobile.svg",
  backgroundColor: highContrast$1.backgroundColor,
  isSearchOpenBackgroundColor: highContrast$1.lightBackgroundColor,
  iconColor: highContrast$1.action,
  textColor: highContrast$1.action,
  dropDownBackgroundColor: highContrast$1.backgroundColor,
  linksColor: highContrast$1.link
}; //MobilePublicNavBar

var mobilePublicNavBar$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  linksColor: highContrast$1.link,
  textColor: highContrast$1.text,
  iconColor: highContrast$1.link,
  boxShadow: "0 15px 10px -15px rgba(255, 255, 255, 0.2)"
}; //News

var news$1 = {
  personCard: {
    style2BgColor: highContrast$1.lightBackgroundColor,
    style2Color: highContrast$1.text
  }
}; //ErrorHandler

var errorHandler$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  color: highContrast$1.text,
  linkColor: highContrast$1.link,
  borderColor: highContrast$1.borderColor,
  hoverColor: highContrast$1.action,
  activeColor: "rgba(129, 212, 250, 0.5)",
  gameFontSize: theme.sizes.xl4,
  gameFontWeight: theme.weight.base,
  gameSquareSize: "110px",
  gameSquareMobileSize: "80px",
  gameSquareXXXSmallMobileSize: "60px",
  gameBorderSize: "1px",
  playButtonContainerBgColor: "rgba(0, 0, 0, 0.85)"
}; //Numbers

var numbers$1 = {
  sectionTitleColor: highContrast$1.text
}; //PeopleArticle

var peopleArticle$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.borderColor
}; //Presentation

var presentation$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.borderColor,
  linkColor: highContrast$1.link,
  linkHoverColor: highContrast$1.link,
  card: {
    border: "3px solid" + highContrast$1.borderColor,
    thinBorderColor: highContrast$1.borderColor
  }
}; //Profile

var profile$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  linkColor: highContrast$1.link,
  iconColor: highContrast$1.link
}; //Services

var services$1 = {
  groupTitleColor: highContrast$1.text
}; //Streaming

var streaming$1 = {
  textColor: highContrast$1.text,
  backgroundColor: highContrast$1.backgroundColor
}; //Projects

var projects$1 = {
  projectList: {
    titleColor: highContrast$1.text,
    table: {
      linkColor: highContrast$1.link
    },
    card: {
      borderColor: highContrast$1.borderColor,
      linkColor: highContrast$1.link,
      textColor: highContrast$1.text
    }
  },
  projectDetails: {
    titleColor: highContrast$1.text,
    textColor: highContrast$1.text,
    logos: {
      borderColor: highContrast$1.borderColor
    }
  }
}; //PublicNavBar

var publicNavbar$1 = {
  borderColor: highContrast$1.lightBorderColor,
  linksColor: highContrast$1.link,
  backgroundColor: highContrast$1.backgroundColor,
  iconColor: highContrast$1.link,
  myUAColor: highContrast$1.link,
  avatar: {
    linksColor: highContrast$1.link
  },
  bentoMenu: {
    icon: "/icons/sushi_icon_hc.svg",
    moreLinkBgColor: highContrast$1.link,
    moreLinkColor: highContrast$1.backgroundColor
  }
}; //SideNav

var sideNav$1 = {
  iconColor: highContrast$1.action,
  backgroundColor: highContrast$1.lightBackgroundColor,
  desktopBoxShadow: "unset",
  mobileBoxShadow: "unset"
}; //SiteMap

var siteMap$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  lineColor: highContrast$1.borderColor,
  linkColor: highContrast$1.link
};
/*
-- SubWebs
*/
//SubWebContacts

var subWebContacts$1 = {
  height: "485px",
  card: {
    bgColor: highContrast$1.backgroundColor,
    iconColor: highContrast$1.text
  }
}; //SubWebCourses

var subWebCourses$1 = {
  titleColor: highContrast$1.link,
  backgroundColor: highContrast$1.backgroundColor
}; //SubWebContacts

var subWebDepartment$1 = {
  titleColor: highContrast$1.text,
  backgroundColor: highContrast$1.backgroundColor,
  height: "485px"
}; //SubWebDepartmentCourses

var subWebDepartmentCourses$1 = {
  subTitleColor: highContrast$1.text,
  card: {
    borderColor: highContrast$1.borderColor,
    titleColor: highContrast$1.link,
    subTitle: highContrast$1.text
  }
}; //SubWebEvents

var subWebEvents$1 = {
  color: highContrast$1.text,
  linkColor: highContrast$1.link,
  card: {
    bgColor: {
      darkGray: highContrast$1.lightBackgroundColor,
      lightGray: highContrast$1.lightBackgroundColor
    },
    text: {
      dark: highContrast$1.text,
      light: highContrast$1.text
    }
  }
}; //SubWebNavigation

var subWebNavigation$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  menuIconColor: highContrast$1.action,
  linksColor: highContrast$1.link,
  boxShadow: "0px 1px 0px 0 rgb(255, 255, 255)",
  whiteLogo: "/imgs/logo.svg",
  activeLineColor: highContrast$1.link
}; //SubWebPeople

var subWebPeople$1 = {
  titleColor: highContrast$1.text,
  personCard: {
    textColor: highContrast$1.text,
    linkColor: highContrast$1.link,
    imagePlaceholderColor: highContrast$1.text
  }
}; //SubWebWarnings

var subWebWarnings$1 = {
  titleColor: highContrast$1.link,
  card: {
    titleColor: highContrast$1.text,
    linkColor: highContrast$1.link
  }
}; //SubWebSchedule

var subWebSchedule$1 = {
  backgroundColor: {
    isOpen: highContrast$1.backgroundColor,
    isClosed: highContrast$1.backgroundColor
  },
  textColor: {
    isOpen: highContrast$1.text,
    isClosed: highContrast$1.text
  },
  linkColor: {
    isOpen: highContrast$1.link,
    isClosed: highContrast$1.link,
    hover: highContrast$1.link
  }
}; //WebNavBar

var webNavBar$1 = {
  whiteLogo: "/imgs/logo.svg",
  mobileWhiteLogo: "/imgs/logo_mobile.svg",
  blackLogo: "/imgs/logo.svg",
  mobileBlackLogo: "/imgs/logo_mobile.svg",
  borderColor: highContrast$1.lightBorderColor,
  backgroundColor: theme.colors.black,
  color: highContrast$1.text,
  isSearchOpenBackgroundColor: highContrast$1.lightBackgroundColor,
  activeLineColor: highContrast$1.link,
  dropDownHoverBackgroundColor: highContrast$1.action,
  dropDownIconColor: highContrast$1.text,
  linksColor: highContrast$1.link,
  iconColor: highContrast$1.action,
  accessibilityActiveBgColor: highContrast$1.action,
  accessibilityIconActiveColor: highContrast$1.backgroundColor,
  accessibilityMenuIconColor: highContrast$1.action,
  accessibilityIconHoverColor: highContrast$1.backgroundColor,
  searchFilterColor: highContrast$1.link,
  accessibilityOnColor: highContrast$1.action
}; //Tables

var tables$1 = {
  titleColor: highContrast$1.text,
  linkColor: highContrast$1.link
}; //Xperimenta

var xperimenta$1 = {
  sessionColor: highContrast$1.link,
  sessionDateAndTimeColor: theme.colors.white,
  card: {
    borderColor: highContrast$1.backgroundColor,
    titleColor: highContrast$1.link,
    subTitle: highContrast$1.text
  }
}; //generalAccordion

var generalAccordion$1 = {
  title: highContrast$1.link,
  header: highContrast$1.text,
  borderColor: "1px solid ".concat(highContrast$1.borderColor),
  card: {
    titleColor: "red",
    subTitle: highContrast$1.text
  }
};
/*
-- Templates
*/
//GlobalSearch

var globalSearch$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  tabLinkColor: highContrast$1.link,
  tabsBorder: "1px solid" + highContrast$1.borderColor,
  places: {
    linkColor: highContrast$1.link,
    linkHoverColor: highContrast$1.link,
    textColor: highContrast$1.text,
    mapLinkColor: highContrast$1.link
  },
  news: {
    linkColor: highContrast$1.link,
    linkHoverColor: highContrast$1.link,
    dateColor: highContrast$1.text,
    textColor: highContrast$1.text
  }
}; //GoogleSearch

var googleSearch$1 = {
  backgroundColor: highContrast$1.backgroundColor,
  brandingTextNameColor: highContrast$1.text,
  brandingTextColor: highContrast$1.text,
  searchButtonBgColor: theme.colors.white,
  searchButtonSvgFill: "#94d60a",
  selectOptionBorder: "1px solid" + highContrast$1.backgroundColor,
  selectOptionColor: highContrast$1.backgroundColor,
  selectOptionBgColor: highContrast$1.action,
  selectLabelColor: highContrast$1.text,
  linkColor: highContrast$1.link,
  linkHoverColor: highContrast$1.link,
  pageNumberColor: highContrast$1.link,
  currentPageColor: highContrast$1.text,
  gscResultInfo: highContrast$1.text,
  gscResultVisibleUrl: highContrast$1.text,
  gsSnippet: highContrast$1.text,
  gcscBrandingClickable: highContrast$1.link,
  findMoreMagnifier: highContrast$1.link,
  optionMenuBgColor: highContrast$1.backgroundColor,
  optionMenuBorder: "1px solid #fff",
  gscOptionMenuBgColor: highContrast$1.action,
  gscOptionMenuColor: highContrast$1.backgroundColor,
  gscMenuItemColor: highContrast$1.text,
  gscActiveMenuItemHoverBgColor: highContrast$1.action,
  gscActiveMenuItemHoverColor: highContrast$1.backgroundColor,
  gscMenuItemHoverBgColor: highContrast$1.action,
  gscMenuItemHoverColor: highContrast$1.backgroundColor
};
/*
-- Others
*/
//GoUpButton

var goToTopButton$1 = {
  backgroundColor: highContrast$1.action,
  boxShadow: "0 3px 6px rgba(129, 212, 250, 0.2)",
  iconColor: highContrast$1.backgroundColor
}; //Loadings

var loadings$1 = {
  mainBgColor: "#707070",
  bgColor: highContrast$1.backgroundColor,
  cardBgColor: highContrast$1.lightBackgroundColor,
  cardBorderColor: highContrast$1.borderColor,
  lightBorderColor: "#707070",
  maskBgColor: highContrast$1.lightBackgroundColor,
  iconColor: "#9e9e9e",
  iconContainerBgColor: "#616161",

  /*
  -- Molecules
  */
  //Cards
  bgImageNewsCard: {
    maskBgColor: "#9e9e9e",
    contentContainerBgColor: "#9e9e9e"
  },
  agendaCard: {
    miniSliderColor: "#707070"
  },
  agendaFeaturedCard: {
    dateContainerBgColor: highContrast$1.text,
    borderColor: highContrast$1.text
  },

  /*
  -- Journal
  */
  //JournalCards
  journalCards: {
    personCard: {
      bgColor: highContrast$1.lightBackgroundColor
    }
  },
  //JournalDetails
  journalDetails: {
    maskBgColor: highContrast$1.backgroundColor,
    socialMediaIconsColor: "#707070"
  },
  //JournalHighLights
  journalHighlights: {
    backgroundColor: highContrast$1.backgroundColor,
    horizontalNewsCard: {
      bgColor: highContrast$1.lightBackgroundColor,
      maskColor: highContrast$1.lightBackgroundColor
    }
  },
  //JournalListing
  journalListing: {
    mediumDevices: {
      loadingMaskBgColor: highContrast$1.lightBackgroundColor
    }
  },
  //JournalNavigation
  journalNavigation: {
    iconColor: "#9e9e9e"
  }
}; //React Slick Slider

var reactSlickSlider$1 = {
  buttonBgColor: highContrast$1.action
};
var theme_highContrast = _objectSpread2({}, theme, {
  viewsColors: viewsColors$1,
  highContrast: highContrast$1,
  globalStyle: globalStyle$1,
  loadings: loadings$1,
  containers: {
    accessibilitySelector: accessibilitySelector$1
  },
  components: {
    //Atoms
    animatedBackground: animatedBackground$1,
    aspectRatio: aspectRatio$1,
    button: button$1,
    icon: icon$1,
    input: input$1,
    line: line$1,
    link: link$1,
    picture: picture$1,
    pagination: pagination$1,
    scrollMore: scrollMore$1,
    text: text$2,
    title: title$2,
    triangle: triangle$1,
    //Molecules
    accessibleAccordion: accessibleAccordion$1,
    accordion: accordion$1,
    breadcrumbs: breadcrumbs$1,
    agendaCard: agendaCard$1,
    agendaFeatured: agendaFeatured$1,
    backgroundImageNewsCard: backgroundImageNewsCard$1,
    borderedCard: borderedCard$1,
    candidatureCard: candidatureCard$1,
    colorExtractCard: colorExtractCard$1,
    columnsCard: columnsCard$1,
    eventCard: eventCard$1,
    horizontalNewsCard: horizontalNewsCard$1,
    imageCard: imageCard$1,
    layeredCard: layeredCard$1,
    miniHorizontalNewsCard: miniHorizontalNewsCard$1,
    newsCard: newsCard$1,
    personCard: personCard$1,
    shareSocialMedia: shareSocialMedia$1,
    showMoreCard: showMoreCard$1,
    iconCard: iconCard$1,
    studentCard: studentCard$1,
    studentCardLink: studentCardLink$1,
    carousel: carousel$1,
    customArrow: customArrow$1,
    datePicker: datePicker$1,
    dropDown: dropDown$1,
    dropdownList: dropdownList$1,
    injectHtml: injectHtml$1,
    instituteSearch: instituteSearch$1,
    listItem: listItem$1,
    plusButton: plusButton$1,
    reactCalendar: reactCalendar$1,
    scrollableTabs: scrollableTabs$1,
    section: section$1,
    sectionHeader: sectionHeader$1,
    select: select$1,
    tab: tab$1,
    tabContent: tabContent$1,
    table: table$1,
    //Organisms
    about: about$1,
    agenda: agenda$1,
    article: article$1,
    campos: campos$1,
    candidature: candidature$1,
    cards: cards$1,
    contentList: contentList$1,
    simpleList: simpleList$1,
    contents: contents$1,
    courses: courses$1,
    curricular: curricular$1,
    curricularPlan: curricularPlan$1,
    curricularUnit: curricularUnit$1,
    departments: departments$1,
    directory: directory$1,
    edicts: edicts$1,
    events: events$1,
    oneFact: oneFact$1,
    files: files$1,
    gallery: gallery$1,
    footer: footer$1,
    header: header$1,
    information: information$1,
    xperimenta: xperimenta$1,
    generalAccordion: generalAccordion$1,
    // - Journal
    journalCards: journalCards$1,
    journalColumns: journalColumns$1,
    journalDetails: journalDetails$1,
    journalDossiers: journalDossiers$1,
    journalFooter: journalFooter$1,
    journalHighlights: journalHighlights$1,
    journalListing: journalListing$1,
    journalMoreNews: journalMoreNews$1,
    journalNavigation: journalNavigation$1,
    journalNews: journalNews$1,
    journalRelated: journalRelated$1,
    journalSlides: journalSlides$1,
    lastUpdate: lastUpdate$1,
    loading: loading$1,
    mobileNavBar: mobileNavBar$1,
    mobilePublicNavBar: mobilePublicNavBar$1,
    news: news$1,
    errorHandler: errorHandler$1,
    numbers: numbers$1,
    peopleArticle: peopleArticle$1,
    presentation: presentation$1,
    profile: profile$1,
    services: services$1,
    streaming: streaming$1,
    projects: projects$1,
    publicNavbar: publicNavbar$1,
    sideNav: sideNav$1,
    siteMap: siteMap$1,
    // - SubWebs
    subWebContacts: subWebContacts$1,
    subWebDepartment: subWebDepartment$1,
    subWebDepartmentCourses: subWebDepartmentCourses$1,
    subWebEvents: subWebEvents$1,
    subWebCourses: subWebCourses$1,
    subWebNavigation: subWebNavigation$1,
    subWebPeople: subWebPeople$1,
    subWebWarnings: subWebWarnings$1,
    subWebSchedule: subWebSchedule$1,
    webNavBar: webNavBar$1,
    tables: tables$1,
    //Templates
    globalSearch: globalSearch$1,
    googleSearch: googleSearch$1,
    //Others
    goToTopButton: goToTopButton$1,
    reactSlickSlider: reactSlickSlider$1
  }
});

function _templateObject$21() {
  var data = _taggedTemplateLiteral(["\n  @import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&display=swap');\n\n  * {\n    margin: 0;\n    padding: 0;\n  }\n\n  html {\n    height: 100%;\n  }\n\n  body {\n    font-family: ", ";\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    zoom: ", ";\n    background-color: ", ";\n  }\n\n  #root {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  :focus {\n    ", ";\n  }\n  //Button Go to Top\n  .go-to-top {\n    position: fixed;\n    bottom: 100px;\n    right: 30px;\n    z-index: 1000;\n    background-color: ", ";\n    height: 50px;\n    width: 50px;\n    border-radius: 50%;\n    box-shadow: ", ";\n    cursor: pointer;\n    outline: none;\n    border: none;\n  }\n  .go-to-top.hidden {\n    visibility: hidden;\n  }\n  .go-to-top.visible {\n    visibility: visible;\n  }\n\n  /* override styles when printing */\n  @media print {\n    @page {\n      margin: 2cm;\n    }\n    html, body {height: 100%; margin: 0;}\n    header, footer, aside, nav, form, iframe, .tags-container, .journal-footer {\n      display: none!important;\n    }\n\n    @-moz-document url-prefix() {\n      body, picture, img, div {\n        display: block!important;\n      }\n    }\n  }\n"]);

  _templateObject$21 = function _templateObject() {
    return data;
  };

  return data;
}
// eslint-disable-next-line

var GlobalStyle$1 = createGlobalStyle(_templateObject$21(), function (props) {
  return props.theme.type.base;
}, function (props) {
  return props.zoom || "100%";
}, function (props) {
  return props.theme.globalStyle.body.backgroundColor;
}, function (props) {
  return typeof window !== "undefined" && window.location.host === "www.ua.pt" ? "outline: 0" : props.theme.mixins.focus();
}, function (props) {
  return props.theme.components.goToTopButton.backgroundColor;
}, function (props) {
  return props.theme.components.goToTopButton.boxShadow;
});
var GlobalStyle$2 = withTheme(GlobalStyle$1);

export { index$k as About, Accordion, AccordionTitle, index$3 as Agenda, AgendaCard$1 as AgendaCard, AgendaCardLoading, AgendaFeatured$1 as AgendaFeatured, AgendaFeaturedLoading, Loading$o as AgendaLoading, AlertBar, AnimatedBackground, index$d as Article, LoadingWithStyles$8 as ArticleLoading, AspectRatioWithStyles as AspectRatio, BackgroundImageNewsCard$1 as BackgroundImageNewsCard, BackgroundImageNewsCardLoading, BorderedCardWithStyles as BorderedCard, BorderedCardLoading, BreadcrumbsWithStyles as Breadcrumbs, Loading$i as BreadcrumbsLoading, Button, index$m as Campos, index$l as Campus, index$e as Candidature, CandidatureCard$1 as CandidatureCard, CandidatureCardLoading, Loading$N as CandidatureLoading, index$c as Cards, Loading$K as CardsLoading, CarouselWithStyles as Carousel, ClickAwayListener, index as ColorExtractCard, ColumnsCard$1 as ColumnsCard, ConfigContext, ConfigProvider, ContentContainer, index$9 as ContentList, Loading$E as ContentListLoading, LoadingWithStyles$2 as ContentLoading, index$6 as Contents, Loading$y as ContentsLoading, Contest, Contests, index$7 as Courses, Loading$A as CoursesLoading, index$a as Curricular, Loading$G as CurricularLoading, index$b as CurricularPlan, Loading$I as CurricularPlanLoading, index$q as CurricularUnit, CustomArrow$1 as CustomArrow, index$1 as DatePicker, index$r as Departments, Dropdown$1 as Dropdown, DropdownList$1 as DropdownList, index$8 as Edicts, Loading$C as EdictsLoading, EmptyStyles as Empty, ErrorWithStyles as Error, index$p as ErrorHandler, EventCard$1 as EventCard, EventCardLoading, index$4 as Events, Loading$u as EventsLoading, index$j as Facts, FadeIn, index$v as Files, index$g as Gallery, Loading$Q as GalleryLoading, Accordion$1 as GeneralAccordion, AccordionHeaderWithStyles as GeneralAccordionHeader, AccordionTitleWithStyles as GeneralAccordionTitle, GlobalStyle$2 as GlobalStyle, index$2 as Header, Loading$m as HeaderLoading, HorizontalList, HorizontalNewsCard$1 as HorizontalNewsCard, HorizontalNewsCardLoading, Icon, IconCard$1 as IconCard, Image, ImageCard$1 as ImageCard, ImageContainer, ImageWrapper, Loading$7 as ImageWrapperLoading, IndentWithStyles as Indent, InjectHtml$1 as InjectHtml, InjectIntlContext, Input, IntlContext, index$H as JournalCards, Loading$19 as JournalCardsLoading, index$J as JournalColumns, Loading$1c as JournalColumnsLoading, index$K as JournalDetails, Loading$1e as JournalDetailsLoading, index$L as JournalDossiers, Loading$1f as JournalDossiersLoading, index$F as JournalHighlights, Loading$15 as JournalHighlightsLoading, index$M as JournalListing, LoadingWithStyles$g as JournalListingLoading, index$I as JournalMoreNews, LoadingWithStyles$f as JournalMoreNewsLoadingPopular, Loading$1b as JournalMoreNewsLoadingRecent, index$G as JournalNavigation, Loading$17 as JournalNavigationLoading, JournalNews$1 as JournalNews, index$N as JournalSlides, Loading$1i as JournalSlidesLoading, index$n as LastUpdate, LayeredCard$1 as LayeredCard, Line, LineTruncate, Link, LinkExternal, ListItem, Loading$q as Loading, MarkdownRenderer, MiniHorizontalNewsCard$1 as MiniHorizontalNewsCard, index$s as MultiColumns, Navigation as NavigationLoading, News$1 as News, NewsCard$1 as NewsCard, NewsCardLoading, LoadingWithStyles$5 as NewsLoading, index$o as Numbers, OneFact$1 as OneFact, PaginationWithStyles as Pagination, PeopleCard$1 as PeopleCard, PeopleCardLoading, PersonCard$1 as PersonCard, PersonCardLoading, PictureContainer as Picture, PlusButton, index$5 as Presentation, Loading$w as PresentationLoading, index$f as Profile, Loading$P as ProfileLoading, ReactCalendarWithStyles as ReactCalendar, ScreenReaderText, ScrollMore$1 as ScrollMore, ScrollableTab, ScrollableTabsWithStyles as ScrollableTabs, ScrollableTabsLoading, Section, SectionHeader, Select, SelectLoading, index$t as Services, ShareSocialMedia$1 as ShareSocialMedia, ShowMoreCard$1 as ShowMoreCard, ShowMoreCardLoading, SocialMediaActions$1 as SocialMediaActions, LoadingStyles as SpinnerLoading, index$w as Streaming, StudentCard$1 as StudentCard, StudentCardLink$1 as StudentCardLink, index$x as SubWebContacts, Loading$U as SubWebContactsLoading, index$z as SubWebCourses, Loading$X as SubWebCoursesLoading, index$A as SubWebDepartment, index$B as SubWebDepartmentCourses, Loading$$ as SubWebDepartmentCoursesLoading, Loading$Z as SubWebDepartmentLoading, index$E as SubWebEvents, SubWebLoading$1 as SubWebHeaderLoading, index$C as SubWebPeople, Loading$11 as SubWebPeopleLoading, index$D as SubWebSchedule, index$y as SubWebWarnings, Loading$V as SubWebWarningsLoading, TabStyles as Tab, TableWithStyles as Table, Loading$g as TableLoading, index$u as Tables, index$h as Testimonials, Text, theme$1 as Theme, theme_highContrast as ThemeContrast, TitleWithStyles as Title, Triangle, VerticalList, VideoPlayer$1 as VideoPlayer, WithProps$e as WithProps, index$i as Xperimenta, Loading$S as XperimentaLoading, useConfig, useFormatMessage, useMousePosition };
//# sourceMappingURL=index.es.js.map
